// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5DEId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
// Find the root element in your HTML
const rootElement = document.getElementById('app');
// Create the root and render your App
const root = (0, _client.createRoot)(rootElement);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
    })
}));

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-dom/client":"5eZdG","react-router-dom":"f3cgC","./App":"ceurZ","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"84Frb"}],"84Frb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"bmhQu"}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7cX1V"}],"7cX1V":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5eZdG":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"82aNB"}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"cfGqX"}],"cfGqX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"bmhQu","ece50e903283a22f":"dHubo"}],"dHubo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"cUjz3"}],"cUjz3":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"f3cgC":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"bmhQu","react-dom":"82aNB","react-router":"9oT3O","@remix-run/router":"jit4b","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"9oT3O":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"bmhQu","@remix-run/router":"jit4b","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"jit4b":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"8Bm3l":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"ceurZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _loggerUtils = require("./utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
var _coreService = require("./services/core.service");
var _renderService = require("./services/render.service");
var _languageUtils = require("./utils/language.utils");
var _i18N = require("./locales/i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _exercise = require("./pages/Exercise/Exercise");
var _horBooking = require("./pages/Booking/HorBooking");
var _tvsType = require("./types/tvs.type");
var _timerType = require("./types/timer.type");
var _timer = require("./pages/Timer/Timer");
const App = ()=>{
    const logger = (0, _loggerUtilsDefault.default).getLogger('App');
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const [bookingScreenData, setBookingScreenData] = (0, _react.useState)(undefined);
    const [workoutScreenData, setWorkoutScreenData] = (0, _react.useState)(undefined);
    const [timerScreenData, setTimerScreenData] = (0, _react.useState)(undefined);
    const coreServiceRef = (0, _react.useRef)(null);
    const renderServiceRef = (0, _react.useRef)(null);
    const workoutScreenDataHandler = (workoutScreenData)=>{
        setWorkoutScreenData(workoutScreenData);
    };
    const bookingScreenDataHandler = (bookingScreenData)=>{
        setBookingScreenData(bookingScreenData);
    };
    const timerScreenDataHandler = (timerScreenData)=>{
        setTimerScreenData(timerScreenData);
    };
    const timerControlRef = (0, _react.useRef)(null);
    const handleAction = (action)=>{
        if (timerControlRef.current) switch(action){
            case (0, _timerType.TimerControlAction).PLAY:
                timerControlRef.current.play();
                break;
            case (0, _timerType.TimerControlAction).STOP:
                timerControlRef.current.stop();
                break;
            case (0, _timerType.TimerControlAction).RESUME:
                timerControlRef.current.resume();
                break;
            case (0, _timerType.TimerControlAction).RESET:
                timerControlRef.current.reset();
                break;
            default:
                logger.error(`Action ${action} is not supported`);
                break;
        }
    };
    (0, _react.useEffect)(()=>{
        const core = coreServiceRef.current = (0, _coreService.CoreService).getInstance();
        const renderService = renderServiceRef.current = (0, _renderService.RenderService).getInstance();
        renderService.addHandler('WorkoutScreenData', workoutScreenDataHandler);
        renderService.addHandler('BookingScreenData', bookingScreenDataHandler);
        renderService.addHandler('TimerScreenData', timerScreenDataHandler);
        core.retrieveTvData().then((tv)=>{
            core.actionHandler = handleAction;
            const tvType = tv?.type;
            switch(tvType){
                case (0, _tvsType.TvTypeEnum).Exercise:
                    navigate(`/exercise${location.search}`);
                    break;
                case (0, _tvsType.TvTypeEnum).Schedule:
                    navigate(`/booking${location.search}`);
                    break;
                case (0, _tvsType.TvTypeEnum).Timer:
                    navigate(`/timer${location.search}`);
                    break;
                case (0, _tvsType.TvTypeEnum).Billboard:
                default:
                    logger.debug('TvType is unknown');
                    break;
            }
        });
        return ()=>{
            logger.debug("Cleanup: Remove handlers");
        //renderService.removeHandler('WorkoutScreenData', workoutScreenDataHandler);
        //renderService.removeHandler('BookingScreenData', bookingScreenDataHandler);
        //renderService.removeHandler('MovementScreenData', movementScreenDataHandler);
        //renderService.removeHandler('TimerScreenData', timerScreenDataHandler);
        };
    }, [
        navigate
    ]);
    (0, _react.useEffect)(()=>{
        (0, _languageUtils.changeLanguage)('pt');
    }, [
        (0, _i18NDefault.default)
    ]);
    (0, _react.useEffect)(()=>{
        const savedLanguage = localStorage.getItem('language') || 'pt';
        (0, _languageUtils.changeLanguage)(savedLanguage);
    }, [
        (0, _i18NDefault.default)
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/timer",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timer.Timer), {
                        timerScreenData: timerScreenData,
                        timerControlRef: timerControlRef
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/booking",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _horBooking.Booking), {
                        screenData: bookingScreenData,
                        timerControlRef: timerControlRef
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/exercise",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exercise.Exercise), {
                        screenData: workoutScreenData,
                        timerControlRef: timerControlRef
                    })
                })
            ]
        })
    });
};
exports.default = App;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./utils/logger.utils":"jsBaU","./services/core.service":"gV1Qw","./services/render.service":"4N2dl","./utils/language.utils":"pIs5H","./locales/i18n":"7WMTA","./pages/Exercise/Exercise":"lCZDc","./pages/Booking/HorBooking":"c8Bsg","./types/tvs.type":"jhV4I","./types/timer.type":"kWmyL","./pages/Timer/Timer":"1RTuZ","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"jsBaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loglevel = require("loglevel");
var _loglevelDefault = parcelHelpers.interopDefault(_loglevel);
var _loglevelPluginPrefix = require("loglevel-plugin-prefix");
var _loglevelPluginPrefixDefault = parcelHelpers.interopDefault(_loglevelPluginPrefix);
var _querystringUtils = require("./querystring.utils");
/**
 * Registers the `loglevel-plugin-prefix` with the `loglevel` logger.
 * The plugin allows for adding a prefix (such as timestamps, log levels, etc.) to log messages.
 */ (0, _loglevelPluginPrefixDefault.default).reg((0, _loglevelDefault.default));
/**
 * Configures the logging prefix to include:
 * - A timestamp
 * - The log level (in uppercase)
 * - The logger name (defaults to 'global' if not provided)
 */ (0, _loglevelPluginPrefixDefault.default).apply((0, _loglevelDefault.default), {
    template: '[%t] %l (%n):',
    timestampFormatter: (date)=>date.toISOString(),
    levelFormatter: (level)=>level.toUpperCase(),
    nameFormatter: (name)=>name || 'global'
});
/**
 * Sets the logging level based on the `BASEZERO_LOG_LEVEL` environment variable.
 * If the variable is not set, defaults to 'info'.
 * 
 * The logging levels are: 'trace', 'debug', 'info', 'warn', 'error', 'silent'.
 */ const logLevel = (0, _querystringUtils.QueryString).getLogLevel() ? (0, _querystringUtils.QueryString).getLogLevel() : "debug";
(0, _loglevelDefault.default).setLevel(logLevel);
/**
 * Exports the configured logger to be used across the application.
 */ exports.default = (0, _loglevelDefault.default);

},{"loglevel":"1RZcA","loglevel-plugin-prefix":"5FWN0","./querystring.utils":"j5Bu7","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"1RZcA":[function(require,module,exports,__globalThis) {
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === 'function' && define.amd) define(definition);
    else if (module.exports) module.exports = definition();
    else root.log = definition();
})(this, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') methodName = 'log';
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === 'trace' && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, 'log');
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods() {
        /*jshint validthis:true */ var level = this.getLevel();
        // Replace the actual methods.
        for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
        // Return any important warnings.
        if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, _level, _loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, factory) {
        // Private instance variables.
        var self = this;
        /**
       * The level inherited from a parent logger (or a global default). We
       * cache this here rather than delegating to the parent so that it stays
       * in sync with the actual logging methods that we have installed (the
       * parent could change levels but we might not have rebuilt the loggers
       * in this child yet).
       * @type {number}
       */ var inheritedLevel;
        /**
       * The default level for this logger, if any. If set, this overrides
       * `inheritedLevel`.
       * @type {number|null}
       */ var defaultLevel;
        /**
       * A user-specific level for this logger. If set, this overrides
       * `defaultLevel`.
       * @type {number|null}
       */ var userLevel;
        var storageKey = "loglevel";
        if (typeof name === "string") storageKey += ":" + name;
        else if (typeof name === "symbol") storageKey = undefined;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType || !storageKey) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var cookieName = encodeURIComponent(storageKey);
                var location = cookie.indexOf(cookieName + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        function clearPersistedLevel() {
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage.removeItem(storageKey);
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (ignore) {}
        }
        function normalizeLevel(input) {
            var level = input;
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
            else throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            if (userLevel != null) return userLevel;
            else if (defaultLevel != null) return defaultLevel;
            else return inheritedLevel;
        };
        self.setLevel = function(level, persist) {
            userLevel = normalizeLevel(level);
            if (persist !== false) persistLevelIfPossible(userLevel);
            // NOTE: in v2, this should call rebuild(), which updates children.
            return replaceLoggingMethods.call(self);
        };
        self.setDefaultLevel = function(level) {
            defaultLevel = normalizeLevel(level);
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.resetLevel = function() {
            userLevel = null;
            clearPersistedLevel();
            replaceLoggingMethods.call(self);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        self.rebuild = function() {
            if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
            replaceLoggingMethods.call(self);
            if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
        };
        // Initialize all the internal levels.
        inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
        var initialLevel = getPersistedLevel();
        if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
        replaceLoggingMethods.call(self);
    }
    /*
     *
     * Top-level API
     *
     */ defaultLogger = new Logger();
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;
    return defaultLogger;
});

},{}],"5FWN0":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else if (module.exports) module.exports = factory();
    else root.prefix = factory(root);
})(this, function(root) {
    'use strict';
    var merge = function(target) {
        var i = 1;
        var length = arguments.length;
        var key;
        for(; i < length; i++){
            for(key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) target[key] = arguments[i][key];
        }
        return target;
    };
    var defaults = {
        template: '[%t] %l:',
        levelFormatter: function(level) {
            return level.toUpperCase();
        },
        nameFormatter: function(name) {
            return name || 'root';
        },
        timestampFormatter: function(date) {
            return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
        },
        format: undefined
    };
    var loglevel;
    var configs = {};
    var reg = function(rootLogger) {
        if (!rootLogger || !rootLogger.getLogger) throw new TypeError('Argument is not a root logger');
        loglevel = rootLogger;
    };
    var apply = function(logger, config) {
        if (!logger || !logger.setLevel) throw new TypeError('Argument is not a logger');
        /* eslint-disable vars-on-top */ var originalFactory = logger.methodFactory;
        var name = logger.name || '';
        var parent = configs[name] || configs[''] || defaults;
        /* eslint-enable vars-on-top */ function methodFactory(methodName, logLevel, loggerName) {
            var originalMethod = originalFactory(methodName, logLevel, loggerName);
            var options = configs[loggerName] || configs[''];
            var hasTimestamp = options.template.indexOf('%t') !== -1;
            var hasLevel = options.template.indexOf('%l') !== -1;
            var hasName = options.template.indexOf('%n') !== -1;
            return function() {
                var content = '';
                var length = arguments.length;
                var args = Array(length);
                var key = 0;
                for(; key < length; key++)args[key] = arguments[key];
                // skip the root method for child loggers to prevent duplicate logic
                if (name || !configs[loggerName]) {
                    /* eslint-disable vars-on-top */ var timestamp = options.timestampFormatter(new Date());
                    var level = options.levelFormatter(methodName);
                    var lname = options.nameFormatter(loggerName);
                    /* eslint-enable vars-on-top */ if (options.format) content += options.format(level, lname, timestamp);
                    else {
                        content += options.template;
                        if (hasTimestamp) content = content.replace(/%t/, timestamp);
                        if (hasLevel) content = content.replace(/%l/, level);
                        if (hasName) content = content.replace(/%n/, lname);
                    }
                    if (args.length && typeof args[0] === 'string') // concat prefix with first argument to support string substitutions
                    args[0] = content + ' ' + args[0];
                    else args.unshift(content);
                }
                originalMethod.apply(undefined, args);
            };
        }
        if (!configs[name]) logger.methodFactory = methodFactory;
        // for remove inherited format option if template option preset
        config = config || {};
        if (config.template) config.format = undefined;
        configs[name] = merge({}, parent, config);
        logger.setLevel(logger.getLevel());
        if (!loglevel) logger.warn('It is necessary to call the function reg() of loglevel-plugin-prefix before calling apply. From the next release, it will throw an error. See more: https://github.com/kutuluk/loglevel-plugin-prefix/blob/master/README.md');
        return logger;
    };
    var api = {
        reg: reg,
        apply: apply
    };
    var save;
    if (root) {
        save = root.prefix;
        api.noConflict = function() {
            if (root.prefix === api) root.prefix = save;
            return api;
        };
    }
    return api;
});

},{}],"j5Bu7":[function(require,module,exports,__globalThis) {
/**
 * Utility class for handling URL query strings.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryString", ()=>QueryString);
class QueryString {
    params;
    /**
     * Initializes the QueryString instance with the current window's search parameters.
     */ constructor(){
        this.params = new URLSearchParams(window.location.search);
    }
    /**
     * Retrieves the value associated with the given query string key.
     * @param key - The key to search for in the query string.
     * @returns The value as a string, or null if the key is not found.
     */ get(key) {
        return this.params.get(key);
    }
    /**
     * Sets the value for a specific key in the query string.
     * @param key - The key to be set in the query string.
     * @param value - The value to associate with the key.
     */ set(key, value) {
        this.params.set(key, value);
    }
    /**
     * Converts the current query parameters to a string.
     * @returns The query parameters as a URL-encoded string.
     */ toString() {
        return this.params.toString();
    }
    /**
     * Static helper method to retrieve a query parameter by key from the current URL.
     * @param key - The query parameter key.
     * @returns The value associated with the key, or null if not found.
     */ static getParam(key) {
        const params = new URLSearchParams(window.location.search);
        return params.get(key);
    }
    /**
     * Retrieves the 'tv' query parameter from the URL.
     * @returns The 'tv' parameter value, or null if not found.
     */ static getTvId() {
        return QueryString.getParam('tv');
    }
    /**
     * Retrieves the 'periodization_instance_id' query parameter from the URL.
     * @returns The 'periodization_instance_id' parameter value, or null if not found.
     */ static getClassInstanceId() {
        const param = QueryString.getParam('instance_id');
        return param ? parseInt(param) : undefined;
    }
    static getAutoStart() {
        return QueryString.getParam('autostart');
    }
    /**
     * Retrieves the 'set_date' query parameter from the URL.
     * @returns The 'set_date' parameter value, or null if not found.
     */ static getSetDate() {
        return QueryString.getParam('set_date');
    }
    /**
     * Retrieves the 'set_time' query parameter from the URL.
     * @returns The 'set_time' parameter value, or null if not found.
     */ static getSetTime() {
        return QueryString.getParam('set_time');
    }
    /**
     * Retrieves the log level from the query string.
     * @returns The log level as a string, or null if it is not present in the query string.
     */ static getLogLevel() {
        let level = 'info';
        const logLevel = QueryString.getParam('log_level');
        if (logLevel) level = logLevel;
        return level;
    }
    static getStudioId() {
        return QueryString.getParam('studio_id');
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"gV1Qw":[function(require,module,exports,__globalThis) {
// CoreService.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoreService", ()=>CoreService);
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
var _tvsType = require("../types/tvs.type");
var _eventsType = require("../types/events.type");
var _configService = require("./config.service");
var _datetimeUtils = require("../utils/datetime.utils");
var _exerciseService = require("./exercise.service");
var _renderEventService = require("./renderEvent.service");
var _apiService = require("./api.service");
var _classScheduleService = require("./classSchedule.service");
var _mqttService = require("./mqtt.service");
var _timerType = require("../types/timer.type");
var _dataFetchService = require("./dataFetch.service");
var _objectUtils = require("../utils/object.utils");
class CoreService {
    static instance;
    logger;
    config;
    apiService;
    mqttService;
    dataFetchService;
    classData;
    bookingData;
    nextClass;
    currentClass;
    classInProgress = false;
    currentExerciseService;
    actionHandler;
    nextClassTimeout;
    // Constructor and Initialization Methods
    constructor(){
        this.logger = (0, _loggerUtilsDefault.default).getLogger('CoreService');
        this.config = (0, _configService.ConfigService).getInstance();
        this.apiService = (0, _apiService.ApiService).getInstance(this.config);
        this.mqttService = (0, _mqttService.MqttService).getInstance();
        this.dataFetchService = new (0, _dataFetchService.DataFetchService)(this.apiService, this.config);
        this.registerEventListeners();
        this.logger.info('CoreService initialized successfully.');
    }
    registerEventListeners() {
        this.logger.debug('Registering MQTT event listeners.');
        this.mqttService.on((0, _eventsType.MqttEvents).onMessage, this.processMqttMessage.bind(this));
    }
    initializeDataSubscriptions() {
        const tv = this.config.currentTv;
        if (!tv) {
            this.logger.error('TV configuration not found.');
            return;
        }
        switch(tv.type){
            case (0, _tvsType.TvTypeEnum).Timer:
            case (0, _tvsType.TvTypeEnum).Exercise:
                this.logger.debug('Subscribing to class data updates.');
                // Define the data fetch function
                const fetchClassData = async ()=>{
                    try {
                        if (!this.classInProgress) {
                            const newClassData = await this.dataFetchService.refreshClassData();
                            if (newClassData) {
                                this.classData = newClassData;
                                this.handleClassSchedule();
                            }
                        }
                    } catch (error) {
                        this.logger.error('Error refreshing class data:', error);
                    }
                };
                // Fetch data immediately
                fetchClassData();
                // Set up interval for subsequent data fetches
                setInterval(fetchClassData, this.config.tvDataUpdateInterval);
                break;
            case (0, _tvsType.TvTypeEnum).Schedule:
                this.logger.debug('Subscribing to booking data updates.');
                const fetchBookingData = async ()=>{
                    try {
                        const newBookingData = await this.dataFetchService.refreshBookingData();
                        if (newBookingData) {
                            this.bookingData = newBookingData;
                            (0, _renderEventService.RenderEventService).emitBookingDataEvent(this.bookingData);
                        }
                    } catch (error) {
                        this.logger.error('Error refreshing booking data:', error);
                    }
                };
                // Fetch data immediately
                fetchBookingData();
                // Set up interval for subsequent data fetches
                setInterval(fetchBookingData, this.config.tvDataUpdateInterval);
                break;
            default:
                this.logger.error('Invalid TV type:', tv.type);
                break;
        }
    }
    // MQTT Event Handling
    processMqttMessage(channel, data) {
        this.logger.info('Received MQTT event on channel', channel, 'with data:', data);
        if (!this.actionHandler) return;
        switch(data.action){
            case 'play':
                this.logger.debug('Processing play action.');
                if (!this.classInProgress) {
                    this.currentClass = this.currentClass || this.nextClass;
                    if (this.currentClass) {
                        this.actionHandler((0, _timerType.TimerControlAction).PLAY);
                        this.handleWorkoutStart();
                    } else this.logger.warn('Play action received, but no class is scheduled to start.');
                } else {
                    this.actionHandler((0, _timerType.TimerControlAction).PLAY);
                    this.currentExerciseService?.play();
                }
                break;
            case 'pause':
                this.logger.debug('Processing pause action.');
                this.actionHandler((0, _timerType.TimerControlAction).STOP);
                this.currentExerciseService?.pause();
                break;
            case 'restart':
                this.logger.debug('Processing restart action.');
                if (this.currentClass) {
                    if (this.classInProgress) {
                        this.currentExerciseService?.stop();
                        this.classInProgress = false;
                    }
                    this.actionHandler((0, _timerType.TimerControlAction).PLAY);
                    this.startWorkoutSession(this.currentClass);
                } else this.logger.warn('Restart action received, but no class is available to restart.');
                break;
            case 'stop':
                this.logger.debug('Processing stop action.');
                if (this.currentClass) {
                    if (this.classInProgress) {
                        this.currentExerciseService?.stop();
                        this.classInProgress = false;
                    }
                    this.actionHandler((0, _timerType.TimerControlAction).PLAY);
                    this.dispatchNextWorkoutEvent();
                } else this.logger.warn('Stop action received, but no class is available to stop.');
                break;
            case 'load':
                this.logger.debug('Processing load action.');
                /* 
                 * workaround to avoid react states misconfigurations
                 * will load again the persisted (in backend) studio workout
                 */ window.location.reload();
                // dead code bellow - keeping it here to keep the history for now
                if (data.data && data.data.date) {
                    this.config.classDate = data.data.date;
                    this.classInProgress = false;
                    this.classData = undefined;
                    this.bookingData = undefined;
                    this.nextClass = undefined;
                    this.currentClass = undefined;
                    this.currentExerciseService?.stop();
                    this.currentExerciseService = undefined;
                    // Define the data fetch function
                    if (this.config.currentTv?.type === (0, _tvsType.TvTypeEnum).Timer || this.config.currentTv?.type === (0, _tvsType.TvTypeEnum).Exercise) {
                        const fetchClassData = async ()=>{
                            try {
                                if (!this.classInProgress) {
                                    const newClassData = await this.dataFetchService.refreshClassData();
                                    if (newClassData) {
                                        this.classData = newClassData;
                                        this.handleClassSchedule();
                                    }
                                }
                            } catch (error) {
                                this.logger.error('Error refreshing class data:', error);
                            }
                        };
                        fetchClassData();
                    } else if (this.config.currentTv?.type === (0, _tvsType.TvTypeEnum).Schedule) {
                        const fetchBookingData = async ()=>{
                            try {
                                const newBookingData = await this.dataFetchService.refreshBookingData();
                                if (newBookingData) {
                                    this.bookingData = newBookingData;
                                    (0, _renderEventService.RenderEventService).emitBookingDataEvent(this.bookingData);
                                }
                            } catch (error) {
                                this.logger.error('Error refreshing booking data:', error);
                            }
                        };
                        // Fetch data immediately
                        fetchBookingData();
                    }
                }
                break;
            default:
                this.logger.warn('Received invalid MQTT action:', data.action);
                break;
        }
    }
    // Class Schedule Handling
    handleClassSchedule() {
        if (this.classInProgress) {
            this.logger.trace('Class is currently in progress; skipping schedule handling.');
            return;
        }
        this.classData = this.dataFetchService.getClassData();
        if (!this.classData) {
            this.logger.warn('Cannot handle class schedule: No class data available.');
            return;
        }
        this.currentClass = this.retrieveCurrentClassFromConfig();
        this.checkPodConfigExists(this.currentClass);
        if (this.currentClass && this.config.autoStart) {
            this.logger.info('Current class found; starting immediately:', this.currentClass);
            this.handleWorkoutStart();
        } else {
            this.nextClass = (0, _classScheduleService.ClassScheduleService).nextClassSchedule(this.classData);
            if (this.nextClass) {
                this.checkPodConfigExists(this.nextClass);
                this.logger.info('Next class scheduled:', this.nextClass);
                this.dispatchNextWorkoutEvent();
                this.scheduleNextClassStart();
            } else this.logger.warn('No upcoming classes found in the schedule.');
        }
    }
    checkPodConfigExists(schedule) {
        /* Single station workouts doesn't have pods - they are a group routine workout */ if (schedule && schedule.workout && !schedule.workout.workout_single_station) {
            const podConfig = schedule.workout.pod_config;
            const isMissing = !podConfig || (0, _objectUtils.ObjectUtils).isNullOrEmpty(podConfig);
            if (isMissing) alert("\u26A0\uFE0F Missing pod configuration for this TV. Please check the Backoffice.");
        }
    }
    retrieveCurrentClassFromConfig() {
        this.logger.debug('Attempting to get current class from configuration.');
        if (!this.classData) return undefined;
        const { classInstanceId } = this.config;
        if (classInstanceId) {
            this.logger.debug('Using class schedule ID from config:', classInstanceId);
            return (0, _classScheduleService.ClassScheduleService).getClassScheduleById(this.classData, classInstanceId);
        } else {
            this.logger.warn('No class schedule found in configuration.');
            return undefined;
        }
    }
    scheduleNextClassStart() {
        if (this.classInProgress || !this.nextClass || !this.nextClass.start_time) return;
        const timeToNextClassMs = this.calculateTimeUntilNextClass(this.nextClass);
        if (timeToNextClassMs > 0) {
            this.logger.info(`Scheduled next class in ${timeToNextClassMs} milliseconds.`);
            clearTimeout(this.nextClassTimeout);
            this.logger.debug('Setting timeout to start next class.');
            this.nextClassTimeout = setTimeout(()=>{
                this.currentClass = this.nextClass;
                this.handleWorkoutStart();
            }, timeToNextClassMs);
        } else this.logger.warn('Cannot schedule next class: class time is in the past or has already started.');
    }
    calculateTimeUntilNextClass(nextClass) {
        const currentTime = Date.now();
        const classTime = (0, _datetimeUtils.DateTimeUtils).hoursToTime(nextClass.start_time).getTime();
        return Math.max(classTime - currentTime, 0);
    }
    // Workout Control
    handleWorkoutStart() {
        if (this.currentClass) {
            this.logger.info('Starting class workout:', this.currentClass);
            this.startWorkoutSession(this.currentClass);
        } else this.logger.warn('Attempted to start class workout, but no current class is scheduled.');
    }
    startWorkoutSession(classSchedule) {
        clearTimeout(this.nextClassTimeout);
        this.logger.debug('Clearing next class timeout.');
        const taskCallback = this.config.currentTv?.type === (0, _tvsType.TvTypeEnum).Timer ? (0, _renderEventService.RenderEventService).emitTimerEvent : (0, _renderEventService.RenderEventService).emitExerciseTaskEvent;
        this.logger.debug('Initializing ExerciseService with class schedule:', classSchedule);
        this.currentExerciseService = new (0, _exerciseService.ExerciseService)(classSchedule, this.config.exercisesTaskDelay, this.handleWorkoutCompletion.bind(this), taskCallback);
        this.logger.debug('Starting ExerciseService play.');
        this.currentExerciseService.play();
        this.classInProgress = true;
    }
    handleWorkoutCompletion() {
        this.classInProgress = false;
        this.logger.info('Class workout completed successfully.');
        this.handleClassSchedule();
    }
    // Rendering Events
    dispatchNextWorkoutEvent() {
        if (this.nextClass) switch(this.config.currentTv?.type){
            case (0, _tvsType.TvTypeEnum).Exercise:
                this.logger.debug('Emitting next workout event for Exercise TV.');
                (0, _renderEventService.RenderEventService).emitExerciseNextWorkoutEvent(this.nextClass);
                break;
            case (0, _tvsType.TvTypeEnum).Timer:
                this.logger.debug('Emitting next workout event for Timer TV.');
                // Creating tasks to reuse the logic that calculate needed metrics for the screens.
                this.currentExerciseService = new (0, _exerciseService.ExerciseService)(this.nextClass);
                (0, _renderEventService.RenderEventService).emitTimerNextWorkoutEvent(this.nextClass, this.currentExerciseService.getTask(0), this.currentExerciseService.getWorkRestTime());
                break;
            default:
                this.logger.error('Failed to emit next workout event: Invalid TV type in configuration.');
                break;
        }
    }
    /**
     * Returns an instance of the CoreService class.
     * If an instance does not exist, a new instance is created and returned.
     *
     * @returns {CoreService} The instance of the CoreService class.
     */ static getInstance() {
        if (!CoreService.instance) CoreService.instance = new CoreService();
        return CoreService.instance;
    }
    /**
     * Retrieves TV data.
     *
     * @returns {Promise<TvType>} A promise that resolves to the TV object.
     * @throws {Error} If TV is not found.
     */ async retrieveTvData() {
        try {
            const tv = await this.config.getTvInfo();
            if (!tv) throw new Error('TV not found');
            this.logger.info(`Fetching data for TV ID ${tv.id} with type ${tv.type}.`);
            //await this.dataFetchService.startFetching();
            this.initializeDataSubscriptions();
            return tv;
        } catch (error) {
            this.logger.error('Error retrieving TV data:', error);
            throw error;
        }
    }
}

},{"../utils/logger.utils":"jsBaU","../types/tvs.type":"jhV4I","../types/events.type":"5nuR4","./config.service":"gpIRk","../utils/datetime.utils":"cyuXt","./exercise.service":"9gto2","./renderEvent.service":"iEmGt","./api.service":"7NMyp","./classSchedule.service":"dNwU0","./mqtt.service":"jOOR7","../types/timer.type":"kWmyL","./dataFetch.service":"a31Zc","../utils/object.utils":"cAP0Z","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"jhV4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TvTypeEnum", ()=>TvTypeEnum);
var TvTypeEnum = /*#__PURE__*/ function(TvTypeEnum) {
    TvTypeEnum["Exercise"] = "exercise";
    TvTypeEnum["Timer"] = "timer";
    TvTypeEnum["Schedule"] = "schedule";
    TvTypeEnum["Billboard"] = "billboard";
    return TvTypeEnum;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"5nuR4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenderEvents", ()=>RenderEvents);
parcelHelpers.export(exports, "CoreEvents", ()=>CoreEvents);
parcelHelpers.export(exports, "MqttEvents", ()=>MqttEvents);
var RenderEvents = /*#__PURE__*/ function(RenderEvents) {
    RenderEvents["classWorkoutAboutToStart"] = "classWorkoutAboutToStart";
    RenderEvents["classDataUpdated"] = "classDataUpdated";
    RenderEvents["classWorkoutStart"] = "classWorkoutStart";
    RenderEvents["classNextWorkout"] = "classNextWorkout";
    RenderEvents["bookingClassesWrapper"] = "bookingClassesWrapper";
    RenderEvents["movementDataUpdated"] = "movementDataUpdated";
    RenderEvents["timerPreWorkout"] = "timerPreWorkout";
    RenderEvents["timerStartWorkout"] = "timerStartWorkout";
    return RenderEvents;
}({});
var CoreEvents = /*#__PURE__*/ function(CoreEvents) {
    CoreEvents["classWorkoutAboutToStart"] = "classWorkoutAboutToStart";
    CoreEvents["classDataUpdated"] = "classDataUpdated";
    CoreEvents["classWorkoutStart"] = "classWorkoutStart";
    CoreEvents["classNextWorkout"] = "classNextWorkout";
    CoreEvents["bookingClassesWrapper"] = "bookingClassesWrapper";
    CoreEvents["bookingDataUpdated"] = "bookingDataUpdated";
    CoreEvents["movementDataUpdated"] = "movementDataUpdated";
    return CoreEvents;
}({});
var MqttEvents = /*#__PURE__*/ function(MqttEvents) {
    MqttEvents["onMessage"] = "mqttOnMessage";
    MqttEvents["sendMessage"] = "mqttSendMessage";
    MqttEvents["connect"] = "mqttConnect";
    MqttEvents["disconnect"] = "mqttDisconnect";
    return MqttEvents;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"gpIRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The ConfigService class provides methods for managing configuration settings.
 */ parcelHelpers.export(exports, "ConfigService", ()=>ConfigService);
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
var _querystringUtils = require("../utils/querystring.utils");
class ConfigService {
    // #region Members
    apiUrl = '';
    language = 'en';
    filesStorageUrl = '';
    studioId = '1';
    tvId = '';
    tvInfo = undefined;
    classDate = '';
    classInstanceId;
    autoStart = false;
    setDate = '';
    setTime = '';
    currentTv;
    logger;
    exercisesTaskDelay = 25000;
    classAboutToStartTime = 60000;
    tvDataUpdateInterval = 60000;
    mqttUrl = "wss://api.basezero.pt:9001";
    mqttUsername = "basezero-tvs";
    mqttPassword = "baseZero2025#sal3";
    // #endregion
    // #region Constructor
    static instance;
    /**
     * Initializes the ConfigService.
     */ constructor(){
        this.logger = (0, _loggerUtilsDefault.default).getLogger('ConfigService');
        // Initialize configuration values
        try {
            this.initializeConfig();
            this.setFilesStorageUrl('https://d2mzg9hfabghhj.cloudfront.net/'); // Set the files storage URL
            this.getTvInfo().then((tvInfo)=>{
                this.currentTv = tvInfo;
            });
        } catch (error) {
            this.logger.error(error);
        }
        this.logger.info('Initialized');
        this.logger.debug('Config:', this);
    }
    /**
     * Initializes the configuration based on environment and query string values.
     */ initializeConfig() {
        const apiUrl = "https://api.basezero.pt";
        let tvId = undefined;
        // Overwrite `tvId` if `tv` parameter exists in query string
        const tvIdFromQuery = (0, _querystringUtils.QueryString).getTvId();
        if (tvIdFromQuery) tvId = tvIdFromQuery;
        // Perform sanity checks
        if (!apiUrl) throw new Error('API URL not provided');
        //if (!tvId) throw new Error('TV ID not provided');
        this.apiUrl = apiUrl;
        this.tvId = tvId ? tvId : '';
        this.fetchAndSetFilesStorageUrl();
        // Load optional environment variables
        this.exercisesTaskDelay = Number("1") || 25000;
        this.classAboutToStartTime = Number("60000") || 60000;
        this.tvDataUpdateInterval = Number("60000") || 60000;
        this.mqttUrl = "wss://api.basezero.pt:9001";
        this.mqttUsername = "basezero-tvs";
        this.mqttPassword = "baseZero2025#sal3";
        // Load optional query params
        this.classInstanceId = (0, _querystringUtils.QueryString).getClassInstanceId();
        this.autoStart = (0, _querystringUtils.QueryString).getAutoStart() === "true" ? true : false;
        this.setDate = (0, _querystringUtils.QueryString).getSetDate() || '';
        this.setTime = (0, _querystringUtils.QueryString).getSetTime() || '';
        this.studioId = (0, _querystringUtils.QueryString).getStudioId() || "hZyz";
    }
    /**
     * Returns an instance of the ConfigService class.
     * If an instance does not exist, a new instance is created and returned.
     *
     * @returns {ConfigService} The ConfigService instance.
     */ static getInstance() {
        if (!ConfigService.instance) ConfigService.instance = new ConfigService();
        return ConfigService.instance;
    }
    // #endregion
    // #region Setters and Getters
    setApiUrl(apiUrl) {
        this.apiUrl = apiUrl;
    }
    getApiUrl() {
        return this.apiUrl;
    }
    setLanguage(language) {
        this.language = language;
    }
    getLanguage() {
        return this.language;
    }
    setFilesStorageUrl(filesStorageUrl) {
        this.filesStorageUrl = filesStorageUrl;
    }
    getFilesStorageUrl() {
        return this.filesStorageUrl;
    }
    setTvId(tvId) {
        this.tvId = tvId;
    }
    getTvId() {
        return this.tvId;
    }
    setTvInfo(tvInfo) {
        this.tvInfo = tvInfo;
    }
    getStudioId() {
        return this.studioId;
    }
    // #endregion
    // #region Private Methods
    /**
     * Fetches TV information from the API.
     *
     * @returns A promise that resolves to a TvType object or undefined in case of failure.
     */ async fetchTvInfo() {
        try {
            const response = await fetch(`${this.apiUrl}/tvs`);
            if (!response.ok) throw new Error('Failed to fetch TVs');
            const tvsData = await response.json();
            if (!tvsData) throw new Error('No TVs found');
            return this.getTvById(tvsData);
        } catch (error) {
            this.logger.error(error);
            return undefined;
        }
    }
    /**
     * Retrieves a TV by its ID from the given array of TVs.
     *
     * @param tvs - The array of TVs to search in.
     * @returns The TV object with the matching ID, or undefined if not found.
     */ getTvById(tvs) {
        const tv = tvs.find((tv)=>tv.id === Number(this.tvId));
        if (!tv) {
            this.logger.error('TV not found');
            return undefined;
        }
        return tv;
    }
    // #endregion
    // #region Public Methods
    /**
     * Retrieves the TV information.
     *
     * @returns A promise that resolves to a TvType object or undefined if the information is not available.
     */ async getTvInfo() {
        if (!this.tvInfo && this.apiUrl && this.tvId) {
            const tvInfo = await this.fetchTvInfo();
            if (tvInfo) this.setTvInfo(tvInfo);
            return tvInfo;
        }
        return this.tvInfo;
    }
    // Method to fetch the config and set the file storage URL
    fetchAndSetFilesStorageUrl() {
        fetch(this.apiUrl + '/tvs/config').then((response)=>{
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json(); // Assuming the response is JSON
        }).then((data)=>{
            // Assuming the config object contains 'filesStorageUrl' key
            if (data.filesStorageUrl) this.setFilesStorageUrl(data.filesStorageUrl); // Set the files storage URL from config
            else console.error('filesStorageUrl not found in config');
        }).catch((error)=>{
            console.error('There has been a problem with your fetch operation:', error);
        });
    }
}

},{"../utils/logger.utils":"jsBaU","../utils/querystring.utils":"j5Bu7","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"cyuXt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Utility class for date and time manipulation.
 */ parcelHelpers.export(exports, "DateTimeUtils", ()=>DateTimeUtils);
var _luxon = require("luxon");
class DateTimeUtils {
    /**
     * Calculates the number of seconds between the current time and a given target time.
     * If the target time is earlier than the current time, it assumes the target time is on the next day.
     *
     * @param targetTime - The target time in 'HH:MM:SS' format.
     * @returns The number of seconds until the target time.
     */ static calculateSecondsToTime(targetTime) {
        if (!targetTime) return 99999; // return a bin int - only triggered for a periodizaton preview
        // Get the current time
        const now = new Date();
        // Convert targetTime string to Date object
        let targetDate = DateTimeUtils.hoursToTime(targetTime);
        // If target time is earlier than now, assume the target time is the next day
        if (targetDate.getTime() < now.getTime()) // Add one day (24 hours in milliseconds)
        targetDate.setDate(targetDate.getDate() + 1);
        // Calculate the difference in seconds
        const differenceInMillis = targetDate.getTime() - now.getTime();
        return Math.floor(differenceInMillis / 1000);
    }
    /**
     * Converts a string in the format 'HH:MM:SS' to a Date object using today's date.
     *
     * @param hoursString - The string to convert to a Date object.
     * @returns A Date object representing the time on today's date.
     */ static hoursToTime2(hoursString) {
        const [targetHours, targetMinutes, targetSeconds] = hoursString.split(':').map(Number);
        // Create a Date object for the target time with today's date
        let targetDate = new Date();
        targetDate.setHours(targetHours, targetMinutes, targetSeconds, 0);
        return targetDate;
    }
    /**
     * Formats a time value in seconds into a string representation.
     * If the time exceeds 3600 seconds, it returns 'HH:MM:SS'.
     * If the time is between 60 and 3600 seconds, it returns 'MM:SS'.
     * Otherwise, it returns 'SS'.
     *
     * @param seconds - The time in seconds to format.
     * @returns The formatted time string.
     */ static formatTime(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor(seconds % 3600 / 60);
        const secs = seconds % 60;
        return seconds > 3600 ? `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}` : seconds >= 60 ? `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}` : `${secs.toString()} s`;
    }
    /**
     * Formats a date string to Portuguese locale in the format 'Weekday, DD/MM'.
     *
     * @param dateString - The ISO date string to format.
     * @returns The formatted date string in Portuguese locale.
     */ static formatDateToPortuguese(dateString) {
        if (!dateString) return undefined;
        const date = (0, _luxon.DateTime).fromISO(dateString).setLocale('pt');
        return date.toFormat("cccc, dd/MM");
    }
    /**
     * Formats a time string to 'HH:mm' format using Luxon.
     *
     * @param time - The time string in 'HH:MM:SS' format.
     * @returns The formatted time string in 'HH:mm' format.
     */ static formatTimeToHHMM(time) {
        const dateTime = (0, _luxon.DateTime).fromISO(`1970-01-01T${time}`, {
            zone: 'local'
        });
        return dateTime.toFormat('HH:mm');
    }
    /**
     * Gets the day of the week for a given date string.
     *
     * @param dateString - The date string to extract the day from.
     * @returns The day of the week as a string.
     */ static getDayOfWeek(dateString) {
        const daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        const date = new Date(dateString);
        return daysOfWeek[date.getDay()];
    }
    /**
     * Formats a date string to 'DD/MM' format.
     *
     * @param dateString - The date string to format.
     * @returns The formatted date string in 'DD/MM' format.
     */ static formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${day}/${month}`;
    }
    /**
         * Combines a date string and a time string into a Date object.
         * If dateStr is undefined, it defaults to today's date.
         * @param dateStr - The date string in "yyyy-mm-dd" format, or undefined.
         * @param timeStr - The time string in "hh:mm:ss" format.
         * @returns A Date object representing the combined date and time.
         */ static combineDateAndTime(dateStr, timeStr) {
        if (!dateStr) {
            // Use today's date
            const today = new Date();
            dateStr = today.toISOString().split('T')[0]; // Format: "yyyy-mm-dd"
        }
        // Handle time strings without seconds
        if (/^\d{2}:\d{2}$/.test(timeStr)) timeStr += ':00';
        const dateTimeStr = `${dateStr}T${timeStr}`;
        const dateTime = new Date(dateTimeStr);
        if (isNaN(dateTime.getTime())) throw new Error(`Invalid date or time format: date="${dateStr}", time="${timeStr}"`);
        return dateTime;
    }
    /**
  * Converts a time string ("hh:mm:ss") to a Date object representing today at that time.
  * @param timeStr - The time string in "hh:mm:ss" format.
  * @returns A Date object representing today at the given time.
  */ static hoursToTime(timeStr) {
        const now = new Date();
        const [hours, minutes, seconds] = timeStr.split(':').map(Number);
        // Create a new Date object for today with the specified time
        const dateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds || 0, 0);
        if (isNaN(dateTime.getTime())) throw new Error(`Invalid time format: "${timeStr}"`);
        return dateTime;
    }
}

},{"luxon":"02bIE","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"02bIE":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var LuxonError = /*#__PURE__*/ function(_Error) {
    _inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
/**
 * @private
 */ var InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    _inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */ var InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    _inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */ var InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    _inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */ var ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */ var InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    _inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */ var InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    _inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */ var ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}(LuxonError);
/**
 * @private
 */ var n = "numeric", s = "short", l = "long";
var DATE_SHORT = {
    year: n,
    month: n,
    day: n
};
var DATE_MED = {
    year: n,
    month: s,
    day: n
};
var DATE_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s
};
var DATE_FULL = {
    year: n,
    month: l,
    day: n
};
var DATE_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l
};
var TIME_SIMPLE = {
    hour: n,
    minute: n
};
var TIME_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n
};
var TIME_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
var TIME_24_SIMPLE = {
    hour: n,
    minute: n,
    hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: l
};
var DATETIME_SHORT = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    second: n
};
var DATETIME_MED = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n
};
var DATETIME_MED_WITH_SECONDS = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n,
    second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s,
    hour: n,
    minute: n
};
var DATETIME_FULL = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
var DATETIME_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
/**
 * @interface
 */ var Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new ZoneIsAbstractError();
    };
    _createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var SystemZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    _createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if (singleton$1 === null) singleton$1 = new SystemZone();
                return singleton$1;
            }
        }
    ]);
    return SystemZone;
}(Zone);
var dtfCache = new Map();
function makeDTF(zoneName) {
    var dtf = dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var IANAZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = ianaZoneCache.get(name);
        if (zone === undefined) ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    };
    IANAZone.resetCache = function resetCache() {
        ianaZoneCache.clear();
        dtfCache.clear();
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    _createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}(Zone);
var _excluded = [
    "base"
], _excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var intlLFCache = {};
function getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        intlLFCache[key] = dtf;
    }
    return dtf;
}
var intlDTCache = new Map();
function getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        intlDTCache.set(key, dtf);
    }
    return dtf;
}
var intlNumCache = new Map();
function getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        intlNumCache.set(key, inf);
    }
    return inf;
}
var intlRelCache = new Map();
function getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, _excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        intlRelCache.set(key, inf);
    }
    return inf;
}
var sysLocaleCache = null;
function systemLocale() {
    if (sysLocaleCache) return sysLocaleCache;
    else {
        sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return sysLocaleCache;
    }
}
var intlResolvedOptionsCache = new Map();
function getCachedIntResolvedOptions(locString) {
    var opts = intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var weekInfoCache = new Map();
function getCachedWeekInfo(locString) {
    var data = weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = _extends({}, fallbackWeekSettings, data);
        weekInfoCache.set(locString, data);
    }
    return data;
}
function parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = _objectWithoutPropertiesLoose(opts, _excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = _extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
            return padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = _extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return _extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = _extends({
            style: "long"
        }, opts);
        if (!isEnglish && hasRelative()) this.rtf = getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
        var numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
        var weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        sysLocaleCache = null;
        intlDTCache.clear();
        intlNumCache.clear();
        intlRelCache.clear();
        intlResolvedOptionsCache.clear();
        weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone(_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone(_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return listStuff(this, length, months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return listStuff(this, length, weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return listStuff(this, undefined, function() {
            return meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    DateTime.utc(2016, 11, 13, 9),
                    DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return listStuff(this, length, eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                DateTime.utc(-40, 1, 1),
                DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!hasLocaleWeekInfo()) return fallbackWeekSettings;
        else return getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    _createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone(signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return formatOffset(this.fixed, format);
    };
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    _createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if (singleton === null) singleton = new FixedOffsetZone(0);
                return singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}(Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var InvalidZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    _createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}(Zone);
/**
 * @private
 */ function normalizeZone(input, defaultZone) {
    if (isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof Zone) return input;
    else if (isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
        else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
    } else if (isNumber(input)) return FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new InvalidZone(input);
}
var numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search(numberingSystems.hanidec) !== -1) value += hanidecChars.indexOf(str[i]);
            else for(var key in numberingSystemsUTF16){
                var _numberingSystemsUTF = numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var digitRegexCache = new Map();
function resetDigitRegexCache() {
    digitRegexCache.clear();
}
function digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var now = function now() {
    return Date.now();
}, defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        Locale.resetCache();
        IANAZone.resetCache();
        DateTime.resetCache();
        resetDigitRegexCache();
    };
    _createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return now;
            },
            set: function set(n) {
                now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return normalizeZone(defaultZone, SystemZone.instance);
            },
            set: function set(zone) {
                defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return defaultLocale;
            },
            set: function set(locale) {
                defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return defaultWeekSettings;
            },
            set: function set(weekSettings) {
                defaultWeekSettings = validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return throwOnInvalid;
            },
            set: function set(t) {
                throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function unitOutOfRange(unit, value) {
    return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
    return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
    var table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return _extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, timeObject(gregObj));
}
function weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return _extends({
        year: year,
        month: month,
        day: day
    }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = computeOrdinal(year, month, day);
    return _extends({
        year: year,
        ordinal: ordinal
    }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return _extends({
        year: year,
        month: month,
        day: day
    }, timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
    if (!validYear) return unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function hasInvalidOrdinalData(obj) {
    var validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function hasInvalidGregorianData(obj) {
    var validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validMonth) return unitOutOfRange("month", obj.month);
    else if (!validDay) return unitOutOfRange("day", obj.day);
    else return false;
}
function hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
    if (!validHour) return unitOutOfRange("hour", hour);
    else if (!validMinute) return unitOutOfRange("minute", minute);
    else if (!validSecond) return unitOutOfRange("second", second);
    else if (!validMillisecond) return unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function isUndefined(o) {
    return typeof o === "undefined";
}
function isNumber(o) {
    return typeof o === "number";
}
function isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
    return typeof o === "string";
}
function isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new InvalidArgumentError("Week settings must be an object");
    else {
        if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !integerBetween(v, 1, 7);
        })) throw new InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function integerBetween(thing, bottom, top) {
    return isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function parseInteger(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function parseFloating(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if (isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
    var modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
    if (year > 99) return year;
    else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = _extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if (hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + padStart(hours, 2) + padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function timeObject(obj) {
    return pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function months(length) {
    switch(length){
        case "narrow":
            return [].concat(monthsNarrow);
        case "short":
            return [].concat(monthsShort);
        case "long":
            return [].concat(monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat(weekdaysNarrow);
        case "short":
            return [].concat(weekdaysShort);
        case "long":
            return [].concat(weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var meridiems = [
    "AM",
    "PM"
];
var erasLong = [
    "Before Christ",
    "Anno Domini"
];
var erasShort = [
    "BC",
    "AD"
];
var erasNarrow = [
    "B",
    "A"
];
function eras(length) {
    switch(length){
        case "narrow":
            return [].concat(erasNarrow);
        case "short":
            return [].concat(erasShort);
        case "long":
            return [].concat(erasLong);
        default:
            return null;
    }
}
function meridiemForDateTime(dt) {
    return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
    return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
    return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
    return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var _macroTokenToFormatOpts = {
    D: DATE_SHORT,
    DD: DATE_MED,
    DDD: DATE_FULL,
    DDDD: DATE_HUGE,
    t: TIME_SIMPLE,
    tt: TIME_WITH_SECONDS,
    ttt: TIME_WITH_SHORT_OFFSET,
    tttt: TIME_WITH_LONG_OFFSET,
    T: TIME_24_SIMPLE,
    TT: TIME_24_WITH_SECONDS,
    TTT: TIME_24_WITH_SHORT_OFFSET,
    TTTT: TIME_24_WITH_LONG_OFFSET,
    f: DATETIME_SHORT,
    ff: DATETIME_MED,
    fff: DATETIME_FULL,
    ffff: DATETIME_HUGE,
    F: DATETIME_SHORT_WITH_SECONDS,
    FF: DATETIME_MED_WITH_SECONDS,
    FFF: DATETIME_FULL_WITH_SECONDS,
    FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return _macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, _extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return padStart(n, p);
        var opts = _extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                _extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = "(?:" + offsetRegex.source + "?(?:\\[(" + ianaRegex.source + ")\\])?)?";
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + isoExtendedZone);
var isoTimeExtensionRegex = RegExp("(?:[Tt]" + isoTimeRegex.source + ")?");
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?");
var sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
function int(match, pos, fallback) {
    var m = match[pos];
    return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
    var item = {
        year: int(match, cursor),
        month: int(match, cursor + 1, 1),
        day: int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function extractISOTime(match, cursor) {
    var item = {
        hours: int(match, cursor, 0),
        minutes: int(match, cursor + 1, 0),
        seconds: int(match, cursor + 2, 0),
        milliseconds: parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function extractIANAZone(match, cursor) {
    var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$");
// ISO duration parsing
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate(parseFloating(yearStr)),
            months: maybeNegate(parseFloating(monthStr)),
            weeks: maybeNegate(parseFloating(weekStr)),
            days: maybeNegate(parseFloating(dayStr)),
            hours: maybeNegate(parseFloating(hourStr)),
            minutes: maybeNegate(parseFloating(minuteStr)),
            seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
        month: monthsShort.indexOf(monthStr) + 1,
        day: parseInteger(dayStr),
        hour: parseInteger(hourStr),
        minute: parseInteger(minuteStr)
    };
    if (secondStr) result.second = parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new FixedOffsetZone(offset)
    ];
}
function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
function extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
/*
 * @private
 */ function parseISODate(s) {
    return parse(s, [
        isoYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        isoWeekWithTimeExtensionRegex,
        extractISOWeekTimeAndOffset
    ], [
        isoOrdinalWithTimeExtensionRegex,
        extractISOOrdinalDateAndTime
    ], [
        isoTimeCombinedRegex,
        extractISOTimeAndOffset
    ]);
}
function parseRFC2822Date(s) {
    return parse(preprocessRFC2822(s), [
        rfc2822,
        extractRFC2822
    ]);
}
function parseHTTPDate(s) {
    return parse(s, [
        rfc1123,
        extractRFC1123Or850
    ], [
        rfc850,
        extractRFC1123Or850
    ], [
        ascii,
        extractASCII
    ]);
}
function parseISODuration(s) {
    return parse(s, [
        isoDuration,
        extractISODuration
    ]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
    return parse(s, [
        isoTimeOnly,
        extractISOTimeOnly
    ]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
    return parse(s, [
        sqlYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        sqlTimeCombinedRegex,
        extractISOTimeOffsetAndIANAZone
    ]);
}
var INVALID$2 = "Invalid Duration";
// unit conversion constants
var lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, casualMatrix = _extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, lowOrderMatrix), daysInYearAccurate = 365.2425, daysInMonthAccurate = 30.436875, accurateMatrix = _extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: daysInYearAccurate / 7,
        days: daysInYearAccurate,
        hours: daysInYearAccurate * 24,
        minutes: daysInYearAccurate * 1440,
        seconds: daysInYearAccurate * 86400,
        milliseconds: daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: daysInYearAccurate / 28,
        days: daysInYearAccurate / 4,
        hours: daysInYearAccurate * 24 / 4,
        minutes: daysInYearAccurate * 1440 / 4,
        seconds: daysInYearAccurate * 86400 / 4,
        milliseconds: daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: daysInMonthAccurate / 7,
        days: daysInMonthAccurate,
        hours: daysInMonthAccurate * 24,
        minutes: daysInMonthAccurate * 1440,
        seconds: daysInMonthAccurate * 86400,
        milliseconds: daysInMonthAccurate * 86400000
    }
}, lowOrderMatrix);
// units ordered by size
var orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var reverseUnits = orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : _extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new Duration(conf);
}
function durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = _createForOfIteratorHelperLoose(reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
    orderedUnits$1.reduceRight(function(previous, current) {
        if (!isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    orderedUnits$1.reduce(function(previous, current) {
        if (!isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? accurateMatrix : casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: normalizeObject(obj, Duration.normalizeUnit),
            loc: Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if (isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = _extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if (isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter(_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter(_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return _extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = _extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return durationToMillis(this.matrix, this.values);
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = asNumber(fn(this.values[k], k));
        }
        return clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = _extends({}, this.values, normalizeObject(values, Duration.normalizeUnit));
        return clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        normalizeValues(this.matrix, vals);
        return clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = removeZeroes(this.normalize().shiftToAll().toObject());
        return clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if (isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if (isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        normalizeValues(this.matrix, built);
        return clone$1(this, {
            values: built
        }, true);
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return clone$1(this, {
            values: negated
        }, true);
    };
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = removeZeroes(this.values);
        return clone$1(this, {
            values: vals
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    _createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
    if (!start || !start.isValid) return Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return Interval.invalid("missing or invalid end");
    else if (end < start) return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
        var validateError = validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map(friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    _createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = Settings.defaultZone;
        var proto = DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return normalizeZone(input, Settings.defaultZone);
    };
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || Locale.create(locale)).getStartOfWeek();
    };
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
    };
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || Locale.create(locale)).getWeekendDays().slice();
    };
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: hasRelative(),
            localeWeek: hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function _diff(earlier, later, units, opts) {
    var _highOrderDiffs = highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post(parseDigits(s));
        }
    };
}
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "[ " + NBSP + "]";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map(fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return stripInsensitivities(s) === stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return signedOffset(h, m);
        },
        groups: groups
    };
}
function simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function unitForToken(token, loc) {
    var one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp(escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return oneOf(loc.eras("short"), 0);
            case "GG":
                return oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return intUnit(oneToSix);
            case "yy":
                return intUnit(twoToFour, untruncateYear);
            case "yyyy":
                return intUnit(four);
            case "yyyyy":
                return intUnit(fourToSix);
            case "yyyyyy":
                return intUnit(six);
            // months
            case "M":
                return intUnit(oneOrTwo);
            case "MM":
                return intUnit(two);
            case "MMM":
                return oneOf(loc.months("short", true), 1);
            case "MMMM":
                return oneOf(loc.months("long", true), 1);
            case "L":
                return intUnit(oneOrTwo);
            case "LL":
                return intUnit(two);
            case "LLL":
                return oneOf(loc.months("short", false), 1);
            case "LLLL":
                return oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return intUnit(oneOrTwo);
            case "dd":
                return intUnit(two);
            // ordinals
            case "o":
                return intUnit(oneToThree);
            case "ooo":
                return intUnit(three);
            // time
            case "HH":
                return intUnit(two);
            case "H":
                return intUnit(oneOrTwo);
            case "hh":
                return intUnit(two);
            case "h":
                return intUnit(oneOrTwo);
            case "mm":
                return intUnit(two);
            case "m":
                return intUnit(oneOrTwo);
            case "q":
                return intUnit(oneOrTwo);
            case "qq":
                return intUnit(two);
            case "s":
                return intUnit(oneOrTwo);
            case "ss":
                return intUnit(two);
            case "S":
                return intUnit(oneToThree);
            case "SSS":
                return intUnit(three);
            case "u":
                return simple(oneToNine);
            case "uu":
                return simple(oneOrTwo);
            case "uuu":
                return intUnit(one);
            // meridiem
            case "a":
                return oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return intUnit(four);
            case "kk":
                return intUnit(twoToFour, untruncateYear);
            // weekNumber (W)
            case "W":
                return intUnit(oneOrTwo);
            case "WW":
                return intUnit(two);
            // weekdays
            case "E":
            case "c":
                return intUnit(one);
            case "EEE":
                return oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if (hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!isUndefined(matches.z)) zone = IANAZone.create(matches.z);
    if (!isUndefined(matches.Z)) {
        if (!zone) zone = new FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!isUndefined(matches.u)) matches.S = parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var dummyDateTimeCache = null;
function getDummyDateTime() {
    if (!dummyDateTimeCache) dummyDateTimeCache = DateTime.fromMillis(1555555555555);
    return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = Formatter.macroTokenToFormatOpts(token.val);
    var tokens = formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    _createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function explainFromTokens(locale, input, format) {
    var parser = new TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
    var _explainFromTokens = explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter(getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var INVALID = "Invalid DateTime";
var MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
    return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new DateTime(_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
    return fixOffset(objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = _extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = objToLocalTS(c);
    var _fixOffset = fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, _extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? Formatter.create(Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function _toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += padStart(o.c.day);
    return c;
}
function _toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += padStart(o.c.second);
                }
            } else {
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += padStart(Math.trunc(o.o / 60));
            c += ":";
            c += padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function guessOffsetForZone(zone) {
    if (zoneOffsetTs === undefined) zoneOffsetTs = Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset(zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset(zoneOffsetTs);
        zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
    var zone = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
    var loc = Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if (isUndefined(obj[u])) obj[u] = defaultUnitValues[u];
        }
        var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
        if (invalid) return DateTime.invalid(invalid);
        var offsetProvis = guessOffsetForZone(zone);
        var _objToTS = objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = Settings.now();
    return new DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function diffRelative(start, end, opts) {
    var round = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = _createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = FixedOffsetZone.utcInstance;
        return quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!isNumber(milliseconds)) throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!isNumber(seconds)) throw new InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        var loc = Locale.fromObject(opts);
        var normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = orderedWeekUnits;
            defaultValues = defaultWeekUnitValues;
            objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = orderedOrdinalUnits;
            defaultValues = defaultOrdinalUnitValues;
            objNow = gregorianToOrdinal(objNow);
        } else {
            units = orderedUnits;
            defaultValues = defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = _createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if (isUndefined(text) || isUndefined(fmt)) throw new InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        zoneOffsetTs = undefined;
        zoneOffsetGuessCache.clear();
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = tsToObj(ts1, o1);
        var c2 = tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            clone(this, {
                ts: ts1
            }),
            clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone(FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone(Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = normalizeZone(zone, Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = weekToGregorian(_extends({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!isUndefined(normalized.ordinal)) mixed = ordinalToGregorian(_extends({}, gregorianToOrdinal(this.c), normalized));
        else {
            mixed = _extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if (isUndefined(normalized.day)) mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return clone(this, adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration).negate();
        return clone(this, adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        var ext = format === "extended";
        var c = _toISODate(this, ext, precision);
        if (orderedUnits.indexOf(precision) >= 3) c += "T";
        c += _toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    };
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return _toISODate(this, format === "extended", normalizeUnit(precision));
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        var c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + _toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return _toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : INVALID;
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = _extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = _extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = _diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return diffRelative(base, this.plus(padding), _extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, _extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("min requires all arguments be DateTimes");
        return bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("max requires all arguments be DateTimes");
        return bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new TokenParser(localeToUse, fmt);
    };
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if (isUndefined(text) || isUndefined(formatParser)) throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    };
    _createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function friendlyDateTime(dateTimeish) {
    if (DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) return DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return DateTime.fromObject(dateTimeish);
    else throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var VERSION = "3.7.1";
exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.Settings = Settings;
exports.SystemZone = SystemZone;
exports.VERSION = VERSION;
exports.Zone = Zone;

},{}],"9gto2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExerciseService", ()=>ExerciseService);
var _datetimeUtils = require("../utils/datetime.utils");
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
class ExerciseService {
    logger;
    classSchedule;
    tasks;
    onExerciceComplete;
    onTask;
    currentIndex;
    remainingTime;
    timer;
    exercisesTaskDelay = 1000;
    isFirstRun = true;
    taskStartTime = 0;
    isTaskRunning = false;
    currentTask = null;
    constructor(classSchedule, exercisesTaskDelay, onExerciceComplete, onTask){
        this.logger = (0, _loggerUtilsDefault.default).getLogger("ExerciseService");
        this.classSchedule = classSchedule;
        this.onExerciceComplete = onExerciceComplete || (()=>{});
        this.onTask = onTask;
        this.currentIndex = 0;
        this.remainingTime = 0;
        this.timer = null;
        this.tasks = this.exerciseTasks(classSchedule);
        this.exercisesTaskDelay = exercisesTaskDelay || this.exercisesTaskDelay;
    }
    /**
     * Cleans up the service, stops the timer if running,
     * and releases resources to prevent memory leaks.
     */ destroy() {
        // Stop any ongoing process
        this.stop();
        // Nullify references to help with garbage collection
        this.onExerciceComplete = ()=>{};
        this.onTask = undefined;
        this.currentTask = null;
        this.tasks = [];
        this.classSchedule = null; // Type-casting as any to allow null assignment if strict null checks are enabled
    }
    // Start or resume the emission process
    play() {
        if (this.timer) // Already running
        return;
        if (this.remainingTime > 0) {
            this.taskStartTime = Date.now();
            if (this.isTaskRunning) // Resume current task
            this.timer = setTimeout(()=>{
                // Task ends
                this.isTaskRunning = false;
                this.remainingTime = 0;
                this.currentIndex++;
                if (this.currentIndex < this.tasks.length) this.scheduleNextTask();
                else if (this.onExerciceComplete) this.onExerciceComplete(this.classSchedule);
            }, this.remainingTime);
            else // Resume delay before task starts
            this.timer = setTimeout(()=>{
                this.startTask(this.currentTask);
            }, this.remainingTime);
        } else // Start next task
        this.scheduleNextTask();
    }
    // Pause the emission process
    pause() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
            const elapsedTime = Date.now() - this.taskStartTime;
            if (this.isTaskRunning) {
                const taskDuration = this.currentTask ? this.currentTask.time * 1000 : 0;
                this.remainingTime = taskDuration - elapsedTime;
            } else // Before task starts
            this.remainingTime -= elapsedTime;
        }
    }
    // Restart the emission process from the beginning
    restart() {
        this.pause();
        this.currentIndex = 0;
        this.remainingTime = 0;
        this.isFirstRun = true;
        this.play();
    }
    // Stop the emission process
    stop() {
        this.pause();
        this.currentIndex = 0;
        this.remainingTime = 0;
        this.isFirstRun = true;
    }
    getTask(index = 0) {
        return this.tasks[index];
    }
    /**
     * 
     * @returns The first founded work and rest times
     */ getWorkRestTime() {
        /* If a group routine - like pilates - the rest was replaced by the hydrate */ const findRestByProp = this.tasks.find((w)=>w.type === "work")?.is_group_routine ? 'hydrate' : 'rest';
        return {
            work_time: this.tasks.find((w)=>w.type === "work")?.time || 0,
            rest_time: this.tasks.find((w)=>w.type === findRestByProp)?.time || 0
        };
    }
    scheduleNextTask() {
        if (this.currentIndex >= this.tasks.length) return;
        const currentTask = this.tasks[this.currentIndex];
        this.currentTask = currentTask;
        this.isTaskRunning = false;
        // Calculate the delay before starting the task
        const delay = this.isFirstRun ? 0 : this.exercisesTaskDelay;
        this.taskStartTime = Date.now();
        this.remainingTime = delay;
        if (delay === 0) this.startTask(currentTask);
        else this.timer = setTimeout(()=>{
            this.startTask(currentTask);
        }, delay);
        this.isFirstRun = false;
    }
    startTask(currentTask) {
        this.isTaskRunning = true;
        this.taskStartTime = Date.now();
        this.remainingTime = currentTask.time * 1000; // in milliseconds
        if (this.onTask) this.onTask(this.classSchedule, currentTask);
        this.timer = setTimeout(()=>{
            // Task ends
            this.isTaskRunning = false;
            this.remainingTime = 0;
            this.currentIndex++;
            if (this.currentIndex < this.tasks.length) this.scheduleNextTask();
            else if (this.onExerciceComplete) this.onExerciceComplete(this.classSchedule);
        }, this.remainingTime);
    }
    getGroupRoutinePhase(workout, phase) {
        // returning an array. some phases like lap and pod may have multiple routines
        return workout?.workout_group_routines?.filter((gr)=>gr.phase == phase)?.map((gr)=>gr.group_routine);
    }
    getRoutineForTransition(routines, transitionIndex) {
        if (!routines?.length) return undefined;
        // % is used to create a cycle on routines. 4 transitions but only 2 routines, it goes [0, 1, 0, 1]
        return routines[transitionIndex % routines.length];
    }
    exerciseTasks(schedule) {
        let tasks = [];
        if (!schedule) return tasks;
        const workout = schedule.workout;
        const isGroupWorkout = workout.workout_single_station ? true : false;
        const routinesByPhase = {
            start: this.getGroupRoutinePhase(workout, 'start'),
            pod: this.getGroupRoutinePhase(workout, 'pod'),
            lap: this.getGroupRoutinePhase(workout, 'lap'),
            end: this.getGroupRoutinePhase(workout, 'end')
        };
        let lapTransitionIndex = 0;
        let podTransitionIndex = 0;
        if (isGroupWorkout) // Handling Single Station workouts;
        for(let i = 0; i < workout.workout_single_station.exercises_count; i++){
            tasks.push({
                workout_id: workout.id,
                is_group_routine: true,
                type: "work",
                time: workout.workout_single_station.exercises_duration,
                pod: 1,
                current_pod: 1,
                current_lap: 1,
                remaining_laps: 1,
                stations: workout.workout_single_station.exercises_count,
                current_station: i + 1,
                current_set: 1,
                remaining_sets: 1,
                exercises_accumulated: i + 1
            });
            // avoid to add a rest/hydration task after the last exercise
            if (i < workout.workout_single_station.exercises_count - 1) tasks.push({
                workout_id: workout.id,
                type: "hydrate",
                is_group_routine: true,
                pod: 1,
                current_pod: 1,
                time: workout.workout_single_station.exercises_rest,
                current_lap: 1,
                remaining_laps: 1,
                stations: workout.workout_single_station.exercises_count,
                current_station: 0,
                current_set: 0,
                remaining_sets: 0
            });
        }
        else {
            // Handling Movement and Pod config workouts;
            const hydration_type = workout.hydration_type;
            const numberOfPods = !workout.is_single_pod ? workout.movement.pods : 1;
            for(let i = 0; i < numberOfPods; i++){
                // Access only the first element of workout.pod_config
                if (workout.pod_config.length > 0) {
                    const pod = workout.pod_config[0];
                    if (pod.is_amrap) pod.laps.forEach((lap, lapIndex)=>{
                        const currentLap = lapIndex + 1;
                        const remainingLaps = pod.laps.length - currentLap;
                        for(let set = 1; set <= lap.sets; set++){
                            const currentSet = set;
                            const remainingSets = lap.sets - set;
                            tasks.push({
                                workout_id: workout.id,
                                type: "work",
                                time: lap.work,
                                pod: pod.pod_number,
                                current_pod: i + 1,
                                current_lap: currentLap,
                                remaining_laps: remainingLaps,
                                stations: pod.stations,
                                current_station: 0,
                                current_set: currentSet,
                                remaining_sets: remainingSets
                            });
                        }
                        // Add lap routine ONLY if not last lap
                        const isLastLap = lapIndex === pod.laps.length - 1;
                        if (!isLastLap) {
                            const lapRoutine = this.getRoutineForTransition(routinesByPhase.lap, lapTransitionIndex);
                            if (lapRoutine) this.addGroupRoutinePhaseTasks(tasks, workout, lapRoutine, 'lap');
                            lapTransitionIndex++;
                        }
                        if (hydration_type === "lap" && workout.hydration_break > 0) tasks.push({
                            workout_id: workout.id,
                            type: "hydrate",
                            pod: pod.pod_number,
                            current_pod: i + 1,
                            time: workout.hydration_break,
                            current_lap: currentLap,
                            remaining_laps: remainingLaps,
                            stations: pod.stations,
                            current_station: 0,
                            current_set: 0,
                            remaining_sets: 0
                        });
                    });
                    else pod.laps.forEach((lap, lapIndex)=>{
                        const currentLap = lapIndex + 1;
                        const remainingLaps = pod.laps.length - currentLap;
                        for(let station = 0; station < pod.stations; station++){
                            const currentStation = station + 1;
                            for(let set = 1; set <= lap.sets; set++){
                                const currentSet = set;
                                const remainingSets = lap.sets - set;
                                tasks.push({
                                    workout_id: workout.id,
                                    type: "work",
                                    time: lap.work,
                                    pod: pod.pod_number,
                                    current_pod: i + 1,
                                    current_lap: currentLap,
                                    remaining_laps: remainingLaps,
                                    stations: pod.stations,
                                    current_station: currentStation,
                                    current_set: currentSet,
                                    remaining_sets: remainingSets,
                                    isAmrap: pod.is_amrap ? true : false
                                });
                                if (!pod.is_amrap) tasks.push({
                                    workout_id: workout.id,
                                    type: "rest",
                                    time: lap.rest,
                                    pod: pod.pod_number,
                                    current_pod: i + 1,
                                    current_lap: currentLap,
                                    remaining_laps: remainingLaps,
                                    stations: pod.stations,
                                    current_station: currentStation,
                                    current_set: currentSet,
                                    remaining_sets: remainingSets
                                });
                            }
                        }
                        const isLastLap = currentLap == pod.laps.length;
                        if (!isLastLap) {
                            const lapRoutine = this.getRoutineForTransition(routinesByPhase.lap, lapTransitionIndex);
                            if (lapRoutine) this.addGroupRoutinePhaseTasks(tasks, workout, lapRoutine, 'lap');
                            lapTransitionIndex++;
                        }
                        if (hydration_type === "lap" && workout.hydration_break > 0) tasks.push({
                            workout_id: workout.id,
                            type: "hydrate",
                            pod: pod.pod_number,
                            current_pod: i + 1,
                            time: workout.hydration_break,
                            current_lap: currentLap,
                            remaining_laps: remainingLaps,
                            stations: pod.stations,
                            current_station: 0,
                            current_set: 0,
                            remaining_sets: 0
                        });
                    });
                }
                const isLastPod = numberOfPods == i + 1;
                if (!isLastPod) {
                    const podRoutine = this.getRoutineForTransition(routinesByPhase.pod, podTransitionIndex);
                    if (podRoutine) this.addGroupRoutinePhaseTasks(tasks, workout, podRoutine, 'pod');
                    podTransitionIndex++;
                }
                if (hydration_type === "pod" && workout.hydration_break > 0) tasks.push({
                    workout_id: workout.id,
                    type: "hydrate",
                    time: workout.hydration_break,
                    pod: 0,
                    current_pod: i + 1,
                    current_lap: 0,
                    remaining_laps: 0,
                    stations: 0,
                    current_station: 0,
                    current_set: 0,
                    remaining_sets: 0
                });
            }
            this.setStationAndPodChange(tasks);
            // Remove rest before hydrate
            tasks = this.removeRestBeforeHydrate(tasks);
            // Remove last hydration task if it is the last task
            if (tasks[tasks.length - 1].type === "hydrate") tasks.pop();
            // Remove last rest task if it is the last task
            if (tasks[tasks.length - 1].type === "rest") tasks.pop();
        }
        // Adding warm up tasks
        if (workout.warmup?.exercises) {
            // Showing again the starting workout after the warmup
            tasks.unshift({
                workout_id: workout.id,
                is_group_routine: isGroupWorkout,
                type: "starting",
                is_transaction: true,
                time: 30,
                pod: 1,
                current_pod: 1,
                current_lap: 1,
                remaining_laps: 0,
                stations: 0,
                current_station: 1,
                current_set: 1,
                remaining_sets: 0,
                exercises_accumulated: 1
            });
            const startRoutine = routinesByPhase.start?.[0];
            if (startRoutine) /* Add it right after the warmup then we have the rest before the workout itself */ this.addGroupRoutinePhaseTasks(tasks, workout, startRoutine, 'start');
            for(let i = workout.warmup.exercises.length - 1; i >= 0; i--){
                const exerciseOrder = i + 1;
                tasks.unshift({
                    workout_id: workout.id,
                    type: "warmup",
                    time: workout.warmup.exercises_duration,
                    pod: 0,
                    current_lap: 0,
                    remaining_laps: 0,
                    stations: 0,
                    current_station: 0,
                    current_set: exerciseOrder,
                    exercises_total: workout.warmup.exercises_count,
                    exercises_accumulated: i + 1,
                    remaining_sets: workout.warmup.exercises_count - exerciseOrder,
                    current_pod: 1
                });
            }
        } else {
            /* When we don't have warmup we add the start routine and rest if exists.. */ const startRoutine = routinesByPhase.start?.[0];
            if (startRoutine) {
                tasks.unshift({
                    workout_id: workout.id,
                    is_group_routine: isGroupWorkout,
                    type: "starting",
                    is_transaction: true,
                    time: 30,
                    pod: 1,
                    current_pod: 1,
                    current_lap: 1,
                    remaining_laps: 0,
                    stations: 0,
                    current_station: 1,
                    current_set: 1,
                    remaining_sets: 0,
                    exercises_accumulated: 1
                });
                this.addGroupRoutinePhaseTasks(tasks, workout, startRoutine, 'start');
            }
        }
        tasks.unshift({
            workout_id: workout.id,
            is_group_routine: isGroupWorkout,
            type: "introduction",
            time: 45,
            pod: 0,
            current_pod: 0,
            current_lap: 0,
            remaining_laps: 0,
            stations: 0,
            current_station: 0,
            current_set: 0,
            remaining_sets: 0
        });
        // Add routine at the end if exist
        const endRoutine = routinesByPhase.end?.[0];
        if (endRoutine) this.addGroupRoutinePhaseTasks(tasks, workout, endRoutine, 'end');
        // Add ending task
        tasks.push({
            workout_id: workout.id,
            type: "ending",
            time: 60,
            pod: 0,
            current_pod: 0,
            current_lap: 0,
            remaining_laps: 0,
            stations: 0,
            current_station: 0,
            current_set: 0,
            remaining_sets: 0
        });
        tasks = this.addSetInformation(tasks);
        this.logger.info("Total time for the workout:", (0, _datetimeUtils.DateTimeUtils).formatTime(this.calculateTotalTime(tasks)));
        tasks = this.addTotalTime(tasks);
        if (!isGroupWorkout) tasks = this.setHydrateProperties(tasks);
        tasks = this.addPodTime(tasks);
        this.logger.debug("Exercise tasks:", tasks);
        return tasks;
    }
    addGroupRoutinePhaseTasks(tasks, workout, routine, phase) {
        const exercisesCount = routine.exercises_count;
        const phaseTasks = [];
        for(let i = 0; i < exercisesCount; i++){
            const exerciseNumber = i + 1;
            phaseTasks.push({
                workout_id: workout.id,
                is_group_routine: true,
                type: "group_exercise",
                routine_id: routine.id,
                phase,
                time: routine.exercises_duration,
                pod: 1,
                current_pod: 1,
                current_lap: 1,
                remaining_laps: 1,
                stations: exercisesCount,
                current_station: exerciseNumber,
                current_set: exerciseNumber,
                remaining_sets: exercisesCount - exerciseNumber,
                exercises_accumulated: exerciseNumber,
                exercises_total: exercisesCount
            });
        }
        if (phase === 'start') tasks.unshift(...phaseTasks);
        else tasks.push(...phaseTasks);
    }
    /**
     * Sets the station_change and pod_change properties for each task in the given array.
     *
     * @param tasks - An array of ExerciseTask objects.
     * @returns The modified array of ExerciseTask objects with updated station_change and pod_change properties.
     */ setStationAndPodChange(tasks) {
        for(let i = 0; i < tasks.length; i++)if (tasks[i].type === "work" || tasks[i].type === "rest") {
            // Find the next "work" task
            let nextWorkTask = tasks.slice(i + 1).find((task)=>task.type === "work");
            if (nextWorkTask) {
                // Set station_change to true if the next work task is in a different station
                tasks[i].station_change = nextWorkTask.current_station !== tasks[i].current_station;
                // Set pod_change to true if the next work task is in a different pod
                tasks[i].pod_change = nextWorkTask.pod !== tasks[i].pod;
            } else {
                tasks[i].station_change = false;
                tasks[i].pod_change = false;
            }
        }
        return tasks;
    }
    /**
     * Removes any "rest" tasks that are followed by a "hydrate" task from the given array.
     *
     * @param tasks - An array of ExerciseTask objects.
     * @returns The modified array of ExerciseTask objects with all "rest" tasks removed that are followed by a "hydrate" task.
     */ removeRestBeforeHydrate(tasks) {
        return tasks.filter((task, index, arr)=>{
            // Keep everything that is not of type "rest"
            if (task.type !== "rest") return true;
            // If current type is "rest", check if the next session is "hydrate"
            const nextTask = arr[index + 1];
            if (nextTask && nextTask.type === "hydrate") return false; // Skip this "rest" session
            // Keep the rest type if not followed by hydrate
            return true;
        });
    }
    /**
     * Calculates the total time for a given array of exercise tasks.
     *
     * @param tasks - The array of exercise tasks.
     * @returns The total time calculated from the sum of each task's time.
     */ calculateTotalTime(tasks) {
        return tasks.filter((task)=>task.type !== 'starting' && task.type !== 'ending').reduce((total, currentItem)=>total + currentItem.time, 0);
    }
    addSetInformation(tasks) {
        let accumulatedExercises = 0;
        let totalExercises = 0;
        // First, calculate the total number of work sets in the entire workout
        totalExercises = tasks.filter((w)=>w.type === 'work').length;
        // Iterate through the workouts and assign the accumulated set and total sets
        tasks.forEach((task)=>{
            // Increment the accumulated sets only for 'work' type
            if (task.type === 'work') accumulatedExercises++;
            if (task.type !== 'warmup' && task.type !== 'group_exercise') {
                // warmup should not be accounted to accumulatedExercises
                task.exercises_accumulated = accumulatedExercises;
                // Add new properties to the workout object - warmup doesn't need it because the exercises_total prop was already set
                task.exercises_total = totalExercises;
            }
        });
        return tasks;
    }
    addTotalTime(tasks) {
        // Calculate the total time by summing up the time of all elements excluding the type "ending" and "starting"
        let totalTime = tasks.reduce((acc, task)=>{
            if (task.type !== "ending" && task.type !== "introduction") return acc + task.time;
            return acc;
        }, 0);
        // Add the total_time property to each element except for the type "ending" and "starting"
        return tasks.map((task)=>{
            if (task.type !== "ending" && task.type !== "introduction") return {
                ...task,
                total_time: totalTime
            };
            return task;
        });
    }
    addPodTime(tasks) {
        // Step 1: Calculate the total time until the first hydration
        let podTime = tasks.reduce((acc, task)=>{
            if (acc.hydrationReached || task.type === "hydrate") {
                if (!task.is_group_routine) {
                    // groupRoutines hydrations are the standard rest - we count them as well to the pod total time
                    acc.hydrationReached = true; // Stop accumulating after the first hydration
                    return acc;
                }
            }
            if (task.type !== "ending" && task.type !== "introduction" && task.type !== "starting" && task.type !== "warmup") acc.totalTime += task.time;
            return acc;
        }, {
            totalTime: 0,
            hydrationReached: false
        }).totalTime;
        // Step 2: Map all tasks to include podDuration
        return tasks.map((task)=>({
                ...task,
                podDuration: task.type == 'warmup' || task.type == 'hydrate' && !task.is_group_routine ? 0 : podTime
            }));
    }
    setHydrateProperties(tasks) {
        let hydrateCount = 0;
        const totalHydrates = tasks.filter((w)=>w.type === "hydrate").length;
        return tasks.map((task)=>{
            if (task.type === "hydrate") {
                hydrateCount++;
                return {
                    ...task,
                    hydrate_active: hydrateCount,
                    hydrate_total: totalHydrates
                };
            } else return {
                ...task,
                hydrate_active: hydrateCount,
                hydrate_total: totalHydrates
            };
        });
    }
}

},{"../utils/datetime.utils":"cyuXt","../utils/logger.utils":"jsBaU","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"iEmGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenderEventService", ()=>RenderEventService);
var _eventsType = require("../types/events.type");
var _renderTypes = require("../types/render.types");
var _datetimeUtils = require("../utils/datetime.utils");
var _eventsService = require("./events.service");
var _eventsServiceDefault = parcelHelpers.interopDefault(_eventsService);
class RenderEventService {
    // Emit the next workout event
    static emitExerciseNextWorkoutEvent(classSchedule) {
        const classNextWorkout = {
            renderItemType: (0, _renderTypes.RenderItemType).EXERCISE_NEXT_WORKOUT,
            classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: (0, _datetimeUtils.DateTimeUtils).calculateSecondsToTime(classSchedule.start_time)
        };
        (0, _eventsServiceDefault.default).emit((0, _eventsType.RenderEvents).classNextWorkout, classNextWorkout);
    }
    // Emit the next workout event
    static emitTimerNextWorkoutEvent(classSchedule, task, timings) {
        if (!classSchedule || !task) return;
        const renderItemInfo = {
            exerciseTask: task,
            duration: task.time
        };
        const renderData = {
            renderItemType: (0, _renderTypes.RenderItemType).TIMER_PRE_WORKOUT,
            renderItemInfo: renderItemInfo,
            classSchedule: classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: task.time,
            rest_time: timings.rest_time,
            work_time: timings.work_time
        };
        (0, _eventsServiceDefault.default).emit((0, _eventsType.RenderEvents).timerPreWorkout, renderData);
    }
    static emitBookingDataEvent(booking) {
        if (!booking) return;
        let bookingClassesWrapper = {
            bookingClasses: booking
        };
        let renderItemInfo = {
            bookingClassesWrapper: bookingClassesWrapper
        };
        const renderItem = {
            renderItemType: (0, _renderTypes.RenderItemType).BOOKING,
            renderItemInfo: renderItemInfo
        };
        (0, _eventsServiceDefault.default).emit((0, _eventsType.RenderEvents).bookingClassesWrapper, renderItem);
    }
    // Emit movement data updated event
    static emitMovementEvent(classSchedule) {
        const renderItem = {
            renderItemType: (0, _renderTypes.RenderItemType).MOVEMENT,
            classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time
        };
        (0, _eventsServiceDefault.default).emit((0, _eventsType.RenderEvents).movementDataUpdated, renderItem);
    }
    // Emit timer event
    static emitTimerEvent(classSchedule, task) {
        if (!classSchedule || !task) return;
        const renderItemInfo = {
            exerciseTask: task,
            duration: task.time
        };
        const timerData = {
            renderItemType: (0, _renderTypes.RenderItemType).TIMER,
            renderItemInfo: renderItemInfo,
            classSchedule: classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: task.time
        };
        (0, _eventsServiceDefault.default).emit((0, _eventsType.RenderEvents).timerStartWorkout, timerData);
    }
    static emitExerciseTaskEvent = (classSchedule, task)=>{
        if (!classSchedule || !task) return;
        const renderItemInfo = {
            exerciseTask: task,
            duration: task.time
        };
        const renderItem = {
            renderItemType: (0, _renderTypes.RenderItemType).EXERCISE,
            renderItemInfo: renderItemInfo,
            classSchedule: classSchedule,
            date: classSchedule.date,
            time: classSchedule.start_time,
            duration: task.time
        };
        (0, _eventsServiceDefault.default).emit((0, _eventsType.RenderEvents).classWorkoutStart, renderItem);
    };
}

},{"../types/events.type":"5nuR4","../types/render.types":"4ztcW","../utils/datetime.utils":"cyuXt","./events.service":"hklsm","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4ztcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenderItemType", ()=>RenderItemType);
var RenderItemType = /*#__PURE__*/ function(RenderItemType) {
    RenderItemType["BOOKING"] = "BOOKING";
    RenderItemType["EXERCISE"] = "EXERCISE";
    RenderItemType["EXERCISE_NEXT_WORKOUT"] = "EXERCISE_NEXT_WORKOUT";
    RenderItemType["EXERCISE_ABOUT_TO_START"] = "EXERCISE_ABOUT_TO_START";
    RenderItemType["MOVEMENT"] = "MOVEMENT";
    RenderItemType["TIMER"] = "TIMER";
    RenderItemType["TIMER_PRE_WORKOUT"] = "TIMER_PRE_WORKOUT";
    return RenderItemType;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"hklsm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
// Create a shared instance of EventEmitter
const eventsService = new (0, _eventemitter3Default.default)();
exports.default = eventsService;

},{"eventemitter3":"g0kuJ","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"g0kuJ":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"7NMyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ApiService is a singleton class to fetch class, booking, and movement data from a remote server.
 * It ensures only one instance is used throughout the application and handles all API requests.
 */ parcelHelpers.export(exports, "ApiService", ()=>ApiService);
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
class ApiService {
    logger;
    static instance;
    baseUrl;
    tvId;
    studioCode;
    constructor(config){
        this.logger = (0, _loggerUtilsDefault.default).getLogger('ApiService');
        this.baseUrl = config.getApiUrl();
        this.tvId = config.getTvId();
        this.studioCode = config.getStudioId();
    }
    /**
     * Returns the singleton instance of ApiService.
     * @param config - Instance of ConfigService.
     */ static getInstance(config) {
        if (!ApiService.instance) ApiService.instance = new ApiService(config);
        return ApiService.instance;
    }
    /**
     * Generalized method to fetch data from the API.
     * @param endpoint - API endpoint to fetch data from.
     * @param queryParams - Optional query parameters to append to the URL.
     * @returns A Promise that resolves to the data of type T or undefined if there's an error.
     */ async fetchData(endpoint, queryParams) {
        try {
            // Construct the full URL
            let url = `${this.baseUrl}/tvs/content/${encodeURIComponent(this.tvId || '')}${endpoint}?studio_code=${encodeURIComponent(this.studioCode || '')}`;
            if (queryParams) url += `&${queryParams}`;
            this.logger.debug(`Fetching data from ${url}`);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            // Handle non-OK responses
            if (!response.ok) {
                this.logger.error(`Failed to fetch data from ${url}. Status: ${response.status}`);
                return undefined;
            }
            // Parse the response as JSON
            const data = await response.json();
            return data;
        } catch (error) {
            this.logger.error('Error fetching data:', error);
            return undefined;
        }
    }
    async fetchClassData(props) {
        const { date, classInstanceId } = props;
        // Build query string dynamically
        const queryParams = new URLSearchParams();
        if (date) queryParams.append('date', date);
        if (classInstanceId) queryParams.append('instance_id', classInstanceId.toString());
        // Fetch data
        const classData = await this.fetchData("", queryParams.toString());
        return classData;
    }
    /**
     * Fetches movement data for a specific date, if provided.
     * @param date - Optional date string to filter movement data.
     * @returns A Promise that resolves to ClassData or undefined in case of an error.
     */ async fetchMovementData(date) {
        const queryParams = date ? `date=${encodeURIComponent(date)}` : undefined;
        return this.fetchData("", queryParams);
    }
    /**
     * Fetches booking data.
     * @returns A Promise that resolves to BookingClasses or undefined in case of an error.
     */ async fetchBookingData(date) {
        const queryParams = date ? `date=${encodeURIComponent(date)}` : undefined;
        return this.fetchData("", queryParams);
    }
}

},{"../utils/logger.utils":"jsBaU","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"dNwU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Service for managing class schedules.
 */ parcelHelpers.export(exports, "ClassScheduleService", ()=>ClassScheduleService);
var _datetimeUtils = require("../utils/datetime.utils");
var _objectUtils = require("../utils/object.utils");
class ClassScheduleService {
    /**
     * Retrieves the first class schedule by class ID from the given class data.
     * 
     * @param classInstances - The class data containing the class schedules.
     * @param classInstanceId - The ID of the class schedule to search for.
     * @returns The first class schedule matching the given class ID, or undefined if not found.
     */ static getClassScheduleById(classInstances, classInstanceId) {
        if (classInstances) return classInstances.find((schedule)=>schedule.id === classInstanceId);
        return undefined;
    }
    /**
     * Retrieves a class schedule from the given class data based on the target time.
     * @param classInstances - The class data containing the schedules.
     * @param targetTime - The target time to search for in the schedules.
     * @returns The class schedule that matches the target time, or undefined if not found.
     */ static getClassScheduleByTime(classInstances, targetTime) {
        if (classInstances) return classInstances.find((schedule)=>schedule.start_time === targetTime);
        return undefined;
    }
    /**
  * Retrieves the next class schedule based on the provided class data and optional date.
  * 
  * @param classInstances - The class data containing the class schedules.
  * @param date - Optional date to use for comparison. If not provided, the current date will be used.
  * @returns The next class schedule or, if none found today, the earliest class schedule.
  */ static nextClassSchedule(classInstances, date) {
        if (classInstances) {
            if (classInstances.length === 1) return classInstances[0];
            const now = date ? date : new Date();
            // Keep only schedules that actually have a start_time
            const validSchedules = classInstances.filter((s)=>!!s.start_time);
            if ((0, _objectUtils.ObjectUtils).isNullOrEmpty(validSchedules)) return undefined;
            // Filter schedules that are in the future for the current day
            const futureSchedules = validSchedules.filter((schedule)=>{
                const scheduleDate = (0, _datetimeUtils.DateTimeUtils).hoursToTime(schedule.start_time);
                return scheduleDate > now;
            });
            if (futureSchedules.length > 0) {
                // Find the next class on the current day
                const nextClass = futureSchedules.reduce((prev, current)=>(0, _datetimeUtils.DateTimeUtils).hoursToTime(current.start_time) < (0, _datetimeUtils.DateTimeUtils).hoursToTime(prev.start_time) ? current : prev);
                return nextClass;
            }
            // If no future class found today, return the earliest class overall
            const earliestClass = validSchedules.reduce((prev, current)=>(0, _datetimeUtils.DateTimeUtils).hoursToTime(current.start_time) < (0, _datetimeUtils.DateTimeUtils).hoursToTime(prev.start_time) ? current : prev);
            return earliestClass;
        }
        return undefined;
    }
}

},{"../utils/datetime.utils":"cyuXt","../utils/object.utils":"cAP0Z","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"cAP0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUtils", ()=>ObjectUtils);
class ObjectUtils {
    static isNullOrEmpty(obj) {
        if (obj === null || obj === undefined) return true;
        if (typeof obj === 'string') return obj.trim().length === 0;
        if (Array.isArray(obj)) return obj.length === 0;
        if (typeof obj === 'object') return Object.keys(obj).length === 0;
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"jOOR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MqttService", ()=>MqttService);
var _eventemitter3 = require("eventemitter3");
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
var _eventsType = require("../types/events.type");
var _configService = require("./config.service");
var _mqtt = require("mqtt");
var _mqttDefault = parcelHelpers.interopDefault(_mqtt);
// MQTT options for reconnection
const options = {
    reconnectPeriod: 1000,
    connectTimeout: 4000,
    keepalive: 60
};
class MqttService extends (0, _eventemitter3.EventEmitter) {
    static instance;
    client = null;
    logger;
    config;
    // Constructor
    constructor(){
        super();
        this.logger = (0, _loggerUtilsDefault.default).getLogger('MqttService');
        this.config = (0, _configService.ConfigService).getInstance();
        this.connect(); // Start MQTT connection on initialization
    }
    static getInstance() {
        if (!MqttService.instance) MqttService.instance = new MqttService();
        return MqttService.instance;
    }
    // Establish MQTT connection with reconnection support
    connect() {
        const mqttUrl = this.config.mqttUrl; // Static MQTT broker URL from config
        this.logger.info('Connecting to MQTT broker:', mqttUrl);
        options.username = this.config.mqttUsername; // Set MQTT username
        options.password = this.config.mqttPassword; // Set MQTT password
        // Create MQTT client instance
        this.client = (0, _mqttDefault.default).connect(mqttUrl, options);
        // Handle successful connection
        this.client.on('connect', ()=>{
            this.logger.info('MQTT connected');
        });
        // Handle incoming MQTT messages
        this.client.on('message', (topic, message)=>{
            this.handleIncomingMessage(topic, message.toString());
        });
        // Handle connection close and reconnection attempts
        this.client.on('close', ()=>{
            this.logger.warn('MQTT connection closed');
        });
        // Handle MQTT errors
        this.client.on('error', (error)=>{
            this.logger.error('MQTT error:', error);
        });
        this.subscribe('displays/' + this.config.studioId + '/action'); // Subscribe to all basezero topics
    }
    // Subscribe to an MQTT topic
    subscribe(topic) {
        if (!this.client) {
            this.logger.error('Cannot subscribe, MQTT client is not connected.');
            return;
        }
        this.client.subscribe(topic, (error)=>{
            if (error) this.logger.error(`Error subscribing to topic "${topic}":`, error);
            else this.logger.info(`Subscribed to topic "${topic}"`);
        });
    }
    // Publish a message to an MQTT topic
    publish(topic, payload) {
        if (!this.client) {
            this.logger.error('Cannot publish, MQTT client is not connected.');
            return;
        }
        const message = JSON.stringify(payload);
        this.client.publish(topic, message, (error)=>{
            if (error) this.logger.error(`Error publishing to topic "${topic}":`, error);
            else this.logger.info(`Published message to topic "${topic}":`, message);
        });
    }
    // Handle incoming MQTT messages
    handleIncomingMessage(topic, data) {
        try {
            const message = JSON.parse(data);
            this.logger.debug('Received MQTT message:', message);
            this.emit((0, _eventsType.MqttEvents).onMessage, topic, message); // Emit event for the core class
        } catch (error) {
            this.logger.error('Error parsing MQTT message:', error);
        }
    }
}

},{"eventemitter3":"g0kuJ","../utils/logger.utils":"jsBaU","../types/events.type":"5nuR4","./config.service":"gpIRk","mqtt":"bp3z9","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"bp3z9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var hs = Object.defineProperty;
var $g = Object.getOwnPropertyDescriptor;
var Hg = Object.getOwnPropertyNames;
var Vg = Object.prototype.hasOwnProperty;
var Ae = (t, e)=>()=>(t && (e = t(t = 0)), e);
var O = (t, e)=>()=>(e || t((e = {
            exports: {}
        }).exports, e), e.exports), Ir = (t, e)=>{
    for(var r in e)hs(t, r, {
        get: e[r],
        enumerable: !0
    });
}, zg = (t, e, r, i)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let n of Hg(e))!Vg.call(t, n) && n !== r && hs(t, n, {
        get: ()=>e[n],
        enumerable: !(i = $g(e, n)) || i.enumerable
    });
    return t;
};
var Q = (t)=>zg(hs({}, "__esModule", {
        value: !0
    }), t);
var _ = Ae(()=>{});
var R = {};
Ir(R, {
    _debugEnd: ()=>fu,
    _debugProcess: ()=>cu,
    _events: ()=>Ru,
    _eventsCount: ()=>Cu,
    _exiting: ()=>Vl,
    _fatalExceptions: ()=>ou,
    _getActiveHandles: ()=>Ql,
    _getActiveRequests: ()=>Gl,
    _kill: ()=>Jl,
    _linkedBinding: ()=>$l,
    _maxListeners: ()=>Tu,
    _preload_modules: ()=>Su,
    _rawDebug: ()=>Fl,
    _startProfilerIdleNotifier: ()=>hu,
    _stopProfilerIdleNotifier: ()=>du,
    _tickCallback: ()=>uu,
    abort: ()=>yu,
    addListener: ()=>Pu,
    allowedNodeEnvironmentFlags: ()=>iu,
    arch: ()=>Cl,
    argv: ()=>Bl,
    argv0: ()=>Eu,
    assert: ()=>nu,
    binding: ()=>ql,
    chdir: ()=>Dl,
    config: ()=>zl,
    cpuUsage: ()=>ji,
    cwd: ()=>Nl,
    debugPort: ()=>vu,
    default: ()=>Nu,
    dlopen: ()=>Kl,
    domain: ()=>Hl,
    emit: ()=>Mu,
    emitWarning: ()=>Ll,
    env: ()=>kl,
    execArgv: ()=>xl,
    execPath: ()=>mu,
    exit: ()=>tu,
    features: ()=>su,
    hasUncaughtExceptionCaptureCallback: ()=>lu,
    hrtime: ()=>Di,
    kill: ()=>eu,
    listeners: ()=>Uu,
    memoryUsage: ()=>Zl,
    moduleLoadList: ()=>Wl,
    nextTick: ()=>Il,
    off: ()=>Bu,
    on: ()=>bt,
    once: ()=>ku,
    openStdin: ()=>ru,
    pid: ()=>wu,
    platform: ()=>Pl,
    ppid: ()=>_u,
    prependListener: ()=>Lu,
    prependOnceListener: ()=>qu,
    reallyExit: ()=>Yl,
    release: ()=>jl,
    removeAllListeners: ()=>Ou,
    removeListener: ()=>xu,
    resourceUsage: ()=>Xl,
    setSourceMapsEnabled: ()=>Au,
    setUncaughtExceptionCaptureCallback: ()=>au,
    stderr: ()=>gu,
    stdin: ()=>bu,
    stdout: ()=>pu,
    title: ()=>Rl,
    umask: ()=>Ul,
    uptime: ()=>Iu,
    version: ()=>Ol,
    versions: ()=>Ml
});
function gs(t) {
    throw new Error("Node.js process " + t + " is not supported by JSPM core outside of Node.js");
}
function Kg() {
    !Tr || !Gt || (Tr = !1, Gt.length ? gt = Gt.concat(gt) : Ni = -1, gt.length && Al());
}
function Al() {
    if (!Tr) {
        var t = setTimeout(Kg, 0);
        Tr = !0;
        for(var e = gt.length; e;){
            for(Gt = gt, gt = []; ++Ni < e;)Gt && Gt[Ni].run();
            Ni = -1, e = gt.length;
        }
        Gt = null, Tr = !1, clearTimeout(t);
    }
}
function Il(t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
    gt.push(new Tl(t, e)), gt.length === 1 && !Tr && setTimeout(Al, 0);
}
function Tl(t, e) {
    this.fun = t, this.array = e;
}
function _e() {}
function $l(t) {
    gs("_linkedBinding");
}
function Kl(t) {
    gs("dlopen");
}
function Gl() {
    return [];
}
function Ql() {
    return [];
}
function nu(t, e) {
    if (!t) throw new Error(e || "assertion error");
}
function lu() {
    return !1;
}
function Iu() {
    return kt.now() / 1e3;
}
function Di(t) {
    var e = Math.floor((Date.now() - kt.now()) * .001), r = kt.now() * .001, i = Math.floor(r) + e, n = Math.floor(r % 1 * 1e9);
    return t && (i = i - t[0], n = n - t[1], n < 0 && (i--, n += ps)), [
        i,
        n
    ];
}
function bt() {
    return Nu;
}
function Uu(t) {
    return [];
}
var gt, Tr, Gt, Ni, Rl, Cl, Pl, kl, Bl, xl, Ol, Ml, Ll, ql, Ul, Nl, Dl, jl, Fl, Wl, Hl, Vl, zl, Yl, Jl, ji, Xl, Zl, eu, tu, ru, iu, su, ou, au, uu, cu, fu, hu, du, pu, gu, bu, yu, wu, _u, mu, vu, Eu, Su, Au, kt, ds, ps, Tu, Ru, Cu, Pu, ku, Bu, xu, Ou, Mu, Lu, qu, Nu, Du = Ae(()=>{
    _();
    v();
    m();
    gt = [], Tr = !1, Ni = -1;
    Tl.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    Rl = "browser", Cl = "x64", Pl = "browser", kl = {
        PATH: "/usr/bin",
        LANG: navigator.language + ".UTF-8",
        PWD: "/",
        HOME: "/home",
        TMP: "/tmp"
    }, Bl = [
        "/usr/bin/node"
    ], xl = [], Ol = "v16.8.0", Ml = {}, Ll = function(t, e) {
        console.warn((e ? e + ": " : "") + t);
    }, ql = function(t) {
        gs("binding");
    }, Ul = function(t) {
        return 0;
    }, Nl = function() {
        return "/";
    }, Dl = function(t) {}, jl = {
        name: "node",
        sourceUrl: "",
        headersUrl: "",
        libUrl: ""
    };
    Fl = _e, Wl = [];
    Hl = {}, Vl = !1, zl = {};
    Yl = _e, Jl = _e, ji = function() {
        return {};
    }, Xl = ji, Zl = ji, eu = _e, tu = _e, ru = _e, iu = {};
    su = {
        inspector: !1,
        debug: !1,
        uv: !1,
        ipv6: !1,
        tls_alpn: !1,
        tls_sni: !1,
        tls_ocsp: !1,
        tls: !1,
        cached_builtins: !0
    }, ou = _e, au = _e;
    uu = _e, cu = _e, fu = _e, hu = _e, du = _e, pu = void 0, gu = void 0, bu = void 0, yu = _e, wu = 2, _u = 1, mu = "/bin/usr/node", vu = 9229, Eu = "node", Su = [], Au = _e, kt = {
        now: typeof performance < "u" ? performance.now.bind(performance) : void 0,
        timing: typeof performance < "u" ? performance.timing : void 0
    };
    kt.now === void 0 && (ds = Date.now(), kt.timing && kt.timing.navigationStart && (ds = kt.timing.navigationStart), kt.now = ()=>Date.now() - ds);
    ps = 1e9;
    Di.bigint = function(t) {
        var e = Di(t);
        return typeof BigInt > "u" ? e[0] * ps + e[1] : BigInt(e[0] * ps) + BigInt(e[1]);
    };
    Tu = 10, Ru = {}, Cu = 0;
    Pu = bt, ku = bt, Bu = bt, xu = bt, Ou = bt, Mu = _e, Lu = bt, qu = bt;
    Nu = {
        version: Ol,
        versions: Ml,
        arch: Cl,
        platform: Pl,
        release: jl,
        _rawDebug: Fl,
        moduleLoadList: Wl,
        binding: ql,
        _linkedBinding: $l,
        _events: Ru,
        _eventsCount: Cu,
        _maxListeners: Tu,
        on: bt,
        addListener: Pu,
        once: ku,
        off: Bu,
        removeListener: xu,
        removeAllListeners: Ou,
        emit: Mu,
        prependListener: Lu,
        prependOnceListener: qu,
        listeners: Uu,
        domain: Hl,
        _exiting: Vl,
        config: zl,
        dlopen: Kl,
        uptime: Iu,
        _getActiveRequests: Gl,
        _getActiveHandles: Ql,
        reallyExit: Yl,
        _kill: Jl,
        cpuUsage: ji,
        resourceUsage: Xl,
        memoryUsage: Zl,
        kill: eu,
        exit: tu,
        openStdin: ru,
        allowedNodeEnvironmentFlags: iu,
        assert: nu,
        features: su,
        _fatalExceptions: ou,
        setUncaughtExceptionCaptureCallback: au,
        hasUncaughtExceptionCaptureCallback: lu,
        emitWarning: Ll,
        nextTick: Il,
        _tickCallback: uu,
        _debugProcess: cu,
        _debugEnd: fu,
        _startProfilerIdleNotifier: hu,
        _stopProfilerIdleNotifier: du,
        stdout: pu,
        stdin: bu,
        stderr: gu,
        abort: yu,
        umask: Ul,
        chdir: Dl,
        cwd: Nl,
        env: kl,
        title: Rl,
        argv: Bl,
        execArgv: xl,
        pid: wu,
        ppid: _u,
        execPath: mu,
        debugPort: vu,
        hrtime: Di,
        argv0: Eu,
        _preload_modules: Su,
        setSourceMapsEnabled: Au
    };
});
var m = Ae(()=>{
    Du();
});
var ye = {};
Ir(ye, {
    Buffer: ()=>x,
    INSPECT_MAX_BYTES: ()=>Jg,
    default: ()=>Bt,
    kMaxLength: ()=>Xg
});
function Gg() {
    if (ju) return oi;
    ju = !0, oi.byteLength = a, oi.toByteArray = f, oi.fromByteArray = g;
    for(var t = [], e = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, o = i.length; n < o; ++n)t[n] = i[n], e[i.charCodeAt(n)] = n;
    e[45] = 62, e[95] = 63;
    function s(b) {
        var E = b.length;
        if (E % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var w = b.indexOf("=");
        w === -1 && (w = E);
        var S = w === E ? 0 : 4 - w % 4;
        return [
            w,
            S
        ];
    }
    function a(b) {
        var E = s(b), w = E[0], S = E[1];
        return (w + S) * 3 / 4 - S;
    }
    function u(b, E, w) {
        return (E + w) * 3 / 4 - w;
    }
    function f(b) {
        var E, w = s(b), S = w[0], I = w[1], P = new r(u(b, S, I)), C = 0, M = I > 0 ? S - 4 : S, q;
        for(q = 0; q < M; q += 4)E = e[b.charCodeAt(q)] << 18 | e[b.charCodeAt(q + 1)] << 12 | e[b.charCodeAt(q + 2)] << 6 | e[b.charCodeAt(q + 3)], P[C++] = E >> 16 & 255, P[C++] = E >> 8 & 255, P[C++] = E & 255;
        return I === 2 && (E = e[b.charCodeAt(q)] << 2 | e[b.charCodeAt(q + 1)] >> 4, P[C++] = E & 255), I === 1 && (E = e[b.charCodeAt(q)] << 10 | e[b.charCodeAt(q + 1)] << 4 | e[b.charCodeAt(q + 2)] >> 2, P[C++] = E >> 8 & 255, P[C++] = E & 255), P;
    }
    function d(b) {
        return t[b >> 18 & 63] + t[b >> 12 & 63] + t[b >> 6 & 63] + t[b & 63];
    }
    function h(b, E, w) {
        for(var S, I = [], P = E; P < w; P += 3)S = (b[P] << 16 & 16711680) + (b[P + 1] << 8 & 65280) + (b[P + 2] & 255), I.push(d(S));
        return I.join("");
    }
    function g(b) {
        for(var E, w = b.length, S = w % 3, I = [], P = 16383, C = 0, M = w - S; C < M; C += P)I.push(h(b, C, C + P > M ? M : C + P));
        return S === 1 ? (E = b[w - 1], I.push(t[E >> 2] + t[E << 4 & 63] + "==")) : S === 2 && (E = (b[w - 2] << 8) + b[w - 1], I.push(t[E >> 10] + t[E >> 4 & 63] + t[E << 2 & 63] + "=")), I.join("");
    }
    return oi;
}
function Qg() {
    if (Fu) return Fi;
    Fu = !0;
    return Fi.read = function(t, e, r, i, n) {
        var o, s, a = n * 8 - i - 1, u = (1 << a) - 1, f = u >> 1, d = -7, h = r ? n - 1 : 0, g = r ? -1 : 1, b = t[e + h];
        for(h += g, o = b & (1 << -d) - 1, b >>= -d, d += a; d > 0; o = o * 256 + t[e + h], h += g, d -= 8);
        for(s = o & (1 << -d) - 1, o >>= -d, d += i; d > 0; s = s * 256 + t[e + h], h += g, d -= 8);
        if (o === 0) o = 1 - f;
        else {
            if (o === u) return s ? NaN : (b ? -1 : 1) * (1 / 0);
            s = s + Math.pow(2, i), o = o - f;
        }
        return (b ? -1 : 1) * s * Math.pow(2, o - i);
    }, Fi.write = function(t, e, r, i, n, o) {
        var s, a, u, f = o * 8 - n - 1, d = (1 << f) - 1, h = d >> 1, g = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = i ? 0 : o - 1, E = i ? 1 : -1, w = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
        for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = d) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), s + h >= 1 ? e += g / u : e += g * Math.pow(2, 1 - h), e * u >= 2 && (s++, u /= 2), s + h >= d ? (a = 0, s = d) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, n), s = s + h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, n), s = 0)); n >= 8; t[r + b] = a & 255, b += E, a /= 256, n -= 8);
        for(s = s << n | a, f += n; f > 0; t[r + b] = s & 255, b += E, s /= 256, f -= 8);
        t[r + b - E] |= w * 128;
    }, Fi;
}
function Yg() {
    if (Wu) return Qt;
    Wu = !0;
    let t = Gg(), e = Qg(), r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    Qt.Buffer = s, Qt.SlowBuffer = I, Qt.INSPECT_MAX_BYTES = 50;
    let i = 2147483647;
    Qt.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = n(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function n() {
        try {
            let p = new Uint8Array(1), l = {
                foo: function() {
                    return 42;
                }
            };
            return Object.setPrototypeOf(l, Uint8Array.prototype), Object.setPrototypeOf(p, l), p.foo() === 42;
        } catch  {
            return !1;
        }
    }
    Object.defineProperty(s.prototype, "parent", {
        enumerable: !0,
        get: function() {
            if (s.isBuffer(this)) return this.buffer;
        }
    }), Object.defineProperty(s.prototype, "offset", {
        enumerable: !0,
        get: function() {
            if (s.isBuffer(this)) return this.byteOffset;
        }
    });
    function o(p) {
        if (p > i) throw new RangeError('The value "' + p + '" is invalid for option "size"');
        let l = new Uint8Array(p);
        return Object.setPrototypeOf(l, s.prototype), l;
    }
    function s(p, l, c) {
        if (typeof p == "number") {
            if (typeof l == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return d(p);
        }
        return a(p, l, c);
    }
    s.poolSize = 8192;
    function a(p, l, c) {
        if (typeof p == "string") return h(p, l);
        if (ArrayBuffer.isView(p)) return b(p);
        if (p == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p);
        if (Qe(p, ArrayBuffer) || p && Qe(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Qe(p, SharedArrayBuffer) || p && Qe(p.buffer, SharedArrayBuffer))) return E(p, l, c);
        if (typeof p == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        let y = p.valueOf && p.valueOf();
        if (y != null && y !== p) return s.from(y, l, c);
        let A = w(p);
        if (A) return A;
        if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function") return s.from(p[Symbol.toPrimitive]("string"), l, c);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p);
    }
    s.from = function(p, l, c) {
        return a(p, l, c);
    }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
    function u(p) {
        if (typeof p != "number") throw new TypeError('"size" argument must be of type number');
        if (p < 0) throw new RangeError('The value "' + p + '" is invalid for option "size"');
    }
    function f(p, l, c) {
        return u(p), p <= 0 ? o(p) : l !== void 0 ? typeof c == "string" ? o(p).fill(l, c) : o(p).fill(l) : o(p);
    }
    s.alloc = function(p, l, c) {
        return f(p, l, c);
    };
    function d(p) {
        return u(p), o(p < 0 ? 0 : S(p) | 0);
    }
    s.allocUnsafe = function(p) {
        return d(p);
    }, s.allocUnsafeSlow = function(p) {
        return d(p);
    };
    function h(p, l) {
        if ((typeof l != "string" || l === "") && (l = "utf8"), !s.isEncoding(l)) throw new TypeError("Unknown encoding: " + l);
        let c = P(p, l) | 0, y = o(c), A = y.write(p, l);
        return A !== c && (y = y.slice(0, A)), y;
    }
    function g(p) {
        let l = p.length < 0 ? 0 : S(p.length) | 0, c = o(l);
        for(let y = 0; y < l; y += 1)c[y] = p[y] & 255;
        return c;
    }
    function b(p) {
        if (Qe(p, Uint8Array)) {
            let l = new Uint8Array(p);
            return E(l.buffer, l.byteOffset, l.byteLength);
        }
        return g(p);
    }
    function E(p, l, c) {
        if (l < 0 || p.byteLength < l) throw new RangeError('"offset" is outside of buffer bounds');
        if (p.byteLength < l + (c || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let y;
        return l === void 0 && c === void 0 ? y = new Uint8Array(p) : c === void 0 ? y = new Uint8Array(p, l) : y = new Uint8Array(p, l, c), Object.setPrototypeOf(y, s.prototype), y;
    }
    function w(p) {
        if (s.isBuffer(p)) {
            let l = S(p.length) | 0, c = o(l);
            return c.length === 0 || p.copy(c, 0, 0, l), c;
        }
        if (p.length !== void 0) return typeof p.length != "number" || fs(p.length) ? o(0) : g(p);
        if (p.type === "Buffer" && Array.isArray(p.data)) return g(p.data);
    }
    function S(p) {
        if (p >= i) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
        return p | 0;
    }
    function I(p) {
        return +p != p && (p = 0), s.alloc(+p);
    }
    s.isBuffer = function(l) {
        return l != null && l._isBuffer === !0 && l !== s.prototype;
    }, s.compare = function(l, c) {
        if (Qe(l, Uint8Array) && (l = s.from(l, l.offset, l.byteLength)), Qe(c, Uint8Array) && (c = s.from(c, c.offset, c.byteLength)), !s.isBuffer(l) || !s.isBuffer(c)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (l === c) return 0;
        let y = l.length, A = c.length;
        for(let T = 0, k = Math.min(y, A); T < k; ++T)if (l[T] !== c[T]) {
            y = l[T], A = c[T];
            break;
        }
        return y < A ? -1 : A < y ? 1 : 0;
    }, s.isEncoding = function(l) {
        switch(String(l).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return !0;
            default:
                return !1;
        }
    }, s.concat = function(l, c) {
        if (!Array.isArray(l)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (l.length === 0) return s.alloc(0);
        let y;
        if (c === void 0) for(c = 0, y = 0; y < l.length; ++y)c += l[y].length;
        let A = s.allocUnsafe(c), T = 0;
        for(y = 0; y < l.length; ++y){
            let k = l[y];
            if (Qe(k, Uint8Array)) T + k.length > A.length ? (s.isBuffer(k) || (k = s.from(k)), k.copy(A, T)) : Uint8Array.prototype.set.call(A, k, T);
            else if (s.isBuffer(k)) k.copy(A, T);
            else throw new TypeError('"list" argument must be an Array of Buffers');
            T += k.length;
        }
        return A;
    };
    function P(p, l) {
        if (s.isBuffer(p)) return p.length;
        if (ArrayBuffer.isView(p) || Qe(p, ArrayBuffer)) return p.byteLength;
        if (typeof p != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p);
        let c = p.length, y = arguments.length > 2 && arguments[2] === !0;
        if (!y && c === 0) return 0;
        let A = !1;
        for(;;)switch(l){
            case "ascii":
            case "latin1":
            case "binary":
                return c;
            case "utf8":
            case "utf-8":
                return cs(p).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return c * 2;
            case "hex":
                return c >>> 1;
            case "base64":
                return Sl(p).length;
            default:
                if (A) return y ? -1 : cs(p).length;
                l = ("" + l).toLowerCase(), A = !0;
        }
    }
    s.byteLength = P;
    function C(p, l, c) {
        let y = !1;
        if ((l === void 0 || l < 0) && (l = 0), l > this.length || ((c === void 0 || c > this.length) && (c = this.length), c <= 0) || (c >>>= 0, l >>>= 0, c <= l)) return "";
        for(p || (p = "utf8");;)switch(p){
            case "hex":
                return Mg(this, l, c);
            case "utf8":
            case "utf-8":
                return Se(this, l, c);
            case "ascii":
                return ls(this, l, c);
            case "latin1":
            case "binary":
                return Og(this, l, c);
            case "base64":
                return Fe(this, l, c);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return Lg(this, l, c);
            default:
                if (y) throw new TypeError("Unknown encoding: " + p);
                p = (p + "").toLowerCase(), y = !0;
        }
    }
    s.prototype._isBuffer = !0;
    function M(p, l, c) {
        let y = p[l];
        p[l] = p[c], p[c] = y;
    }
    s.prototype.swap16 = function() {
        let l = this.length;
        if (l % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(let c = 0; c < l; c += 2)M(this, c, c + 1);
        return this;
    }, s.prototype.swap32 = function() {
        let l = this.length;
        if (l % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(let c = 0; c < l; c += 4)M(this, c, c + 3), M(this, c + 1, c + 2);
        return this;
    }, s.prototype.swap64 = function() {
        let l = this.length;
        if (l % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(let c = 0; c < l; c += 8)M(this, c, c + 7), M(this, c + 1, c + 6), M(this, c + 2, c + 5), M(this, c + 3, c + 4);
        return this;
    }, s.prototype.toString = function() {
        let l = this.length;
        return l === 0 ? "" : arguments.length === 0 ? Se(this, 0, l) : C.apply(this, arguments);
    }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(l) {
        if (!s.isBuffer(l)) throw new TypeError("Argument must be a Buffer");
        return this === l ? !0 : s.compare(this, l) === 0;
    }, s.prototype.inspect = function() {
        let l = "", c = Qt.INSPECT_MAX_BYTES;
        return l = this.toString("hex", 0, c).replace(/(.{2})/g, "$1 ").trim(), this.length > c && (l += " ... "), "<Buffer " + l + ">";
    }, r && (s.prototype[r] = s.prototype.inspect), s.prototype.compare = function(l, c, y, A, T) {
        if (Qe(l, Uint8Array) && (l = s.from(l, l.offset, l.byteLength)), !s.isBuffer(l)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof l);
        if (c === void 0 && (c = 0), y === void 0 && (y = l ? l.length : 0), A === void 0 && (A = 0), T === void 0 && (T = this.length), c < 0 || y > l.length || A < 0 || T > this.length) throw new RangeError("out of range index");
        if (A >= T && c >= y) return 0;
        if (A >= T) return -1;
        if (c >= y) return 1;
        if (c >>>= 0, y >>>= 0, A >>>= 0, T >>>= 0, this === l) return 0;
        let k = T - A, W = y - c, ae = Math.min(k, W), re = this.slice(A, T), le = l.slice(c, y);
        for(let J = 0; J < ae; ++J)if (re[J] !== le[J]) {
            k = re[J], W = le[J];
            break;
        }
        return k < W ? -1 : W < k ? 1 : 0;
    };
    function q(p, l, c, y, A) {
        if (p.length === 0) return -1;
        if (typeof c == "string" ? (y = c, c = 0) : c > 2147483647 ? c = 2147483647 : c < -2147483648 && (c = -2147483648), c = +c, fs(c) && (c = A ? 0 : p.length - 1), c < 0 && (c = p.length + c), c >= p.length) {
            if (A) return -1;
            c = p.length - 1;
        } else if (c < 0) {
            if (A) c = 0;
            else return -1;
        }
        if (typeof l == "string" && (l = s.from(l, y)), s.isBuffer(l)) return l.length === 0 ? -1 : z(p, l, c, y, A);
        if (typeof l == "number") return l = l & 255, typeof Uint8Array.prototype.indexOf == "function" ? A ? Uint8Array.prototype.indexOf.call(p, l, c) : Uint8Array.prototype.lastIndexOf.call(p, l, c) : z(p, [
            l
        ], c, y, A);
        throw new TypeError("val must be string, number or Buffer");
    }
    function z(p, l, c, y, A) {
        let T = 1, k = p.length, W = l.length;
        if (y !== void 0 && (y = String(y).toLowerCase(), y === "ucs2" || y === "ucs-2" || y === "utf16le" || y === "utf-16le")) {
            if (p.length < 2 || l.length < 2) return -1;
            T = 2, k /= 2, W /= 2, c /= 2;
        }
        function ae(le, J) {
            return T === 1 ? le[J] : le.readUInt16BE(J * T);
        }
        let re;
        if (A) {
            let le = -1;
            for(re = c; re < k; re++)if (ae(p, re) === ae(l, le === -1 ? 0 : re - le)) {
                if (le === -1 && (le = re), re - le + 1 === W) return le * T;
            } else le !== -1 && (re -= re - le), le = -1;
        } else for(c + W > k && (c = k - W), re = c; re >= 0; re--){
            let le = !0;
            for(let J = 0; J < W; J++)if (ae(p, re + J) !== ae(l, J)) {
                le = !1;
                break;
            }
            if (le) return re;
        }
        return -1;
    }
    s.prototype.includes = function(l, c, y) {
        return this.indexOf(l, c, y) !== -1;
    }, s.prototype.indexOf = function(l, c, y) {
        return q(this, l, c, y, !0);
    }, s.prototype.lastIndexOf = function(l, c, y) {
        return q(this, l, c, y, !1);
    };
    function j(p, l, c, y) {
        c = Number(c) || 0;
        let A = p.length - c;
        y ? (y = Number(y), y > A && (y = A)) : y = A;
        let T = l.length;
        y > T / 2 && (y = T / 2);
        let k;
        for(k = 0; k < y; ++k){
            let W = parseInt(l.substr(k * 2, 2), 16);
            if (fs(W)) return k;
            p[c + k] = W;
        }
        return k;
    }
    function G(p, l, c, y) {
        return Ui(cs(l, p.length - c), p, c, y);
    }
    function $(p, l, c, y) {
        return Ui(Dg(l), p, c, y);
    }
    function te(p, l, c, y) {
        return Ui(Sl(l), p, c, y);
    }
    function pt(p, l, c, y) {
        return Ui(jg(l, p.length - c), p, c, y);
    }
    s.prototype.write = function(l, c, y, A) {
        if (c === void 0) A = "utf8", y = this.length, c = 0;
        else if (y === void 0 && typeof c == "string") A = c, y = this.length, c = 0;
        else if (isFinite(c)) c = c >>> 0, isFinite(y) ? (y = y >>> 0, A === void 0 && (A = "utf8")) : (A = y, y = void 0);
        else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        let T = this.length - c;
        if ((y === void 0 || y > T) && (y = T), l.length > 0 && (y < 0 || c < 0) || c > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        A || (A = "utf8");
        let k = !1;
        for(;;)switch(A){
            case "hex":
                return j(this, l, c, y);
            case "utf8":
            case "utf-8":
                return G(this, l, c, y);
            case "ascii":
            case "latin1":
            case "binary":
                return $(this, l, c, y);
            case "base64":
                return te(this, l, c, y);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return pt(this, l, c, y);
            default:
                if (k) throw new TypeError("Unknown encoding: " + A);
                A = ("" + A).toLowerCase(), k = !0;
        }
    }, s.prototype.toJSON = function() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function Fe(p, l, c) {
        return l === 0 && c === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(l, c));
    }
    function Se(p, l, c) {
        c = Math.min(p.length, c);
        let y = [], A = l;
        for(; A < c;){
            let T = p[A], k = null, W = T > 239 ? 4 : T > 223 ? 3 : T > 191 ? 2 : 1;
            if (A + W <= c) {
                let ae, re, le, J;
                switch(W){
                    case 1:
                        T < 128 && (k = T);
                        break;
                    case 2:
                        ae = p[A + 1], (ae & 192) === 128 && (J = (T & 31) << 6 | ae & 63, J > 127 && (k = J));
                        break;
                    case 3:
                        ae = p[A + 1], re = p[A + 2], (ae & 192) === 128 && (re & 192) === 128 && (J = (T & 15) << 12 | (ae & 63) << 6 | re & 63, J > 2047 && (J < 55296 || J > 57343) && (k = J));
                        break;
                    case 4:
                        ae = p[A + 1], re = p[A + 2], le = p[A + 3], (ae & 192) === 128 && (re & 192) === 128 && (le & 192) === 128 && (J = (T & 15) << 18 | (ae & 63) << 12 | (re & 63) << 6 | le & 63, J > 65535 && J < 1114112 && (k = J));
                }
            }
            k === null ? (k = 65533, W = 1) : k > 65535 && (k -= 65536, y.push(k >>> 10 & 1023 | 55296), k = 56320 | k & 1023), y.push(k), A += W;
        }
        return Er(y);
    }
    let vr = 4096;
    function Er(p) {
        let l = p.length;
        if (l <= vr) return String.fromCharCode.apply(String, p);
        let c = "", y = 0;
        for(; y < l;)c += String.fromCharCode.apply(String, p.slice(y, y += vr));
        return c;
    }
    function ls(p, l, c) {
        let y = "";
        c = Math.min(p.length, c);
        for(let A = l; A < c; ++A)y += String.fromCharCode(p[A] & 127);
        return y;
    }
    function Og(p, l, c) {
        let y = "";
        c = Math.min(p.length, c);
        for(let A = l; A < c; ++A)y += String.fromCharCode(p[A]);
        return y;
    }
    function Mg(p, l, c) {
        let y = p.length;
        (!l || l < 0) && (l = 0), (!c || c < 0 || c > y) && (c = y);
        let A = "";
        for(let T = l; T < c; ++T)A += Fg[p[T]];
        return A;
    }
    function Lg(p, l, c) {
        let y = p.slice(l, c), A = "";
        for(let T = 0; T < y.length - 1; T += 2)A += String.fromCharCode(y[T] + y[T + 1] * 256);
        return A;
    }
    s.prototype.slice = function(l, c) {
        let y = this.length;
        l = ~~l, c = c === void 0 ? y : ~~c, l < 0 ? (l += y, l < 0 && (l = 0)) : l > y && (l = y), c < 0 ? (c += y, c < 0 && (c = 0)) : c > y && (c = y), c < l && (c = l);
        let A = this.subarray(l, c);
        return Object.setPrototypeOf(A, s.prototype), A;
    };
    function be(p, l, c) {
        if (p % 1 !== 0 || p < 0) throw new RangeError("offset is not uint");
        if (p + l > c) throw new RangeError("Trying to access beyond buffer length");
    }
    s.prototype.readUintLE = s.prototype.readUIntLE = function(l, c, y) {
        l = l >>> 0, c = c >>> 0, y || be(l, c, this.length);
        let A = this[l], T = 1, k = 0;
        for(; ++k < c && (T *= 256);)A += this[l + k] * T;
        return A;
    }, s.prototype.readUintBE = s.prototype.readUIntBE = function(l, c, y) {
        l = l >>> 0, c = c >>> 0, y || be(l, c, this.length);
        let A = this[l + --c], T = 1;
        for(; c > 0 && (T *= 256);)A += this[l + --c] * T;
        return A;
    }, s.prototype.readUint8 = s.prototype.readUInt8 = function(l, c) {
        return l = l >>> 0, c || be(l, 1, this.length), this[l];
    }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(l, c) {
        return l = l >>> 0, c || be(l, 2, this.length), this[l] | this[l + 1] << 8;
    }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(l, c) {
        return l = l >>> 0, c || be(l, 2, this.length), this[l] << 8 | this[l + 1];
    }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(l, c) {
        return l = l >>> 0, c || be(l, 4, this.length), (this[l] | this[l + 1] << 8 | this[l + 2] << 16) + this[l + 3] * 16777216;
    }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(l, c) {
        return l = l >>> 0, c || be(l, 4, this.length), this[l] * 16777216 + (this[l + 1] << 16 | this[l + 2] << 8 | this[l + 3]);
    }, s.prototype.readBigUInt64LE = Pt(function(l) {
        l = l >>> 0, Ar(l, "offset");
        let c = this[l], y = this[l + 7];
        (c === void 0 || y === void 0) && si(l, this.length - 8);
        let A = c + this[++l] * 256 + this[++l] * 2 ** 16 + this[++l] * 2 ** 24, T = this[++l] + this[++l] * 256 + this[++l] * 2 ** 16 + y * 2 ** 24;
        return BigInt(A) + (BigInt(T) << BigInt(32));
    }), s.prototype.readBigUInt64BE = Pt(function(l) {
        l = l >>> 0, Ar(l, "offset");
        let c = this[l], y = this[l + 7];
        (c === void 0 || y === void 0) && si(l, this.length - 8);
        let A = c * 2 ** 24 + this[++l] * 2 ** 16 + this[++l] * 256 + this[++l], T = this[++l] * 2 ** 24 + this[++l] * 2 ** 16 + this[++l] * 256 + y;
        return (BigInt(A) << BigInt(32)) + BigInt(T);
    }), s.prototype.readIntLE = function(l, c, y) {
        l = l >>> 0, c = c >>> 0, y || be(l, c, this.length);
        let A = this[l], T = 1, k = 0;
        for(; ++k < c && (T *= 256);)A += this[l + k] * T;
        return T *= 128, A >= T && (A -= Math.pow(2, 8 * c)), A;
    }, s.prototype.readIntBE = function(l, c, y) {
        l = l >>> 0, c = c >>> 0, y || be(l, c, this.length);
        let A = c, T = 1, k = this[l + --A];
        for(; A > 0 && (T *= 256);)k += this[l + --A] * T;
        return T *= 128, k >= T && (k -= Math.pow(2, 8 * c)), k;
    }, s.prototype.readInt8 = function(l, c) {
        return l = l >>> 0, c || be(l, 1, this.length), this[l] & 128 ? (255 - this[l] + 1) * -1 : this[l];
    }, s.prototype.readInt16LE = function(l, c) {
        l = l >>> 0, c || be(l, 2, this.length);
        let y = this[l] | this[l + 1] << 8;
        return y & 32768 ? y | 4294901760 : y;
    }, s.prototype.readInt16BE = function(l, c) {
        l = l >>> 0, c || be(l, 2, this.length);
        let y = this[l + 1] | this[l] << 8;
        return y & 32768 ? y | 4294901760 : y;
    }, s.prototype.readInt32LE = function(l, c) {
        return l = l >>> 0, c || be(l, 4, this.length), this[l] | this[l + 1] << 8 | this[l + 2] << 16 | this[l + 3] << 24;
    }, s.prototype.readInt32BE = function(l, c) {
        return l = l >>> 0, c || be(l, 4, this.length), this[l] << 24 | this[l + 1] << 16 | this[l + 2] << 8 | this[l + 3];
    }, s.prototype.readBigInt64LE = Pt(function(l) {
        l = l >>> 0, Ar(l, "offset");
        let c = this[l], y = this[l + 7];
        (c === void 0 || y === void 0) && si(l, this.length - 8);
        let A = this[l + 4] + this[l + 5] * 256 + this[l + 6] * 2 ** 16 + (y << 24);
        return (BigInt(A) << BigInt(32)) + BigInt(c + this[++l] * 256 + this[++l] * 2 ** 16 + this[++l] * 2 ** 24);
    }), s.prototype.readBigInt64BE = Pt(function(l) {
        l = l >>> 0, Ar(l, "offset");
        let c = this[l], y = this[l + 7];
        (c === void 0 || y === void 0) && si(l, this.length - 8);
        let A = (c << 24) + this[++l] * 2 ** 16 + this[++l] * 256 + this[++l];
        return (BigInt(A) << BigInt(32)) + BigInt(this[++l] * 2 ** 24 + this[++l] * 2 ** 16 + this[++l] * 256 + y);
    }), s.prototype.readFloatLE = function(l, c) {
        return l = l >>> 0, c || be(l, 4, this.length), e.read(this, l, !0, 23, 4);
    }, s.prototype.readFloatBE = function(l, c) {
        return l = l >>> 0, c || be(l, 4, this.length), e.read(this, l, !1, 23, 4);
    }, s.prototype.readDoubleLE = function(l, c) {
        return l = l >>> 0, c || be(l, 8, this.length), e.read(this, l, !0, 52, 8);
    }, s.prototype.readDoubleBE = function(l, c) {
        return l = l >>> 0, c || be(l, 8, this.length), e.read(this, l, !1, 52, 8);
    };
    function Ce(p, l, c, y, A, T) {
        if (!s.isBuffer(p)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (l > A || l < T) throw new RangeError('"value" argument is out of bounds');
        if (c + y > p.length) throw new RangeError("Index out of range");
    }
    s.prototype.writeUintLE = s.prototype.writeUIntLE = function(l, c, y, A) {
        if (l = +l, c = c >>> 0, y = y >>> 0, !A) {
            let W = Math.pow(2, 8 * y) - 1;
            Ce(this, l, c, y, W, 0);
        }
        let T = 1, k = 0;
        for(this[c] = l & 255; ++k < y && (T *= 256);)this[c + k] = l / T & 255;
        return c + y;
    }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(l, c, y, A) {
        if (l = +l, c = c >>> 0, y = y >>> 0, !A) {
            let W = Math.pow(2, 8 * y) - 1;
            Ce(this, l, c, y, W, 0);
        }
        let T = y - 1, k = 1;
        for(this[c + T] = l & 255; --T >= 0 && (k *= 256);)this[c + T] = l / k & 255;
        return c + y;
    }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 1, 255, 0), this[c] = l & 255, c + 1;
    }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 2, 65535, 0), this[c] = l & 255, this[c + 1] = l >>> 8, c + 2;
    }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 2, 65535, 0), this[c] = l >>> 8, this[c + 1] = l & 255, c + 2;
    }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 4, 4294967295, 0), this[c + 3] = l >>> 24, this[c + 2] = l >>> 16, this[c + 1] = l >>> 8, this[c] = l & 255, c + 4;
    }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 4, 4294967295, 0), this[c] = l >>> 24, this[c + 1] = l >>> 16, this[c + 2] = l >>> 8, this[c + 3] = l & 255, c + 4;
    };
    function bl(p, l, c, y, A) {
        El(l, y, A, p, c, 7);
        let T = Number(l & BigInt(4294967295));
        p[c++] = T, T = T >> 8, p[c++] = T, T = T >> 8, p[c++] = T, T = T >> 8, p[c++] = T;
        let k = Number(l >> BigInt(32) & BigInt(4294967295));
        return p[c++] = k, k = k >> 8, p[c++] = k, k = k >> 8, p[c++] = k, k = k >> 8, p[c++] = k, c;
    }
    function yl(p, l, c, y, A) {
        El(l, y, A, p, c, 7);
        let T = Number(l & BigInt(4294967295));
        p[c + 7] = T, T = T >> 8, p[c + 6] = T, T = T >> 8, p[c + 5] = T, T = T >> 8, p[c + 4] = T;
        let k = Number(l >> BigInt(32) & BigInt(4294967295));
        return p[c + 3] = k, k = k >> 8, p[c + 2] = k, k = k >> 8, p[c + 1] = k, k = k >> 8, p[c] = k, c + 8;
    }
    s.prototype.writeBigUInt64LE = Pt(function(l, c = 0) {
        return bl(this, l, c, BigInt(0), BigInt("0xffffffffffffffff"));
    }), s.prototype.writeBigUInt64BE = Pt(function(l, c = 0) {
        return yl(this, l, c, BigInt(0), BigInt("0xffffffffffffffff"));
    }), s.prototype.writeIntLE = function(l, c, y, A) {
        if (l = +l, c = c >>> 0, !A) {
            let ae = Math.pow(2, 8 * y - 1);
            Ce(this, l, c, y, ae - 1, -ae);
        }
        let T = 0, k = 1, W = 0;
        for(this[c] = l & 255; ++T < y && (k *= 256);)l < 0 && W === 0 && this[c + T - 1] !== 0 && (W = 1), this[c + T] = (l / k >> 0) - W & 255;
        return c + y;
    }, s.prototype.writeIntBE = function(l, c, y, A) {
        if (l = +l, c = c >>> 0, !A) {
            let ae = Math.pow(2, 8 * y - 1);
            Ce(this, l, c, y, ae - 1, -ae);
        }
        let T = y - 1, k = 1, W = 0;
        for(this[c + T] = l & 255; --T >= 0 && (k *= 256);)l < 0 && W === 0 && this[c + T + 1] !== 0 && (W = 1), this[c + T] = (l / k >> 0) - W & 255;
        return c + y;
    }, s.prototype.writeInt8 = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 1, 127, -128), l < 0 && (l = 255 + l + 1), this[c] = l & 255, c + 1;
    }, s.prototype.writeInt16LE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 2, 32767, -32768), this[c] = l & 255, this[c + 1] = l >>> 8, c + 2;
    }, s.prototype.writeInt16BE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 2, 32767, -32768), this[c] = l >>> 8, this[c + 1] = l & 255, c + 2;
    }, s.prototype.writeInt32LE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 4, 2147483647, -2147483648), this[c] = l & 255, this[c + 1] = l >>> 8, this[c + 2] = l >>> 16, this[c + 3] = l >>> 24, c + 4;
    }, s.prototype.writeInt32BE = function(l, c, y) {
        return l = +l, c = c >>> 0, y || Ce(this, l, c, 4, 2147483647, -2147483648), l < 0 && (l = 4294967295 + l + 1), this[c] = l >>> 24, this[c + 1] = l >>> 16, this[c + 2] = l >>> 8, this[c + 3] = l & 255, c + 4;
    }, s.prototype.writeBigInt64LE = Pt(function(l, c = 0) {
        return bl(this, l, c, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), s.prototype.writeBigInt64BE = Pt(function(l, c = 0) {
        return yl(this, l, c, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function wl(p, l, c, y, A, T) {
        if (c + y > p.length) throw new RangeError("Index out of range");
        if (c < 0) throw new RangeError("Index out of range");
    }
    function _l(p, l, c, y, A) {
        return l = +l, c = c >>> 0, A || wl(p, l, c, 4), e.write(p, l, c, y, 23, 4), c + 4;
    }
    s.prototype.writeFloatLE = function(l, c, y) {
        return _l(this, l, c, !0, y);
    }, s.prototype.writeFloatBE = function(l, c, y) {
        return _l(this, l, c, !1, y);
    };
    function ml(p, l, c, y, A) {
        return l = +l, c = c >>> 0, A || wl(p, l, c, 8), e.write(p, l, c, y, 52, 8), c + 8;
    }
    s.prototype.writeDoubleLE = function(l, c, y) {
        return ml(this, l, c, !0, y);
    }, s.prototype.writeDoubleBE = function(l, c, y) {
        return ml(this, l, c, !1, y);
    }, s.prototype.copy = function(l, c, y, A) {
        if (!s.isBuffer(l)) throw new TypeError("argument should be a Buffer");
        if (y || (y = 0), !A && A !== 0 && (A = this.length), c >= l.length && (c = l.length), c || (c = 0), A > 0 && A < y && (A = y), A === y || l.length === 0 || this.length === 0) return 0;
        if (c < 0) throw new RangeError("targetStart out of bounds");
        if (y < 0 || y >= this.length) throw new RangeError("Index out of range");
        if (A < 0) throw new RangeError("sourceEnd out of bounds");
        A > this.length && (A = this.length), l.length - c < A - y && (A = l.length - c + y);
        let T = A - y;
        return this === l && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(c, y, A) : Uint8Array.prototype.set.call(l, this.subarray(y, A), c), T;
    }, s.prototype.fill = function(l, c, y, A) {
        if (typeof l == "string") {
            if (typeof c == "string" ? (A = c, c = 0, y = this.length) : typeof y == "string" && (A = y, y = this.length), A !== void 0 && typeof A != "string") throw new TypeError("encoding must be a string");
            if (typeof A == "string" && !s.isEncoding(A)) throw new TypeError("Unknown encoding: " + A);
            if (l.length === 1) {
                let k = l.charCodeAt(0);
                (A === "utf8" && k < 128 || A === "latin1") && (l = k);
            }
        } else typeof l == "number" ? l = l & 255 : typeof l == "boolean" && (l = Number(l));
        if (c < 0 || this.length < c || this.length < y) throw new RangeError("Out of range index");
        if (y <= c) return this;
        c = c >>> 0, y = y === void 0 ? this.length : y >>> 0, l || (l = 0);
        let T;
        if (typeof l == "number") for(T = c; T < y; ++T)this[T] = l;
        else {
            let k = s.isBuffer(l) ? l : s.from(l, A), W = k.length;
            if (W === 0) throw new TypeError('The value "' + l + '" is invalid for argument "value"');
            for(T = 0; T < y - c; ++T)this[T + c] = k[T % W];
        }
        return this;
    };
    let Sr = {};
    function us(p, l, c) {
        Sr[p] = class extends c {
            constructor(){
                super(), Object.defineProperty(this, "message", {
                    value: l.apply(this, arguments),
                    writable: !0,
                    configurable: !0
                }), this.name = `${this.name} [${p}]`, this.stack, delete this.name;
            }
            get code() {
                return p;
            }
            set code(A) {
                Object.defineProperty(this, "code", {
                    configurable: !0,
                    enumerable: !0,
                    value: A,
                    writable: !0
                });
            }
            toString() {
                return `${this.name} [${p}]: ${this.message}`;
            }
        };
    }
    us("ERR_BUFFER_OUT_OF_BOUNDS", function(p) {
        return p ? `${p} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    }, RangeError), us("ERR_INVALID_ARG_TYPE", function(p, l) {
        return `The "${p}" argument must be of type number. Received type ${typeof l}`;
    }, TypeError), us("ERR_OUT_OF_RANGE", function(p, l, c) {
        let y = `The value of "${p}" is out of range.`, A = c;
        return Number.isInteger(c) && Math.abs(c) > 2 ** 32 ? A = vl(String(c)) : typeof c == "bigint" && (A = String(c), (c > BigInt(2) ** BigInt(32) || c < -(BigInt(2) ** BigInt(32))) && (A = vl(A)), A += "n"), y += ` It must be ${l}. Received ${A}`, y;
    }, RangeError);
    function vl(p) {
        let l = "", c = p.length, y = p[0] === "-" ? 1 : 0;
        for(; c >= y + 4; c -= 3)l = `_${p.slice(c - 3, c)}${l}`;
        return `${p.slice(0, c)}${l}`;
    }
    function qg(p, l, c) {
        Ar(l, "offset"), (p[l] === void 0 || p[l + c] === void 0) && si(l, p.length - (c + 1));
    }
    function El(p, l, c, y, A, T) {
        if (p > c || p < l) {
            let k = typeof l == "bigint" ? "n" : "", W;
            throw T > 3 ? l === 0 || l === BigInt(0) ? W = `>= 0${k} and < 2${k} ** ${(T + 1) * 8}${k}` : W = `>= -(2${k} ** ${(T + 1) * 8 - 1}${k}) and < 2 ** ${(T + 1) * 8 - 1}${k}` : W = `>= ${l}${k} and <= ${c}${k}`, new Sr.ERR_OUT_OF_RANGE("value", W, p);
        }
        qg(y, A, T);
    }
    function Ar(p, l) {
        if (typeof p != "number") throw new Sr.ERR_INVALID_ARG_TYPE(l, "number", p);
    }
    function si(p, l, c) {
        throw Math.floor(p) !== p ? (Ar(p, c), new Sr.ERR_OUT_OF_RANGE(c || "offset", "an integer", p)) : l < 0 ? new Sr.ERR_BUFFER_OUT_OF_BOUNDS : new Sr.ERR_OUT_OF_RANGE(c || "offset", `>= ${c ? 1 : 0} and <= ${l}`, p);
    }
    let Ug = /[^+/0-9A-Za-z-_]/g;
    function Ng(p) {
        if (p = p.split("=")[0], p = p.trim().replace(Ug, ""), p.length < 2) return "";
        for(; p.length % 4 !== 0;)p = p + "=";
        return p;
    }
    function cs(p, l) {
        l = l || 1 / 0;
        let c, y = p.length, A = null, T = [];
        for(let k = 0; k < y; ++k){
            if (c = p.charCodeAt(k), c > 55295 && c < 57344) {
                if (!A) {
                    if (c > 56319) {
                        (l -= 3) > -1 && T.push(239, 191, 189);
                        continue;
                    } else if (k + 1 === y) {
                        (l -= 3) > -1 && T.push(239, 191, 189);
                        continue;
                    }
                    A = c;
                    continue;
                }
                if (c < 56320) {
                    (l -= 3) > -1 && T.push(239, 191, 189), A = c;
                    continue;
                }
                c = (A - 55296 << 10 | c - 56320) + 65536;
            } else A && (l -= 3) > -1 && T.push(239, 191, 189);
            if (A = null, c < 128) {
                if ((l -= 1) < 0) break;
                T.push(c);
            } else if (c < 2048) {
                if ((l -= 2) < 0) break;
                T.push(c >> 6 | 192, c & 63 | 128);
            } else if (c < 65536) {
                if ((l -= 3) < 0) break;
                T.push(c >> 12 | 224, c >> 6 & 63 | 128, c & 63 | 128);
            } else if (c < 1114112) {
                if ((l -= 4) < 0) break;
                T.push(c >> 18 | 240, c >> 12 & 63 | 128, c >> 6 & 63 | 128, c & 63 | 128);
            } else throw new Error("Invalid code point");
        }
        return T;
    }
    function Dg(p) {
        let l = [];
        for(let c = 0; c < p.length; ++c)l.push(p.charCodeAt(c) & 255);
        return l;
    }
    function jg(p, l) {
        let c, y, A, T = [];
        for(let k = 0; k < p.length && !((l -= 2) < 0); ++k)c = p.charCodeAt(k), y = c >> 8, A = c % 256, T.push(A), T.push(y);
        return T;
    }
    function Sl(p) {
        return t.toByteArray(Ng(p));
    }
    function Ui(p, l, c, y) {
        let A;
        for(A = 0; A < y && !(A + c >= l.length || A >= p.length); ++A)l[A + c] = p[A];
        return A;
    }
    function Qe(p, l) {
        return p instanceof l || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === l.name;
    }
    function fs(p) {
        return p !== p;
    }
    let Fg = function() {
        let p = "0123456789abcdef", l = new Array(256);
        for(let c = 0; c < 16; ++c){
            let y = c * 16;
            for(let A = 0; A < 16; ++A)l[y + A] = p[c] + p[A];
        }
        return l;
    }();
    function Pt(p) {
        return typeof BigInt > "u" ? Wg : p;
    }
    function Wg() {
        throw new Error("BigInt not supported");
    }
    return Qt;
}
var oi, ju, Fi, Fu, Qt, Wu, Bt, x, Jg, Xg, he = Ae(()=>{
    _();
    v();
    m();
    oi = {}, ju = !1;
    Fi = {}, Fu = !1;
    Qt = {}, Wu = !1;
    Bt = Yg();
    Bt.Buffer;
    Bt.SlowBuffer;
    Bt.INSPECT_MAX_BYTES;
    Bt.kMaxLength;
    x = Bt.Buffer, Jg = Bt.INSPECT_MAX_BYTES, Xg = Bt.kMaxLength;
});
var v = Ae(()=>{
    he();
});
var $u = O((ys)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(ys, "__esModule", {
        value: !0
    });
    var bs = class {
        constructor(e){
            this.aliasToTopic = {}, this.max = e;
        }
        put(e, r) {
            return r === 0 || r > this.max ? !1 : (this.aliasToTopic[r] = e, this.length = Object.keys(this.aliasToTopic).length, !0);
        }
        getTopicByAlias(e) {
            return this.aliasToTopic[e];
        }
        clear() {
            this.aliasToTopic = {};
        }
    };
    ys.default = bs;
});
var ie = O((zA, Hu)=>{
    "use strict";
    _();
    v();
    m();
    var ws = class extends Error {
        constructor(e){
            if (!Array.isArray(e)) throw new TypeError(`Expected input to be an Array, got ${typeof e}`);
            let r = "";
            for(let i = 0; i < e.length; i++)r += `    ${e[i].stack}
`;
            super(r), this.name = "AggregateError", this.errors = e;
        }
    };
    Hu.exports = {
        AggregateError: ws,
        ArrayIsArray (t) {
            return Array.isArray(t);
        },
        ArrayPrototypeIncludes (t, e) {
            return t.includes(e);
        },
        ArrayPrototypeIndexOf (t, e) {
            return t.indexOf(e);
        },
        ArrayPrototypeJoin (t, e) {
            return t.join(e);
        },
        ArrayPrototypeMap (t, e) {
            return t.map(e);
        },
        ArrayPrototypePop (t, e) {
            return t.pop(e);
        },
        ArrayPrototypePush (t, e) {
            return t.push(e);
        },
        ArrayPrototypeSlice (t, e, r) {
            return t.slice(e, r);
        },
        Error,
        FunctionPrototypeCall (t, e, ...r) {
            return t.call(e, ...r);
        },
        FunctionPrototypeSymbolHasInstance (t, e) {
            return Function.prototype[Symbol.hasInstance].call(t, e);
        },
        MathFloor: Math.floor,
        Number,
        NumberIsInteger: Number.isInteger,
        NumberIsNaN: Number.isNaN,
        NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
        NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
        NumberParseInt: Number.parseInt,
        ObjectDefineProperties (t, e) {
            return Object.defineProperties(t, e);
        },
        ObjectDefineProperty (t, e, r) {
            return Object.defineProperty(t, e, r);
        },
        ObjectGetOwnPropertyDescriptor (t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        },
        ObjectKeys (t) {
            return Object.keys(t);
        },
        ObjectSetPrototypeOf (t, e) {
            return Object.setPrototypeOf(t, e);
        },
        Promise,
        PromisePrototypeCatch (t, e) {
            return t.catch(e);
        },
        PromisePrototypeThen (t, e, r) {
            return t.then(e, r);
        },
        PromiseReject (t) {
            return Promise.reject(t);
        },
        PromiseResolve (t) {
            return Promise.resolve(t);
        },
        ReflectApply: Reflect.apply,
        RegExpPrototypeTest (t, e) {
            return t.test(e);
        },
        SafeSet: Set,
        String,
        StringPrototypeSlice (t, e, r) {
            return t.slice(e, r);
        },
        StringPrototypeToLowerCase (t) {
            return t.toLowerCase();
        },
        StringPrototypeToUpperCase (t) {
            return t.toUpperCase();
        },
        StringPrototypeTrim (t) {
            return t.trim();
        },
        Symbol,
        SymbolFor: Symbol.for,
        SymbolAsyncIterator: Symbol.asyncIterator,
        SymbolHasInstance: Symbol.hasInstance,
        SymbolIterator: Symbol.iterator,
        SymbolDispose: Symbol.dispose || Symbol("Symbol.dispose"),
        SymbolAsyncDispose: Symbol.asyncDispose || Symbol("Symbol.asyncDispose"),
        TypedArrayPrototypeSet (t, e, r) {
            return t.set(e, r);
        },
        Boolean,
        Uint8Array
    };
});
var _s = O((rI, Vu)=>{
    "use strict";
    _();
    v();
    m();
    Vu.exports = {
        format (t, ...e) {
            return t.replace(/%([sdifj])/g, function(...[r, i]) {
                let n = e.shift();
                return i === "f" ? n.toFixed(6) : i === "j" ? JSON.stringify(n) : i === "s" && typeof n == "object" ? `${n.constructor !== Object ? n.constructor.name : ""} {}`.trim() : n.toString();
            });
        },
        inspect (t) {
            switch(typeof t){
                case "string":
                    if (t.includes("'")) {
                        if (t.includes('"')) {
                            if (!t.includes("`") && !t.includes("${")) return `\`${t}\``;
                        } else return `"${t}"`;
                    }
                    return `'${t}'`;
                case "number":
                    return isNaN(t) ? "NaN" : Object.is(t, -0) ? String(t) : t;
                case "bigint":
                    return `${String(t)}n`;
                case "boolean":
                case "undefined":
                    return String(t);
                case "object":
                    return "{}";
            }
        }
    };
});
var me = O((hI, Gu)=>{
    "use strict";
    _();
    v();
    m();
    var { format: Zg, inspect: Wi } = _s(), { AggregateError: eb } = ie(), tb = globalThis.AggregateError || eb, rb = Symbol("kIsNodeError"), ib = [
        "string",
        "function",
        "number",
        "object",
        "Function",
        "Object",
        "boolean",
        "bigint",
        "symbol"
    ], nb = /^([A-Z][a-z0-9]*)+$/, sb = "__node_internal_", $i = {};
    function Yt(t, e) {
        if (!t) throw new $i.ERR_INTERNAL_ASSERTION(e);
    }
    function zu(t) {
        let e = "", r = t.length, i = t[0] === "-" ? 1 : 0;
        for(; r >= i + 4; r -= 3)e = `_${t.slice(r - 3, r)}${e}`;
        return `${t.slice(0, r)}${e}`;
    }
    function ob(t, e, r) {
        if (typeof e == "function") return Yt(e.length <= r.length, `Code: ${t}; The provided arguments length (${r.length}) does not match the required ones (${e.length}).`), e(...r);
        let i = (e.match(/%[dfijoOs]/g) || []).length;
        return Yt(i === r.length, `Code: ${t}; The provided arguments length (${r.length}) does not match the required ones (${i}).`), r.length === 0 ? e : Zg(e, ...r);
    }
    function we(t, e, r) {
        r || (r = Error);
        class i extends r {
            constructor(...o){
                super(ob(t, e, o));
            }
            toString() {
                return `${this.name} [${t}]: ${this.message}`;
            }
        }
        Object.defineProperties(i.prototype, {
            name: {
                value: r.name,
                writable: !0,
                enumerable: !1,
                configurable: !0
            },
            toString: {
                value () {
                    return `${this.name} [${t}]: ${this.message}`;
                },
                writable: !0,
                enumerable: !1,
                configurable: !0
            }
        }), i.prototype.code = t, i.prototype[rb] = !0, $i[t] = i;
    }
    function Ku(t) {
        let e = sb + t.name;
        return Object.defineProperty(t, "name", {
            value: e
        }), t;
    }
    function ab(t, e) {
        if (t && e && t !== e) {
            if (Array.isArray(e.errors)) return e.errors.push(t), e;
            let r = new tb([
                e,
                t
            ], e.message);
            return r.code = e.code, r;
        }
        return t || e;
    }
    var ms = class extends Error {
        constructor(e = "The operation was aborted", r){
            if (r !== void 0 && typeof r != "object") throw new $i.ERR_INVALID_ARG_TYPE("options", "Object", r);
            super(e, r), this.code = "ABORT_ERR", this.name = "AbortError";
        }
    };
    we("ERR_ASSERTION", "%s", Error);
    we("ERR_INVALID_ARG_TYPE", (t, e, r)=>{
        Yt(typeof t == "string", "'name' must be a string"), Array.isArray(e) || (e = [
            e
        ]);
        let i = "The ";
        t.endsWith(" argument") ? i += `${t} ` : i += `"${t}" ${t.includes(".") ? "property" : "argument"} `, i += "must be ";
        let n = [], o = [], s = [];
        for (let u of e)Yt(typeof u == "string", "All expected entries have to be of type string"), ib.includes(u) ? n.push(u.toLowerCase()) : nb.test(u) ? o.push(u) : (Yt(u !== "object", 'The value "object" should be written as "Object"'), s.push(u));
        if (o.length > 0) {
            let u = n.indexOf("object");
            u !== -1 && (n.splice(n, u, 1), o.push("Object"));
        }
        if (n.length > 0) {
            switch(n.length){
                case 1:
                    i += `of type ${n[0]}`;
                    break;
                case 2:
                    i += `one of type ${n[0]} or ${n[1]}`;
                    break;
                default:
                    {
                        let u = n.pop();
                        i += `one of type ${n.join(", ")}, or ${u}`;
                    }
            }
            (o.length > 0 || s.length > 0) && (i += " or ");
        }
        if (o.length > 0) {
            switch(o.length){
                case 1:
                    i += `an instance of ${o[0]}`;
                    break;
                case 2:
                    i += `an instance of ${o[0]} or ${o[1]}`;
                    break;
                default:
                    {
                        let u = o.pop();
                        i += `an instance of ${o.join(", ")}, or ${u}`;
                    }
            }
            s.length > 0 && (i += " or ");
        }
        switch(s.length){
            case 0:
                break;
            case 1:
                s[0].toLowerCase() !== s[0] && (i += "an "), i += `${s[0]}`;
                break;
            case 2:
                i += `one of ${s[0]} or ${s[1]}`;
                break;
            default:
                {
                    let u = s.pop();
                    i += `one of ${s.join(", ")}, or ${u}`;
                }
        }
        if (r == null) i += `. Received ${r}`;
        else if (typeof r == "function" && r.name) i += `. Received function ${r.name}`;
        else if (typeof r == "object") {
            var a;
            if ((a = r.constructor) !== null && a !== void 0 && a.name) i += `. Received an instance of ${r.constructor.name}`;
            else {
                let u = Wi(r, {
                    depth: -1
                });
                i += `. Received ${u}`;
            }
        } else {
            let u = Wi(r, {
                colors: !1
            });
            u.length > 25 && (u = `${u.slice(0, 25)}...`), i += `. Received type ${typeof r} (${u})`;
        }
        return i;
    }, TypeError);
    we("ERR_INVALID_ARG_VALUE", (t, e, r = "is invalid")=>{
        let i = Wi(e);
        return i.length > 128 && (i = i.slice(0, 128) + "..."), `The ${t.includes(".") ? "property" : "argument"} '${t}' ${r}. Received ${i}`;
    }, TypeError);
    we("ERR_INVALID_RETURN_VALUE", (t, e, r)=>{
        var i;
        let n = r != null && (i = r.constructor) !== null && i !== void 0 && i.name ? `instance of ${r.constructor.name}` : `type ${typeof r}`;
        return `Expected ${t} to be returned from the "${e}" function but got ${n}.`;
    }, TypeError);
    we("ERR_MISSING_ARGS", (...t)=>{
        Yt(t.length > 0, "At least one arg needs to be specified");
        let e, r = t.length;
        switch(t = (Array.isArray(t) ? t : [
            t
        ]).map((i)=>`"${i}"`).join(" or "), r){
            case 1:
                e += `The ${t[0]} argument`;
                break;
            case 2:
                e += `The ${t[0]} and ${t[1]} arguments`;
                break;
            default:
                {
                    let i = t.pop();
                    e += `The ${t.join(", ")}, and ${i} arguments`;
                }
                break;
        }
        return `${e} must be specified`;
    }, TypeError);
    we("ERR_OUT_OF_RANGE", (t, e, r)=>{
        Yt(e, 'Missing "range" argument');
        let i;
        if (Number.isInteger(r) && Math.abs(r) > 2 ** 32) i = zu(String(r));
        else if (typeof r == "bigint") {
            i = String(r);
            let n = BigInt(2) ** BigInt(32);
            (r > n || r < -n) && (i = zu(i)), i += "n";
        } else i = Wi(r);
        return `The value of "${t}" is out of range. It must be ${e}. Received ${i}`;
    }, RangeError);
    we("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
    we("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
    we("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
    we("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
    we("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
    we("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
    we("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
    we("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
    we("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
    we("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
    we("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
    Gu.exports = {
        AbortError: ms,
        aggregateTwoErrors: Ku(ab),
        hideStackFrames: Ku,
        codes: $i
    };
});
var Rr = O((EI, Hi)=>{
    "use strict";
    _();
    v();
    m();
    var { AbortController: Qu, AbortSignal: lb } = typeof self < "u" ? self : typeof window < "u" ? window : void 0;
    Hi.exports = Qu;
    Hi.exports.AbortSignal = lb;
    Hi.exports.default = Qu;
});
function Y() {
    Y.init.call(this);
}
function Vi(t) {
    if (typeof t != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
function sc(t) {
    return t._maxListeners === void 0 ? Y.defaultMaxListeners : t._maxListeners;
}
function Zu(t, e, r, i) {
    var n, o, s, a;
    if (Vi(r), (o = t._events) === void 0 ? (o = t._events = Object.create(null), t._eventsCount = 0) : (o.newListener !== void 0 && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), s = o[e]), s === void 0) s = o[e] = r, ++t._eventsCount;
    else if (typeof s == "function" ? s = o[e] = i ? [
        r,
        s
    ] : [
        s,
        r
    ] : i ? s.unshift(r) : s.push(r), (n = sc(t)) > 0 && s.length > n && !s.warned) {
        s.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = s.length, a = u, console && console.warn && console.warn(a);
    }
    return t;
}
function ub() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function ec(t, e, r) {
    var i = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: r
    }, n = ub.bind(i);
    return n.listener = r, i.wrapFn = n, n;
}
function tc(t, e, r) {
    var i = t._events;
    if (i === void 0) return [];
    var n = i[e];
    return n === void 0 ? [] : typeof n == "function" ? r ? [
        n.listener || n
    ] : [
        n
    ] : r ? function(o) {
        for(var s = new Array(o.length), a = 0; a < s.length; ++a)s[a] = o[a].listener || o[a];
        return s;
    }(n) : oc(n, n.length);
}
function rc(t) {
    var e = this._events;
    if (e !== void 0) {
        var r = e[t];
        if (typeof r == "function") return 1;
        if (r !== void 0) return r.length;
    }
    return 0;
}
function oc(t, e) {
    for(var r = new Array(e), i = 0; i < e; ++i)r[i] = t[i];
    return r;
}
var ic, nc, Cr, Yu, Ju, Xu, Pe, vs = Ae(()=>{
    _();
    v();
    m();
    Cr = typeof Reflect == "object" ? Reflect : null, Yu = Cr && typeof Cr.apply == "function" ? Cr.apply : function(t, e, r) {
        return Function.prototype.apply.call(t, e, r);
    };
    nc = Cr && typeof Cr.ownKeys == "function" ? Cr.ownKeys : Object.getOwnPropertySymbols ? function(t) {
        return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function(t) {
        return Object.getOwnPropertyNames(t);
    };
    Ju = Number.isNaN || function(t) {
        return t != t;
    };
    ic = Y, Y.EventEmitter = Y, Y.prototype._events = void 0, Y.prototype._eventsCount = 0, Y.prototype._maxListeners = void 0;
    Xu = 10;
    Object.defineProperty(Y, "defaultMaxListeners", {
        enumerable: !0,
        get: function() {
            return Xu;
        },
        set: function(t) {
            if (typeof t != "number" || t < 0 || Ju(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
            Xu = t;
        }
    }), Y.init = function() {
        this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, Y.prototype.setMaxListeners = function(t) {
        if (typeof t != "number" || t < 0 || Ju(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
        return this._maxListeners = t, this;
    }, Y.prototype.getMaxListeners = function() {
        return sc(this);
    }, Y.prototype.emit = function(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e.push(arguments[r]);
        var i = t === "error", n = this._events;
        if (n !== void 0) i = i && n.error === void 0;
        else if (!i) return !1;
        if (i) {
            var o;
            if (e.length > 0 && (o = e[0]), o instanceof Error) throw o;
            var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
            throw s.context = o, s;
        }
        var a = n[t];
        if (a === void 0) return !1;
        if (typeof a == "function") Yu(a, this, e);
        else {
            var u = a.length, f = oc(a, u);
            for(r = 0; r < u; ++r)Yu(f[r], this, e);
        }
        return !0;
    }, Y.prototype.addListener = function(t, e) {
        return Zu(this, t, e, !1);
    }, Y.prototype.on = Y.prototype.addListener, Y.prototype.prependListener = function(t, e) {
        return Zu(this, t, e, !0);
    }, Y.prototype.once = function(t, e) {
        return Vi(e), this.on(t, ec(this, t, e)), this;
    }, Y.prototype.prependOnceListener = function(t, e) {
        return Vi(e), this.prependListener(t, ec(this, t, e)), this;
    }, Y.prototype.removeListener = function(t, e) {
        var r, i, n, o, s;
        if (Vi(e), (i = this._events) === void 0) return this;
        if ((r = i[t]) === void 0) return this;
        if (r === e || r.listener === e) --this._eventsCount == 0 ? this._events = Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, r.listener || e));
        else if (typeof r != "function") {
            for(n = -1, o = r.length - 1; o >= 0; o--)if (r[o] === e || r[o].listener === e) {
                s = r[o].listener, n = o;
                break;
            }
            if (n < 0) return this;
            n === 0 ? r.shift() : function(a, u) {
                for(; u + 1 < a.length; u++)a[u] = a[u + 1];
                a.pop();
            }(r, n), r.length === 1 && (i[t] = r[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || e);
        }
        return this;
    }, Y.prototype.off = Y.prototype.removeListener, Y.prototype.removeAllListeners = function(t) {
        var e, r, i;
        if ((r = this._events) === void 0) return this;
        if (r.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : r[t] !== void 0 && (--this._eventsCount == 0 ? this._events = Object.create(null) : delete r[t]), this;
        if (arguments.length === 0) {
            var n, o = Object.keys(r);
            for(i = 0; i < o.length; ++i)(n = o[i]) !== "removeListener" && this.removeAllListeners(n);
            return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }
        if (typeof (e = r[t]) == "function") this.removeListener(t, e);
        else if (e !== void 0) for(i = e.length - 1; i >= 0; i--)this.removeListener(t, e[i]);
        return this;
    }, Y.prototype.listeners = function(t) {
        return tc(this, t, !0);
    }, Y.prototype.rawListeners = function(t) {
        return tc(this, t, !1);
    }, Y.listenerCount = function(t, e) {
        return typeof t.listenerCount == "function" ? t.listenerCount(e) : rc.call(t, e);
    }, Y.prototype.listenerCount = rc, Y.prototype.eventNames = function() {
        return this._eventsCount > 0 ? nc(this._events) : [];
    };
    Pe = ic;
    Pe.EventEmitter;
    Pe.defaultMaxListeners;
    Pe.init;
    Pe.listenerCount;
    Pe.EventEmitter;
    Pe.defaultMaxListeners;
    Pe.init;
    Pe.listenerCount;
});
var xt = {};
Ir(xt, {
    EventEmitter: ()=>cb,
    default: ()=>Pe,
    defaultMaxListeners: ()=>fb,
    init: ()=>hb,
    listenerCount: ()=>db,
    on: ()=>pb,
    once: ()=>gb
});
var cb, fb, hb, db, pb, gb, Ot = Ae(()=>{
    _();
    v();
    m();
    vs();
    vs();
    Pe.once = function(t, e) {
        return new Promise((r, i)=>{
            function n(...s) {
                o !== void 0 && t.removeListener("error", o), r(s);
            }
            let o;
            e !== "error" && (o = (s)=>{
                t.removeListener(name, n), i(s);
            }, t.once("error", o)), t.once(e, n);
        });
    };
    Pe.on = function(t, e) {
        let r = [], i = [], n = null, o = !1, s = {
            async next () {
                let f = r.shift();
                if (f) return createIterResult(f, !1);
                if (n) {
                    let d = Promise.reject(n);
                    return n = null, d;
                }
                return o ? createIterResult(void 0, !0) : new Promise((d, h)=>i.push({
                        resolve: d,
                        reject: h
                    }));
            },
            async return () {
                t.removeListener(e, a), t.removeListener("error", u), o = !0;
                for (let f of i)f.resolve(createIterResult(void 0, !0));
                return createIterResult(void 0, !0);
            },
            throw (f) {
                n = f, t.removeListener(e, a), t.removeListener("error", u);
            },
            [Symbol.asyncIterator] () {
                return this;
            }
        };
        return t.on(e, a), t.on("error", u), s;
        function a(...f) {
            let d = i.shift();
            d ? d.resolve(createIterResult(f, !1)) : r.push(f);
        }
        function u(f) {
            o = !0;
            let d = i.shift();
            d ? d.reject(f) : n = f, s.return();
        }
    };
    ({ EventEmitter: cb, defaultMaxListeners: fb, init: hb, listenerCount: db, on: pb, once: gb } = Pe);
});
var Ie = O((ZI, Ss)=>{
    "use strict";
    _();
    v();
    m();
    var bb = (he(), Q(ye)), { format: yb, inspect: wb } = _s(), { codes: { ERR_INVALID_ARG_TYPE: Es } } = me(), { kResistStopPropagation: _b, AggregateError: mb, SymbolDispose: vb } = ie(), Eb = globalThis.AbortSignal || Rr().AbortSignal, Sb = globalThis.AbortController || Rr().AbortController, Ab = Object.getPrototypeOf(async function() {}).constructor, ac = globalThis.Blob || bb.Blob, Ib = typeof ac < "u" ? function(e) {
        return e instanceof ac;
    } : function(e) {
        return !1;
    }, lc = (t, e)=>{
        if (t !== void 0 && (t === null || typeof t != "object" || !("aborted" in t))) throw new Es(e, "AbortSignal", t);
    }, Tb = (t, e)=>{
        if (typeof t != "function") throw new Es(e, "Function", t);
    };
    Ss.exports = {
        AggregateError: mb,
        kEmptyObject: Object.freeze({}),
        once (t) {
            let e = !1;
            return function(...r) {
                e || (e = !0, t.apply(this, r));
            };
        },
        createDeferredPromise: function() {
            let t, e;
            return {
                promise: new Promise((i, n)=>{
                    t = i, e = n;
                }),
                resolve: t,
                reject: e
            };
        },
        promisify (t) {
            return new Promise((e, r)=>{
                t((i, ...n)=>i ? r(i) : e(...n));
            });
        },
        debuglog () {
            return function() {};
        },
        format: yb,
        inspect: wb,
        types: {
            isAsyncFunction (t) {
                return t instanceof Ab;
            },
            isArrayBufferView (t) {
                return ArrayBuffer.isView(t);
            }
        },
        isBlob: Ib,
        deprecate (t, e) {
            return t;
        },
        addAbortListener: (Ot(), Q(xt)).addAbortListener || function(e, r) {
            if (e === void 0) throw new Es("signal", "AbortSignal", e);
            lc(e, "signal"), Tb(r, "listener");
            let i;
            return e.aborted ? queueMicrotask(()=>r()) : (e.addEventListener("abort", r, {
                __proto__: null,
                once: !0,
                [_b]: !0
            }), i = ()=>{
                e.removeEventListener("abort", r);
            }), {
                __proto__: null,
                [vb] () {
                    var n;
                    (n = i) === null || n === void 0 || n();
                }
            };
        },
        AbortSignalAny: Eb.any || function(e) {
            if (e.length === 1) return e[0];
            let r = new Sb, i = ()=>r.abort();
            return e.forEach((n)=>{
                lc(n, "signals"), n.addEventListener("abort", i, {
                    once: !0
                });
            }), r.signal.addEventListener("abort", ()=>{
                e.forEach((n)=>n.removeEventListener("abort", i));
            }, {
                once: !0
            }), r.signal;
        }
    };
    Ss.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");
});
var kr = O((uT, wc)=>{
    "use strict";
    _();
    v();
    m();
    var { ArrayIsArray: Is, ArrayPrototypeIncludes: hc, ArrayPrototypeJoin: dc, ArrayPrototypeMap: Rb, NumberIsInteger: Ts, NumberIsNaN: Cb, NumberMAX_SAFE_INTEGER: Pb, NumberMIN_SAFE_INTEGER: kb, NumberParseInt: Bb, ObjectPrototypeHasOwnProperty: xb, RegExpPrototypeExec: pc, String: Ob, StringPrototypeToUpperCase: Mb, StringPrototypeTrim: Lb } = ie(), { hideStackFrames: Me, codes: { ERR_SOCKET_BAD_PORT: qb, ERR_INVALID_ARG_TYPE: ve, ERR_INVALID_ARG_VALUE: Pr, ERR_OUT_OF_RANGE: Jt, ERR_UNKNOWN_SIGNAL: uc } } = me(), { normalizeEncoding: Ub } = Ie(), { isAsyncFunction: Nb, isArrayBufferView: Db } = Ie().types, cc = {};
    function jb(t) {
        return t === (t | 0);
    }
    function Fb(t) {
        return t === t >>> 0;
    }
    var Wb = /^[0-7]+$/, $b = "must be a 32-bit unsigned integer or an octal string";
    function Hb(t, e, r) {
        if (typeof t > "u" && (t = r), typeof t == "string") {
            if (pc(Wb, t) === null) throw new Pr(e, t, $b);
            t = Bb(t, 8);
        }
        return gc(t, e), t;
    }
    var Vb = Me((t, e, r = kb, i = Pb)=>{
        if (typeof t != "number") throw new ve(e, "number", t);
        if (!Ts(t)) throw new Jt(e, "an integer", t);
        if (t < r || t > i) throw new Jt(e, `>= ${r} && <= ${i}`, t);
    }), zb = Me((t, e, r = -2147483648, i = 2147483647)=>{
        if (typeof t != "number") throw new ve(e, "number", t);
        if (!Ts(t)) throw new Jt(e, "an integer", t);
        if (t < r || t > i) throw new Jt(e, `>= ${r} && <= ${i}`, t);
    }), gc = Me((t, e, r = !1)=>{
        if (typeof t != "number") throw new ve(e, "number", t);
        if (!Ts(t)) throw new Jt(e, "an integer", t);
        let i = r ? 1 : 0, n = 4294967295;
        if (t < i || t > n) throw new Jt(e, `>= ${i} && <= ${n}`, t);
    });
    function Rs(t, e) {
        if (typeof t != "string") throw new ve(e, "string", t);
    }
    function Kb(t, e, r, i) {
        if (typeof t != "number") throw new ve(e, "number", t);
        if (r != null && t < r || i != null && t > i || (r != null || i != null) && Cb(t)) throw new Jt(e, `${r != null ? `>= ${r}` : ""}${r != null && i != null ? " && " : ""}${i != null ? `<= ${i}` : ""}`, t);
    }
    var Gb = Me((t, e, r)=>{
        if (!hc(r, t)) {
            let n = "must be one of: " + dc(Rb(r, (o)=>typeof o == "string" ? `'${o}'` : Ob(o)), ", ");
            throw new Pr(e, t, n);
        }
    });
    function bc(t, e) {
        if (typeof t != "boolean") throw new ve(e, "boolean", t);
    }
    function As(t, e, r) {
        return t == null || !xb(t, e) ? r : t[e];
    }
    var Qb = Me((t, e, r = null)=>{
        let i = As(r, "allowArray", !1), n = As(r, "allowFunction", !1);
        if (!As(r, "nullable", !1) && t === null || !i && Is(t) || typeof t != "object" && (!n || typeof t != "function")) throw new ve(e, "Object", t);
    }), Yb = Me((t, e)=>{
        if (t != null && typeof t != "object" && typeof t != "function") throw new ve(e, "a dictionary", t);
    }), zi = Me((t, e, r = 0)=>{
        if (!Is(t)) throw new ve(e, "Array", t);
        if (t.length < r) {
            let i = `must be longer than ${r}`;
            throw new Pr(e, t, i);
        }
    });
    function Jb(t, e) {
        zi(t, e);
        for(let r = 0; r < t.length; r++)Rs(t[r], `${e}[${r}]`);
    }
    function Xb(t, e) {
        zi(t, e);
        for(let r = 0; r < t.length; r++)bc(t[r], `${e}[${r}]`);
    }
    function Zb(t, e) {
        zi(t, e);
        for(let r = 0; r < t.length; r++){
            let i = t[r], n = `${e}[${r}]`;
            if (i == null) throw new ve(n, "AbortSignal", i);
            yc(i, n);
        }
    }
    function ey(t, e = "signal") {
        if (Rs(t, e), cc[t] === void 0) throw cc[Mb(t)] !== void 0 ? new uc(t + " (signals must use all capital letters)") : new uc(t);
    }
    var ty = Me((t, e = "buffer")=>{
        if (!Db(t)) throw new ve(e, [
            "Buffer",
            "TypedArray",
            "DataView"
        ], t);
    });
    function ry(t, e) {
        let r = Ub(e), i = t.length;
        if (r === "hex" && i % 2 !== 0) throw new Pr("encoding", e, `is invalid for data of length ${i}`);
    }
    function iy(t, e = "Port", r = !0) {
        if (typeof t != "number" && typeof t != "string" || typeof t == "string" && Lb(t).length === 0 || +t !== +t >>> 0 || t > 65535 || t === 0 && !r) throw new qb(e, t, r);
        return t | 0;
    }
    var yc = Me((t, e)=>{
        if (t !== void 0 && (t === null || typeof t != "object" || !("aborted" in t))) throw new ve(e, "AbortSignal", t);
    }), ny = Me((t, e)=>{
        if (typeof t != "function") throw new ve(e, "Function", t);
    }), sy = Me((t, e)=>{
        if (typeof t != "function" || Nb(t)) throw new ve(e, "Function", t);
    }), oy = Me((t, e)=>{
        if (t !== void 0) throw new ve(e, "undefined", t);
    });
    function ay(t, e, r) {
        if (!hc(r, t)) throw new ve(e, `('${dc(r, "|")}')`, t);
    }
    var ly = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
    function fc(t, e) {
        if (typeof t > "u" || !pc(ly, t)) throw new Pr(e, t, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
    }
    function uy(t) {
        if (typeof t == "string") return fc(t, "hints"), t;
        if (Is(t)) {
            let e = t.length, r = "";
            if (e === 0) return r;
            for(let i = 0; i < e; i++){
                let n = t[i];
                fc(n, "hints"), r += n, i !== e - 1 && (r += ", ");
            }
            return r;
        }
        throw new Pr("hints", t, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
    }
    wc.exports = {
        isInt32: jb,
        isUint32: Fb,
        parseFileMode: Hb,
        validateArray: zi,
        validateStringArray: Jb,
        validateBooleanArray: Xb,
        validateAbortSignalArray: Zb,
        validateBoolean: bc,
        validateBuffer: ty,
        validateDictionary: Yb,
        validateEncoding: ry,
        validateFunction: ny,
        validateInt32: zb,
        validateInteger: Vb,
        validateNumber: Kb,
        validateObject: Qb,
        validateOneOf: Gb,
        validatePlainFunction: sy,
        validatePort: iy,
        validateSignalName: ey,
        validateString: Rs,
        validateUint32: gc,
        validateUndefined: oy,
        validateUnion: ay,
        validateAbortSignal: yc,
        validateLinkHeaderValue: uy
    };
});
var Mt = O((_T, Ec)=>{
    _();
    v();
    m();
    var ue = Ec.exports = {}, Ye, Je;
    function Cs() {
        throw new Error("setTimeout has not been defined");
    }
    function Ps() {
        throw new Error("clearTimeout has not been defined");
    }
    (function() {
        try {
            typeof setTimeout == "function" ? Ye = setTimeout : Ye = Cs;
        } catch  {
            Ye = Cs;
        }
        try {
            typeof clearTimeout == "function" ? Je = clearTimeout : Je = Ps;
        } catch  {
            Je = Ps;
        }
    })();
    function _c(t) {
        if (Ye === setTimeout) return setTimeout(t, 0);
        if ((Ye === Cs || !Ye) && setTimeout) return Ye = setTimeout, setTimeout(t, 0);
        try {
            return Ye(t, 0);
        } catch  {
            try {
                return Ye.call(null, t, 0);
            } catch  {
                return Ye.call(this, t, 0);
            }
        }
    }
    function cy(t) {
        if (Je === clearTimeout) return clearTimeout(t);
        if ((Je === Ps || !Je) && clearTimeout) return Je = clearTimeout, clearTimeout(t);
        try {
            return Je(t);
        } catch  {
            try {
                return Je.call(null, t);
            } catch  {
                return Je.call(this, t);
            }
        }
    }
    var yt = [], Br = !1, Xt, Ki = -1;
    function fy() {
        !Br || !Xt || (Br = !1, Xt.length ? yt = Xt.concat(yt) : Ki = -1, yt.length && mc());
    }
    function mc() {
        if (!Br) {
            var t = _c(fy);
            Br = !0;
            for(var e = yt.length; e;){
                for(Xt = yt, yt = []; ++Ki < e;)Xt && Xt[Ki].run();
                Ki = -1, e = yt.length;
            }
            Xt = null, Br = !1, cy(t);
        }
    }
    ue.nextTick = function(t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        yt.push(new vc(t, e)), yt.length === 1 && !Br && _c(mc);
    };
    function vc(t, e) {
        this.fun = t, this.array = e;
    }
    vc.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    ue.title = "browser";
    ue.browser = !0;
    ue.env = {};
    ue.argv = [];
    ue.version = "";
    ue.versions = {};
    function wt() {}
    ue.on = wt;
    ue.addListener = wt;
    ue.once = wt;
    ue.off = wt;
    ue.removeListener = wt;
    ue.removeAllListeners = wt;
    ue.emit = wt;
    ue.prependListener = wt;
    ue.prependOnceListener = wt;
    ue.listeners = function(t) {
        return [];
    };
    ue.binding = function(t) {
        throw new Error("process.binding is not supported");
    };
    ue.cwd = function() {
        return "/";
    };
    ue.chdir = function(t) {
        throw new Error("process.chdir is not supported");
    };
    ue.umask = function() {
        return 0;
    };
});
var Ze = O((PT, Uc)=>{
    "use strict";
    _();
    v();
    m();
    var { SymbolAsyncIterator: Sc, SymbolIterator: Ac, SymbolFor: Zt } = ie(), Ic = Zt("nodejs.stream.destroyed"), Tc = Zt("nodejs.stream.errored"), ks = Zt("nodejs.stream.readable"), Bs = Zt("nodejs.stream.writable"), Rc = Zt("nodejs.stream.disturbed"), hy = Zt("nodejs.webstream.isClosedPromise"), dy = Zt("nodejs.webstream.controllerErrorFunction");
    function Gi(t, e = !1) {
        var r;
        return !!(t && typeof t.pipe == "function" && typeof t.on == "function" && (!e || typeof t.pause == "function" && typeof t.resume == "function") && (!t._writableState || ((r = t._readableState) === null || r === void 0 ? void 0 : r.readable) !== !1) && (!t._writableState || t._readableState));
    }
    function Qi(t) {
        var e;
        return !!(t && typeof t.write == "function" && typeof t.on == "function" && (!t._readableState || ((e = t._writableState) === null || e === void 0 ? void 0 : e.writable) !== !1));
    }
    function py(t) {
        return !!(t && typeof t.pipe == "function" && t._readableState && typeof t.on == "function" && typeof t.write == "function");
    }
    function Xe(t) {
        return t && (t._readableState || t._writableState || typeof t.write == "function" && typeof t.on == "function" || typeof t.pipe == "function" && typeof t.on == "function");
    }
    function Cc(t) {
        return !!(t && !Xe(t) && typeof t.pipeThrough == "function" && typeof t.getReader == "function" && typeof t.cancel == "function");
    }
    function Pc(t) {
        return !!(t && !Xe(t) && typeof t.getWriter == "function" && typeof t.abort == "function");
    }
    function kc(t) {
        return !!(t && !Xe(t) && typeof t.readable == "object" && typeof t.writable == "object");
    }
    function gy(t) {
        return Cc(t) || Pc(t) || kc(t);
    }
    function by(t, e) {
        return t == null ? !1 : e === !0 ? typeof t[Sc] == "function" : e === !1 ? typeof t[Ac] == "function" : typeof t[Sc] == "function" || typeof t[Ac] == "function";
    }
    function Yi(t) {
        if (!Xe(t)) return null;
        let e = t._writableState, r = t._readableState, i = e || r;
        return !!(t.destroyed || t[Ic] || i != null && i.destroyed);
    }
    function Bc(t) {
        if (!Qi(t)) return null;
        if (t.writableEnded === !0) return !0;
        let e = t._writableState;
        return e != null && e.errored ? !1 : typeof e?.ended != "boolean" ? null : e.ended;
    }
    function yy(t, e) {
        if (!Qi(t)) return null;
        if (t.writableFinished === !0) return !0;
        let r = t._writableState;
        return r != null && r.errored ? !1 : typeof r?.finished != "boolean" ? null : !!(r.finished || e === !1 && r.ended === !0 && r.length === 0);
    }
    function wy(t) {
        if (!Gi(t)) return null;
        if (t.readableEnded === !0) return !0;
        let e = t._readableState;
        return !e || e.errored ? !1 : typeof e?.ended != "boolean" ? null : e.ended;
    }
    function xc(t, e) {
        if (!Gi(t)) return null;
        let r = t._readableState;
        return r != null && r.errored ? !1 : typeof r?.endEmitted != "boolean" ? null : !!(r.endEmitted || e === !1 && r.ended === !0 && r.length === 0);
    }
    function Oc(t) {
        return t && t[ks] != null ? t[ks] : typeof t?.readable != "boolean" ? null : Yi(t) ? !1 : Gi(t) && t.readable && !xc(t);
    }
    function Mc(t) {
        return t && t[Bs] != null ? t[Bs] : typeof t?.writable != "boolean" ? null : Yi(t) ? !1 : Qi(t) && t.writable && !Bc(t);
    }
    function _y(t, e) {
        return Xe(t) ? Yi(t) ? !0 : !(e?.readable !== !1 && Oc(t) || e?.writable !== !1 && Mc(t)) : null;
    }
    function my(t) {
        var e, r;
        return Xe(t) ? t.writableErrored ? t.writableErrored : (e = (r = t._writableState) === null || r === void 0 ? void 0 : r.errored) !== null && e !== void 0 ? e : null : null;
    }
    function vy(t) {
        var e, r;
        return Xe(t) ? t.readableErrored ? t.readableErrored : (e = (r = t._readableState) === null || r === void 0 ? void 0 : r.errored) !== null && e !== void 0 ? e : null : null;
    }
    function Ey(t) {
        if (!Xe(t)) return null;
        if (typeof t.closed == "boolean") return t.closed;
        let e = t._writableState, r = t._readableState;
        return typeof e?.closed == "boolean" || typeof r?.closed == "boolean" ? e?.closed || r?.closed : typeof t._closed == "boolean" && Lc(t) ? t._closed : null;
    }
    function Lc(t) {
        return typeof t._closed == "boolean" && typeof t._defaultKeepAlive == "boolean" && typeof t._removedConnection == "boolean" && typeof t._removedContLen == "boolean";
    }
    function qc(t) {
        return typeof t._sent100 == "boolean" && Lc(t);
    }
    function Sy(t) {
        var e;
        return typeof t._consuming == "boolean" && typeof t._dumped == "boolean" && ((e = t.req) === null || e === void 0 ? void 0 : e.upgradeOrConnect) === void 0;
    }
    function Ay(t) {
        if (!Xe(t)) return null;
        let e = t._writableState, r = t._readableState, i = e || r;
        return !i && qc(t) || !!(i && i.autoDestroy && i.emitClose && i.closed === !1);
    }
    function Iy(t) {
        var e;
        return !!(t && ((e = t[Rc]) !== null && e !== void 0 ? e : t.readableDidRead || t.readableAborted));
    }
    function Ty(t) {
        var e, r, i, n, o, s, a, u, f, d;
        return !!(t && ((e = (r = (i = (n = (o = (s = t[Tc]) !== null && s !== void 0 ? s : t.readableErrored) !== null && o !== void 0 ? o : t.writableErrored) !== null && n !== void 0 ? n : (a = t._readableState) === null || a === void 0 ? void 0 : a.errorEmitted) !== null && i !== void 0 ? i : (u = t._writableState) === null || u === void 0 ? void 0 : u.errorEmitted) !== null && r !== void 0 ? r : (f = t._readableState) === null || f === void 0 ? void 0 : f.errored) !== null && e !== void 0 ? e : !((d = t._writableState) === null || d === void 0) && d.errored));
    }
    Uc.exports = {
        isDestroyed: Yi,
        kIsDestroyed: Ic,
        isDisturbed: Iy,
        kIsDisturbed: Rc,
        isErrored: Ty,
        kIsErrored: Tc,
        isReadable: Oc,
        kIsReadable: ks,
        kIsClosedPromise: hy,
        kControllerErrorFunction: dy,
        kIsWritable: Bs,
        isClosed: Ey,
        isDuplexNodeStream: py,
        isFinished: _y,
        isIterable: by,
        isReadableNodeStream: Gi,
        isReadableStream: Cc,
        isReadableEnded: wy,
        isReadableFinished: xc,
        isReadableErrored: vy,
        isNodeStream: Xe,
        isWebStream: gy,
        isWritable: Mc,
        isWritableNodeStream: Qi,
        isWritableStream: Pc,
        isWritableEnded: Bc,
        isWritableFinished: yy,
        isWritableErrored: my,
        isServerRequest: Sy,
        isServerResponse: qc,
        willEmitClose: Ay,
        isTransformStream: kc
    };
});
var _t = O((DT, qs)=>{
    "use strict";
    _();
    v();
    m();
    var Lt = Mt(), { AbortError: zc, codes: Ry } = me(), { ERR_INVALID_ARG_TYPE: Cy, ERR_STREAM_PREMATURE_CLOSE: Nc } = Ry, { kEmptyObject: Os, once: Ms } = Ie(), { validateAbortSignal: Py, validateFunction: ky, validateObject: By, validateBoolean: xy } = kr(), { Promise: Oy, PromisePrototypeThen: My, SymbolDispose: Kc } = ie(), { isClosed: Ly, isReadable: Dc, isReadableNodeStream: xs, isReadableStream: qy, isReadableFinished: jc, isReadableErrored: Fc, isWritable: Wc, isWritableNodeStream: $c, isWritableStream: Uy, isWritableFinished: Hc, isWritableErrored: Vc, isNodeStream: Ny, willEmitClose: Dy, kIsClosedPromise: jy } = Ze(), xr;
    function Fy(t) {
        return t.setHeader && typeof t.abort == "function";
    }
    var Ls = ()=>{};
    function Gc(t, e, r) {
        var i, n;
        if (arguments.length === 2 ? (r = e, e = Os) : e == null ? e = Os : By(e, "options"), ky(r, "callback"), Py(e.signal, "options.signal"), r = Ms(r), qy(t) || Uy(t)) return Wy(t, e, r);
        if (!Ny(t)) throw new Cy("stream", [
            "ReadableStream",
            "WritableStream",
            "Stream"
        ], t);
        let o = (i = e.readable) !== null && i !== void 0 ? i : xs(t), s = (n = e.writable) !== null && n !== void 0 ? n : $c(t), a = t._writableState, u = t._readableState, f = ()=>{
            t.writable || g();
        }, d = Dy(t) && xs(t) === o && $c(t) === s, h = Hc(t, !1), g = ()=>{
            h = !0, t.destroyed && (d = !1), !(d && (!t.readable || o)) && (!o || b) && r.call(t);
        }, b = jc(t, !1), E = ()=>{
            b = !0, t.destroyed && (d = !1), !(d && (!t.writable || s)) && (!s || h) && r.call(t);
        }, w = (q)=>{
            r.call(t, q);
        }, S = Ly(t), I = ()=>{
            S = !0;
            let q = Vc(t) || Fc(t);
            if (q && typeof q != "boolean") return r.call(t, q);
            if (o && !b && xs(t, !0) && !jc(t, !1)) return r.call(t, new Nc);
            if (s && !h && !Hc(t, !1)) return r.call(t, new Nc);
            r.call(t);
        }, P = ()=>{
            S = !0;
            let q = Vc(t) || Fc(t);
            if (q && typeof q != "boolean") return r.call(t, q);
            r.call(t);
        }, C = ()=>{
            t.req.on("finish", g);
        };
        Fy(t) ? (t.on("complete", g), d || t.on("abort", I), t.req ? C() : t.on("request", C)) : s && !a && (t.on("end", f), t.on("close", f)), !d && typeof t.aborted == "boolean" && t.on("aborted", I), t.on("end", E), t.on("finish", g), e.error !== !1 && t.on("error", w), t.on("close", I), S ? Lt.nextTick(I) : a != null && a.errorEmitted || u != null && u.errorEmitted ? d || Lt.nextTick(P) : (!o && (!d || Dc(t)) && (h || Wc(t) === !1) || !s && (!d || Wc(t)) && (b || Dc(t) === !1) || u && t.req && t.aborted) && Lt.nextTick(P);
        let M = ()=>{
            r = Ls, t.removeListener("aborted", I), t.removeListener("complete", g), t.removeListener("abort", I), t.removeListener("request", C), t.req && t.req.removeListener("finish", g), t.removeListener("end", f), t.removeListener("close", f), t.removeListener("finish", g), t.removeListener("end", E), t.removeListener("error", w), t.removeListener("close", I);
        };
        if (e.signal && !S) {
            let q = ()=>{
                let z = r;
                M(), z.call(t, new zc(void 0, {
                    cause: e.signal.reason
                }));
            };
            if (e.signal.aborted) Lt.nextTick(q);
            else {
                xr = xr || Ie().addAbortListener;
                let z = xr(e.signal, q), j = r;
                r = Ms((...G)=>{
                    z[Kc](), j.apply(t, G);
                });
            }
        }
        return M;
    }
    function Wy(t, e, r) {
        let i = !1, n = Ls;
        if (e.signal) {
            if (n = ()=>{
                i = !0, r.call(t, new zc(void 0, {
                    cause: e.signal.reason
                }));
            }, e.signal.aborted) Lt.nextTick(n);
            else {
                xr = xr || Ie().addAbortListener;
                let s = xr(e.signal, n), a = r;
                r = Ms((...u)=>{
                    s[Kc](), a.apply(t, u);
                });
            }
        }
        let o = (...s)=>{
            i || Lt.nextTick(()=>r.apply(t, s));
        };
        return My(t[jy].promise, o, o), Ls;
    }
    function $y(t, e) {
        var r;
        let i = !1;
        return e === null && (e = Os), (r = e) !== null && r !== void 0 && r.cleanup && (xy(e.cleanup, "cleanup"), i = e.cleanup), new Oy((n, o)=>{
            let s = Gc(t, e, (a)=>{
                i && s(), a ? o(a) : n();
            });
        });
    }
    qs.exports = Gc;
    qs.exports.finished = $y;
});
var er = O((QT, rf)=>{
    "use strict";
    _();
    v();
    m();
    var et = Mt(), { aggregateTwoErrors: Hy, codes: { ERR_MULTIPLE_CALLBACK: Vy }, AbortError: zy } = me(), { Symbol: Jc } = ie(), { kIsDestroyed: Ky, isDestroyed: Gy, isFinished: Qy, isServerRequest: Yy } = Ze(), Xc = Jc("kDestroy"), Us = Jc("kConstruct");
    function Zc(t, e, r) {
        t && (t.stack, e && !e.errored && (e.errored = t), r && !r.errored && (r.errored = t));
    }
    function Jy(t, e) {
        let r = this._readableState, i = this._writableState, n = i || r;
        return i != null && i.destroyed || r != null && r.destroyed ? (typeof e == "function" && e(), this) : (Zc(t, i, r), i && (i.destroyed = !0), r && (r.destroyed = !0), n.constructed ? Qc(this, t, e) : this.once(Xc, function(o) {
            Qc(this, Hy(o, t), e);
        }), this);
    }
    function Qc(t, e, r) {
        let i = !1;
        function n(o) {
            if (i) return;
            i = !0;
            let s = t._readableState, a = t._writableState;
            Zc(o, a, s), a && (a.closed = !0), s && (s.closed = !0), typeof r == "function" && r(o), o ? et.nextTick(Xy, t, o) : et.nextTick(ef, t);
        }
        try {
            t._destroy(e || null, n);
        } catch (o) {
            n(o);
        }
    }
    function Xy(t, e) {
        Ns(t, e), ef(t);
    }
    function ef(t) {
        let e = t._readableState, r = t._writableState;
        r && (r.closeEmitted = !0), e && (e.closeEmitted = !0), (r != null && r.emitClose || e != null && e.emitClose) && t.emit("close");
    }
    function Ns(t, e) {
        let r = t._readableState, i = t._writableState;
        i != null && i.errorEmitted || r != null && r.errorEmitted || (i && (i.errorEmitted = !0), r && (r.errorEmitted = !0), t.emit("error", e));
    }
    function Zy() {
        let t = this._readableState, e = this._writableState;
        t && (t.constructed = !0, t.closed = !1, t.closeEmitted = !1, t.destroyed = !1, t.errored = null, t.errorEmitted = !1, t.reading = !1, t.ended = t.readable === !1, t.endEmitted = t.readable === !1), e && (e.constructed = !0, e.destroyed = !1, e.closed = !1, e.closeEmitted = !1, e.errored = null, e.errorEmitted = !1, e.finalCalled = !1, e.prefinished = !1, e.ended = e.writable === !1, e.ending = e.writable === !1, e.finished = e.writable === !1);
    }
    function Ds(t, e, r) {
        let i = t._readableState, n = t._writableState;
        if (n != null && n.destroyed || i != null && i.destroyed) return this;
        i != null && i.autoDestroy || n != null && n.autoDestroy ? t.destroy(e) : e && (e.stack, n && !n.errored && (n.errored = e), i && !i.errored && (i.errored = e), r ? et.nextTick(Ns, t, e) : Ns(t, e));
    }
    function ew(t, e) {
        if (typeof t._construct != "function") return;
        let r = t._readableState, i = t._writableState;
        r && (r.constructed = !1), i && (i.constructed = !1), t.once(Us, e), !(t.listenerCount(Us) > 1) && et.nextTick(tw, t);
    }
    function tw(t) {
        let e = !1;
        function r(i) {
            if (e) {
                Ds(t, i ?? new Vy);
                return;
            }
            e = !0;
            let n = t._readableState, o = t._writableState, s = o || n;
            n && (n.constructed = !0), o && (o.constructed = !0), s.destroyed ? t.emit(Xc, i) : i ? Ds(t, i, !0) : et.nextTick(rw, t);
        }
        try {
            t._construct((i)=>{
                et.nextTick(r, i);
            });
        } catch (i) {
            et.nextTick(r, i);
        }
    }
    function rw(t) {
        t.emit(Us);
    }
    function Yc(t) {
        return t?.setHeader && typeof t.abort == "function";
    }
    function tf(t) {
        t.emit("close");
    }
    function iw(t, e) {
        t.emit("error", e), et.nextTick(tf, t);
    }
    function nw(t, e) {
        !t || Gy(t) || (!e && !Qy(t) && (e = new zy), Yy(t) ? (t.socket = null, t.destroy(e)) : Yc(t) ? t.abort() : Yc(t.req) ? t.req.abort() : typeof t.destroy == "function" ? t.destroy(e) : typeof t.close == "function" ? t.close() : e ? et.nextTick(iw, t, e) : et.nextTick(tf, t), t.destroyed || (t[Ky] = !0));
    }
    rf.exports = {
        construct: ew,
        destroyer: nw,
        destroy: Jy,
        undestroy: Zy,
        errorOrDestroy: Ds
    };
});
var Zi = O((sR, sf)=>{
    "use strict";
    _();
    v();
    m();
    var { ArrayIsArray: sw, ObjectSetPrototypeOf: nf } = ie(), { EventEmitter: Ji } = (Ot(), Q(xt));
    function Xi(t) {
        Ji.call(this, t);
    }
    nf(Xi.prototype, Ji.prototype);
    nf(Xi, Ji);
    Xi.prototype.pipe = function(t, e) {
        let r = this;
        function i(d) {
            t.writable && t.write(d) === !1 && r.pause && r.pause();
        }
        r.on("data", i);
        function n() {
            r.readable && r.resume && r.resume();
        }
        t.on("drain", n), !t._isStdio && (!e || e.end !== !1) && (r.on("end", s), r.on("close", a));
        let o = !1;
        function s() {
            o || (o = !0, t.end());
        }
        function a() {
            o || (o = !0, typeof t.destroy == "function" && t.destroy());
        }
        function u(d) {
            f(), Ji.listenerCount(this, "error") === 0 && this.emit("error", d);
        }
        js(r, "error", u), js(t, "error", u);
        function f() {
            r.removeListener("data", i), t.removeListener("drain", n), r.removeListener("end", s), r.removeListener("close", a), r.removeListener("error", u), t.removeListener("error", u), r.removeListener("end", f), r.removeListener("close", f), t.removeListener("close", f);
        }
        return r.on("end", f), r.on("close", f), t.on("close", f), t.emit("pipe", r), t;
    };
    function js(t, e, r) {
        if (typeof t.prependListener == "function") return t.prependListener(e, r);
        !t._events || !t._events[e] ? t.on(e, r) : sw(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [
            r,
            t._events[e]
        ];
    }
    sf.exports = {
        Stream: Xi,
        prependListener: js
    };
});
var ai = O((gR, en)=>{
    "use strict";
    _();
    v();
    m();
    var { SymbolDispose: ow } = ie(), { AbortError: of, codes: aw } = me(), { isNodeStream: af, isWebStream: lw, kControllerErrorFunction: uw } = Ze(), cw = _t(), { ERR_INVALID_ARG_TYPE: lf } = aw, Fs, fw = (t, e)=>{
        if (typeof t != "object" || !("aborted" in t)) throw new lf(e, "AbortSignal", t);
    };
    en.exports.addAbortSignal = function(e, r) {
        if (fw(e, "signal"), !af(r) && !lw(r)) throw new lf("stream", [
            "ReadableStream",
            "WritableStream",
            "Stream"
        ], r);
        return en.exports.addAbortSignalNoValidate(e, r);
    };
    en.exports.addAbortSignalNoValidate = function(t, e) {
        if (typeof t != "object" || !("aborted" in t)) return e;
        let r = af(e) ? ()=>{
            e.destroy(new of(void 0, {
                cause: t.reason
            }));
        } : ()=>{
            e[uw](new of(void 0, {
                cause: t.reason
            }));
        };
        if (t.aborted) r();
        else {
            Fs = Fs || Ie().addAbortListener;
            let i = Fs(t, r);
            cw(e, i[ow]);
        }
        return e;
    };
});
var ff = O((TR, cf)=>{
    "use strict";
    _();
    v();
    m();
    var { StringPrototypeSlice: uf, SymbolIterator: hw, TypedArrayPrototypeSet: tn, Uint8Array: dw } = ie(), { Buffer: Ws } = (he(), Q(ye)), { inspect: pw } = Ie();
    cf.exports = class {
        constructor(){
            this.head = null, this.tail = null, this.length = 0;
        }
        push(e) {
            let r = {
                data: e,
                next: null
            };
            this.length > 0 ? this.tail.next = r : this.head = r, this.tail = r, ++this.length;
        }
        unshift(e) {
            let r = {
                data: e,
                next: this.head
            };
            this.length === 0 && (this.tail = r), this.head = r, ++this.length;
        }
        shift() {
            if (this.length === 0) return;
            let e = this.head.data;
            return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
        }
        clear() {
            this.head = this.tail = null, this.length = 0;
        }
        join(e) {
            if (this.length === 0) return "";
            let r = this.head, i = "" + r.data;
            for(; (r = r.next) !== null;)i += e + r.data;
            return i;
        }
        concat(e) {
            if (this.length === 0) return Ws.alloc(0);
            let r = Ws.allocUnsafe(e >>> 0), i = this.head, n = 0;
            for(; i;)tn(r, i.data, n), n += i.data.length, i = i.next;
            return r;
        }
        consume(e, r) {
            let i = this.head.data;
            if (e < i.length) {
                let n = i.slice(0, e);
                return this.head.data = i.slice(e), n;
            }
            return e === i.length ? this.shift() : r ? this._getString(e) : this._getBuffer(e);
        }
        first() {
            return this.head.data;
        }
        *[hw]() {
            for(let e = this.head; e; e = e.next)yield e.data;
        }
        _getString(e) {
            let r = "", i = this.head, n = 0;
            do {
                let o = i.data;
                if (e > o.length) r += o, e -= o.length;
                else {
                    e === o.length ? (r += o, ++n, i.next ? this.head = i.next : this.head = this.tail = null) : (r += uf(o, 0, e), this.head = i, i.data = uf(o, e));
                    break;
                }
                ++n;
            }while ((i = i.next) !== null);
            return this.length -= n, r;
        }
        _getBuffer(e) {
            let r = Ws.allocUnsafe(e), i = e, n = this.head, o = 0;
            do {
                let s = n.data;
                if (e > s.length) tn(r, s, i - e), e -= s.length;
                else {
                    e === s.length ? (tn(r, s, i - e), ++o, n.next ? this.head = n.next : this.head = this.tail = null) : (tn(r, new dw(s.buffer, s.byteOffset, e), i - e), this.head = n, n.data = s.slice(e));
                    break;
                }
                ++o;
            }while ((n = n.next) !== null);
            return this.length -= o, r;
        }
        [Symbol.for("nodejs.util.inspect.custom")](e, r) {
            return pw(this, {
                ...r,
                depth: 0,
                customInspect: !1
            });
        }
    };
});
var li = O((qR, gf)=>{
    "use strict";
    _();
    v();
    m();
    var { MathFloor: gw, NumberIsInteger: bw } = ie(), { validateInteger: yw } = kr(), { ERR_INVALID_ARG_VALUE: ww } = me().codes, hf = 16384, df = 16;
    function _w(t, e, r) {
        return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
    }
    function pf(t) {
        return t ? df : hf;
    }
    function mw(t, e) {
        yw(e, "value", 0), t ? df = e : hf = e;
    }
    function vw(t, e, r, i) {
        let n = _w(e, i, r);
        if (n != null) {
            if (!bw(n) || n < 0) {
                let o = i ? `options.${r}` : "options.highWaterMark";
                throw new ww(o, n);
            }
            return gw(n);
        }
        return pf(t.objectMode);
    }
    gf.exports = {
        getHighWaterMark: vw,
        getDefaultHighWaterMark: pf,
        setDefaultHighWaterMark: mw
    };
});
var wf = O(($s, yf)=>{
    _();
    v();
    m();
    var rn = (he(), Q(ye)), tt = rn.Buffer;
    function bf(t, e) {
        for(var r in t)e[r] = t[r];
    }
    tt.from && tt.alloc && tt.allocUnsafe && tt.allocUnsafeSlow ? yf.exports = rn : (bf(rn, $s), $s.Buffer = tr);
    function tr(t, e, r) {
        return tt(t, e, r);
    }
    tr.prototype = Object.create(tt.prototype);
    bf(tt, tr);
    tr.from = function(t, e, r) {
        if (typeof t == "number") throw new TypeError("Argument must not be a number");
        return tt(t, e, r);
    };
    tr.alloc = function(t, e, r) {
        if (typeof t != "number") throw new TypeError("Argument must be a number");
        var i = tt(t);
        return e !== void 0 ? typeof r == "string" ? i.fill(e, r) : i.fill(e) : i.fill(0), i;
    };
    tr.allocUnsafe = function(t) {
        if (typeof t != "number") throw new TypeError("Argument must be a number");
        return tt(t);
    };
    tr.allocUnsafeSlow = function(t) {
        if (typeof t != "number") throw new TypeError("Argument must be a number");
        return rn.SlowBuffer(t);
    };
});
var vf = O((mf)=>{
    "use strict";
    _();
    v();
    m();
    var Vs = wf().Buffer, _f = Vs.isEncoding || function(t) {
        switch(t = "" + t, t && t.toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
                return !0;
            default:
                return !1;
        }
    };
    function Ew(t) {
        if (!t) return "utf8";
        for(var e;;)switch(t){
            case "utf8":
            case "utf-8":
                return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return "utf16le";
            case "latin1":
            case "binary":
                return "latin1";
            case "base64":
            case "ascii":
            case "hex":
                return t;
            default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
        }
    }
    function Sw(t) {
        var e = Ew(t);
        if (typeof e != "string" && (Vs.isEncoding === _f || !_f(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
    }
    mf.StringDecoder = ui;
    function ui(t) {
        this.encoding = Sw(t);
        var e;
        switch(this.encoding){
            case "utf16le":
                this.text = Pw, this.end = kw, e = 4;
                break;
            case "utf8":
                this.fillLast = Tw, e = 4;
                break;
            case "base64":
                this.text = Bw, this.end = xw, e = 3;
                break;
            default:
                this.write = Ow, this.end = Mw;
                return;
        }
        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Vs.allocUnsafe(e);
    }
    ui.prototype.write = function(t) {
        if (t.length === 0) return "";
        var e, r;
        if (this.lastNeed) {
            if (e = this.fillLast(t), e === void 0) return "";
            r = this.lastNeed, this.lastNeed = 0;
        } else r = 0;
        return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
    };
    ui.prototype.end = Cw;
    ui.prototype.text = Rw;
    ui.prototype.fillLast = function(t) {
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
    function Hs(t) {
        return t <= 127 ? 0 : t >> 5 === 6 ? 2 : t >> 4 === 14 ? 3 : t >> 3 === 30 ? 4 : t >> 6 === 2 ? -1 : -2;
    }
    function Aw(t, e, r) {
        var i = e.length - 1;
        if (i < r) return 0;
        var n = Hs(e[i]);
        return n >= 0 ? (n > 0 && (t.lastNeed = n - 1), n) : --i < r || n === -2 ? 0 : (n = Hs(e[i]), n >= 0 ? (n > 0 && (t.lastNeed = n - 2), n) : --i < r || n === -2 ? 0 : (n = Hs(e[i]), n >= 0 ? (n > 0 && (n === 2 ? n = 0 : t.lastNeed = n - 3), n) : 0));
    }
    function Iw(t, e, r) {
        if ((e[0] & 192) !== 128) return t.lastNeed = 0, "\uFFFD";
        if (t.lastNeed > 1 && e.length > 1) {
            if ((e[1] & 192) !== 128) return t.lastNeed = 1, "\uFFFD";
            if (t.lastNeed > 2 && e.length > 2 && (e[2] & 192) !== 128) return t.lastNeed = 2, "\uFFFD";
        }
    }
    function Tw(t) {
        var e = this.lastTotal - this.lastNeed, r = Iw(this, t, e);
        if (r !== void 0) return r;
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, e, 0, t.length), this.lastNeed -= t.length;
    }
    function Rw(t, e) {
        var r = Aw(this, t, e);
        if (!this.lastNeed) return t.toString("utf8", e);
        this.lastTotal = r;
        var i = t.length - (r - this.lastNeed);
        return t.copy(this.lastChar, 0, i), t.toString("utf8", e, i);
    }
    function Cw(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + "\uFFFD" : e;
    }
    function Pw(t, e) {
        if ((t.length - e) % 2 === 0) {
            var r = t.toString("utf16le", e);
            if (r) {
                var i = r.charCodeAt(r.length - 1);
                if (i >= 55296 && i <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
            }
            return r;
        }
        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }
    function kw(t) {
        var e = t && t.length ? this.write(t) : "";
        if (this.lastNeed) {
            var r = this.lastTotal - this.lastNeed;
            return e + this.lastChar.toString("utf16le", 0, r);
        }
        return e;
    }
    function Bw(t, e) {
        var r = (t.length - e) % 3;
        return r === 0 ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
    }
    function xw(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }
    function Ow(t) {
        return t.toString(this.encoding);
    }
    function Mw(t) {
        return t && t.length ? this.write(t) : "";
    }
});
var zs = O((fC, If)=>{
    "use strict";
    _();
    v();
    m();
    var Ef = Mt(), { PromisePrototypeThen: Lw, SymbolAsyncIterator: Sf, SymbolIterator: Af } = ie(), { Buffer: qw } = (he(), Q(ye)), { ERR_INVALID_ARG_TYPE: Uw, ERR_STREAM_NULL_VALUES: Nw } = me().codes;
    function Dw(t, e, r) {
        let i;
        if (typeof e == "string" || e instanceof qw) return new t({
            objectMode: !0,
            ...r,
            read () {
                this.push(e), this.push(null);
            }
        });
        let n;
        if (e && e[Sf]) n = !0, i = e[Sf]();
        else if (e && e[Af]) n = !1, i = e[Af]();
        else throw new Uw("iterable", [
            "Iterable"
        ], e);
        let o = new t({
            objectMode: !0,
            highWaterMark: 1,
            ...r
        }), s = !1;
        o._read = function() {
            s || (s = !0, u());
        }, o._destroy = function(f, d) {
            Lw(a(f), ()=>Ef.nextTick(d, f), (h)=>Ef.nextTick(d, h || f));
        };
        async function a(f) {
            let d = f != null, h = typeof i.throw == "function";
            if (d && h) {
                let { value: g, done: b } = await i.throw(f);
                if (await g, b) return;
            }
            if (typeof i.return == "function") {
                let { value: g } = await i.return();
                await g;
            }
        }
        async function u() {
            for(;;){
                try {
                    let { value: f, done: d } = n ? await i.next() : i.next();
                    if (d) o.push(null);
                    else {
                        let h = f && typeof f.then == "function" ? await f : f;
                        if (h === null) throw s = !1, new Nw;
                        if (o.push(h)) continue;
                        s = !1;
                    }
                } catch (f) {
                    o.destroy(f);
                }
                break;
            }
        }
        return o;
    }
    If.exports = Dw;
});
var fi = O((vC, $f)=>{
    "use strict";
    _();
    v();
    m();
    var We = Mt(), { ArrayPrototypeIndexOf: jw, NumberIsInteger: Fw, NumberIsNaN: Ww, NumberParseInt: $w, ObjectDefineProperties: eo, ObjectKeys: Hw, ObjectSetPrototypeOf: Cf, Promise: Pf, SafeSet: Vw, SymbolAsyncDispose: zw, SymbolAsyncIterator: Kw, Symbol: Gw } = ie();
    $f.exports = F;
    F.ReadableState = an;
    var { EventEmitter: Qw } = (Ot(), Q(xt)), { Stream: qt, prependListener: Yw } = Zi(), { Buffer: Ks } = (he(), Q(ye)), { addAbortSignal: Jw } = ai(), kf = _t(), H = Ie().debuglog("stream", (t)=>{
        H = t;
    }), Xw = ff(), Lr = er(), { getHighWaterMark: Zw, getDefaultHighWaterMark: e_ } = li(), { aggregateTwoErrors: Tf, codes: { ERR_INVALID_ARG_TYPE: t_, ERR_METHOD_NOT_IMPLEMENTED: r_, ERR_OUT_OF_RANGE: i_, ERR_STREAM_PUSH_AFTER_EOF: n_, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: s_ }, AbortError: o_ } = me(), { validateObject: a_ } = kr(), rr = Gw("kPaused"), { StringDecoder: Bf } = vf(), l_ = zs();
    Cf(F.prototype, qt.prototype);
    Cf(F, qt);
    var Gs = ()=>{}, { errorOrDestroy: Or } = Lr, Mr = 1, u_ = 2, xf = 4, ci = 8, Of = 16, nn = 32, sn = 64, Mf = 128, c_ = 256, f_ = 512, h_ = 1024, Xs = 2048, Zs = 4096, d_ = 8192, p_ = 16384, g_ = 32768, Lf = 65536, b_ = 131072, y_ = 262144;
    function de(t) {
        return {
            enumerable: !1,
            get () {
                return (this.state & t) !== 0;
            },
            set (e) {
                e ? this.state |= t : this.state &= ~t;
            }
        };
    }
    eo(an.prototype, {
        objectMode: de(Mr),
        ended: de(u_),
        endEmitted: de(xf),
        reading: de(ci),
        constructed: de(Of),
        sync: de(nn),
        needReadable: de(sn),
        emittedReadable: de(Mf),
        readableListening: de(c_),
        resumeScheduled: de(f_),
        errorEmitted: de(h_),
        emitClose: de(Xs),
        autoDestroy: de(Zs),
        destroyed: de(d_),
        closed: de(p_),
        closeEmitted: de(g_),
        multiAwaitDrain: de(Lf),
        readingMore: de(b_),
        dataEmitted: de(y_)
    });
    function an(t, e, r) {
        typeof r != "boolean" && (r = e instanceof rt()), this.state = Xs | Zs | Of | nn, t && t.objectMode && (this.state |= Mr), r && t && t.readableObjectMode && (this.state |= Mr), this.highWaterMark = t ? Zw(this, t, "readableHighWaterMark", r) : e_(!1), this.buffer = new Xw, this.length = 0, this.pipes = [], this.flowing = null, this[rr] = null, t && t.emitClose === !1 && (this.state &= ~Xs), t && t.autoDestroy === !1 && (this.state &= ~Zs), this.errored = null, this.defaultEncoding = t && t.defaultEncoding || "utf8", this.awaitDrainWriters = null, this.decoder = null, this.encoding = null, t && t.encoding && (this.decoder = new Bf(t.encoding), this.encoding = t.encoding);
    }
    function F(t) {
        if (!(this instanceof F)) return new F(t);
        let e = this instanceof rt();
        this._readableState = new an(t, this, e), t && (typeof t.read == "function" && (this._read = t.read), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.construct == "function" && (this._construct = t.construct), t.signal && !e && Jw(t.signal, this)), qt.call(this, t), Lr.construct(this, ()=>{
            this._readableState.needReadable && on(this, this._readableState);
        });
    }
    F.prototype.destroy = Lr.destroy;
    F.prototype._undestroy = Lr.undestroy;
    F.prototype._destroy = function(t, e) {
        e(t);
    };
    F.prototype[Qw.captureRejectionSymbol] = function(t) {
        this.destroy(t);
    };
    F.prototype[zw] = function() {
        let t;
        return this.destroyed || (t = this.readableEnded ? null : new o_, this.destroy(t)), new Pf((e, r)=>kf(this, (i)=>i && i !== t ? r(i) : e(null)));
    };
    F.prototype.push = function(t, e) {
        return qf(this, t, e, !1);
    };
    F.prototype.unshift = function(t, e) {
        return qf(this, t, e, !0);
    };
    function qf(t, e, r, i) {
        H("readableAddChunk", e);
        let n = t._readableState, o;
        if ((n.state & Mr) === 0 && (typeof e == "string" ? (r = r || n.defaultEncoding, n.encoding !== r && (i && n.encoding ? e = Ks.from(e, r).toString(n.encoding) : (e = Ks.from(e, r), r = ""))) : e instanceof Ks ? r = "" : qt._isUint8Array(e) ? (e = qt._uint8ArrayToBuffer(e), r = "") : e != null && (o = new t_("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], e))), o) Or(t, o);
        else if (e === null) n.state &= ~ci, m_(t, n);
        else if ((n.state & Mr) !== 0 || e && e.length > 0) {
            if (i) {
                if ((n.state & xf) !== 0) Or(t, new s_);
                else {
                    if (n.destroyed || n.errored) return !1;
                    Qs(t, n, e, !0);
                }
            } else if (n.ended) Or(t, new n_);
            else {
                if (n.destroyed || n.errored) return !1;
                n.state &= ~ci, n.decoder && !r ? (e = n.decoder.write(e), n.objectMode || e.length !== 0 ? Qs(t, n, e, !1) : on(t, n)) : Qs(t, n, e, !1);
            }
        } else i || (n.state &= ~ci, on(t, n));
        return !n.ended && (n.length < n.highWaterMark || n.length === 0);
    }
    function Qs(t, e, r, i) {
        e.flowing && e.length === 0 && !e.sync && t.listenerCount("data") > 0 ? ((e.state & Lf) !== 0 ? e.awaitDrainWriters.clear() : e.awaitDrainWriters = null, e.dataEmitted = !0, t.emit("data", r)) : (e.length += e.objectMode ? 1 : r.length, i ? e.buffer.unshift(r) : e.buffer.push(r), (e.state & sn) !== 0 && ln(t)), on(t, e);
    }
    F.prototype.isPaused = function() {
        let t = this._readableState;
        return t[rr] === !0 || t.flowing === !1;
    };
    F.prototype.setEncoding = function(t) {
        let e = new Bf(t);
        this._readableState.decoder = e, this._readableState.encoding = this._readableState.decoder.encoding;
        let r = this._readableState.buffer, i = "";
        for (let n of r)i += e.write(n);
        return r.clear(), i !== "" && r.push(i), this._readableState.length = i.length, this;
    };
    var w_ = 1073741824;
    function __(t) {
        if (t > w_) throw new i_("size", "<= 1GiB", t);
        return t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++, t;
    }
    function Rf(t, e) {
        return t <= 0 || e.length === 0 && e.ended ? 0 : (e.state & Mr) !== 0 ? 1 : Ww(t) ? e.flowing && e.length ? e.buffer.first().length : e.length : t <= e.length ? t : e.ended ? e.length : 0;
    }
    F.prototype.read = function(t) {
        H("read", t), t === void 0 ? t = NaN : Fw(t) || (t = $w(t, 10));
        let e = this._readableState, r = t;
        if (t > e.highWaterMark && (e.highWaterMark = __(t)), t !== 0 && (e.state &= ~Mf), t === 0 && e.needReadable && ((e.highWaterMark !== 0 ? e.length >= e.highWaterMark : e.length > 0) || e.ended)) return H("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? Ys(this) : ln(this), null;
        if (t = Rf(t, e), t === 0 && e.ended) return e.length === 0 && Ys(this), null;
        let i = (e.state & sn) !== 0;
        if (H("need readable", i), (e.length === 0 || e.length - t < e.highWaterMark) && (i = !0, H("length less than watermark", i)), e.ended || e.reading || e.destroyed || e.errored || !e.constructed) i = !1, H("reading, ended or constructing", i);
        else if (i) {
            H("do read"), e.state |= ci | nn, e.length === 0 && (e.state |= sn);
            try {
                this._read(e.highWaterMark);
            } catch (o) {
                Or(this, o);
            }
            e.state &= ~nn, e.reading || (t = Rf(r, e));
        }
        let n;
        return t > 0 ? n = Ff(t, e) : n = null, n === null ? (e.needReadable = e.length <= e.highWaterMark, t = 0) : (e.length -= t, e.multiAwaitDrain ? e.awaitDrainWriters.clear() : e.awaitDrainWriters = null), e.length === 0 && (e.ended || (e.needReadable = !0), r !== t && e.ended && Ys(this)), n !== null && !e.errorEmitted && !e.closeEmitted && (e.dataEmitted = !0, this.emit("data", n)), n;
    };
    function m_(t, e) {
        if (H("onEofChunk"), !e.ended) {
            if (e.decoder) {
                let r = e.decoder.end();
                r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
            }
            e.ended = !0, e.sync ? ln(t) : (e.needReadable = !1, e.emittedReadable = !0, Uf(t));
        }
    }
    function ln(t) {
        let e = t._readableState;
        H("emitReadable", e.needReadable, e.emittedReadable), e.needReadable = !1, e.emittedReadable || (H("emitReadable", e.flowing), e.emittedReadable = !0, We.nextTick(Uf, t));
    }
    function Uf(t) {
        let e = t._readableState;
        H("emitReadable_", e.destroyed, e.length, e.ended), !e.destroyed && !e.errored && (e.length || e.ended) && (t.emit("readable"), e.emittedReadable = !1), e.needReadable = !e.flowing && !e.ended && e.length <= e.highWaterMark, Df(t);
    }
    function on(t, e) {
        !e.readingMore && e.constructed && (e.readingMore = !0, We.nextTick(v_, t, e));
    }
    function v_(t, e) {
        for(; !e.reading && !e.ended && (e.length < e.highWaterMark || e.flowing && e.length === 0);){
            let r = e.length;
            if (H("maybeReadMore read 0"), t.read(0), r === e.length) break;
        }
        e.readingMore = !1;
    }
    F.prototype._read = function(t) {
        throw new r_("_read()");
    };
    F.prototype.pipe = function(t, e) {
        let r = this, i = this._readableState;
        i.pipes.length === 1 && (i.multiAwaitDrain || (i.multiAwaitDrain = !0, i.awaitDrainWriters = new Vw(i.awaitDrainWriters ? [
            i.awaitDrainWriters
        ] : []))), i.pipes.push(t), H("pipe count=%d opts=%j", i.pipes.length, e);
        let o = (!e || e.end !== !1) && t !== We.stdout && t !== We.stderr ? a : S;
        i.endEmitted ? We.nextTick(o) : r.once("end", o), t.on("unpipe", s);
        function s(I, P) {
            H("onunpipe"), I === r && P && P.hasUnpiped === !1 && (P.hasUnpiped = !0, d());
        }
        function a() {
            H("onend"), t.end();
        }
        let u, f = !1;
        function d() {
            H("cleanup"), t.removeListener("close", E), t.removeListener("finish", w), u && t.removeListener("drain", u), t.removeListener("error", b), t.removeListener("unpipe", s), r.removeListener("end", a), r.removeListener("end", S), r.removeListener("data", g), f = !0, u && i.awaitDrainWriters && (!t._writableState || t._writableState.needDrain) && u();
        }
        function h() {
            f || (i.pipes.length === 1 && i.pipes[0] === t ? (H("false write response, pause", 0), i.awaitDrainWriters = t, i.multiAwaitDrain = !1) : i.pipes.length > 1 && i.pipes.includes(t) && (H("false write response, pause", i.awaitDrainWriters.size), i.awaitDrainWriters.add(t)), r.pause()), u || (u = E_(r, t), t.on("drain", u));
        }
        r.on("data", g);
        function g(I) {
            H("ondata");
            let P = t.write(I);
            H("dest.write", P), P === !1 && h();
        }
        function b(I) {
            if (H("onerror", I), S(), t.removeListener("error", b), t.listenerCount("error") === 0) {
                let P = t._writableState || t._readableState;
                P && !P.errorEmitted ? Or(t, I) : t.emit("error", I);
            }
        }
        Yw(t, "error", b);
        function E() {
            t.removeListener("finish", w), S();
        }
        t.once("close", E);
        function w() {
            H("onfinish"), t.removeListener("close", E), S();
        }
        t.once("finish", w);
        function S() {
            H("unpipe"), r.unpipe(t);
        }
        return t.emit("pipe", r), t.writableNeedDrain === !0 ? h() : i.flowing || (H("pipe resume"), r.resume()), t;
    };
    function E_(t, e) {
        return function() {
            let i = t._readableState;
            i.awaitDrainWriters === e ? (H("pipeOnDrain", 1), i.awaitDrainWriters = null) : i.multiAwaitDrain && (H("pipeOnDrain", i.awaitDrainWriters.size), i.awaitDrainWriters.delete(e)), (!i.awaitDrainWriters || i.awaitDrainWriters.size === 0) && t.listenerCount("data") && t.resume();
        };
    }
    F.prototype.unpipe = function(t) {
        let e = this._readableState, r = {
            hasUnpiped: !1
        };
        if (e.pipes.length === 0) return this;
        if (!t) {
            let n = e.pipes;
            e.pipes = [], this.pause();
            for(let o = 0; o < n.length; o++)n[o].emit("unpipe", this, {
                hasUnpiped: !1
            });
            return this;
        }
        let i = jw(e.pipes, t);
        return i === -1 ? this : (e.pipes.splice(i, 1), e.pipes.length === 0 && this.pause(), t.emit("unpipe", this, r), this);
    };
    F.prototype.on = function(t, e) {
        let r = qt.prototype.on.call(this, t, e), i = this._readableState;
        return t === "data" ? (i.readableListening = this.listenerCount("readable") > 0, i.flowing !== !1 && this.resume()) : t === "readable" && !i.endEmitted && !i.readableListening && (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, H("on readable", i.length, i.reading), i.length ? ln(this) : i.reading || We.nextTick(S_, this)), r;
    };
    F.prototype.addListener = F.prototype.on;
    F.prototype.removeListener = function(t, e) {
        let r = qt.prototype.removeListener.call(this, t, e);
        return t === "readable" && We.nextTick(Nf, this), r;
    };
    F.prototype.off = F.prototype.removeListener;
    F.prototype.removeAllListeners = function(t) {
        let e = qt.prototype.removeAllListeners.apply(this, arguments);
        return (t === "readable" || t === void 0) && We.nextTick(Nf, this), e;
    };
    function Nf(t) {
        let e = t._readableState;
        e.readableListening = t.listenerCount("readable") > 0, e.resumeScheduled && e[rr] === !1 ? e.flowing = !0 : t.listenerCount("data") > 0 ? t.resume() : e.readableListening || (e.flowing = null);
    }
    function S_(t) {
        H("readable nexttick read 0"), t.read(0);
    }
    F.prototype.resume = function() {
        let t = this._readableState;
        return t.flowing || (H("resume"), t.flowing = !t.readableListening, A_(this, t)), t[rr] = !1, this;
    };
    function A_(t, e) {
        e.resumeScheduled || (e.resumeScheduled = !0, We.nextTick(I_, t, e));
    }
    function I_(t, e) {
        H("resume", e.reading), e.reading || t.read(0), e.resumeScheduled = !1, t.emit("resume"), Df(t), e.flowing && !e.reading && t.read(0);
    }
    F.prototype.pause = function() {
        return H("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (H("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState[rr] = !0, this;
    };
    function Df(t) {
        let e = t._readableState;
        for(H("flow", e.flowing); e.flowing && t.read() !== null;);
    }
    F.prototype.wrap = function(t) {
        let e = !1;
        t.on("data", (i)=>{
            !this.push(i) && t.pause && (e = !0, t.pause());
        }), t.on("end", ()=>{
            this.push(null);
        }), t.on("error", (i)=>{
            Or(this, i);
        }), t.on("close", ()=>{
            this.destroy();
        }), t.on("destroy", ()=>{
            this.destroy();
        }), this._read = ()=>{
            e && t.resume && (e = !1, t.resume());
        };
        let r = Hw(t);
        for(let i = 1; i < r.length; i++){
            let n = r[i];
            this[n] === void 0 && typeof t[n] == "function" && (this[n] = t[n].bind(t));
        }
        return this;
    };
    F.prototype[Kw] = function() {
        return jf(this);
    };
    F.prototype.iterator = function(t) {
        return t !== void 0 && a_(t, "options"), jf(this, t);
    };
    function jf(t, e) {
        typeof t.read != "function" && (t = F.wrap(t, {
            objectMode: !0
        }));
        let r = T_(t, e);
        return r.stream = t, r;
    }
    async function* T_(t, e) {
        let r = Gs;
        function i(s) {
            this === t ? (r(), r = Gs) : r = s;
        }
        t.on("readable", i);
        let n, o = kf(t, {
            writable: !1
        }, (s)=>{
            n = s ? Tf(n, s) : null, r(), r = Gs;
        });
        try {
            for(;;){
                let s = t.destroyed ? null : t.read();
                if (s !== null) yield s;
                else {
                    if (n) throw n;
                    if (n === null) return;
                    await new Pf(i);
                }
            }
        } catch (s) {
            throw n = Tf(n, s), n;
        } finally{
            (n || e?.destroyOnReturn !== !1) && (n === void 0 || t._readableState.autoDestroy) ? Lr.destroyer(t, null) : (t.off("readable", i), o());
        }
    }
    eo(F.prototype, {
        readable: {
            __proto__: null,
            get () {
                let t = this._readableState;
                return !!t && t.readable !== !1 && !t.destroyed && !t.errorEmitted && !t.endEmitted;
            },
            set (t) {
                this._readableState && (this._readableState.readable = !!t);
            }
        },
        readableDidRead: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState.dataEmitted;
            }
        },
        readableAborted: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return !!(this._readableState.readable !== !1 && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
            }
        },
        readableHighWaterMark: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState.highWaterMark;
            }
        },
        readableBuffer: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState && this._readableState.buffer;
            }
        },
        readableFlowing: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState.flowing;
            },
            set: function(t) {
                this._readableState && (this._readableState.flowing = t);
            }
        },
        readableLength: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState.length;
            }
        },
        readableObjectMode: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.objectMode : !1;
            }
        },
        readableEncoding: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.encoding : null;
            }
        },
        errored: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.errored : null;
            }
        },
        closed: {
            __proto__: null,
            get () {
                return this._readableState ? this._readableState.closed : !1;
            }
        },
        destroyed: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.destroyed : !1;
            },
            set (t) {
                this._readableState && (this._readableState.destroyed = t);
            }
        },
        readableEnded: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.endEmitted : !1;
            }
        }
    });
    eo(an.prototype, {
        pipesCount: {
            __proto__: null,
            get () {
                return this.pipes.length;
            }
        },
        paused: {
            __proto__: null,
            get () {
                return this[rr] !== !1;
            },
            set (t) {
                this[rr] = !!t;
            }
        }
    });
    F._fromList = Ff;
    function Ff(t, e) {
        if (e.length === 0) return null;
        let r;
        return e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (e.decoder ? r = e.buffer.join("") : e.buffer.length === 1 ? r = e.buffer.first() : r = e.buffer.concat(e.length), e.buffer.clear()) : r = e.buffer.consume(t, e.decoder), r;
    }
    function Ys(t) {
        let e = t._readableState;
        H("endReadable", e.endEmitted), e.endEmitted || (e.ended = !0, We.nextTick(R_, e, t));
    }
    function R_(t, e) {
        if (H("endReadableNT", t.endEmitted, t.length), !t.errored && !t.closeEmitted && !t.endEmitted && t.length === 0) {
            if (t.endEmitted = !0, e.emit("end"), e.writable && e.allowHalfOpen === !1) We.nextTick(C_, e);
            else if (t.autoDestroy) {
                let r = e._writableState;
                (!r || r.autoDestroy && (r.finished || r.writable === !1)) && e.destroy();
            }
        }
    }
    function C_(t) {
        t.writable && !t.writableEnded && !t.destroyed && t.end();
    }
    F.from = function(t, e) {
        return l_(F, t, e);
    };
    var Js;
    function Wf() {
        return Js === void 0 && (Js = {}), Js;
    }
    F.fromWeb = function(t, e) {
        return Wf().newStreamReadableFromReadableStream(t, e);
    };
    F.toWeb = function(t, e) {
        return Wf().newReadableStreamFromStreamReadable(t, e);
    };
    F.wrap = function(t, e) {
        var r, i;
        return new F({
            objectMode: (r = (i = t.readableObjectMode) !== null && i !== void 0 ? i : t.objectMode) !== null && r !== void 0 ? r : !0,
            ...e,
            destroy (n, o) {
                Lr.destroyer(t, n), o(n);
            }
        }).wrap(t);
    };
});
var dn = O((BC, th)=>{
    "use strict";
    _();
    v();
    m();
    var ir = Mt(), { ArrayPrototypeSlice: zf, Error: P_, FunctionPrototypeSymbolHasInstance: Kf, ObjectDefineProperty: Gf, ObjectDefineProperties: k_, ObjectSetPrototypeOf: Qf, StringPrototypeToLowerCase: B_, Symbol: x_, SymbolHasInstance: O_ } = ie();
    th.exports = se;
    se.WritableState = pi;
    var { EventEmitter: M_ } = (Ot(), Q(xt)), hi = Zi().Stream, { Buffer: un } = (he(), Q(ye)), hn = er(), { addAbortSignal: L_ } = ai(), { getHighWaterMark: q_, getDefaultHighWaterMark: U_ } = li(), { ERR_INVALID_ARG_TYPE: N_, ERR_METHOD_NOT_IMPLEMENTED: D_, ERR_MULTIPLE_CALLBACK: Yf, ERR_STREAM_CANNOT_PIPE: j_, ERR_STREAM_DESTROYED: di, ERR_STREAM_ALREADY_FINISHED: F_, ERR_STREAM_NULL_VALUES: W_, ERR_STREAM_WRITE_AFTER_END: $_, ERR_UNKNOWN_ENCODING: Jf } = me().codes, { errorOrDestroy: qr } = hn;
    Qf(se.prototype, hi.prototype);
    Qf(se, hi);
    function io() {}
    var Ur = x_("kOnFinished");
    function pi(t, e, r) {
        typeof r != "boolean" && (r = e instanceof rt()), this.objectMode = !!(t && t.objectMode), r && (this.objectMode = this.objectMode || !!(t && t.writableObjectMode)), this.highWaterMark = t ? q_(this, t, "writableHighWaterMark", r) : U_(!1), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        let i = !!(t && t.decodeStrings === !1);
        this.decodeStrings = !i, this.defaultEncoding = t && t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = V_.bind(void 0, e), this.writecb = null, this.writelen = 0, this.afterWriteTickInfo = null, fn(this), this.pendingcb = 0, this.constructed = !0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !t || t.emitClose !== !1, this.autoDestroy = !t || t.autoDestroy !== !1, this.errored = null, this.closed = !1, this.closeEmitted = !1, this[Ur] = [];
    }
    function fn(t) {
        t.buffered = [], t.bufferedIndex = 0, t.allBuffers = !0, t.allNoop = !0;
    }
    pi.prototype.getBuffer = function() {
        return zf(this.buffered, this.bufferedIndex);
    };
    Gf(pi.prototype, "bufferedRequestCount", {
        __proto__: null,
        get () {
            return this.buffered.length - this.bufferedIndex;
        }
    });
    function se(t) {
        let e = this instanceof rt();
        if (!e && !Kf(se, this)) return new se(t);
        this._writableState = new pi(t, this, e), t && (typeof t.write == "function" && (this._write = t.write), typeof t.writev == "function" && (this._writev = t.writev), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.final == "function" && (this._final = t.final), typeof t.construct == "function" && (this._construct = t.construct), t.signal && L_(t.signal, this)), hi.call(this, t), hn.construct(this, ()=>{
            let r = this._writableState;
            r.writing || so(this, r), oo(this, r);
        });
    }
    Gf(se, O_, {
        __proto__: null,
        value: function(t) {
            return Kf(this, t) ? !0 : this !== se ? !1 : t && t._writableState instanceof pi;
        }
    });
    se.prototype.pipe = function() {
        qr(this, new j_);
    };
    function Xf(t, e, r, i) {
        let n = t._writableState;
        if (typeof r == "function") i = r, r = n.defaultEncoding;
        else {
            if (!r) r = n.defaultEncoding;
            else if (r !== "buffer" && !un.isEncoding(r)) throw new Jf(r);
            typeof i != "function" && (i = io);
        }
        if (e === null) throw new W_;
        if (!n.objectMode) {
            if (typeof e == "string") n.decodeStrings !== !1 && (e = un.from(e, r), r = "buffer");
            else if (e instanceof un) r = "buffer";
            else if (hi._isUint8Array(e)) e = hi._uint8ArrayToBuffer(e), r = "buffer";
            else throw new N_("chunk", [
                "string",
                "Buffer",
                "Uint8Array"
            ], e);
        }
        let o;
        return n.ending ? o = new $_ : n.destroyed && (o = new di("write")), o ? (ir.nextTick(i, o), qr(t, o, !0), o) : (n.pendingcb++, H_(t, n, e, r, i));
    }
    se.prototype.write = function(t, e, r) {
        return Xf(this, t, e, r) === !0;
    };
    se.prototype.cork = function() {
        this._writableState.corked++;
    };
    se.prototype.uncork = function() {
        let t = this._writableState;
        t.corked && (t.corked--, t.writing || so(this, t));
    };
    se.prototype.setDefaultEncoding = function(e) {
        if (typeof e == "string" && (e = B_(e)), !un.isEncoding(e)) throw new Jf(e);
        return this._writableState.defaultEncoding = e, this;
    };
    function H_(t, e, r, i, n) {
        let o = e.objectMode ? 1 : r.length;
        e.length += o;
        let s = e.length < e.highWaterMark;
        return s || (e.needDrain = !0), e.writing || e.corked || e.errored || !e.constructed ? (e.buffered.push({
            chunk: r,
            encoding: i,
            callback: n
        }), e.allBuffers && i !== "buffer" && (e.allBuffers = !1), e.allNoop && n !== io && (e.allNoop = !1)) : (e.writelen = o, e.writecb = n, e.writing = !0, e.sync = !0, t._write(r, i, e.onwrite), e.sync = !1), s && !e.errored && !e.destroyed;
    }
    function Hf(t, e, r, i, n, o, s) {
        e.writelen = i, e.writecb = s, e.writing = !0, e.sync = !0, e.destroyed ? e.onwrite(new di("write")) : r ? t._writev(n, e.onwrite) : t._write(n, o, e.onwrite), e.sync = !1;
    }
    function Vf(t, e, r, i) {
        --e.pendingcb, i(r), no(e), qr(t, r);
    }
    function V_(t, e) {
        let r = t._writableState, i = r.sync, n = r.writecb;
        if (typeof n != "function") {
            qr(t, new Yf);
            return;
        }
        r.writing = !1, r.writecb = null, r.length -= r.writelen, r.writelen = 0, e ? (e.stack, r.errored || (r.errored = e), t._readableState && !t._readableState.errored && (t._readableState.errored = e), i ? ir.nextTick(Vf, t, r, e, n) : Vf(t, r, e, n)) : (r.buffered.length > r.bufferedIndex && so(t, r), i ? r.afterWriteTickInfo !== null && r.afterWriteTickInfo.cb === n ? r.afterWriteTickInfo.count++ : (r.afterWriteTickInfo = {
            count: 1,
            cb: n,
            stream: t,
            state: r
        }, ir.nextTick(z_, r.afterWriteTickInfo)) : Zf(t, r, 1, n));
    }
    function z_({ stream: t, state: e, count: r, cb: i }) {
        return e.afterWriteTickInfo = null, Zf(t, e, r, i);
    }
    function Zf(t, e, r, i) {
        for(!e.ending && !t.destroyed && e.length === 0 && e.needDrain && (e.needDrain = !1, t.emit("drain")); r-- > 0;)e.pendingcb--, i();
        e.destroyed && no(e), oo(t, e);
    }
    function no(t) {
        if (t.writing) return;
        for(let n = t.bufferedIndex; n < t.buffered.length; ++n){
            var e;
            let { chunk: o, callback: s } = t.buffered[n], a = t.objectMode ? 1 : o.length;
            t.length -= a, s((e = t.errored) !== null && e !== void 0 ? e : new di("write"));
        }
        let r = t[Ur].splice(0);
        for(let n = 0; n < r.length; n++){
            var i;
            r[n]((i = t.errored) !== null && i !== void 0 ? i : new di("end"));
        }
        fn(t);
    }
    function so(t, e) {
        if (e.corked || e.bufferProcessing || e.destroyed || !e.constructed) return;
        let { buffered: r, bufferedIndex: i, objectMode: n } = e, o = r.length - i;
        if (!o) return;
        let s = i;
        if (e.bufferProcessing = !0, o > 1 && t._writev) {
            e.pendingcb -= o - 1;
            let a = e.allNoop ? io : (f)=>{
                for(let d = s; d < r.length; ++d)r[d].callback(f);
            }, u = e.allNoop && s === 0 ? r : zf(r, s);
            u.allBuffers = e.allBuffers, Hf(t, e, !0, e.length, u, "", a), fn(e);
        } else {
            do {
                let { chunk: a, encoding: u, callback: f } = r[s];
                r[s++] = null;
                let d = n ? 1 : a.length;
                Hf(t, e, !1, d, a, u, f);
            }while (s < r.length && !e.writing);
            s === r.length ? fn(e) : s > 256 ? (r.splice(0, s), e.bufferedIndex = 0) : e.bufferedIndex = s;
        }
        e.bufferProcessing = !1;
    }
    se.prototype._write = function(t, e, r) {
        if (this._writev) this._writev([
            {
                chunk: t,
                encoding: e
            }
        ], r);
        else throw new D_("_write()");
    };
    se.prototype._writev = null;
    se.prototype.end = function(t, e, r) {
        let i = this._writableState;
        typeof t == "function" ? (r = t, t = null, e = null) : typeof e == "function" && (r = e, e = null);
        let n;
        if (t != null) {
            let o = Xf(this, t, e);
            o instanceof P_ && (n = o);
        }
        return i.corked && (i.corked = 1, this.uncork()), n || (!i.errored && !i.ending ? (i.ending = !0, oo(this, i, !0), i.ended = !0) : i.finished ? n = new F_("end") : i.destroyed && (n = new di("end"))), typeof r == "function" && (n || i.finished ? ir.nextTick(r, n) : i[Ur].push(r)), this;
    };
    function cn(t) {
        return t.ending && !t.destroyed && t.constructed && t.length === 0 && !t.errored && t.buffered.length === 0 && !t.finished && !t.writing && !t.errorEmitted && !t.closeEmitted;
    }
    function K_(t, e) {
        let r = !1;
        function i(n) {
            if (r) {
                qr(t, n ?? Yf());
                return;
            }
            if (r = !0, e.pendingcb--, n) {
                let o = e[Ur].splice(0);
                for(let s = 0; s < o.length; s++)o[s](n);
                qr(t, n, e.sync);
            } else cn(e) && (e.prefinished = !0, t.emit("prefinish"), e.pendingcb++, ir.nextTick(ro, t, e));
        }
        e.sync = !0, e.pendingcb++;
        try {
            t._final(i);
        } catch (n) {
            i(n);
        }
        e.sync = !1;
    }
    function G_(t, e) {
        !e.prefinished && !e.finalCalled && (typeof t._final == "function" && !e.destroyed ? (e.finalCalled = !0, K_(t, e)) : (e.prefinished = !0, t.emit("prefinish")));
    }
    function oo(t, e, r) {
        cn(e) && (G_(t, e), e.pendingcb === 0 && (r ? (e.pendingcb++, ir.nextTick((i, n)=>{
            cn(n) ? ro(i, n) : n.pendingcb--;
        }, t, e)) : cn(e) && (e.pendingcb++, ro(t, e))));
    }
    function ro(t, e) {
        e.pendingcb--, e.finished = !0;
        let r = e[Ur].splice(0);
        for(let i = 0; i < r.length; i++)r[i]();
        if (t.emit("finish"), e.autoDestroy) {
            let i = t._readableState;
            (!i || i.autoDestroy && (i.endEmitted || i.readable === !1)) && t.destroy();
        }
    }
    k_(se.prototype, {
        closed: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.closed : !1;
            }
        },
        destroyed: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.destroyed : !1;
            },
            set (t) {
                this._writableState && (this._writableState.destroyed = t);
            }
        },
        writable: {
            __proto__: null,
            get () {
                let t = this._writableState;
                return !!t && t.writable !== !1 && !t.destroyed && !t.errored && !t.ending && !t.ended;
            },
            set (t) {
                this._writableState && (this._writableState.writable = !!t);
            }
        },
        writableFinished: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.finished : !1;
            }
        },
        writableObjectMode: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.objectMode : !1;
            }
        },
        writableBuffer: {
            __proto__: null,
            get () {
                return this._writableState && this._writableState.getBuffer();
            }
        },
        writableEnded: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.ending : !1;
            }
        },
        writableNeedDrain: {
            __proto__: null,
            get () {
                let t = this._writableState;
                return t ? !t.destroyed && !t.ending && t.needDrain : !1;
            }
        },
        writableHighWaterMark: {
            __proto__: null,
            get () {
                return this._writableState && this._writableState.highWaterMark;
            }
        },
        writableCorked: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.corked : 0;
            }
        },
        writableLength: {
            __proto__: null,
            get () {
                return this._writableState && this._writableState.length;
            }
        },
        errored: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._writableState ? this._writableState.errored : null;
            }
        },
        writableAborted: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return !!(this._writableState.writable !== !1 && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
            }
        }
    });
    var Q_ = hn.destroy;
    se.prototype.destroy = function(t, e) {
        let r = this._writableState;
        return !r.destroyed && (r.bufferedIndex < r.buffered.length || r[Ur].length) && ir.nextTick(no, r), Q_.call(this, t, e), this;
    };
    se.prototype._undestroy = hn.undestroy;
    se.prototype._destroy = function(t, e) {
        e(t);
    };
    se.prototype[M_.captureRejectionSymbol] = function(t) {
        this.destroy(t);
    };
    var to;
    function eh() {
        return to === void 0 && (to = {}), to;
    }
    se.fromWeb = function(t, e) {
        return eh().newStreamWritableFromWritableStream(t, e);
    };
    se.toWeb = function(t) {
        return eh().newWritableStreamFromStreamWritable(t);
    };
});
var bh = O((FC, gh)=>{
    _();
    v();
    m();
    var ao = Mt(), Y_ = (he(), Q(ye)), { isReadable: J_, isWritable: X_, isIterable: rh, isNodeStream: Z_, isReadableNodeStream: ih, isWritableNodeStream: nh, isDuplexNodeStream: em, isReadableStream: sh, isWritableStream: oh } = Ze(), ah = _t(), { AbortError: dh, codes: { ERR_INVALID_ARG_TYPE: tm, ERR_INVALID_RETURN_VALUE: lh } } = me(), { destroyer: Dr } = er(), rm = rt(), ph = fi(), im = dn(), { createDeferredPromise: uh } = Ie(), ch = zs(), fh = globalThis.Blob || Y_.Blob, nm = typeof fh < "u" ? function(e) {
        return e instanceof fh;
    } : function(e) {
        return !1;
    }, sm = globalThis.AbortController || Rr().AbortController, { FunctionPrototypeCall: hh } = ie(), Ut = class extends rm {
        constructor(e){
            super(e), e?.readable === !1 && (this._readableState.readable = !1, this._readableState.ended = !0, this._readableState.endEmitted = !0), e?.writable === !1 && (this._writableState.writable = !1, this._writableState.ending = !0, this._writableState.ended = !0, this._writableState.finished = !0);
        }
    };
    gh.exports = function t(e, r) {
        if (em(e)) return e;
        if (ih(e)) return Nr({
            readable: e
        });
        if (nh(e)) return Nr({
            writable: e
        });
        if (Z_(e)) return Nr({
            writable: !1,
            readable: !1
        });
        if (sh(e)) return Nr({
            readable: ph.fromWeb(e)
        });
        if (oh(e)) return Nr({
            writable: im.fromWeb(e)
        });
        if (typeof e == "function") {
            let { value: n, write: o, final: s, destroy: a } = om(e);
            if (rh(n)) return ch(Ut, n, {
                objectMode: !0,
                write: o,
                final: s,
                destroy: a
            });
            let u = n?.then;
            if (typeof u == "function") {
                let f, d = hh(u, n, (h)=>{
                    if (h != null) throw new lh("nully", "body", h);
                }, (h)=>{
                    Dr(f, h);
                });
                return f = new Ut({
                    objectMode: !0,
                    readable: !1,
                    write: o,
                    final (h) {
                        s(async ()=>{
                            try {
                                await d, ao.nextTick(h, null);
                            } catch (g) {
                                ao.nextTick(h, g);
                            }
                        });
                    },
                    destroy: a
                });
            }
            throw new lh("Iterable, AsyncIterable or AsyncFunction", r, n);
        }
        if (nm(e)) return t(e.arrayBuffer());
        if (rh(e)) return ch(Ut, e, {
            objectMode: !0,
            writable: !1
        });
        if (sh(e?.readable) && oh(e?.writable)) return Ut.fromWeb(e);
        if (typeof e?.writable == "object" || typeof e?.readable == "object") {
            let n = e != null && e.readable ? ih(e?.readable) ? e?.readable : t(e.readable) : void 0, o = e != null && e.writable ? nh(e?.writable) ? e?.writable : t(e.writable) : void 0;
            return Nr({
                readable: n,
                writable: o
            });
        }
        let i = e?.then;
        if (typeof i == "function") {
            let n;
            return hh(i, e, (o)=>{
                o != null && n.push(o), n.push(null);
            }, (o)=>{
                Dr(n, o);
            }), n = new Ut({
                objectMode: !0,
                writable: !1,
                read () {}
            });
        }
        throw new tm(r, [
            "Blob",
            "ReadableStream",
            "WritableStream",
            "Stream",
            "Iterable",
            "AsyncIterable",
            "Function",
            "{ readable, writable } pair",
            "Promise"
        ], e);
    };
    function om(t) {
        let { promise: e, resolve: r } = uh(), i = new sm, n = i.signal;
        return {
            value: t(async function*() {
                for(;;){
                    let s = e;
                    e = null;
                    let { chunk: a, done: u, cb: f } = await s;
                    if (ao.nextTick(f), u) return;
                    if (n.aborted) throw new dh(void 0, {
                        cause: n.reason
                    });
                    ({ promise: e, resolve: r } = uh()), yield a;
                }
            }(), {
                signal: n
            }),
            write (s, a, u) {
                let f = r;
                r = null, f({
                    chunk: s,
                    done: !1,
                    cb: u
                });
            },
            final (s) {
                let a = r;
                r = null, a({
                    done: !0,
                    cb: s
                });
            },
            destroy (s, a) {
                i.abort(), a(s);
            }
        };
    }
    function Nr(t) {
        let e = t.readable && typeof t.readable.read != "function" ? ph.wrap(t.readable) : t.readable, r = t.writable, i = !!J_(e), n = !!X_(r), o, s, a, u, f;
        function d(h) {
            let g = u;
            u = null, g ? g(h) : h && f.destroy(h);
        }
        return f = new Ut({
            readableObjectMode: !!(e != null && e.readableObjectMode),
            writableObjectMode: !!(r != null && r.writableObjectMode),
            readable: i,
            writable: n
        }), n && (ah(r, (h)=>{
            n = !1, h && Dr(e, h), d(h);
        }), f._write = function(h, g, b) {
            r.write(h, g) ? b() : o = b;
        }, f._final = function(h) {
            r.end(), s = h;
        }, r.on("drain", function() {
            if (o) {
                let h = o;
                o = null, h();
            }
        }), r.on("finish", function() {
            if (s) {
                let h = s;
                s = null, h();
            }
        })), i && (ah(e, (h)=>{
            i = !1, h && Dr(e, h), d(h);
        }), e.on("readable", function() {
            if (a) {
                let h = a;
                a = null, h();
            }
        }), e.on("end", function() {
            f.push(null);
        }), f._read = function() {
            for(;;){
                let h = e.read();
                if (h === null) {
                    a = f._read;
                    return;
                }
                if (!f.push(h)) return;
            }
        }), f._destroy = function(h, g) {
            !h && u !== null && (h = new dh), a = null, o = null, s = null, u === null ? g(h) : (u = g, Dr(r, h), Dr(e, h));
        }, f;
    }
});
var rt = O((JC, _h)=>{
    "use strict";
    _();
    v();
    m();
    var { ObjectDefineProperties: am, ObjectGetOwnPropertyDescriptor: mt, ObjectKeys: lm, ObjectSetPrototypeOf: yh } = ie();
    _h.exports = $e;
    var co = fi(), Le = dn();
    yh($e.prototype, co.prototype);
    yh($e, co);
    {
        let t = lm(Le.prototype);
        for(let e = 0; e < t.length; e++){
            let r = t[e];
            $e.prototype[r] || ($e.prototype[r] = Le.prototype[r]);
        }
    }
    function $e(t) {
        if (!(this instanceof $e)) return new $e(t);
        co.call(this, t), Le.call(this, t), t ? (this.allowHalfOpen = t.allowHalfOpen !== !1, t.readable === !1 && (this._readableState.readable = !1, this._readableState.ended = !0, this._readableState.endEmitted = !0), t.writable === !1 && (this._writableState.writable = !1, this._writableState.ending = !0, this._writableState.ended = !0, this._writableState.finished = !0)) : this.allowHalfOpen = !0;
    }
    am($e.prototype, {
        writable: {
            __proto__: null,
            ...mt(Le.prototype, "writable")
        },
        writableHighWaterMark: {
            __proto__: null,
            ...mt(Le.prototype, "writableHighWaterMark")
        },
        writableObjectMode: {
            __proto__: null,
            ...mt(Le.prototype, "writableObjectMode")
        },
        writableBuffer: {
            __proto__: null,
            ...mt(Le.prototype, "writableBuffer")
        },
        writableLength: {
            __proto__: null,
            ...mt(Le.prototype, "writableLength")
        },
        writableFinished: {
            __proto__: null,
            ...mt(Le.prototype, "writableFinished")
        },
        writableCorked: {
            __proto__: null,
            ...mt(Le.prototype, "writableCorked")
        },
        writableEnded: {
            __proto__: null,
            ...mt(Le.prototype, "writableEnded")
        },
        writableNeedDrain: {
            __proto__: null,
            ...mt(Le.prototype, "writableNeedDrain")
        },
        destroyed: {
            __proto__: null,
            get () {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
            },
            set (t) {
                this._readableState && this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
            }
        }
    });
    var lo;
    function wh() {
        return lo === void 0 && (lo = {}), lo;
    }
    $e.fromWeb = function(t, e) {
        return wh().newStreamDuplexFromReadableWritablePair(t, e);
    };
    $e.toWeb = function(t) {
        return wh().newReadableWritablePairFromDuplex(t);
    };
    var uo;
    $e.from = function(t) {
        return uo || (uo = bh()), uo(t, "body");
    };
});
var po = O((aP, vh)=>{
    "use strict";
    _();
    v();
    m();
    var { ObjectSetPrototypeOf: mh, Symbol: um } = ie();
    vh.exports = vt;
    var { ERR_METHOD_NOT_IMPLEMENTED: cm } = me().codes, ho = rt(), { getHighWaterMark: fm } = li();
    mh(vt.prototype, ho.prototype);
    mh(vt, ho);
    var gi = um("kCallback");
    function vt(t) {
        if (!(this instanceof vt)) return new vt(t);
        let e = t ? fm(this, t, "readableHighWaterMark", !0) : null;
        e === 0 && (t = {
            ...t,
            highWaterMark: null,
            readableHighWaterMark: e,
            writableHighWaterMark: t.writableHighWaterMark || 0
        }), ho.call(this, t), this._readableState.sync = !1, this[gi] = null, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", hm);
    }
    function fo(t) {
        typeof this._flush == "function" && !this.destroyed ? this._flush((e, r)=>{
            if (e) {
                t ? t(e) : this.destroy(e);
                return;
            }
            r != null && this.push(r), this.push(null), t && t();
        }) : (this.push(null), t && t());
    }
    function hm() {
        this._final !== fo && fo.call(this);
    }
    vt.prototype._final = fo;
    vt.prototype._transform = function(t, e, r) {
        throw new cm("_transform()");
    };
    vt.prototype._write = function(t, e, r) {
        let i = this._readableState, n = this._writableState, o = i.length;
        this._transform(t, e, (s, a)=>{
            if (s) {
                r(s);
                return;
            }
            a != null && this.push(a), n.ended || o === i.length || i.length < i.highWaterMark ? r() : this[gi] = r;
        });
    };
    vt.prototype._read = function() {
        if (this[gi]) {
            let t = this[gi];
            this[gi] = null, t();
        }
    };
});
var bo = O((yP, Sh)=>{
    "use strict";
    _();
    v();
    m();
    var { ObjectSetPrototypeOf: Eh } = ie();
    Sh.exports = jr;
    var go = po();
    Eh(jr.prototype, go.prototype);
    Eh(jr, go);
    function jr(t) {
        if (!(this instanceof jr)) return new jr(t);
        go.call(this, t);
    }
    jr.prototype._transform = function(t, e, r) {
        r(null, t);
    };
});
var yn = O((RP, Ch)=>{
    _();
    v();
    m();
    var bi = Mt(), { ArrayIsArray: dm, Promise: pm, SymbolAsyncIterator: gm, SymbolDispose: bm } = ie(), bn = _t(), { once: ym } = Ie(), wm = er(), Ah = rt(), { aggregateTwoErrors: _m, codes: { ERR_INVALID_ARG_TYPE: Io, ERR_INVALID_RETURN_VALUE: yo, ERR_MISSING_ARGS: mm, ERR_STREAM_DESTROYED: vm, ERR_STREAM_PREMATURE_CLOSE: Em }, AbortError: Sm } = me(), { validateFunction: Am, validateAbortSignal: Im } = kr(), { isIterable: nr, isReadable: wo, isReadableNodeStream: gn, isNodeStream: Ih, isTransformStream: Fr, isWebStream: Tm, isReadableStream: _o, isReadableFinished: Rm } = Ze(), Cm = globalThis.AbortController || Rr().AbortController, mo, vo, Eo;
    function Th(t, e, r) {
        let i = !1;
        t.on("close", ()=>{
            i = !0;
        });
        let n = bn(t, {
            readable: e,
            writable: r
        }, (o)=>{
            i = !o;
        });
        return {
            destroy: (o)=>{
                i || (i = !0, wm.destroyer(t, o || new vm("pipe")));
            },
            cleanup: n
        };
    }
    function Pm(t) {
        return Am(t[t.length - 1], "streams[stream.length - 1]"), t.pop();
    }
    function So(t) {
        if (nr(t)) return t;
        if (gn(t)) return km(t);
        throw new Io("val", [
            "Readable",
            "Iterable",
            "AsyncIterable"
        ], t);
    }
    async function* km(t) {
        vo || (vo = fi()), yield* vo.prototype[gm].call(t);
    }
    async function pn(t, e, r, { end: i }) {
        let n, o = null, s = (f)=>{
            if (f && (n = f), o) {
                let d = o;
                o = null, d();
            }
        }, a = ()=>new pm((f, d)=>{
                n ? d(n) : o = ()=>{
                    n ? d(n) : f();
                };
            });
        e.on("drain", s);
        let u = bn(e, {
            readable: !1
        }, s);
        try {
            e.writableNeedDrain && await a();
            for await (let f of t)e.write(f) || await a();
            i && (e.end(), await a()), r();
        } catch (f) {
            r(n !== f ? _m(n, f) : f);
        } finally{
            u(), e.off("drain", s);
        }
    }
    async function Ao(t, e, r, { end: i }) {
        Fr(e) && (e = e.writable);
        let n = e.getWriter();
        try {
            for await (let o of t)await n.ready, n.write(o).catch(()=>{});
            await n.ready, i && await n.close(), r();
        } catch (o) {
            try {
                await n.abort(o), r(o);
            } catch (s) {
                r(s);
            }
        }
    }
    function Bm(...t) {
        return Rh(t, ym(Pm(t)));
    }
    function Rh(t, e, r) {
        if (t.length === 1 && dm(t[0]) && (t = t[0]), t.length < 2) throw new mm("streams");
        let i = new Cm, n = i.signal, o = r?.signal, s = [];
        Im(o, "options.signal");
        function a() {
            E(new Sm);
        }
        Eo = Eo || Ie().addAbortListener;
        let u;
        o && (u = Eo(o, a));
        let f, d, h = [], g = 0;
        function b(C) {
            E(C, --g === 0);
        }
        function E(C, M) {
            var q;
            if (C && (!f || f.code === "ERR_STREAM_PREMATURE_CLOSE") && (f = C), !(!f && !M)) {
                for(; h.length;)h.shift()(f);
                (q = u) === null || q === void 0 || q[bm](), i.abort(), M && (f || s.forEach((z)=>z()), bi.nextTick(e, f, d));
            }
        }
        let w;
        for(let C = 0; C < t.length; C++){
            let M = t[C], q = C < t.length - 1, z = C > 0, j = q || r?.end !== !1, G = C === t.length - 1;
            if (Ih(M)) {
                let $ = function(te) {
                    te && te.name !== "AbortError" && te.code !== "ERR_STREAM_PREMATURE_CLOSE" && b(te);
                };
                var P = $;
                if (j) {
                    let { destroy: te, cleanup: pt } = Th(M, q, z);
                    h.push(te), wo(M) && G && s.push(pt);
                }
                M.on("error", $), wo(M) && G && s.push(()=>{
                    M.removeListener("error", $);
                });
            }
            if (C === 0) {
                if (typeof M == "function") {
                    if (w = M({
                        signal: n
                    }), !nr(w)) throw new yo("Iterable, AsyncIterable or Stream", "source", w);
                } else nr(M) || gn(M) || Fr(M) ? w = M : w = Ah.from(M);
            } else if (typeof M == "function") {
                if (Fr(w)) {
                    var S;
                    w = So((S = w) === null || S === void 0 ? void 0 : S.readable);
                } else w = So(w);
                if (w = M(w, {
                    signal: n
                }), q) {
                    if (!nr(w, !0)) throw new yo("AsyncIterable", `transform[${C - 1}]`, w);
                } else {
                    var I;
                    mo || (mo = bo());
                    let $ = new mo({
                        objectMode: !0
                    }), te = (I = w) === null || I === void 0 ? void 0 : I.then;
                    if (typeof te == "function") g++, te.call(w, (Se)=>{
                        d = Se, Se != null && $.write(Se), j && $.end(), bi.nextTick(b);
                    }, (Se)=>{
                        $.destroy(Se), bi.nextTick(b, Se);
                    });
                    else if (nr(w, !0)) g++, pn(w, $, b, {
                        end: j
                    });
                    else if (_o(w) || Fr(w)) {
                        let Se = w.readable || w;
                        g++, pn(Se, $, b, {
                            end: j
                        });
                    } else throw new yo("AsyncIterable or Promise", "destination", w);
                    w = $;
                    let { destroy: pt, cleanup: Fe } = Th(w, !1, !0);
                    h.push(pt), G && s.push(Fe);
                }
            } else if (Ih(M)) {
                if (gn(w)) {
                    g += 2;
                    let $ = xm(w, M, b, {
                        end: j
                    });
                    wo(M) && G && s.push($);
                } else if (Fr(w) || _o(w)) {
                    let $ = w.readable || w;
                    g++, pn($, M, b, {
                        end: j
                    });
                } else if (nr(w)) g++, pn(w, M, b, {
                    end: j
                });
                else throw new Io("val", [
                    "Readable",
                    "Iterable",
                    "AsyncIterable",
                    "ReadableStream",
                    "TransformStream"
                ], w);
                w = M;
            } else if (Tm(M)) {
                if (gn(w)) g++, Ao(So(w), M, b, {
                    end: j
                });
                else if (_o(w) || nr(w)) g++, Ao(w, M, b, {
                    end: j
                });
                else if (Fr(w)) g++, Ao(w.readable, M, b, {
                    end: j
                });
                else throw new Io("val", [
                    "Readable",
                    "Iterable",
                    "AsyncIterable",
                    "ReadableStream",
                    "TransformStream"
                ], w);
                w = M;
            } else w = Ah.from(M);
        }
        return (n != null && n.aborted || o != null && o.aborted) && bi.nextTick(a), w;
    }
    function xm(t, e, r, { end: i }) {
        let n = !1;
        if (e.on("close", ()=>{
            n || r(new Em);
        }), t.pipe(e, {
            end: !1
        }), i) {
            let s = function() {
                n = !0, e.end();
            };
            var o = s;
            Rm(t) ? bi.nextTick(s) : t.once("end", s);
        } else r();
        return bn(t, {
            readable: !0,
            writable: !1
        }, (s)=>{
            let a = t._readableState;
            s && s.code === "ERR_STREAM_PREMATURE_CLOSE" && a && a.ended && !a.errored && !a.errorEmitted ? t.once("end", r).once("error", r) : r(s);
        }), bn(e, {
            readable: !1,
            writable: !0
        }, r);
    }
    Ch.exports = {
        pipelineImpl: Rh,
        pipeline: Bm
    };
});
var Ro = O((UP, Mh)=>{
    "use strict";
    _();
    v();
    m();
    var { pipeline: Om } = yn(), wn = rt(), { destroyer: Mm } = er(), { isNodeStream: _n, isReadable: Ph, isWritable: kh, isWebStream: To, isTransformStream: sr, isWritableStream: Bh, isReadableStream: xh } = Ze(), { AbortError: Lm, codes: { ERR_INVALID_ARG_VALUE: Oh, ERR_MISSING_ARGS: qm } } = me(), Um = _t();
    Mh.exports = function(...e) {
        if (e.length === 0) throw new qm("streams");
        if (e.length === 1) return wn.from(e[0]);
        let r = [
            ...e
        ];
        if (typeof e[0] == "function" && (e[0] = wn.from(e[0])), typeof e[e.length - 1] == "function") {
            let b = e.length - 1;
            e[b] = wn.from(e[b]);
        }
        for(let b = 0; b < e.length; ++b)if (!(!_n(e[b]) && !To(e[b]))) {
            if (b < e.length - 1 && !(Ph(e[b]) || xh(e[b]) || sr(e[b]))) throw new Oh(`streams[${b}]`, r[b], "must be readable");
            if (b > 0 && !(kh(e[b]) || Bh(e[b]) || sr(e[b]))) throw new Oh(`streams[${b}]`, r[b], "must be writable");
        }
        let i, n, o, s, a;
        function u(b) {
            let E = s;
            s = null, E ? E(b) : b ? a.destroy(b) : !g && !h && a.destroy();
        }
        let f = e[0], d = Om(e, u), h = !!(kh(f) || Bh(f) || sr(f)), g = !!(Ph(d) || xh(d) || sr(d));
        if (a = new wn({
            writableObjectMode: !!(f != null && f.writableObjectMode),
            readableObjectMode: !!(d != null && d.readableObjectMode),
            writable: h,
            readable: g
        }), h) {
            if (_n(f)) a._write = function(E, w, S) {
                f.write(E, w) ? S() : i = S;
            }, a._final = function(E) {
                f.end(), n = E;
            }, f.on("drain", function() {
                if (i) {
                    let E = i;
                    i = null, E();
                }
            });
            else if (To(f)) {
                let w = (sr(f) ? f.writable : f).getWriter();
                a._write = async function(S, I, P) {
                    try {
                        await w.ready, w.write(S).catch(()=>{}), P();
                    } catch (C) {
                        P(C);
                    }
                }, a._final = async function(S) {
                    try {
                        await w.ready, w.close().catch(()=>{}), n = S;
                    } catch (I) {
                        S(I);
                    }
                };
            }
            let b = sr(d) ? d.readable : d;
            Um(b, ()=>{
                if (n) {
                    let E = n;
                    n = null, E();
                }
            });
        }
        if (g) {
            if (_n(d)) d.on("readable", function() {
                if (o) {
                    let b = o;
                    o = null, b();
                }
            }), d.on("end", function() {
                a.push(null);
            }), a._read = function() {
                for(;;){
                    let b = d.read();
                    if (b === null) {
                        o = a._read;
                        return;
                    }
                    if (!a.push(b)) return;
                }
            };
            else if (To(d)) {
                let E = (sr(d) ? d.readable : d).getReader();
                a._read = async function() {
                    for(;;)try {
                        let { value: w, done: S } = await E.read();
                        if (!a.push(w)) return;
                        if (S) {
                            a.push(null);
                            return;
                        }
                    } catch  {
                        return;
                    }
                };
            }
        }
        return a._destroy = function(b, E) {
            !b && s !== null && (b = new Lm), o = null, i = null, n = null, s === null ? E(b) : (s = E, _n(d) && Mm(d, b));
        }, a;
    };
});
var Hh = O((KP, ko)=>{
    "use strict";
    _();
    v();
    m();
    var Nm = globalThis.AbortController || Rr().AbortController, { codes: { ERR_INVALID_ARG_VALUE: Dm, ERR_INVALID_ARG_TYPE: yi, ERR_MISSING_ARGS: jm, ERR_OUT_OF_RANGE: Fm }, AbortError: it } = me(), { validateAbortSignal: or, validateInteger: Lh, validateObject: ar } = kr(), Wm = ie().Symbol("kWeak"), $m = ie().Symbol("kResistStopPropagation"), { finished: Hm } = _t(), Vm = Ro(), { addAbortSignalNoValidate: zm } = ai(), { isWritable: Km, isNodeStream: Gm } = Ze(), { deprecate: Qm } = Ie(), { ArrayPrototypePush: Ym, Boolean: Jm, MathFloor: qh, Number: Xm, NumberIsNaN: Zm, Promise: Uh, PromiseReject: Nh, PromiseResolve: e0, PromisePrototypeThen: Dh, Symbol: Fh } = ie(), mn = Fh("kEmpty"), jh = Fh("kEof");
    function t0(t, e) {
        if (e != null && ar(e, "options"), e?.signal != null && or(e.signal, "options.signal"), Gm(t) && !Km(t)) throw new Dm("stream", t, "must be writable");
        let r = Vm(this, t);
        return e != null && e.signal && zm(e.signal, r), r;
    }
    function vn(t, e) {
        if (typeof t != "function") throw new yi("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        e != null && ar(e, "options"), e?.signal != null && or(e.signal, "options.signal");
        let r = 1;
        e?.concurrency != null && (r = qh(e.concurrency));
        let i = r - 1;
        return e?.highWaterMark != null && (i = qh(e.highWaterMark)), Lh(r, "options.concurrency", 1), Lh(i, "options.highWaterMark", 0), i += r, (async function*() {
            let o = Ie().AbortSignalAny([
                e?.signal
            ].filter(Jm)), s = this, a = [], u = {
                signal: o
            }, f, d, h = !1, g = 0;
            function b() {
                h = !0, E();
            }
            function E() {
                g -= 1, w();
            }
            function w() {
                d && !h && g < r && a.length < i && (d(), d = null);
            }
            async function S() {
                try {
                    for await (let I of s){
                        if (h) return;
                        if (o.aborted) throw new it;
                        try {
                            if (I = t(I, u), I === mn) continue;
                            I = e0(I);
                        } catch (P) {
                            I = Nh(P);
                        }
                        g += 1, Dh(I, E, b), a.push(I), f && (f(), f = null), !h && (a.length >= i || g >= r) && await new Uh((P)=>{
                            d = P;
                        });
                    }
                    a.push(jh);
                } catch (I) {
                    let P = Nh(I);
                    Dh(P, E, b), a.push(P);
                } finally{
                    h = !0, f && (f(), f = null);
                }
            }
            S();
            try {
                for(;;){
                    for(; a.length > 0;){
                        let I = await a[0];
                        if (I === jh) return;
                        if (o.aborted) throw new it;
                        I !== mn && (yield I), a.shift(), w();
                    }
                    await new Uh((I)=>{
                        f = I;
                    });
                }
            } finally{
                h = !0, d && (d(), d = null);
            }
        }).call(this);
    }
    function r0(t) {
        return t != null && ar(t, "options"), t?.signal != null && or(t.signal, "options.signal"), (async function*() {
            let r = 0;
            for await (let n of this){
                var i;
                if (t != null && (i = t.signal) !== null && i !== void 0 && i.aborted) throw new it({
                    cause: t.signal.reason
                });
                yield [
                    r++,
                    n
                ];
            }
        }).call(this);
    }
    async function Wh(t, e) {
        for await (let r of Po.call(this, t, e))return !0;
        return !1;
    }
    async function i0(t, e) {
        if (typeof t != "function") throw new yi("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        return !await Wh.call(this, async (...r)=>!await t(...r), e);
    }
    async function n0(t, e) {
        for await (let r of Po.call(this, t, e))return r;
    }
    async function s0(t, e) {
        if (typeof t != "function") throw new yi("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        async function r(i, n) {
            return await t(i, n), mn;
        }
        for await (let i of vn.call(this, r, e));
    }
    function Po(t, e) {
        if (typeof t != "function") throw new yi("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        async function r(i, n) {
            return await t(i, n) ? i : mn;
        }
        return vn.call(this, r, e);
    }
    var Co = class extends jm {
        constructor(){
            super("reduce"), this.message = "Reduce of an empty stream requires an initial value";
        }
    };
    async function o0(t, e, r) {
        var i;
        if (typeof t != "function") throw new yi("reducer", [
            "Function",
            "AsyncFunction"
        ], t);
        r != null && ar(r, "options"), r?.signal != null && or(r.signal, "options.signal");
        let n = arguments.length > 1;
        if (r != null && (i = r.signal) !== null && i !== void 0 && i.aborted) {
            let f = new it(void 0, {
                cause: r.signal.reason
            });
            throw this.once("error", ()=>{}), await Hm(this.destroy(f)), f;
        }
        let o = new Nm, s = o.signal;
        if (r != null && r.signal) {
            let f = {
                once: !0,
                [Wm]: this,
                [$m]: !0
            };
            r.signal.addEventListener("abort", ()=>o.abort(), f);
        }
        let a = !1;
        try {
            for await (let f of this){
                var u;
                if (a = !0, r != null && (u = r.signal) !== null && u !== void 0 && u.aborted) throw new it;
                n ? e = await t(e, f, {
                    signal: s
                }) : (e = f, n = !0);
            }
            if (!a && !n) throw new Co;
        } finally{
            o.abort();
        }
        return e;
    }
    async function a0(t) {
        t != null && ar(t, "options"), t?.signal != null && or(t.signal, "options.signal");
        let e = [];
        for await (let i of this){
            var r;
            if (t != null && (r = t.signal) !== null && r !== void 0 && r.aborted) throw new it(void 0, {
                cause: t.signal.reason
            });
            Ym(e, i);
        }
        return e;
    }
    function l0(t, e) {
        let r = vn.call(this, t, e);
        return (async function*() {
            for await (let n of r)yield* n;
        }).call(this);
    }
    function $h(t) {
        if (t = Xm(t), Zm(t)) return 0;
        if (t < 0) throw new Fm("number", ">= 0", t);
        return t;
    }
    function u0(t, e) {
        return e != null && ar(e, "options"), e?.signal != null && or(e.signal, "options.signal"), t = $h(t), (async function*() {
            var i;
            if (e != null && (i = e.signal) !== null && i !== void 0 && i.aborted) throw new it;
            for await (let o of this){
                var n;
                if (e != null && (n = e.signal) !== null && n !== void 0 && n.aborted) throw new it;
                t-- <= 0 && (yield o);
            }
        }).call(this);
    }
    function c0(t, e) {
        return e != null && ar(e, "options"), e?.signal != null && or(e.signal, "options.signal"), t = $h(t), (async function*() {
            var i;
            if (e != null && (i = e.signal) !== null && i !== void 0 && i.aborted) throw new it;
            for await (let o of this){
                var n;
                if (e != null && (n = e.signal) !== null && n !== void 0 && n.aborted) throw new it;
                if (t-- > 0 && (yield o), t <= 0) return;
            }
        }).call(this);
    }
    ko.exports.streamReturningOperators = {
        asIndexedPairs: Qm(r0, "readable.asIndexedPairs will be removed in a future version."),
        drop: u0,
        filter: Po,
        flatMap: l0,
        map: vn,
        take: c0,
        compose: t0
    };
    ko.exports.promiseReturningOperators = {
        every: i0,
        forEach: s0,
        reduce: o0,
        toArray: a0,
        some: Wh,
        find: n0
    };
});
var Bo = O((ik, Vh)=>{
    "use strict";
    _();
    v();
    m();
    var { ArrayPrototypePop: f0, Promise: h0 } = ie(), { isIterable: d0, isNodeStream: p0, isWebStream: g0 } = Ze(), { pipelineImpl: b0 } = yn(), { finished: y0 } = _t();
    xo();
    function w0(...t) {
        return new h0((e, r)=>{
            let i, n, o = t[t.length - 1];
            if (o && typeof o == "object" && !p0(o) && !d0(o) && !g0(o)) {
                let s = f0(t);
                i = s.signal, n = s.end;
            }
            b0(t, (s, a)=>{
                s ? r(s) : e(a);
            }, {
                signal: i,
                end: n
            });
        });
    }
    Vh.exports = {
        finished: y0,
        pipeline: w0
    };
});
var xo = O((dk, ed)=>{
    "use strict";
    _();
    v();
    m();
    var { Buffer: _0 } = (he(), Q(ye)), { ObjectDefineProperty: Et, ObjectKeys: Gh, ReflectApply: Qh } = ie(), { promisify: { custom: Yh } } = Ie(), { streamReturningOperators: zh, promiseReturningOperators: Kh } = Hh(), { codes: { ERR_ILLEGAL_CONSTRUCTOR: Jh } } = me(), m0 = Ro(), { setDefaultHighWaterMark: v0, getDefaultHighWaterMark: E0 } = li(), { pipeline: Xh } = yn(), { destroyer: S0 } = er(), Zh = _t(), Oo = Bo(), wi = Ze(), ee = ed.exports = Zi().Stream;
    ee.isDestroyed = wi.isDestroyed;
    ee.isDisturbed = wi.isDisturbed;
    ee.isErrored = wi.isErrored;
    ee.isReadable = wi.isReadable;
    ee.isWritable = wi.isWritable;
    ee.Readable = fi();
    for (let t of Gh(zh)){
        let r = function(...i) {
            if (new.target) throw Jh();
            return ee.Readable.from(Qh(e, this, i));
        }, e = zh[t];
        Et(r, "name", {
            __proto__: null,
            value: e.name
        }), Et(r, "length", {
            __proto__: null,
            value: e.length
        }), Et(ee.Readable.prototype, t, {
            __proto__: null,
            value: r,
            enumerable: !1,
            configurable: !0,
            writable: !0
        });
    }
    for (let t of Gh(Kh)){
        let r = function(...i) {
            if (new.target) throw Jh();
            return Qh(e, this, i);
        }, e = Kh[t];
        Et(r, "name", {
            __proto__: null,
            value: e.name
        }), Et(r, "length", {
            __proto__: null,
            value: e.length
        }), Et(ee.Readable.prototype, t, {
            __proto__: null,
            value: r,
            enumerable: !1,
            configurable: !0,
            writable: !0
        });
    }
    ee.Writable = dn();
    ee.Duplex = rt();
    ee.Transform = po();
    ee.PassThrough = bo();
    ee.pipeline = Xh;
    var { addAbortSignal: A0 } = ai();
    ee.addAbortSignal = A0;
    ee.finished = Zh;
    ee.destroy = S0;
    ee.compose = m0;
    ee.setDefaultHighWaterMark = v0;
    ee.getDefaultHighWaterMark = E0;
    Et(ee, "promises", {
        __proto__: null,
        configurable: !0,
        enumerable: !0,
        get () {
            return Oo;
        }
    });
    Et(Xh, Yh, {
        __proto__: null,
        enumerable: !0,
        get () {
            return Oo.pipeline;
        }
    });
    Et(Zh, Yh, {
        __proto__: null,
        enumerable: !0,
        get () {
            return Oo.finished;
        }
    });
    ee.Stream = ee;
    ee._isUint8Array = function(e) {
        return e instanceof Uint8Array;
    };
    ee._uint8ArrayToBuffer = function(e) {
        return _0.from(e.buffer, e.byteOffset, e.byteLength);
    };
});
var Nt = O((Sk, ce)=>{
    "use strict";
    _();
    v();
    m();
    var pe = xo(), I0 = Bo(), T0 = pe.Readable.destroy;
    ce.exports = pe.Readable;
    ce.exports._uint8ArrayToBuffer = pe._uint8ArrayToBuffer;
    ce.exports._isUint8Array = pe._isUint8Array;
    ce.exports.isDisturbed = pe.isDisturbed;
    ce.exports.isErrored = pe.isErrored;
    ce.exports.isReadable = pe.isReadable;
    ce.exports.Readable = pe.Readable;
    ce.exports.Writable = pe.Writable;
    ce.exports.Duplex = pe.Duplex;
    ce.exports.Transform = pe.Transform;
    ce.exports.PassThrough = pe.PassThrough;
    ce.exports.addAbortSignal = pe.addAbortSignal;
    ce.exports.finished = pe.finished;
    ce.exports.destroy = pe.destroy;
    ce.exports.destroy = T0;
    ce.exports.pipeline = pe.pipeline;
    ce.exports.compose = pe.compose;
    Object.defineProperty(pe, "promises", {
        configurable: !0,
        enumerable: !0,
        get () {
            return I0;
        }
    });
    ce.exports.Stream = pe.Stream;
    ce.exports.default = ce.exports;
});
var td = O((Ok, Mo)=>{
    _();
    v();
    m();
    typeof Object.create == "function" ? Mo.exports = function(e, r) {
        r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : Mo.exports = function(e, r) {
        if (r) {
            e.super_ = r;
            var i = function() {};
            i.prototype = r.prototype, e.prototype = new i, e.prototype.constructor = e;
        }
    };
});
var nd = O(($k, id)=>{
    "use strict";
    _();
    v();
    m();
    var { Buffer: He } = (he(), Q(ye)), rd = Symbol.for("BufferList");
    function Z(t) {
        if (!(this instanceof Z)) return new Z(t);
        Z._init.call(this, t);
    }
    Z._init = function(e) {
        Object.defineProperty(this, rd, {
            value: !0
        }), this._bufs = [], this.length = 0, e && this.append(e);
    };
    Z.prototype._new = function(e) {
        return new Z(e);
    };
    Z.prototype._offset = function(e) {
        if (e === 0) return [
            0,
            0
        ];
        let r = 0;
        for(let i = 0; i < this._bufs.length; i++){
            let n = r + this._bufs[i].length;
            if (e < n || i === this._bufs.length - 1) return [
                i,
                e - r
            ];
            r = n;
        }
    };
    Z.prototype._reverseOffset = function(t) {
        let e = t[0], r = t[1];
        for(let i = 0; i < e; i++)r += this._bufs[i].length;
        return r;
    };
    Z.prototype.get = function(e) {
        if (e > this.length || e < 0) return;
        let r = this._offset(e);
        return this._bufs[r[0]][r[1]];
    };
    Z.prototype.slice = function(e, r) {
        return typeof e == "number" && e < 0 && (e += this.length), typeof r == "number" && r < 0 && (r += this.length), this.copy(null, 0, e, r);
    };
    Z.prototype.copy = function(e, r, i, n) {
        if ((typeof i != "number" || i < 0) && (i = 0), (typeof n != "number" || n > this.length) && (n = this.length), i >= this.length || n <= 0) return e || He.alloc(0);
        let o = !!e, s = this._offset(i), a = n - i, u = a, f = o && r || 0, d = s[1];
        if (i === 0 && n === this.length) {
            if (!o) return this._bufs.length === 1 ? this._bufs[0] : He.concat(this._bufs, this.length);
            for(let h = 0; h < this._bufs.length; h++)this._bufs[h].copy(e, f), f += this._bufs[h].length;
            return e;
        }
        if (u <= this._bufs[s[0]].length - d) return o ? this._bufs[s[0]].copy(e, r, d, d + u) : this._bufs[s[0]].slice(d, d + u);
        o || (e = He.allocUnsafe(a));
        for(let h = s[0]; h < this._bufs.length; h++){
            let g = this._bufs[h].length - d;
            if (u > g) this._bufs[h].copy(e, f, d), f += g;
            else {
                this._bufs[h].copy(e, f, d, d + u), f += g;
                break;
            }
            u -= g, d && (d = 0);
        }
        return e.length > f ? e.slice(0, f) : e;
    };
    Z.prototype.shallowSlice = function(e, r) {
        if (e = e || 0, r = typeof r != "number" ? this.length : r, e < 0 && (e += this.length), r < 0 && (r += this.length), e === r) return this._new();
        let i = this._offset(e), n = this._offset(r), o = this._bufs.slice(i[0], n[0] + 1);
        return n[1] === 0 ? o.pop() : o[o.length - 1] = o[o.length - 1].slice(0, n[1]), i[1] !== 0 && (o[0] = o[0].slice(i[1])), this._new(o);
    };
    Z.prototype.toString = function(e, r, i) {
        return this.slice(r, i).toString(e);
    };
    Z.prototype.consume = function(e) {
        if (e = Math.trunc(e), Number.isNaN(e) || e <= 0) return this;
        for(; this._bufs.length;)if (e >= this._bufs[0].length) e -= this._bufs[0].length, this.length -= this._bufs[0].length, this._bufs.shift();
        else {
            this._bufs[0] = this._bufs[0].slice(e), this.length -= e;
            break;
        }
        return this;
    };
    Z.prototype.duplicate = function() {
        let e = this._new();
        for(let r = 0; r < this._bufs.length; r++)e.append(this._bufs[r]);
        return e;
    };
    Z.prototype.append = function(e) {
        if (e == null) return this;
        if (e.buffer) this._appendBuffer(He.from(e.buffer, e.byteOffset, e.byteLength));
        else if (Array.isArray(e)) for(let r = 0; r < e.length; r++)this.append(e[r]);
        else if (this._isBufferList(e)) for(let r = 0; r < e._bufs.length; r++)this.append(e._bufs[r]);
        else typeof e == "number" && (e = e.toString()), this._appendBuffer(He.from(e));
        return this;
    };
    Z.prototype._appendBuffer = function(e) {
        this._bufs.push(e), this.length += e.length;
    };
    Z.prototype.indexOf = function(t, e, r) {
        if (r === void 0 && typeof e == "string" && (r = e, e = void 0), typeof t == "function" || Array.isArray(t)) throw new TypeError('The "value" argument must be one of type string, Buffer, BufferList, or Uint8Array.');
        if (typeof t == "number" ? t = He.from([
            t
        ]) : typeof t == "string" ? t = He.from(t, r) : this._isBufferList(t) ? t = t.slice() : Array.isArray(t.buffer) ? t = He.from(t.buffer, t.byteOffset, t.byteLength) : He.isBuffer(t) || (t = He.from(t)), e = Number(e || 0), isNaN(e) && (e = 0), e < 0 && (e = this.length + e), e < 0 && (e = 0), t.length === 0) return e > this.length ? this.length : e;
        let i = this._offset(e), n = i[0], o = i[1];
        for(; n < this._bufs.length; n++){
            let s = this._bufs[n];
            for(; o < s.length;)if (s.length - o >= t.length) {
                let u = s.indexOf(t, o);
                if (u !== -1) return this._reverseOffset([
                    n,
                    u
                ]);
                o = s.length - t.length + 1;
            } else {
                let u = this._reverseOffset([
                    n,
                    o
                ]);
                if (this._match(u, t)) return u;
                o++;
            }
            o = 0;
        }
        return -1;
    };
    Z.prototype._match = function(t, e) {
        if (this.length - t < e.length) return !1;
        for(let r = 0; r < e.length; r++)if (this.get(t + r) !== e[r]) return !1;
        return !0;
    };
    (function() {
        let t = {
            readDoubleBE: 8,
            readDoubleLE: 8,
            readFloatBE: 4,
            readFloatLE: 4,
            readBigInt64BE: 8,
            readBigInt64LE: 8,
            readBigUInt64BE: 8,
            readBigUInt64LE: 8,
            readInt32BE: 4,
            readInt32LE: 4,
            readUInt32BE: 4,
            readUInt32LE: 4,
            readInt16BE: 2,
            readInt16LE: 2,
            readUInt16BE: 2,
            readUInt16LE: 2,
            readInt8: 1,
            readUInt8: 1,
            readIntBE: null,
            readIntLE: null,
            readUIntBE: null,
            readUIntLE: null
        };
        for(let e in t)(function(r) {
            t[r] === null ? Z.prototype[r] = function(i, n) {
                return this.slice(i, i + n)[r](0, n);
            } : Z.prototype[r] = function(i = 0) {
                return this.slice(i, i + t[r])[r](0);
            };
        })(e);
    })();
    Z.prototype._isBufferList = function(e) {
        return e instanceof Z || Z.isBufferList(e);
    };
    Z.isBufferList = function(e) {
        return e != null && e[rd];
    };
    id.exports = Z;
});
var sd = O((Zk, En)=>{
    "use strict";
    _();
    v();
    m();
    var Lo = Nt().Duplex, R0 = td(), _i = nd();
    function Ee(t) {
        if (!(this instanceof Ee)) return new Ee(t);
        if (typeof t == "function") {
            this._callback = t;
            let e = (function(i) {
                this._callback && (this._callback(i), this._callback = null);
            }).bind(this);
            this.on("pipe", function(i) {
                i.on("error", e);
            }), this.on("unpipe", function(i) {
                i.removeListener("error", e);
            }), t = null;
        }
        _i._init.call(this, t), Lo.call(this);
    }
    R0(Ee, Lo);
    Object.assign(Ee.prototype, _i.prototype);
    Ee.prototype._new = function(e) {
        return new Ee(e);
    };
    Ee.prototype._write = function(e, r, i) {
        this._appendBuffer(e), typeof i == "function" && i();
    };
    Ee.prototype._read = function(e) {
        if (!this.length) return this.push(null);
        e = Math.min(e, this.length), this.push(this.slice(0, e)), this.consume(e);
    };
    Ee.prototype.end = function(e) {
        Lo.prototype.end.call(this, e), this._callback && (this._callback(null, this.slice()), this._callback = null);
    };
    Ee.prototype._destroy = function(e, r) {
        this._bufs.length = 0, this.length = 0, r(e);
    };
    Ee.prototype._isBufferList = function(e) {
        return e instanceof Ee || e instanceof _i || Ee.isBufferList(e);
    };
    Ee.isBufferList = _i.isBufferList;
    En.exports = Ee;
    En.exports.BufferListStream = Ee;
    En.exports.BufferList = _i;
});
var ad = O((uB, od)=>{
    _();
    v();
    m();
    var qo = class {
        constructor(){
            this.cmd = null, this.retain = !1, this.qos = 0, this.dup = !1, this.length = -1, this.topic = null, this.payload = null;
        }
    };
    od.exports = qo;
});
var Uo = O((_B, ld)=>{
    _();
    v();
    m();
    var L = ld.exports, { Buffer: ke } = (he(), Q(ye));
    L.types = {
        0: "reserved",
        1: "connect",
        2: "connack",
        3: "publish",
        4: "puback",
        5: "pubrec",
        6: "pubrel",
        7: "pubcomp",
        8: "subscribe",
        9: "suback",
        10: "unsubscribe",
        11: "unsuback",
        12: "pingreq",
        13: "pingresp",
        14: "disconnect",
        15: "auth"
    };
    L.requiredHeaderFlags = {
        1: 0,
        2: 0,
        4: 0,
        5: 0,
        6: 2,
        7: 0,
        8: 2,
        9: 0,
        10: 2,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0
    };
    L.requiredHeaderFlagsErrors = {};
    for(let t in L.requiredHeaderFlags){
        let e = L.requiredHeaderFlags[t];
        L.requiredHeaderFlagsErrors[t] = "Invalid header flag bits, must be 0x" + e.toString(16) + " for " + L.types[t] + " packet";
    }
    L.codes = {};
    for(let t in L.types){
        let e = L.types[t];
        L.codes[e] = t;
    }
    L.CMD_SHIFT = 4;
    L.CMD_MASK = 240;
    L.DUP_MASK = 8;
    L.QOS_MASK = 3;
    L.QOS_SHIFT = 1;
    L.RETAIN_MASK = 1;
    L.VARBYTEINT_MASK = 127;
    L.VARBYTEINT_FIN_MASK = 128;
    L.VARBYTEINT_MAX = 268435455;
    L.SESSIONPRESENT_MASK = 1;
    L.SESSIONPRESENT_HEADER = ke.from([
        L.SESSIONPRESENT_MASK
    ]);
    L.CONNACK_HEADER = ke.from([
        L.codes.connack << L.CMD_SHIFT
    ]);
    L.USERNAME_MASK = 128;
    L.PASSWORD_MASK = 64;
    L.WILL_RETAIN_MASK = 32;
    L.WILL_QOS_MASK = 24;
    L.WILL_QOS_SHIFT = 3;
    L.WILL_FLAG_MASK = 4;
    L.CLEAN_SESSION_MASK = 2;
    L.CONNECT_HEADER = ke.from([
        L.codes.connect << L.CMD_SHIFT
    ]);
    L.properties = {
        sessionExpiryInterval: 17,
        willDelayInterval: 24,
        receiveMaximum: 33,
        maximumPacketSize: 39,
        topicAliasMaximum: 34,
        requestResponseInformation: 25,
        requestProblemInformation: 23,
        userProperties: 38,
        authenticationMethod: 21,
        authenticationData: 22,
        payloadFormatIndicator: 1,
        messageExpiryInterval: 2,
        contentType: 3,
        responseTopic: 8,
        correlationData: 9,
        maximumQoS: 36,
        retainAvailable: 37,
        assignedClientIdentifier: 18,
        reasonString: 31,
        wildcardSubscriptionAvailable: 40,
        subscriptionIdentifiersAvailable: 41,
        sharedSubscriptionAvailable: 42,
        serverKeepAlive: 19,
        responseInformation: 26,
        serverReference: 28,
        topicAlias: 35,
        subscriptionIdentifier: 11
    };
    L.propertiesCodes = {};
    for(let t in L.properties){
        let e = L.properties[t];
        L.propertiesCodes[e] = t;
    }
    L.propertiesTypes = {
        sessionExpiryInterval: "int32",
        willDelayInterval: "int32",
        receiveMaximum: "int16",
        maximumPacketSize: "int32",
        topicAliasMaximum: "int16",
        requestResponseInformation: "byte",
        requestProblemInformation: "byte",
        userProperties: "pair",
        authenticationMethod: "string",
        authenticationData: "binary",
        payloadFormatIndicator: "byte",
        messageExpiryInterval: "int32",
        contentType: "string",
        responseTopic: "string",
        correlationData: "binary",
        maximumQoS: "int8",
        retainAvailable: "byte",
        assignedClientIdentifier: "string",
        reasonString: "string",
        wildcardSubscriptionAvailable: "byte",
        subscriptionIdentifiersAvailable: "byte",
        sharedSubscriptionAvailable: "byte",
        serverKeepAlive: "int16",
        responseInformation: "string",
        serverReference: "string",
        topicAlias: "int16",
        subscriptionIdentifier: "var"
    };
    function Dt(t) {
        return [
            0,
            1,
            2
        ].map((e)=>[
                0,
                1
            ].map((r)=>[
                    0,
                    1
                ].map((i)=>{
                    let n = ke.alloc(1);
                    return n.writeUInt8(L.codes[t] << L.CMD_SHIFT | (r ? L.DUP_MASK : 0) | e << L.QOS_SHIFT | i, 0, !0), n;
                })));
    }
    L.PUBLISH_HEADER = Dt("publish");
    L.SUBSCRIBE_HEADER = Dt("subscribe");
    L.SUBSCRIBE_OPTIONS_QOS_MASK = 3;
    L.SUBSCRIBE_OPTIONS_NL_MASK = 1;
    L.SUBSCRIBE_OPTIONS_NL_SHIFT = 2;
    L.SUBSCRIBE_OPTIONS_RAP_MASK = 1;
    L.SUBSCRIBE_OPTIONS_RAP_SHIFT = 3;
    L.SUBSCRIBE_OPTIONS_RH_MASK = 3;
    L.SUBSCRIBE_OPTIONS_RH_SHIFT = 4;
    L.SUBSCRIBE_OPTIONS_RH = [
        0,
        16,
        32
    ];
    L.SUBSCRIBE_OPTIONS_NL = 4;
    L.SUBSCRIBE_OPTIONS_RAP = 8;
    L.SUBSCRIBE_OPTIONS_QOS = [
        0,
        1,
        2
    ];
    L.UNSUBSCRIBE_HEADER = Dt("unsubscribe");
    L.ACKS = {
        unsuback: Dt("unsuback"),
        puback: Dt("puback"),
        pubcomp: Dt("pubcomp"),
        pubrel: Dt("pubrel"),
        pubrec: Dt("pubrec")
    };
    L.SUBACK_HEADER = ke.from([
        L.codes.suback << L.CMD_SHIFT
    ]);
    L.VERSION3 = ke.from([
        3
    ]);
    L.VERSION4 = ke.from([
        4
    ]);
    L.VERSION5 = ke.from([
        5
    ]);
    L.VERSION131 = ke.from([
        131
    ]);
    L.VERSION132 = ke.from([
        132
    ]);
    L.QOS = [
        0,
        1,
        2
    ].map((t)=>ke.from([
            t
        ]));
    L.EMPTY = {
        pingreq: ke.from([
            L.codes.pingreq << 4,
            0
        ]),
        pingresp: ke.from([
            L.codes.pingresp << 4,
            0
        ]),
        disconnect: ke.from([
            L.codes.disconnect << 4,
            0
        ])
    };
    L.MQTT5_PUBACK_PUBREC_CODES = {
        0: "Success",
        16: "No matching subscribers",
        128: "Unspecified error",
        131: "Implementation specific error",
        135: "Not authorized",
        144: "Topic Name invalid",
        145: "Packet identifier in use",
        151: "Quota exceeded",
        153: "Payload format invalid"
    };
    L.MQTT5_PUBREL_PUBCOMP_CODES = {
        0: "Success",
        146: "Packet Identifier not found"
    };
    L.MQTT5_SUBACK_CODES = {
        0: "Granted QoS 0",
        1: "Granted QoS 1",
        2: "Granted QoS 2",
        128: "Unspecified error",
        131: "Implementation specific error",
        135: "Not authorized",
        143: "Topic Filter invalid",
        145: "Packet Identifier in use",
        151: "Quota exceeded",
        158: "Shared Subscriptions not supported",
        161: "Subscription Identifiers not supported",
        162: "Wildcard Subscriptions not supported"
    };
    L.MQTT5_UNSUBACK_CODES = {
        0: "Success",
        17: "No subscription existed",
        128: "Unspecified error",
        131: "Implementation specific error",
        135: "Not authorized",
        143: "Topic Filter invalid",
        145: "Packet Identifier in use"
    };
    L.MQTT5_DISCONNECT_CODES = {
        0: "Normal disconnection",
        4: "Disconnect with Will Message",
        128: "Unspecified error",
        129: "Malformed Packet",
        130: "Protocol Error",
        131: "Implementation specific error",
        135: "Not authorized",
        137: "Server busy",
        139: "Server shutting down",
        141: "Keep Alive timeout",
        142: "Session taken over",
        143: "Topic Filter invalid",
        144: "Topic Name invalid",
        147: "Receive Maximum exceeded",
        148: "Topic Alias invalid",
        149: "Packet too large",
        150: "Message rate too high",
        151: "Quota exceeded",
        152: "Administrative action",
        153: "Payload format invalid",
        154: "Retain not supported",
        155: "QoS not supported",
        156: "Use another server",
        157: "Server moved",
        158: "Shared Subscriptions not supported",
        159: "Connection rate exceeded",
        160: "Maximum connect time",
        161: "Subscription Identifiers not supported",
        162: "Wildcard Subscriptions not supported"
    };
    L.MQTT5_AUTH_CODES = {
        0: "Success",
        24: "Continue authentication",
        25: "Re-authenticate"
    };
});
var cd = O((PB, ud)=>{
    _();
    v();
    m();
    var Wr = 1e3, $r = Wr * 60, Hr = $r * 60, lr = Hr * 24, C0 = lr * 7, P0 = lr * 365.25;
    ud.exports = function(t, e) {
        e = e || {};
        var r = typeof t;
        if (r === "string" && t.length > 0) return k0(t);
        if (r === "number" && isFinite(t)) return e.long ? x0(t) : B0(t);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
    };
    function k0(t) {
        if (t = String(t), !(t.length > 100)) {
            var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
            if (e) {
                var r = parseFloat(e[1]), i = (e[2] || "ms").toLowerCase();
                switch(i){
                    case "years":
                    case "year":
                    case "yrs":
                    case "yr":
                    case "y":
                        return r * P0;
                    case "weeks":
                    case "week":
                    case "w":
                        return r * C0;
                    case "days":
                    case "day":
                    case "d":
                        return r * lr;
                    case "hours":
                    case "hour":
                    case "hrs":
                    case "hr":
                    case "h":
                        return r * Hr;
                    case "minutes":
                    case "minute":
                    case "mins":
                    case "min":
                    case "m":
                        return r * $r;
                    case "seconds":
                    case "second":
                    case "secs":
                    case "sec":
                    case "s":
                        return r * Wr;
                    case "milliseconds":
                    case "millisecond":
                    case "msecs":
                    case "msec":
                    case "ms":
                        return r;
                    default:
                        return;
                }
            }
        }
    }
    function B0(t) {
        var e = Math.abs(t);
        return e >= lr ? Math.round(t / lr) + "d" : e >= Hr ? Math.round(t / Hr) + "h" : e >= $r ? Math.round(t / $r) + "m" : e >= Wr ? Math.round(t / Wr) + "s" : t + "ms";
    }
    function x0(t) {
        var e = Math.abs(t);
        return e >= lr ? Sn(t, e, lr, "day") : e >= Hr ? Sn(t, e, Hr, "hour") : e >= $r ? Sn(t, e, $r, "minute") : e >= Wr ? Sn(t, e, Wr, "second") : t + " ms";
    }
    function Sn(t, e, r, i) {
        var n = e >= r * 1.5;
        return Math.round(t / r) + " " + i + (n ? "s" : "");
    }
});
var hd = O((DB, fd)=>{
    _();
    v();
    m();
    function O0(t) {
        r.debug = r, r.default = r, r.coerce = u, r.disable = s, r.enable = n, r.enabled = a, r.humanize = cd(), r.destroy = f, Object.keys(t).forEach((d)=>{
            r[d] = t[d];
        }), r.names = [], r.skips = [], r.formatters = {};
        function e(d) {
            let h = 0;
            for(let g = 0; g < d.length; g++)h = (h << 5) - h + d.charCodeAt(g), h |= 0;
            return r.colors[Math.abs(h) % r.colors.length];
        }
        r.selectColor = e;
        function r(d) {
            let h, g = null, b, E;
            function w(...S) {
                if (!w.enabled) return;
                let I = w, P = Number(new Date), C = P - (h || P);
                I.diff = C, I.prev = h, I.curr = P, h = P, S[0] = r.coerce(S[0]), typeof S[0] != "string" && S.unshift("%O");
                let M = 0;
                S[0] = S[0].replace(/%([a-zA-Z%])/g, (z, j)=>{
                    if (z === "%%") return "%";
                    M++;
                    let G = r.formatters[j];
                    if (typeof G == "function") {
                        let $ = S[M];
                        z = G.call(I, $), S.splice(M, 1), M--;
                    }
                    return z;
                }), r.formatArgs.call(I, S), (I.log || r.log).apply(I, S);
            }
            return w.namespace = d, w.useColors = r.useColors(), w.color = r.selectColor(d), w.extend = i, w.destroy = r.destroy, Object.defineProperty(w, "enabled", {
                enumerable: !0,
                configurable: !1,
                get: ()=>g !== null ? g : (b !== r.namespaces && (b = r.namespaces, E = r.enabled(d)), E),
                set: (S)=>{
                    g = S;
                }
            }), typeof r.init == "function" && r.init(w), w;
        }
        function i(d, h) {
            let g = r(this.namespace + (typeof h > "u" ? ":" : h) + d);
            return g.log = this.log, g;
        }
        function n(d) {
            r.save(d), r.namespaces = d, r.names = [], r.skips = [];
            let h = (typeof d == "string" ? d : "").trim().replace(" ", ",").split(",").filter(Boolean);
            for (let g of h)g[0] === "-" ? r.skips.push(g.slice(1)) : r.names.push(g);
        }
        function o(d, h) {
            let g = 0, b = 0, E = -1, w = 0;
            for(; g < d.length;)if (b < h.length && (h[b] === d[g] || h[b] === "*")) h[b] === "*" ? (E = b, w = g, b++) : (g++, b++);
            else if (E !== -1) b = E + 1, w++, g = w;
            else return !1;
            for(; b < h.length && h[b] === "*";)b++;
            return b === h.length;
        }
        function s() {
            let d = [
                ...r.names,
                ...r.skips.map((h)=>"-" + h)
            ].join(",");
            return r.enable(""), d;
        }
        function a(d) {
            for (let h of r.skips)if (o(d, h)) return !1;
            for (let h of r.names)if (o(d, h)) return !0;
            return !1;
        }
        function u(d) {
            return d instanceof Error ? d.stack || d.message : d;
        }
        function f() {
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        return r.enable(r.load()), r;
    }
    fd.exports = O0;
});
var nt = O((Be, An)=>{
    _();
    v();
    m();
    Be.formatArgs = L0;
    Be.save = q0;
    Be.load = U0;
    Be.useColors = M0;
    Be.storage = N0();
    Be.destroy = (()=>{
        let t = !1;
        return ()=>{
            t || (t = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
        };
    })();
    Be.colors = [
        "#0000CC",
        "#0000FF",
        "#0033CC",
        "#0033FF",
        "#0066CC",
        "#0066FF",
        "#0099CC",
        "#0099FF",
        "#00CC00",
        "#00CC33",
        "#00CC66",
        "#00CC99",
        "#00CCCC",
        "#00CCFF",
        "#3300CC",
        "#3300FF",
        "#3333CC",
        "#3333FF",
        "#3366CC",
        "#3366FF",
        "#3399CC",
        "#3399FF",
        "#33CC00",
        "#33CC33",
        "#33CC66",
        "#33CC99",
        "#33CCCC",
        "#33CCFF",
        "#6600CC",
        "#6600FF",
        "#6633CC",
        "#6633FF",
        "#66CC00",
        "#66CC33",
        "#9900CC",
        "#9900FF",
        "#9933CC",
        "#9933FF",
        "#99CC00",
        "#99CC33",
        "#CC0000",
        "#CC0033",
        "#CC0066",
        "#CC0099",
        "#CC00CC",
        "#CC00FF",
        "#CC3300",
        "#CC3333",
        "#CC3366",
        "#CC3399",
        "#CC33CC",
        "#CC33FF",
        "#CC6600",
        "#CC6633",
        "#CC9900",
        "#CC9933",
        "#CCCC00",
        "#CCCC33",
        "#FF0000",
        "#FF0033",
        "#FF0066",
        "#FF0099",
        "#FF00CC",
        "#FF00FF",
        "#FF3300",
        "#FF3333",
        "#FF3366",
        "#FF3399",
        "#FF33CC",
        "#FF33FF",
        "#FF6600",
        "#FF6633",
        "#FF9900",
        "#FF9933",
        "#FFCC00",
        "#FFCC33"
    ];
    function M0() {
        if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return !0;
        if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
        let t;
        return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (t = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(t[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function L0(t) {
        if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + An.exports.humanize(this.diff), !this.useColors) return;
        let e = "color: " + this.color;
        t.splice(1, 0, e, "color: inherit");
        let r = 0, i = 0;
        t[0].replace(/%[a-zA-Z%]/g, (n)=>{
            n !== "%%" && (r++, n === "%c" && (i = r));
        }), t.splice(i, 0, e);
    }
    Be.log = console.debug || console.log || (()=>{});
    function q0(t) {
        try {
            t ? Be.storage.setItem("debug", t) : Be.storage.removeItem("debug");
        } catch  {}
    }
    function U0() {
        let t;
        try {
            t = Be.storage.getItem("debug");
        } catch  {}
        return !t && typeof R < "u" && "env" in R && (t = R.env.DEBUG), t;
    }
    function N0() {
        try {
            return localStorage;
        } catch  {}
    }
    An.exports = hd()(Be);
    var { formatters: D0 } = An.exports;
    D0.j = function(t) {
        try {
            return JSON.stringify(t);
        } catch (e) {
            return "[UnexpectedJSONParseError]: " + e.message;
        }
    };
});
var gd = O((nx, pd)=>{
    _();
    v();
    m();
    var j0 = sd(), { EventEmitter: F0 } = (Ot(), Q(xt)), dd = ad(), V = Uo(), N = nt()("mqtt-packet:parser"), No = class t extends F0 {
        constructor(){
            super(), this.parser = this.constructor.parser;
        }
        static parser(e) {
            return this instanceof t ? (this.settings = e || {}, this._states = [
                "_parseHeader",
                "_parseLength",
                "_parsePayload",
                "_newPacket"
            ], this._resetState(), this) : new t().parser(e);
        }
        _resetState() {
            N("_resetState: resetting packet, error, _list, and _stateCounter"), this.packet = new dd, this.error = null, this._list = j0(), this._stateCounter = 0;
        }
        parse(e) {
            for(this.error && this._resetState(), this._list.append(e), N("parse: current state: %s", this._states[this._stateCounter]); (this.packet.length !== -1 || this._list.length > 0) && this[this._states[this._stateCounter]]() && !this.error;)this._stateCounter++, N("parse: state complete. _stateCounter is now: %d", this._stateCounter), N("parse: packet.length: %d, buffer list length: %d", this.packet.length, this._list.length), this._stateCounter >= this._states.length && (this._stateCounter = 0);
            return N("parse: exited while loop. packet: %d, buffer list length: %d", this.packet.length, this._list.length), this._list.length;
        }
        _parseHeader() {
            let e = this._list.readUInt8(0), r = e >> V.CMD_SHIFT;
            this.packet.cmd = V.types[r];
            let i = e & 15, n = V.requiredHeaderFlags[r];
            return n != null && i !== n ? this._emitError(new Error(V.requiredHeaderFlagsErrors[r])) : (this.packet.retain = (e & V.RETAIN_MASK) !== 0, this.packet.qos = e >> V.QOS_SHIFT & V.QOS_MASK, this.packet.qos > 2 ? this._emitError(new Error("Packet must not have both QoS bits set to 1")) : (this.packet.dup = (e & V.DUP_MASK) !== 0, N("_parseHeader: packet: %o", this.packet), this._list.consume(1), !0));
        }
        _parseLength() {
            let e = this._parseVarByteNum(!0);
            return e && (this.packet.length = e.value, this._list.consume(e.bytes)), N("_parseLength %d", e.value), !!e;
        }
        _parsePayload() {
            N("_parsePayload: payload %O", this._list);
            let e = !1;
            if (this.packet.length === 0 || this._list.length >= this.packet.length) {
                switch(this._pos = 0, this.packet.cmd){
                    case "connect":
                        this._parseConnect();
                        break;
                    case "connack":
                        this._parseConnack();
                        break;
                    case "publish":
                        this._parsePublish();
                        break;
                    case "puback":
                    case "pubrec":
                    case "pubrel":
                    case "pubcomp":
                        this._parseConfirmation();
                        break;
                    case "subscribe":
                        this._parseSubscribe();
                        break;
                    case "suback":
                        this._parseSuback();
                        break;
                    case "unsubscribe":
                        this._parseUnsubscribe();
                        break;
                    case "unsuback":
                        this._parseUnsuback();
                        break;
                    case "pingreq":
                    case "pingresp":
                        break;
                    case "disconnect":
                        this._parseDisconnect();
                        break;
                    case "auth":
                        this._parseAuth();
                        break;
                    default:
                        this._emitError(new Error("Not supported"));
                }
                e = !0;
            }
            return N("_parsePayload complete result: %s", e), e;
        }
        _parseConnect() {
            N("_parseConnect");
            let e, r, i, n, o = {}, s = this.packet, a = this._parseString();
            if (a === null) return this._emitError(new Error("Cannot parse protocolId"));
            if (a !== "MQTT" && a !== "MQIsdp") return this._emitError(new Error("Invalid protocolId"));
            if (s.protocolId = a, this._pos >= this._list.length) return this._emitError(new Error("Packet too short"));
            if (s.protocolVersion = this._list.readUInt8(this._pos), s.protocolVersion >= 128 && (s.bridgeMode = !0, s.protocolVersion = s.protocolVersion - 128), s.protocolVersion !== 3 && s.protocolVersion !== 4 && s.protocolVersion !== 5) return this._emitError(new Error("Invalid protocol version"));
            if (this._pos++, this._pos >= this._list.length) return this._emitError(new Error("Packet too short"));
            if (this._list.readUInt8(this._pos) & 1) return this._emitError(new Error("Connect flag bit 0 must be 0, but got 1"));
            o.username = this._list.readUInt8(this._pos) & V.USERNAME_MASK, o.password = this._list.readUInt8(this._pos) & V.PASSWORD_MASK, o.will = this._list.readUInt8(this._pos) & V.WILL_FLAG_MASK;
            let u = !!(this._list.readUInt8(this._pos) & V.WILL_RETAIN_MASK), f = (this._list.readUInt8(this._pos) & V.WILL_QOS_MASK) >> V.WILL_QOS_SHIFT;
            if (o.will) s.will = {}, s.will.retain = u, s.will.qos = f;
            else {
                if (u) return this._emitError(new Error("Will Retain Flag must be set to zero when Will Flag is set to 0"));
                if (f) return this._emitError(new Error("Will QoS must be set to zero when Will Flag is set to 0"));
            }
            if (s.clean = (this._list.readUInt8(this._pos) & V.CLEAN_SESSION_MASK) !== 0, this._pos++, s.keepalive = this._parseNum(), s.keepalive === -1) return this._emitError(new Error("Packet too short"));
            if (s.protocolVersion === 5) {
                let h = this._parseProperties();
                Object.getOwnPropertyNames(h).length && (s.properties = h);
            }
            let d = this._parseString();
            if (d === null) return this._emitError(new Error("Packet too short"));
            if (s.clientId = d, N("_parseConnect: packet.clientId: %s", s.clientId), o.will) {
                if (s.protocolVersion === 5) {
                    let h = this._parseProperties();
                    Object.getOwnPropertyNames(h).length && (s.will.properties = h);
                }
                if (e = this._parseString(), e === null) return this._emitError(new Error("Cannot parse will topic"));
                if (s.will.topic = e, N("_parseConnect: packet.will.topic: %s", s.will.topic), r = this._parseBuffer(), r === null) return this._emitError(new Error("Cannot parse will payload"));
                s.will.payload = r, N("_parseConnect: packet.will.paylaod: %s", s.will.payload);
            }
            if (o.username) {
                if (n = this._parseString(), n === null) return this._emitError(new Error("Cannot parse username"));
                s.username = n, N("_parseConnect: packet.username: %s", s.username);
            }
            if (o.password) {
                if (i = this._parseBuffer(), i === null) return this._emitError(new Error("Cannot parse password"));
                s.password = i;
            }
            return this.settings = s, N("_parseConnect: complete"), s;
        }
        _parseConnack() {
            N("_parseConnack");
            let e = this.packet;
            if (this._list.length < 1) return null;
            let r = this._list.readUInt8(this._pos++);
            if (r > 1) return this._emitError(new Error("Invalid connack flags, bits 7-1 must be set to 0"));
            if (e.sessionPresent = !!(r & V.SESSIONPRESENT_MASK), this.settings.protocolVersion === 5) this._list.length >= 2 ? e.reasonCode = this._list.readUInt8(this._pos++) : e.reasonCode = 0;
            else {
                if (this._list.length < 2) return null;
                e.returnCode = this._list.readUInt8(this._pos++);
            }
            if (e.returnCode === -1 || e.reasonCode === -1) return this._emitError(new Error("Cannot parse return code"));
            if (this.settings.protocolVersion === 5) {
                let i = this._parseProperties();
                Object.getOwnPropertyNames(i).length && (e.properties = i);
            }
            N("_parseConnack: complete");
        }
        _parsePublish() {
            N("_parsePublish");
            let e = this.packet;
            if (e.topic = this._parseString(), e.topic === null) return this._emitError(new Error("Cannot parse topic"));
            if (!(e.qos > 0 && !this._parseMessageId())) {
                if (this.settings.protocolVersion === 5) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
                e.payload = this._list.slice(this._pos, e.length), N("_parsePublish: payload from buffer list: %o", e.payload);
            }
        }
        _parseSubscribe() {
            N("_parseSubscribe");
            let e = this.packet, r, i, n, o, s, a, u;
            if (e.subscriptions = [], !!this._parseMessageId()) {
                if (this.settings.protocolVersion === 5) {
                    let f = this._parseProperties();
                    Object.getOwnPropertyNames(f).length && (e.properties = f);
                }
                if (e.length <= 0) return this._emitError(new Error("Malformed subscribe, no payload specified"));
                for(; this._pos < e.length;){
                    if (r = this._parseString(), r === null) return this._emitError(new Error("Cannot parse topic"));
                    if (this._pos >= e.length) return this._emitError(new Error("Malformed Subscribe Payload"));
                    if (i = this._parseByte(), this.settings.protocolVersion === 5) {
                        if (i & 192) return this._emitError(new Error("Invalid subscribe topic flag bits, bits 7-6 must be 0"));
                    } else if (i & 252) return this._emitError(new Error("Invalid subscribe topic flag bits, bits 7-2 must be 0"));
                    if (n = i & V.SUBSCRIBE_OPTIONS_QOS_MASK, n > 2) return this._emitError(new Error("Invalid subscribe QoS, must be <= 2"));
                    if (a = (i >> V.SUBSCRIBE_OPTIONS_NL_SHIFT & V.SUBSCRIBE_OPTIONS_NL_MASK) !== 0, s = (i >> V.SUBSCRIBE_OPTIONS_RAP_SHIFT & V.SUBSCRIBE_OPTIONS_RAP_MASK) !== 0, o = i >> V.SUBSCRIBE_OPTIONS_RH_SHIFT & V.SUBSCRIBE_OPTIONS_RH_MASK, o > 2) return this._emitError(new Error("Invalid retain handling, must be <= 2"));
                    u = {
                        topic: r,
                        qos: n
                    }, this.settings.protocolVersion === 5 ? (u.nl = a, u.rap = s, u.rh = o) : this.settings.bridgeMode && (u.rh = 0, u.rap = !0, u.nl = !0), N("_parseSubscribe: push subscription `%s` to subscription", u), e.subscriptions.push(u);
                }
            }
        }
        _parseSuback() {
            N("_parseSuback");
            let e = this.packet;
            if (this.packet.granted = [], !!this._parseMessageId()) {
                if (this.settings.protocolVersion === 5) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
                if (e.length <= 0) return this._emitError(new Error("Malformed suback, no payload specified"));
                for(; this._pos < this.packet.length;){
                    let r = this._list.readUInt8(this._pos++);
                    if (this.settings.protocolVersion === 5) {
                        if (!V.MQTT5_SUBACK_CODES[r]) return this._emitError(new Error("Invalid suback code"));
                    } else if (r > 2 && r !== 128) return this._emitError(new Error("Invalid suback QoS, must be 0, 1, 2 or 128"));
                    this.packet.granted.push(r);
                }
            }
        }
        _parseUnsubscribe() {
            N("_parseUnsubscribe");
            let e = this.packet;
            if (e.unsubscriptions = [], !!this._parseMessageId()) {
                if (this.settings.protocolVersion === 5) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
                if (e.length <= 0) return this._emitError(new Error("Malformed unsubscribe, no payload specified"));
                for(; this._pos < e.length;){
                    let r = this._parseString();
                    if (r === null) return this._emitError(new Error("Cannot parse topic"));
                    N("_parseUnsubscribe: push topic `%s` to unsubscriptions", r), e.unsubscriptions.push(r);
                }
            }
        }
        _parseUnsuback() {
            N("_parseUnsuback");
            let e = this.packet;
            if (!this._parseMessageId()) return this._emitError(new Error("Cannot parse messageId"));
            if ((this.settings.protocolVersion === 3 || this.settings.protocolVersion === 4) && e.length !== 2) return this._emitError(new Error("Malformed unsuback, payload length must be 2"));
            if (e.length <= 0) return this._emitError(new Error("Malformed unsuback, no payload specified"));
            if (this.settings.protocolVersion === 5) {
                let r = this._parseProperties();
                for(Object.getOwnPropertyNames(r).length && (e.properties = r), e.granted = []; this._pos < this.packet.length;){
                    let i = this._list.readUInt8(this._pos++);
                    if (!V.MQTT5_UNSUBACK_CODES[i]) return this._emitError(new Error("Invalid unsuback code"));
                    this.packet.granted.push(i);
                }
            }
        }
        _parseConfirmation() {
            N("_parseConfirmation: packet.cmd: `%s`", this.packet.cmd);
            let e = this.packet;
            if (this._parseMessageId(), this.settings.protocolVersion === 5) {
                if (e.length > 2) {
                    switch(e.reasonCode = this._parseByte(), this.packet.cmd){
                        case "puback":
                        case "pubrec":
                            if (!V.MQTT5_PUBACK_PUBREC_CODES[e.reasonCode]) return this._emitError(new Error("Invalid " + this.packet.cmd + " reason code"));
                            break;
                        case "pubrel":
                        case "pubcomp":
                            if (!V.MQTT5_PUBREL_PUBCOMP_CODES[e.reasonCode]) return this._emitError(new Error("Invalid " + this.packet.cmd + " reason code"));
                            break;
                    }
                    N("_parseConfirmation: packet.reasonCode `%d`", e.reasonCode);
                } else e.reasonCode = 0;
                if (e.length > 3) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
            }
            return !0;
        }
        _parseDisconnect() {
            let e = this.packet;
            if (N("_parseDisconnect"), this.settings.protocolVersion === 5) {
                this._list.length > 0 ? (e.reasonCode = this._parseByte(), V.MQTT5_DISCONNECT_CODES[e.reasonCode] || this._emitError(new Error("Invalid disconnect reason code"))) : e.reasonCode = 0;
                let r = this._parseProperties();
                Object.getOwnPropertyNames(r).length && (e.properties = r);
            }
            return N("_parseDisconnect result: true"), !0;
        }
        _parseAuth() {
            N("_parseAuth");
            let e = this.packet;
            if (this.settings.protocolVersion !== 5) return this._emitError(new Error("Not supported auth packet for this version MQTT"));
            if (e.reasonCode = this._parseByte(), !V.MQTT5_AUTH_CODES[e.reasonCode]) return this._emitError(new Error("Invalid auth reason code"));
            let r = this._parseProperties();
            return Object.getOwnPropertyNames(r).length && (e.properties = r), N("_parseAuth: result: true"), !0;
        }
        _parseMessageId() {
            let e = this.packet;
            return e.messageId = this._parseNum(), e.messageId === null ? (this._emitError(new Error("Cannot parse messageId")), !1) : (N("_parseMessageId: packet.messageId %d", e.messageId), !0);
        }
        _parseString(e) {
            let r = this._parseNum(), i = r + this._pos;
            if (r === -1 || i > this._list.length || i > this.packet.length) return null;
            let n = this._list.toString("utf8", this._pos, i);
            return this._pos += r, N("_parseString: result: %s", n), n;
        }
        _parseStringPair() {
            return N("_parseStringPair"), {
                name: this._parseString(),
                value: this._parseString()
            };
        }
        _parseBuffer() {
            let e = this._parseNum(), r = e + this._pos;
            if (e === -1 || r > this._list.length || r > this.packet.length) return null;
            let i = this._list.slice(this._pos, r);
            return this._pos += e, N("_parseBuffer: result: %o", i), i;
        }
        _parseNum() {
            if (this._list.length - this._pos < 2) return -1;
            let e = this._list.readUInt16BE(this._pos);
            return this._pos += 2, N("_parseNum: result: %s", e), e;
        }
        _parse4ByteNum() {
            if (this._list.length - this._pos < 4) return -1;
            let e = this._list.readUInt32BE(this._pos);
            return this._pos += 4, N("_parse4ByteNum: result: %s", e), e;
        }
        _parseVarByteNum(e) {
            N("_parseVarByteNum");
            let r = 4, i = 0, n = 1, o = 0, s = !1, a, u = this._pos ? this._pos : 0;
            for(; i < r && u + i < this._list.length;){
                if (a = this._list.readUInt8(u + i++), o += n * (a & V.VARBYTEINT_MASK), n *= 128, (a & V.VARBYTEINT_FIN_MASK) === 0) {
                    s = !0;
                    break;
                }
                if (this._list.length <= i) break;
            }
            return !s && i === r && this._list.length >= i && this._emitError(new Error("Invalid variable byte integer")), u && (this._pos += i), s ? e ? s = {
                bytes: i,
                value: o
            } : s = o : s = !1, N("_parseVarByteNum: result: %o", s), s;
        }
        _parseByte() {
            let e;
            return this._pos < this._list.length && (e = this._list.readUInt8(this._pos), this._pos++), N("_parseByte: result: %o", e), e;
        }
        _parseByType(e) {
            switch(N("_parseByType: type: %s", e), e){
                case "byte":
                    return this._parseByte() !== 0;
                case "int8":
                    return this._parseByte();
                case "int16":
                    return this._parseNum();
                case "int32":
                    return this._parse4ByteNum();
                case "var":
                    return this._parseVarByteNum();
                case "string":
                    return this._parseString();
                case "pair":
                    return this._parseStringPair();
                case "binary":
                    return this._parseBuffer();
            }
        }
        _parseProperties() {
            N("_parseProperties");
            let e = this._parseVarByteNum(), i = this._pos + e, n = {};
            for(; this._pos < i;){
                let o = this._parseByte();
                if (!o) return this._emitError(new Error("Cannot parse property code type")), !1;
                let s = V.propertiesCodes[o];
                if (!s) return this._emitError(new Error("Unknown property")), !1;
                if (s === "userProperties") {
                    n[s] || (n[s] = Object.create(null));
                    let a = this._parseByType(V.propertiesTypes[s]);
                    if (n[s][a.name]) {
                        if (Array.isArray(n[s][a.name])) n[s][a.name].push(a.value);
                        else {
                            let u = n[s][a.name];
                            n[s][a.name] = [
                                u
                            ], n[s][a.name].push(a.value);
                        }
                    } else n[s][a.name] = a.value;
                    continue;
                }
                n[s] ? Array.isArray(n[s]) ? n[s].push(this._parseByType(V.propertiesTypes[s])) : (n[s] = [
                    n[s]
                ], n[s].push(this._parseByType(V.propertiesTypes[s]))) : n[s] = this._parseByType(V.propertiesTypes[s]);
            }
            return n;
        }
        _newPacket() {
            return N("_newPacket"), this.packet && (this._list.consume(this.packet.length), N("_newPacket: parser emit packet: packet.cmd: %s, packet.payload: %s, packet.length: %d", this.packet.cmd, this.packet.payload, this.packet.length), this.emit("packet", this.packet)), N("_newPacket: new packet"), this.packet = new dd, this._pos = 0, !0;
        }
        _emitError(e) {
            N("_emitError", e), this.error = e, this.emit("error", e);
        }
    };
    pd.exports = No;
});
var _d = O((px, wd)=>{
    _();
    v();
    m();
    var { Buffer: mi } = (he(), Q(ye)), W0 = 65536, bd = {}, $0 = mi.isBuffer(mi.from([
        1,
        2
    ]).subarray(0, 1));
    function yd(t) {
        let e = mi.allocUnsafe(2);
        return e.writeUInt8(t >> 8, 0), e.writeUInt8(t & 255, 1), e;
    }
    function H0() {
        for(let t = 0; t < W0; t++)bd[t] = yd(t);
    }
    function V0(t) {
        let r = 0, i = 0, n = mi.allocUnsafe(4);
        do r = t % 128 | 0, t = t / 128 | 0, t > 0 && (r = r | 128), n.writeUInt8(r, i++);
        while (t > 0 && i < 4);
        return t > 0 && (i = 0), $0 ? n.subarray(0, i) : n.slice(0, i);
    }
    function z0(t) {
        let e = mi.allocUnsafe(4);
        return e.writeUInt32BE(t, 0), e;
    }
    wd.exports = {
        cache: bd,
        generateCache: H0,
        generateNumber: yd,
        genBufVariableByteInt: V0,
        generate4ByteBuffer: z0
    };
});
var md = O((Ix, Do)=>{
    "use strict";
    _();
    v();
    m();
    typeof R > "u" || !R.version || R.version.indexOf("v0.") === 0 || R.version.indexOf("v1.") === 0 && R.version.indexOf("v1.8.") !== 0 ? Do.exports = {
        nextTick: K0
    } : Do.exports = R;
    function K0(t, e, r, i) {
        if (typeof t != "function") throw new TypeError('"callback" argument must be a function');
        var n = arguments.length, o, s;
        switch(n){
            case 0:
            case 1:
                return R.nextTick(t);
            case 2:
                return R.nextTick(function() {
                    t.call(null, e);
                });
            case 3:
                return R.nextTick(function() {
                    t.call(null, e, r);
                });
            case 4:
                return R.nextTick(function() {
                    t.call(null, e, r, i);
                });
            default:
                for(o = new Array(n - 1), s = 0; s < o.length;)o[s++] = arguments[s];
                return R.nextTick(function() {
                    t.apply(null, o);
                });
        }
    }
});
var Wo = O((Lx, Cd)=>{
    _();
    v();
    m();
    var D = Uo(), { Buffer: U } = (he(), Q(ye)), G0 = U.allocUnsafe(0), Q0 = U.from([
        0
    ]), vi = _d(), Y0 = md().nextTick, qe = nt()("mqtt-packet:writeToStream"), In = vi.cache, J0 = vi.generateNumber, X0 = vi.generateCache, jo = vi.genBufVariableByteInt, Z0 = vi.generate4ByteBuffer, Te = Fo, Tn = !0;
    function Td(t, e, r) {
        switch(qe("generate called"), e.cork && (e.cork(), Y0(ev, e)), Tn && (Tn = !1, X0()), qe("generate: packet.cmd: %s", t.cmd), t.cmd){
            case "connect":
                return tv(t, e, r);
            case "connack":
                return rv(t, e, r);
            case "publish":
                return iv(t, e, r);
            case "puback":
            case "pubrec":
            case "pubrel":
            case "pubcomp":
                return nv(t, e, r);
            case "subscribe":
                return sv(t, e, r);
            case "suback":
                return ov(t, e, r);
            case "unsubscribe":
                return av(t, e, r);
            case "unsuback":
                return lv(t, e, r);
            case "pingreq":
            case "pingresp":
                return uv(t, e, r);
            case "disconnect":
                return cv(t, e, r);
            case "auth":
                return fv(t, e, r);
            default:
                return e.destroy(new Error("Unknown command")), !1;
        }
    }
    Object.defineProperty(Td, "cacheNumbers", {
        get () {
            return Te === Fo;
        },
        set (t) {
            t ? ((!In || Object.keys(In).length === 0) && (Tn = !0), Te = Fo) : (Tn = !1, Te = hv);
        }
    });
    function ev(t) {
        t.uncork();
    }
    function tv(t, e, r) {
        let i = t || {}, n = i.protocolId || "MQTT", o = i.protocolVersion || 4, s = i.will, a = i.clean, u = i.keepalive || 0, f = i.clientId || "", d = i.username, h = i.password, g = i.properties;
        a === void 0 && (a = !0);
        let b = 0;
        if (!n || typeof n != "string" && !U.isBuffer(n)) return e.destroy(new Error("Invalid protocolId")), !1;
        if (b += n.length + 2, o !== 3 && o !== 4 && o !== 5) return e.destroy(new Error("Invalid protocol version")), !1;
        if (b += 1, (typeof f == "string" || U.isBuffer(f)) && (f || o >= 4) && (f || a)) b += U.byteLength(f) + 2;
        else {
            if (o < 4) return e.destroy(new Error("clientId must be supplied before 3.1.1")), !1;
            if (a * 1 === 0) return e.destroy(new Error("clientId must be given if cleanSession set to 0")), !1;
        }
        if (typeof u != "number" || u < 0 || u > 65535 || u % 1 !== 0) return e.destroy(new Error("Invalid keepalive")), !1;
        b += 2, b += 1;
        let E, w;
        if (o === 5) {
            if (E = jt(e, g), !E) return !1;
            b += E.length;
        }
        if (s) {
            if (typeof s != "object") return e.destroy(new Error("Invalid will")), !1;
            if (!s.topic || typeof s.topic != "string") return e.destroy(new Error("Invalid will topic")), !1;
            if (b += U.byteLength(s.topic) + 2, b += 2, s.payload) {
                if (s.payload.length >= 0) typeof s.payload == "string" ? b += U.byteLength(s.payload) : b += s.payload.length;
                else return e.destroy(new Error("Invalid will payload")), !1;
            }
            if (w = {}, o === 5) {
                if (w = jt(e, s.properties), !w) return !1;
                b += w.length;
            }
        }
        let S = !1;
        if (d != null) {
            if (Id(d)) S = !0, b += U.byteLength(d) + 2;
            else return e.destroy(new Error("Invalid username")), !1;
        }
        if (h != null) {
            if (!S) return e.destroy(new Error("Username is required to use password")), !1;
            if (Id(h)) b += Rd(h) + 2;
            else return e.destroy(new Error("Invalid password")), !1;
        }
        e.write(D.CONNECT_HEADER), Ue(e, b), Vr(e, n), i.bridgeMode && (o += 128), e.write(o === 131 ? D.VERSION131 : o === 132 ? D.VERSION132 : o === 4 ? D.VERSION4 : o === 5 ? D.VERSION5 : D.VERSION3);
        let I = 0;
        return I |= d != null ? D.USERNAME_MASK : 0, I |= h != null ? D.PASSWORD_MASK : 0, I |= s && s.retain ? D.WILL_RETAIN_MASK : 0, I |= s && s.qos ? s.qos << D.WILL_QOS_SHIFT : 0, I |= s ? D.WILL_FLAG_MASK : 0, I |= a ? D.CLEAN_SESSION_MASK : 0, e.write(U.from([
            I
        ])), Te(e, u), o === 5 && E.write(), Vr(e, f), s && (o === 5 && w.write(), ur(e, s.topic), Vr(e, s.payload)), d != null && Vr(e, d), h != null && Vr(e, h), !0;
    }
    function rv(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = i === 5 ? n.reasonCode : n.returnCode, s = n.properties, a = 2;
        if (typeof o != "number") return e.destroy(new Error("Invalid return code")), !1;
        let u = null;
        if (i === 5) {
            if (u = jt(e, s), !u) return !1;
            a += u.length;
        }
        return e.write(D.CONNACK_HEADER), Ue(e, a), e.write(n.sessionPresent ? D.SESSIONPRESENT_HEADER : Q0), e.write(U.from([
            o
        ])), u?.write(), !0;
    }
    function iv(t, e, r) {
        qe("publish: packet: %o", t);
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.qos || 0, s = n.retain ? D.RETAIN_MASK : 0, a = n.topic, u = n.payload || G0, f = n.messageId, d = n.properties, h = 0;
        if (typeof a == "string") h += U.byteLength(a) + 2;
        else if (U.isBuffer(a)) h += a.length + 2;
        else return e.destroy(new Error("Invalid topic")), !1;
        if (U.isBuffer(u) ? h += u.length : h += U.byteLength(u), o && typeof f != "number") return e.destroy(new Error("Invalid messageId")), !1;
        o && (h += 2);
        let g = null;
        if (i === 5) {
            if (g = jt(e, d), !g) return !1;
            h += g.length;
        }
        return e.write(D.PUBLISH_HEADER[o][n.dup ? 1 : 0][s ? 1 : 0]), Ue(e, h), Te(e, Rd(a)), e.write(a), o > 0 && Te(e, f), g?.write(), qe("publish: payload: %o", u), e.write(u);
    }
    function nv(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.cmd || "puback", s = n.messageId, a = n.dup && o === "pubrel" ? D.DUP_MASK : 0, u = 0, f = n.reasonCode, d = n.properties, h = i === 5 ? 3 : 2;
        if (o === "pubrel" && (u = 1), typeof s != "number") return e.destroy(new Error("Invalid messageId")), !1;
        let g = null;
        if (i === 5 && typeof d == "object") {
            if (g = Ei(e, d, r, h), !g) return !1;
            h += g.length;
        }
        return e.write(D.ACKS[o][u][a][0]), h === 3 && (h += f !== 0 ? 1 : -1), Ue(e, h), Te(e, s), i === 5 && h !== 2 && e.write(U.from([
            f
        ])), g !== null ? g.write() : h === 4 && e.write(U.from([
            0
        ])), !0;
    }
    function sv(t, e, r) {
        qe("subscribe: packet: ");
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.dup ? D.DUP_MASK : 0, s = n.messageId, a = n.subscriptions, u = n.properties, f = 0;
        if (typeof s != "number") return e.destroy(new Error("Invalid messageId")), !1;
        f += 2;
        let d = null;
        if (i === 5) {
            if (d = jt(e, u), !d) return !1;
            f += d.length;
        }
        if (typeof a == "object" && a.length) for(let g = 0; g < a.length; g += 1){
            let b = a[g].topic, E = a[g].qos;
            if (typeof b != "string") return e.destroy(new Error("Invalid subscriptions - invalid topic")), !1;
            if (typeof E != "number") return e.destroy(new Error("Invalid subscriptions - invalid qos")), !1;
            if (i === 5) {
                if (typeof (a[g].nl || !1) != "boolean") return e.destroy(new Error("Invalid subscriptions - invalid No Local")), !1;
                if (typeof (a[g].rap || !1) != "boolean") return e.destroy(new Error("Invalid subscriptions - invalid Retain as Published")), !1;
                let I = a[g].rh || 0;
                if (typeof I != "number" || I > 2) return e.destroy(new Error("Invalid subscriptions - invalid Retain Handling")), !1;
            }
            f += U.byteLength(b) + 2 + 1;
        }
        else return e.destroy(new Error("Invalid subscriptions")), !1;
        qe("subscribe: writing to stream: %o", D.SUBSCRIBE_HEADER), e.write(D.SUBSCRIBE_HEADER[1][o ? 1 : 0][0]), Ue(e, f), Te(e, s), d !== null && d.write();
        let h = !0;
        for (let g of a){
            let b = g.topic, E = g.qos, w = +g.nl, S = +g.rap, I = g.rh, P;
            ur(e, b), P = D.SUBSCRIBE_OPTIONS_QOS[E], i === 5 && (P |= w ? D.SUBSCRIBE_OPTIONS_NL : 0, P |= S ? D.SUBSCRIBE_OPTIONS_RAP : 0, P |= I ? D.SUBSCRIBE_OPTIONS_RH[I] : 0), h = e.write(U.from([
                P
            ]));
        }
        return h;
    }
    function ov(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.messageId, s = n.granted, a = n.properties, u = 0;
        if (typeof o != "number") return e.destroy(new Error("Invalid messageId")), !1;
        if (u += 2, typeof s == "object" && s.length) for(let d = 0; d < s.length; d += 1){
            if (typeof s[d] != "number") return e.destroy(new Error("Invalid qos vector")), !1;
            u += 1;
        }
        else return e.destroy(new Error("Invalid qos vector")), !1;
        let f = null;
        if (i === 5) {
            if (f = Ei(e, a, r, u), !f) return !1;
            u += f.length;
        }
        return e.write(D.SUBACK_HEADER), Ue(e, u), Te(e, o), f !== null && f.write(), e.write(U.from(s));
    }
    function av(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.messageId, s = n.dup ? D.DUP_MASK : 0, a = n.unsubscriptions, u = n.properties, f = 0;
        if (typeof o != "number") return e.destroy(new Error("Invalid messageId")), !1;
        if (f += 2, typeof a == "object" && a.length) for(let g = 0; g < a.length; g += 1){
            if (typeof a[g] != "string") return e.destroy(new Error("Invalid unsubscriptions")), !1;
            f += U.byteLength(a[g]) + 2;
        }
        else return e.destroy(new Error("Invalid unsubscriptions")), !1;
        let d = null;
        if (i === 5) {
            if (d = jt(e, u), !d) return !1;
            f += d.length;
        }
        e.write(D.UNSUBSCRIBE_HEADER[1][s ? 1 : 0][0]), Ue(e, f), Te(e, o), d !== null && d.write();
        let h = !0;
        for(let g = 0; g < a.length; g++)h = ur(e, a[g]);
        return h;
    }
    function lv(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.messageId, s = n.dup ? D.DUP_MASK : 0, a = n.granted, u = n.properties, f = n.cmd, d = 0, h = 2;
        if (typeof o != "number") return e.destroy(new Error("Invalid messageId")), !1;
        if (i === 5) {
            if (typeof a == "object" && a.length) for(let b = 0; b < a.length; b += 1){
                if (typeof a[b] != "number") return e.destroy(new Error("Invalid qos vector")), !1;
                h += 1;
            }
            else return e.destroy(new Error("Invalid qos vector")), !1;
        }
        let g = null;
        if (i === 5) {
            if (g = Ei(e, u, r, h), !g) return !1;
            h += g.length;
        }
        return e.write(D.ACKS[f][d][s][0]), Ue(e, h), Te(e, o), g !== null && g.write(), i === 5 && e.write(U.from(a)), !0;
    }
    function uv(t, e, r) {
        return e.write(D.EMPTY[t.cmd]);
    }
    function cv(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.reasonCode, s = n.properties, a = i === 5 ? 1 : 0, u = null;
        if (i === 5) {
            if (u = Ei(e, s, r, a), !u) return !1;
            a += u.length;
        }
        return e.write(U.from([
            D.codes.disconnect << 4
        ])), Ue(e, a), i === 5 && e.write(U.from([
            o
        ])), u !== null && u.write(), !0;
    }
    function fv(t, e, r) {
        let i = r ? r.protocolVersion : 4, n = t || {}, o = n.reasonCode, s = n.properties, a = i === 5 ? 1 : 0;
        i !== 5 && e.destroy(new Error("Invalid mqtt version for auth packet"));
        let u = Ei(e, s, r, a);
        return u ? (a += u.length, e.write(U.from([
            D.codes.auth << 4
        ])), Ue(e, a), e.write(U.from([
            o
        ])), u !== null && u.write(), !0) : !1;
    }
    var vd = {};
    function Ue(t, e) {
        if (e > D.VARBYTEINT_MAX) return t.destroy(new Error(`Invalid variable byte integer: ${e}`)), !1;
        let r = vd[e];
        return r || (r = jo(e), e < 16384 && (vd[e] = r)), qe("writeVarByteInt: writing to stream: %o", r), t.write(r);
    }
    function ur(t, e) {
        let r = U.byteLength(e);
        return Te(t, r), qe("writeString: %s", e), t.write(e, "utf8");
    }
    function Ed(t, e, r) {
        ur(t, e), ur(t, r);
    }
    function Fo(t, e) {
        return qe("writeNumberCached: number: %d", e), qe("writeNumberCached: %o", In[e]), t.write(In[e]);
    }
    function hv(t, e) {
        let r = J0(e);
        return qe("writeNumberGenerated: %o", r), t.write(r);
    }
    function dv(t, e) {
        let r = Z0(e);
        return qe("write4ByteNumber: %o", r), t.write(r);
    }
    function Vr(t, e) {
        typeof e == "string" ? ur(t, e) : e ? (Te(t, e.length), t.write(e)) : Te(t, 0);
    }
    function jt(t, e) {
        if (typeof e != "object" || e.length != null) return {
            length: 1,
            write () {
                Ad(t, {}, 0);
            }
        };
        let r = 0;
        function i(o, s) {
            let a = D.propertiesTypes[o], u = 0;
            switch(a){
                case "byte":
                    if (typeof s != "boolean") return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 2;
                    break;
                case "int8":
                    if (typeof s != "number" || s < 0 || s > 255) return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 2;
                    break;
                case "binary":
                    if (s && s === null) return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 1 + U.byteLength(s) + 2;
                    break;
                case "int16":
                    if (typeof s != "number" || s < 0 || s > 65535) return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 3;
                    break;
                case "int32":
                    if (typeof s != "number" || s < 0 || s > 4294967295) return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 5;
                    break;
                case "var":
                    if (typeof s != "number" || s < 0 || s > 268435455) return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 1 + U.byteLength(jo(s));
                    break;
                case "string":
                    if (typeof s != "string") return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += 3 + U.byteLength(s.toString());
                    break;
                case "pair":
                    if (typeof s != "object") return t.destroy(new Error(`Invalid ${o}: ${s}`)), !1;
                    u += Object.getOwnPropertyNames(s).reduce((f, d)=>{
                        let h = s[d];
                        return Array.isArray(h) ? f += h.reduce((g, b)=>(g += 3 + U.byteLength(d.toString()) + 2 + U.byteLength(b.toString()), g), 0) : f += 3 + U.byteLength(d.toString()) + 2 + U.byteLength(s[d].toString()), f;
                    }, 0);
                    break;
                default:
                    return t.destroy(new Error(`Invalid property ${o}: ${s}`)), !1;
            }
            return u;
        }
        if (e) for(let o in e){
            let s = 0, a = 0, u = e[o];
            if (u !== void 0) {
                if (Array.isArray(u)) for(let f = 0; f < u.length; f++){
                    if (a = i(o, u[f]), !a) return !1;
                    s += a;
                }
                else {
                    if (a = i(o, u), !a) return !1;
                    s = a;
                }
                if (!s) return !1;
                r += s;
            }
        }
        return {
            length: U.byteLength(jo(r)) + r,
            write () {
                Ad(t, e, r);
            }
        };
    }
    function Ei(t, e, r, i) {
        let n = [
            "reasonString",
            "userProperties"
        ], o = r && r.properties && r.properties.maximumPacketSize ? r.properties.maximumPacketSize : 0, s = jt(t, e);
        if (o) for(; i + s.length > o;){
            let a = n.shift();
            if (a && e[a]) delete e[a], s = jt(t, e);
            else return !1;
        }
        return s;
    }
    function Sd(t, e, r) {
        switch(D.propertiesTypes[e]){
            case "byte":
                t.write(U.from([
                    D.properties[e]
                ])), t.write(U.from([
                    +r
                ]));
                break;
            case "int8":
                t.write(U.from([
                    D.properties[e]
                ])), t.write(U.from([
                    r
                ]));
                break;
            case "binary":
                t.write(U.from([
                    D.properties[e]
                ])), Vr(t, r);
                break;
            case "int16":
                t.write(U.from([
                    D.properties[e]
                ])), Te(t, r);
                break;
            case "int32":
                t.write(U.from([
                    D.properties[e]
                ])), dv(t, r);
                break;
            case "var":
                t.write(U.from([
                    D.properties[e]
                ])), Ue(t, r);
                break;
            case "string":
                t.write(U.from([
                    D.properties[e]
                ])), ur(t, r);
                break;
            case "pair":
                Object.getOwnPropertyNames(r).forEach((n)=>{
                    let o = r[n];
                    Array.isArray(o) ? o.forEach((s)=>{
                        t.write(U.from([
                            D.properties[e]
                        ])), Ed(t, n.toString(), s.toString());
                    }) : (t.write(U.from([
                        D.properties[e]
                    ])), Ed(t, n.toString(), o.toString()));
                });
                break;
            default:
                return t.destroy(new Error(`Invalid property ${e} value: ${r}`)), !1;
        }
    }
    function Ad(t, e, r) {
        Ue(t, r);
        for(let i in e)if (Object.prototype.hasOwnProperty.call(e, i) && e[i] != null) {
            let n = e[i];
            if (Array.isArray(n)) for(let o = 0; o < n.length; o++)Sd(t, i, n[o]);
            else Sd(t, i, n);
        }
    }
    function Rd(t) {
        return t ? t instanceof U ? t.length : U.byteLength(t) : 0;
    }
    function Id(t) {
        return typeof t == "string" || t instanceof U;
    }
    Cd.exports = Td;
});
var Bd = O((Vx, kd)=>{
    _();
    v();
    m();
    var pv = Wo(), { EventEmitter: gv } = (Ot(), Q(xt)), { Buffer: Pd } = (he(), Q(ye));
    function bv(t, e) {
        let r = new $o;
        return pv(t, r, e), r.concat();
    }
    var $o = class extends gv {
        constructor(){
            super(), this._array = new Array(20), this._i = 0;
        }
        write(e) {
            return this._array[this._i++] = e, !0;
        }
        concat() {
            let e = 0, r = new Array(this._array.length), i = this._array, n = 0, o;
            for(o = 0; o < i.length && i[o] !== void 0; o++)typeof i[o] != "string" ? r[o] = i[o].length : r[o] = Pd.byteLength(i[o]), e += r[o];
            let s = Pd.allocUnsafe(e);
            for(o = 0; o < i.length && i[o] !== void 0; o++)typeof i[o] != "string" ? (i[o].copy(s, n), n += r[o]) : (s.write(i[o], n), n += r[o]);
            return s;
        }
        destroy(e) {
            e && this.emit("error", e);
        }
    };
    kd.exports = bv;
});
var xd = O((Rn)=>{
    _();
    v();
    m();
    Rn.parser = gd().parser;
    Rn.generate = Bd();
    Rn.writeToStream = Wo();
});
var zo = O((Vo)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Vo, "__esModule", {
        value: !0
    });
    var Ho = class {
        constructor(){
            this.nextId = Math.max(1, Math.floor(Math.random() * 65535));
        }
        allocate() {
            let e = this.nextId++;
            return this.nextId === 65536 && (this.nextId = 1), e;
        }
        getLastAllocated() {
            return this.nextId === 1 ? 65535 : this.nextId - 1;
        }
        register(e) {
            return !0;
        }
        deallocate(e) {}
        clear() {}
    };
    Vo.default = Ho;
});
var Md = O((vO, Od)=>{
    "use strict";
    _();
    v();
    m();
    Od.exports = yv;
    function zr(t) {
        return t instanceof x ? x.from(t) : new t.constructor(t.buffer.slice(), t.byteOffset, t.length);
    }
    function yv(t) {
        if (t = t || {}, t.circles) return wv(t);
        let e = new Map;
        if (e.set(Date, (s)=>new Date(s)), e.set(Map, (s, a)=>new Map(i(Array.from(s), a))), e.set(Set, (s, a)=>new Set(i(Array.from(s), a))), t.constructorHandlers) for (let s of t.constructorHandlers)e.set(s[0], s[1]);
        let r = null;
        return t.proto ? o : n;
        function i(s, a) {
            let u = Object.keys(s), f = new Array(u.length);
            for(let d = 0; d < u.length; d++){
                let h = u[d], g = s[h];
                typeof g != "object" || g === null ? f[h] = g : g.constructor !== Object && (r = e.get(g.constructor)) ? f[h] = r(g, a) : ArrayBuffer.isView(g) ? f[h] = zr(g) : f[h] = a(g);
            }
            return f;
        }
        function n(s) {
            if (typeof s != "object" || s === null) return s;
            if (Array.isArray(s)) return i(s, n);
            if (s.constructor !== Object && (r = e.get(s.constructor))) return r(s, n);
            let a = {};
            for(let u in s){
                if (Object.hasOwnProperty.call(s, u) === !1) continue;
                let f = s[u];
                typeof f != "object" || f === null ? a[u] = f : f.constructor !== Object && (r = e.get(f.constructor)) ? a[u] = r(f, n) : ArrayBuffer.isView(f) ? a[u] = zr(f) : a[u] = n(f);
            }
            return a;
        }
        function o(s) {
            if (typeof s != "object" || s === null) return s;
            if (Array.isArray(s)) return i(s, o);
            if (s.constructor !== Object && (r = e.get(s.constructor))) return r(s, o);
            let a = {};
            for(let u in s){
                let f = s[u];
                typeof f != "object" || f === null ? a[u] = f : f.constructor !== Object && (r = e.get(f.constructor)) ? a[u] = r(f, o) : ArrayBuffer.isView(f) ? a[u] = zr(f) : a[u] = o(f);
            }
            return a;
        }
    }
    function wv(t) {
        let e = [], r = [], i = new Map;
        if (i.set(Date, (u)=>new Date(u)), i.set(Map, (u, f)=>new Map(o(Array.from(u), f))), i.set(Set, (u, f)=>new Set(o(Array.from(u), f))), t.constructorHandlers) for (let u of t.constructorHandlers)i.set(u[0], u[1]);
        let n = null;
        return t.proto ? a : s;
        function o(u, f) {
            let d = Object.keys(u), h = new Array(d.length);
            for(let g = 0; g < d.length; g++){
                let b = d[g], E = u[b];
                if (typeof E != "object" || E === null) h[b] = E;
                else if (E.constructor !== Object && (n = i.get(E.constructor))) h[b] = n(E, f);
                else if (ArrayBuffer.isView(E)) h[b] = zr(E);
                else {
                    let w = e.indexOf(E);
                    w !== -1 ? h[b] = r[w] : h[b] = f(E);
                }
            }
            return h;
        }
        function s(u) {
            if (typeof u != "object" || u === null) return u;
            if (Array.isArray(u)) return o(u, s);
            if (u.constructor !== Object && (n = i.get(u.constructor))) return n(u, s);
            let f = {};
            e.push(u), r.push(f);
            for(let d in u){
                if (Object.hasOwnProperty.call(u, d) === !1) continue;
                let h = u[d];
                if (typeof h != "object" || h === null) f[d] = h;
                else if (h.constructor !== Object && (n = i.get(h.constructor))) f[d] = n(h, s);
                else if (ArrayBuffer.isView(h)) f[d] = zr(h);
                else {
                    let g = e.indexOf(h);
                    g !== -1 ? f[d] = r[g] : f[d] = s(h);
                }
            }
            return e.pop(), r.pop(), f;
        }
        function a(u) {
            if (typeof u != "object" || u === null) return u;
            if (Array.isArray(u)) return o(u, a);
            if (u.constructor !== Object && (n = i.get(u.constructor))) return n(u, a);
            let f = {};
            e.push(u), r.push(f);
            for(let d in u){
                let h = u[d];
                if (typeof h != "object" || h === null) f[d] = h;
                else if (h.constructor !== Object && (n = i.get(h.constructor))) f[d] = n(h, a);
                else if (ArrayBuffer.isView(h)) f[d] = zr(h);
                else {
                    let g = e.indexOf(h);
                    g !== -1 ? f[d] = r[g] : f[d] = a(h);
                }
            }
            return e.pop(), r.pop(), f;
        }
    }
});
var qd = O((BO, Ld)=>{
    "use strict";
    _();
    v();
    m();
    Ld.exports = Md()();
});
var Nd = O((Cn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Cn, "__esModule", {
        value: !0
    });
    Cn.validateTopic = Ud;
    Cn.validateTopics = _v;
    function Ud(t) {
        let e = t.split("/");
        for(let r = 0; r < e.length; r++)if (e[r] !== "+") {
            if (e[r] === "#") return r === e.length - 1;
            if (e[r].indexOf("+") !== -1 || e[r].indexOf("#") !== -1) return !1;
        }
        return !0;
    }
    function _v(t) {
        if (t.length === 0) return "empty_topic_list";
        for(let e = 0; e < t.length; e++)if (!Ud(t[e])) return t[e];
        return null;
    }
});
var Qo = O((Go)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Go, "__esModule", {
        value: !0
    });
    var mv = Nt(), vv = {
        objectMode: !0
    }, Ev = {
        clean: !0
    }, Ko = class {
        constructor(e){
            this.options = e || {}, this.options = Object.assign(Object.assign({}, Ev), e), this._inflights = new Map;
        }
        put(e, r) {
            return this._inflights.set(e.messageId, e), r && r(), this;
        }
        createStream() {
            let e = new mv.Readable(vv), r = [], i = !1, n = 0;
            return this._inflights.forEach((o, s)=>{
                r.push(o);
            }), e._read = ()=>{
                !i && n < r.length ? e.push(r[n++]) : e.push(null);
            }, e.destroy = (o)=>{
                if (!i) return i = !0, setTimeout(()=>{
                    e.emit("close");
                }, 0), e;
            }, e;
        }
        del(e, r) {
            let i = this._inflights.get(e.messageId);
            return i ? (this._inflights.delete(e.messageId), r(null, i)) : r && r(new Error("missing packet")), this;
        }
        get(e, r) {
            let i = this._inflights.get(e.messageId);
            return i ? r(null, i) : r && r(new Error("missing packet")), this;
        }
        close(e) {
            this.options.clean && (this._inflights = null), e && e();
        }
    };
    Go.default = Ko;
});
var jd = O((Yo)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Yo, "__esModule", {
        value: !0
    });
    var Dd = [
        0,
        16,
        128,
        131,
        135,
        144,
        145,
        151,
        153
    ], Sv = (t, e, r)=>{
        t.log("handlePublish: packet %o", e), r = typeof r < "u" ? r : t.noop;
        let i = e.topic.toString(), n = e.payload, { qos: o } = e, { messageId: s } = e, { options: a } = t;
        if (t.options.protocolVersion === 5) {
            let u;
            if (e.properties && (u = e.properties.topicAlias), typeof u < "u") {
                if (i.length === 0) {
                    if (u > 0 && u <= 65535) {
                        let f = t.topicAliasRecv.getTopicByAlias(u);
                        if (f) i = f, t.log("handlePublish :: topic complemented by alias. topic: %s - alias: %d", i, u);
                        else {
                            t.log("handlePublish :: unregistered topic alias. alias: %d", u), t.emit("error", new Error("Received unregistered Topic Alias"));
                            return;
                        }
                    } else {
                        t.log("handlePublish :: topic alias out of range. alias: %d", u), t.emit("error", new Error("Received Topic Alias is out of range"));
                        return;
                    }
                } else if (t.topicAliasRecv.put(i, u)) t.log("handlePublish :: registered topic: %s - alias: %d", i, u);
                else {
                    t.log("handlePublish :: topic alias out of range. alias: %d", u), t.emit("error", new Error("Received Topic Alias is out of range"));
                    return;
                }
            }
        }
        switch(t.log("handlePublish: qos %d", o), o){
            case 2:
                a.customHandleAcks(i, n, e, (u, f)=>{
                    if (typeof u == "number" && (f = u, u = null), u) return t.emit("error", u);
                    if (Dd.indexOf(f) === -1) return t.emit("error", new Error("Wrong reason code for pubrec"));
                    f ? t._sendPacket({
                        cmd: "pubrec",
                        messageId: s,
                        reasonCode: f
                    }, r) : t.incomingStore.put(e, ()=>{
                        t._sendPacket({
                            cmd: "pubrec",
                            messageId: s
                        }, r);
                    });
                });
                break;
            case 1:
                a.customHandleAcks(i, n, e, (u, f)=>{
                    if (typeof u == "number" && (f = u, u = null), u) return t.emit("error", u);
                    if (Dd.indexOf(f) === -1) return t.emit("error", new Error("Wrong reason code for puback"));
                    f || t.emit("message", i, n, e), t.handleMessage(e, (d)=>{
                        if (d) return r && r(d);
                        t._sendPacket({
                            cmd: "puback",
                            messageId: s,
                            reasonCode: f
                        }, r);
                    });
                });
                break;
            case 0:
                t.emit("message", i, n, e), t.handleMessage(e, r);
                break;
            default:
                t.log("handlePublish: unknown QoS. Doing nothing.");
                break;
        }
    };
    Yo.default = Sv;
});
var Fd = O((yM, Av)=>{
    Av.exports = {
        version: "5.13.2"
    };
});
var cr = O((Ve)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Ve, "__esModule", {
        value: !0
    });
    Ve.MQTTJS_VERSION = Ve.nextTick = Ve.ErrorWithSubackPacket = Ve.ErrorWithReasonCode = void 0;
    Ve.applyMixin = Iv;
    var Jo = class t extends Error {
        constructor(e, r){
            super(e), this.code = r, Object.setPrototypeOf(this, t.prototype), Object.getPrototypeOf(this).name = "ErrorWithReasonCode";
        }
    };
    Ve.ErrorWithReasonCode = Jo;
    var Xo = class t extends Error {
        constructor(e, r){
            super(e), this.packet = r, Object.setPrototypeOf(this, t.prototype), Object.getPrototypeOf(this).name = "ErrorWithSubackPacket";
        }
    };
    Ve.ErrorWithSubackPacket = Xo;
    function Iv(t, e, r = !1) {
        var i;
        let n = [
            e
        ];
        for(;;){
            let o = n[0], s = Object.getPrototypeOf(o);
            if (s?.prototype) n.unshift(s);
            else break;
        }
        for (let o of n)for (let s of Object.getOwnPropertyNames(o.prototype))(r || s !== "constructor") && Object.defineProperty(t.prototype, s, (i = Object.getOwnPropertyDescriptor(o.prototype, s)) !== null && i !== void 0 ? i : Object.create(null));
    }
    Ve.nextTick = typeof (R === null || R === void 0 ? void 0 : R.nextTick) == "function" ? R.nextTick : (t)=>{
        setTimeout(t, 0);
    };
    Ve.MQTTJS_VERSION = Fd().version;
});
var Si = O((Ft)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Ft, "__esModule", {
        value: !0
    });
    Ft.ReasonCodes = void 0;
    var Wd = cr();
    Ft.ReasonCodes = {
        0: "",
        1: "Unacceptable protocol version",
        2: "Identifier rejected",
        3: "Server unavailable",
        4: "Bad username or password",
        5: "Not authorized",
        16: "No matching subscribers",
        17: "No subscription existed",
        128: "Unspecified error",
        129: "Malformed Packet",
        130: "Protocol Error",
        131: "Implementation specific error",
        132: "Unsupported Protocol Version",
        133: "Client Identifier not valid",
        134: "Bad User Name or Password",
        135: "Not authorized",
        136: "Server unavailable",
        137: "Server busy",
        138: "Banned",
        139: "Server shutting down",
        140: "Bad authentication method",
        141: "Keep Alive timeout",
        142: "Session taken over",
        143: "Topic Filter invalid",
        144: "Topic Name invalid",
        145: "Packet identifier in use",
        146: "Packet Identifier not found",
        147: "Receive Maximum exceeded",
        148: "Topic Alias invalid",
        149: "Packet too large",
        150: "Message rate too high",
        151: "Quota exceeded",
        152: "Administrative action",
        153: "Payload format invalid",
        154: "Retain not supported",
        155: "QoS not supported",
        156: "Use another server",
        157: "Server moved",
        158: "Shared Subscriptions not supported",
        159: "Connection rate exceeded",
        160: "Maximum connect time",
        161: "Subscription Identifiers not supported",
        162: "Wildcard Subscriptions not supported"
    };
    var Tv = (t, e)=>{
        let { messageId: r } = e, i = e.cmd, n = null, o = t.outgoing[r] ? t.outgoing[r].cb : null, s = null;
        if (!o) {
            t.log("_handleAck :: Server sent an ack in error. Ignoring.");
            return;
        }
        switch(t.log("_handleAck :: packet type", i), i){
            case "pubcomp":
            case "puback":
                {
                    let a = e.reasonCode;
                    a && a > 0 && a !== 16 ? (s = new Wd.ErrorWithReasonCode(`Publish error: ${Ft.ReasonCodes[a]}`, a), t._removeOutgoingAndStoreMessage(r, ()=>{
                        o(s, e);
                    })) : t._removeOutgoingAndStoreMessage(r, o);
                    break;
                }
            case "pubrec":
                {
                    n = {
                        cmd: "pubrel",
                        qos: 2,
                        messageId: r
                    };
                    let a = e.reasonCode;
                    a && a > 0 && a !== 16 ? (s = new Wd.ErrorWithReasonCode(`Publish error: ${Ft.ReasonCodes[a]}`, a), t._removeOutgoingAndStoreMessage(r, ()=>{
                        o(s, e);
                    })) : t._sendPacket(n);
                    break;
                }
            case "suback":
                {
                    delete t.outgoing[r], t.messageIdProvider.deallocate(r);
                    let a = e.granted;
                    for(let u = 0; u < a.length; u++){
                        let f = a[u];
                        if ((f & 128) !== 0) {
                            s = new Error(`Subscribe error: ${Ft.ReasonCodes[f]}`), s.code = f;
                            let d = t.messageIdToTopic[r];
                            d && d.forEach((h)=>{
                                delete t._resubscribeTopics[h];
                            });
                        }
                    }
                    delete t.messageIdToTopic[r], t._invokeStoreProcessingQueue(), o(s, e);
                    break;
                }
            case "unsuback":
                delete t.outgoing[r], t.messageIdProvider.deallocate(r), t._invokeStoreProcessingQueue(), o(null, e);
                break;
            default:
                t.emit("error", new Error("unrecognized packet type"));
        }
        t.disconnecting && Object.keys(t.outgoing).length === 0 && t.emit("outgoingEmpty");
    };
    Ft.default = Tv;
});
var Hd = O((Zo)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Zo, "__esModule", {
        value: !0
    });
    var $d = cr(), Rv = Si(), Cv = (t, e)=>{
        let { options: r } = t, i = r.protocolVersion, n = i === 5 ? e.reasonCode : e.returnCode;
        if (i !== 5) {
            let o = new $d.ErrorWithReasonCode(`Protocol error: Auth packets are only supported in MQTT 5. Your version:${i}`, n);
            t.emit("error", o);
            return;
        }
        t.handleAuth(e, (o, s)=>{
            if (o) {
                t.emit("error", o);
                return;
            }
            if (n === 24) t.reconnecting = !1, t._sendPacket(s);
            else {
                let a = new $d.ErrorWithReasonCode(`Connection refused: ${Rv.ReasonCodes[n]}`, n);
                t.emit("error", a);
            }
        });
    };
    Zo.default = Cv;
});
var Qd = O((kn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(kn, "__esModule", {
        value: !0
    });
    kn.LRUCache = void 0;
    var Kr = typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date, zd = new Set, ea = typeof R == "object" && R ? R : {}, Kd = (t, e, r, i)=>{
        typeof ea.emitWarning == "function" ? ea.emitWarning(t, e, r, i) : console.error(`[${r}] ${e}: ${t}`);
    }, Pn = globalThis.AbortController, Vd = globalThis.AbortSignal;
    if (typeof Pn > "u") {
        Vd = class {
            onabort;
            _onabort = [];
            reason;
            aborted = !1;
            addEventListener(i, n) {
                this._onabort.push(n);
            }
        }, Pn = class {
            constructor(){
                e();
            }
            signal = new Vd;
            abort(i) {
                if (!this.signal.aborted) {
                    this.signal.reason = i, this.signal.aborted = !0;
                    for (let n of this.signal._onabort)n(i);
                    this.signal.onabort?.(i);
                }
            }
        };
        let t = ea.env?.LRU_CACHE_IGNORE_AC_WARNING !== "1", e = ()=>{
            t && (t = !1, Kd("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", "NO_ABORT_CONTROLLER", "ENOTSUP", e));
        };
    }
    var Pv = (t)=>!zd.has(t), YM = Symbol("type"), Wt = (t)=>t && t === Math.floor(t) && t > 0 && isFinite(t), Gd = (t)=>Wt(t) ? t <= Math.pow(2, 8) ? Uint8Array : t <= Math.pow(2, 16) ? Uint16Array : t <= Math.pow(2, 32) ? Uint32Array : t <= Number.MAX_SAFE_INTEGER ? Gr : null : null, Gr = class extends Array {
        constructor(e){
            super(e), this.fill(0);
        }
    }, ta = class t {
        heap;
        length;
        static #l = !1;
        static create(e) {
            let r = Gd(e);
            if (!r) return [];
            t.#l = !0;
            let i = new t(e, r);
            return t.#l = !1, i;
        }
        constructor(e, r){
            if (!t.#l) throw new TypeError("instantiate Stack using Stack.create(n)");
            this.heap = new r(e), this.length = 0;
        }
        push(e) {
            this.heap[this.length++] = e;
        }
        pop() {
            return this.heap[--this.length];
        }
    }, ra = class t {
        #l;
        #f;
        #g;
        #b;
        #k;
        #B;
        ttl;
        ttlResolution;
        ttlAutopurge;
        updateAgeOnGet;
        updateAgeOnHas;
        allowStale;
        noDisposeOnSet;
        noUpdateTTL;
        maxEntrySize;
        sizeCalculation;
        noDeleteOnFetchRejection;
        noDeleteOnStaleGet;
        allowStaleOnFetchAbort;
        allowStaleOnFetchRejection;
        ignoreFetchAbort;
        #n;
        #y;
        #i;
        #r;
        #e;
        #u;
        #h;
        #a;
        #s;
        #w;
        #o;
        #_;
        #m;
        #d;
        #v;
        #T;
        #c;
        static unsafeExposeInternals(e) {
            return {
                starts: e.#m,
                ttls: e.#d,
                sizes: e.#_,
                keyMap: e.#i,
                keyList: e.#r,
                valList: e.#e,
                next: e.#u,
                prev: e.#h,
                get head () {
                    return e.#a;
                },
                get tail () {
                    return e.#s;
                },
                free: e.#w,
                isBackgroundFetch: (r)=>e.#t(r),
                backgroundFetch: (r, i, n, o)=>e.#M(r, i, n, o),
                moveToTail: (r)=>e.#P(r),
                indexes: (r)=>e.#E(r),
                rindexes: (r)=>e.#S(r),
                isStale: (r)=>e.#p(r)
            };
        }
        get max() {
            return this.#l;
        }
        get maxSize() {
            return this.#f;
        }
        get calculatedSize() {
            return this.#y;
        }
        get size() {
            return this.#n;
        }
        get fetchMethod() {
            return this.#k;
        }
        get memoMethod() {
            return this.#B;
        }
        get dispose() {
            return this.#g;
        }
        get disposeAfter() {
            return this.#b;
        }
        constructor(e){
            let { max: r = 0, ttl: i, ttlResolution: n = 1, ttlAutopurge: o, updateAgeOnGet: s, updateAgeOnHas: a, allowStale: u, dispose: f, disposeAfter: d, noDisposeOnSet: h, noUpdateTTL: g, maxSize: b = 0, maxEntrySize: E = 0, sizeCalculation: w, fetchMethod: S, memoMethod: I, noDeleteOnFetchRejection: P, noDeleteOnStaleGet: C, allowStaleOnFetchRejection: M, allowStaleOnFetchAbort: q, ignoreFetchAbort: z } = e;
            if (r !== 0 && !Wt(r)) throw new TypeError("max option must be a nonnegative integer");
            let j = r ? Gd(r) : Array;
            if (!j) throw new Error("invalid max value: " + r);
            if (this.#l = r, this.#f = b, this.maxEntrySize = E || this.#f, this.sizeCalculation = w, this.sizeCalculation) {
                if (!this.#f && !this.maxEntrySize) throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
                if (typeof this.sizeCalculation != "function") throw new TypeError("sizeCalculation set to non-function");
            }
            if (I !== void 0 && typeof I != "function") throw new TypeError("memoMethod must be a function if defined");
            if (this.#B = I, S !== void 0 && typeof S != "function") throw new TypeError("fetchMethod must be a function if specified");
            if (this.#k = S, this.#T = !!S, this.#i = new Map, this.#r = new Array(r).fill(void 0), this.#e = new Array(r).fill(void 0), this.#u = new j(r), this.#h = new j(r), this.#a = 0, this.#s = 0, this.#w = ta.create(r), this.#n = 0, this.#y = 0, typeof f == "function" && (this.#g = f), typeof d == "function" ? (this.#b = d, this.#o = []) : (this.#b = void 0, this.#o = void 0), this.#v = !!this.#g, this.#c = !!this.#b, this.noDisposeOnSet = !!h, this.noUpdateTTL = !!g, this.noDeleteOnFetchRejection = !!P, this.allowStaleOnFetchRejection = !!M, this.allowStaleOnFetchAbort = !!q, this.ignoreFetchAbort = !!z, this.maxEntrySize !== 0) {
                if (this.#f !== 0 && !Wt(this.#f)) throw new TypeError("maxSize must be a positive integer if specified");
                if (!Wt(this.maxEntrySize)) throw new TypeError("maxEntrySize must be a positive integer if specified");
                this.#F();
            }
            if (this.allowStale = !!u, this.noDeleteOnStaleGet = !!C, this.updateAgeOnGet = !!s, this.updateAgeOnHas = !!a, this.ttlResolution = Wt(n) || n === 0 ? n : 1, this.ttlAutopurge = !!o, this.ttl = i || 0, this.ttl) {
                if (!Wt(this.ttl)) throw new TypeError("ttl must be a positive integer if specified");
                this.#L();
            }
            if (this.#l === 0 && this.ttl === 0 && this.#f === 0) throw new TypeError("At least one of max, maxSize, or ttl is required");
            if (!this.ttlAutopurge && !this.#l && !this.#f) {
                let G = "LRU_CACHE_UNBOUNDED";
                Pv(G) && (zd.add(G), Kd("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", G, t));
            }
        }
        getRemainingTTL(e) {
            return this.#i.has(e) ? 1 / 0 : 0;
        }
        #L() {
            let e = new Gr(this.#l), r = new Gr(this.#l);
            this.#d = e, this.#m = r, this.#q = (o, s, a = Kr.now())=>{
                if (r[o] = s !== 0 ? a : 0, e[o] = s, s !== 0 && this.ttlAutopurge) {
                    let u = setTimeout(()=>{
                        this.#p(o) && this.#A(this.#r[o], "expire");
                    }, s + 1);
                    u.unref && u.unref();
                }
            }, this.#R = (o)=>{
                r[o] = e[o] !== 0 ? Kr.now() : 0;
            }, this.#I = (o, s)=>{
                if (e[s]) {
                    let a = e[s], u = r[s];
                    if (!a || !u) return;
                    o.ttl = a, o.start = u, o.now = i || n();
                    let f = o.now - u;
                    o.remainingTTL = a - f;
                }
            };
            let i = 0, n = ()=>{
                let o = Kr.now();
                if (this.ttlResolution > 0) {
                    i = o;
                    let s = setTimeout(()=>i = 0, this.ttlResolution);
                    s.unref && s.unref();
                }
                return o;
            };
            this.getRemainingTTL = (o)=>{
                let s = this.#i.get(o);
                if (s === void 0) return 0;
                let a = e[s], u = r[s];
                if (!a || !u) return 1 / 0;
                let f = (i || n()) - u;
                return a - f;
            }, this.#p = (o)=>{
                let s = r[o], a = e[o];
                return !!a && !!s && (i || n()) - s > a;
            };
        }
        #R = ()=>{};
        #I = ()=>{};
        #q = ()=>{};
        #p = ()=>!1;
        #F() {
            let e = new Gr(this.#l);
            this.#y = 0, this.#_ = e, this.#C = (r)=>{
                this.#y -= e[r], e[r] = 0;
            }, this.#U = (r, i, n, o)=>{
                if (this.#t(i)) return 0;
                if (!Wt(n)) {
                    if (o) {
                        if (typeof o != "function") throw new TypeError("sizeCalculation must be a function");
                        if (n = o(i, r), !Wt(n)) throw new TypeError("sizeCalculation return invalid (expect positive integer)");
                    } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
                }
                return n;
            }, this.#x = (r, i, n)=>{
                if (e[r] = i, this.#f) {
                    let o = this.#f - e[r];
                    for(; this.#y > o;)this.#O(!0);
                }
                this.#y += e[r], n && (n.entrySize = i, n.totalCalculatedSize = this.#y);
            };
        }
        #C = (e)=>{};
        #x = (e, r, i)=>{};
        #U = (e, r, i, n)=>{
            if (i || n) throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
            return 0;
        };
        *#E({ allowStale: e = this.allowStale } = {}) {
            if (this.#n) for(let r = this.#s; !(!this.#N(r) || ((e || !this.#p(r)) && (yield r), r === this.#a));)r = this.#h[r];
        }
        *#S({ allowStale: e = this.allowStale } = {}) {
            if (this.#n) for(let r = this.#a; !(!this.#N(r) || ((e || !this.#p(r)) && (yield r), r === this.#s));)r = this.#u[r];
        }
        #N(e) {
            return e !== void 0 && this.#i.get(this.#r[e]) === e;
        }
        *entries() {
            for (let e of this.#E())this.#e[e] !== void 0 && this.#r[e] !== void 0 && !this.#t(this.#e[e]) && (yield [
                this.#r[e],
                this.#e[e]
            ]);
        }
        *rentries() {
            for (let e of this.#S())this.#e[e] !== void 0 && this.#r[e] !== void 0 && !this.#t(this.#e[e]) && (yield [
                this.#r[e],
                this.#e[e]
            ]);
        }
        *keys() {
            for (let e of this.#E()){
                let r = this.#r[e];
                r !== void 0 && !this.#t(this.#e[e]) && (yield r);
            }
        }
        *rkeys() {
            for (let e of this.#S()){
                let r = this.#r[e];
                r !== void 0 && !this.#t(this.#e[e]) && (yield r);
            }
        }
        *values() {
            for (let e of this.#E())this.#e[e] !== void 0 && !this.#t(this.#e[e]) && (yield this.#e[e]);
        }
        *rvalues() {
            for (let e of this.#S())this.#e[e] !== void 0 && !this.#t(this.#e[e]) && (yield this.#e[e]);
        }
        [Symbol.iterator]() {
            return this.entries();
        }
        [Symbol.toStringTag] = "LRUCache";
        find(e, r = {}) {
            for (let i of this.#E()){
                let n = this.#e[i], o = this.#t(n) ? n.__staleWhileFetching : n;
                if (o !== void 0 && e(o, this.#r[i], this)) return this.get(this.#r[i], r);
            }
        }
        forEach(e, r = this) {
            for (let i of this.#E()){
                let n = this.#e[i], o = this.#t(n) ? n.__staleWhileFetching : n;
                o !== void 0 && e.call(r, o, this.#r[i], this);
            }
        }
        rforEach(e, r = this) {
            for (let i of this.#S()){
                let n = this.#e[i], o = this.#t(n) ? n.__staleWhileFetching : n;
                o !== void 0 && e.call(r, o, this.#r[i], this);
            }
        }
        purgeStale() {
            let e = !1;
            for (let r of this.#S({
                allowStale: !0
            }))this.#p(r) && (this.#A(this.#r[r], "expire"), e = !0);
            return e;
        }
        info(e) {
            let r = this.#i.get(e);
            if (r === void 0) return;
            let i = this.#e[r], n = this.#t(i) ? i.__staleWhileFetching : i;
            if (n === void 0) return;
            let o = {
                value: n
            };
            if (this.#d && this.#m) {
                let s = this.#d[r], a = this.#m[r];
                if (s && a) {
                    let u = s - (Kr.now() - a);
                    o.ttl = u, o.start = Date.now();
                }
            }
            return this.#_ && (o.size = this.#_[r]), o;
        }
        dump() {
            let e = [];
            for (let r of this.#E({
                allowStale: !0
            })){
                let i = this.#r[r], n = this.#e[r], o = this.#t(n) ? n.__staleWhileFetching : n;
                if (o === void 0 || i === void 0) continue;
                let s = {
                    value: o
                };
                if (this.#d && this.#m) {
                    s.ttl = this.#d[r];
                    let a = Kr.now() - this.#m[r];
                    s.start = Math.floor(Date.now() - a);
                }
                this.#_ && (s.size = this.#_[r]), e.unshift([
                    i,
                    s
                ]);
            }
            return e;
        }
        load(e) {
            this.clear();
            for (let [r, i] of e){
                if (i.start) {
                    let n = Date.now() - i.start;
                    i.start = Kr.now() - n;
                }
                this.set(r, i.value, i);
            }
        }
        set(e, r, i = {}) {
            if (r === void 0) return this.delete(e), this;
            let { ttl: n = this.ttl, start: o, noDisposeOnSet: s = this.noDisposeOnSet, sizeCalculation: a = this.sizeCalculation, status: u } = i, { noUpdateTTL: f = this.noUpdateTTL } = i, d = this.#U(e, r, i.size || 0, a);
            if (this.maxEntrySize && d > this.maxEntrySize) return u && (u.set = "miss", u.maxEntrySizeExceeded = !0), this.#A(e, "set"), this;
            let h = this.#n === 0 ? void 0 : this.#i.get(e);
            if (h === void 0) h = this.#n === 0 ? this.#s : this.#w.length !== 0 ? this.#w.pop() : this.#n === this.#l ? this.#O(!1) : this.#n, this.#r[h] = e, this.#e[h] = r, this.#i.set(e, h), this.#u[this.#s] = h, this.#h[h] = this.#s, this.#s = h, this.#n++, this.#x(h, d, u), u && (u.set = "add"), f = !1;
            else {
                this.#P(h);
                let g = this.#e[h];
                if (r !== g) {
                    if (this.#T && this.#t(g)) {
                        g.__abortController.abort(new Error("replaced"));
                        let { __staleWhileFetching: b } = g;
                        b !== void 0 && !s && (this.#v && this.#g?.(b, e, "set"), this.#c && this.#o?.push([
                            b,
                            e,
                            "set"
                        ]));
                    } else s || (this.#v && this.#g?.(g, e, "set"), this.#c && this.#o?.push([
                        g,
                        e,
                        "set"
                    ]));
                    if (this.#C(h), this.#x(h, d, u), this.#e[h] = r, u) {
                        u.set = "replace";
                        let b = g && this.#t(g) ? g.__staleWhileFetching : g;
                        b !== void 0 && (u.oldValue = b);
                    }
                } else u && (u.set = "update");
            }
            if (n !== 0 && !this.#d && this.#L(), this.#d && (f || this.#q(h, n, o), u && this.#I(u, h)), !s && this.#c && this.#o) {
                let g = this.#o, b;
                for(; b = g?.shift();)this.#b?.(...b);
            }
            return this;
        }
        pop() {
            try {
                for(; this.#n;){
                    let e = this.#e[this.#a];
                    if (this.#O(!0), this.#t(e)) {
                        if (e.__staleWhileFetching) return e.__staleWhileFetching;
                    } else if (e !== void 0) return e;
                }
            } finally{
                if (this.#c && this.#o) {
                    let e = this.#o, r;
                    for(; r = e?.shift();)this.#b?.(...r);
                }
            }
        }
        #O(e) {
            let r = this.#a, i = this.#r[r], n = this.#e[r];
            return this.#T && this.#t(n) ? n.__abortController.abort(new Error("evicted")) : (this.#v || this.#c) && (this.#v && this.#g?.(n, i, "evict"), this.#c && this.#o?.push([
                n,
                i,
                "evict"
            ])), this.#C(r), e && (this.#r[r] = void 0, this.#e[r] = void 0, this.#w.push(r)), this.#n === 1 ? (this.#a = this.#s = 0, this.#w.length = 0) : this.#a = this.#u[r], this.#i.delete(i), this.#n--, r;
        }
        has(e, r = {}) {
            let { updateAgeOnHas: i = this.updateAgeOnHas, status: n } = r, o = this.#i.get(e);
            if (o !== void 0) {
                let s = this.#e[o];
                if (this.#t(s) && s.__staleWhileFetching === void 0) return !1;
                if (this.#p(o)) n && (n.has = "stale", this.#I(n, o));
                else return i && this.#R(o), n && (n.has = "hit", this.#I(n, o)), !0;
            } else n && (n.has = "miss");
            return !1;
        }
        peek(e, r = {}) {
            let { allowStale: i = this.allowStale } = r, n = this.#i.get(e);
            if (n === void 0 || !i && this.#p(n)) return;
            let o = this.#e[n];
            return this.#t(o) ? o.__staleWhileFetching : o;
        }
        #M(e, r, i, n) {
            let o = r === void 0 ? void 0 : this.#e[r];
            if (this.#t(o)) return o;
            let s = new Pn, { signal: a } = i;
            a?.addEventListener("abort", ()=>s.abort(a.reason), {
                signal: s.signal
            });
            let u = {
                signal: s.signal,
                options: i,
                context: n
            }, f = (w, S = !1)=>{
                let { aborted: I } = s.signal, P = i.ignoreFetchAbort && w !== void 0;
                if (i.status && (I && !S ? (i.status.fetchAborted = !0, i.status.fetchError = s.signal.reason, P && (i.status.fetchAbortIgnored = !0)) : i.status.fetchResolved = !0), I && !P && !S) return h(s.signal.reason);
                let C = b;
                return this.#e[r] === b && (w === void 0 ? C.__staleWhileFetching ? this.#e[r] = C.__staleWhileFetching : this.#A(e, "fetch") : (i.status && (i.status.fetchUpdated = !0), this.set(e, w, u.options))), w;
            }, d = (w)=>(i.status && (i.status.fetchRejected = !0, i.status.fetchError = w), h(w)), h = (w)=>{
                let { aborted: S } = s.signal, I = S && i.allowStaleOnFetchAbort, P = I || i.allowStaleOnFetchRejection, C = P || i.noDeleteOnFetchRejection, M = b;
                if (this.#e[r] === b && (!C || M.__staleWhileFetching === void 0 ? this.#A(e, "fetch") : I || (this.#e[r] = M.__staleWhileFetching)), P) return i.status && M.__staleWhileFetching !== void 0 && (i.status.returnedStale = !0), M.__staleWhileFetching;
                if (M.__returned === M) throw w;
            }, g = (w, S)=>{
                let I = this.#k?.(e, o, u);
                I && I instanceof Promise && I.then((P)=>w(P === void 0 ? void 0 : P), S), s.signal.addEventListener("abort", ()=>{
                    (!i.ignoreFetchAbort || i.allowStaleOnFetchAbort) && (w(void 0), i.allowStaleOnFetchAbort && (w = (P)=>f(P, !0)));
                });
            };
            i.status && (i.status.fetchDispatched = !0);
            let b = new Promise(g).then(f, d), E = Object.assign(b, {
                __abortController: s,
                __staleWhileFetching: o,
                __returned: void 0
            });
            return r === void 0 ? (this.set(e, E, {
                ...u.options,
                status: void 0
            }), r = this.#i.get(e)) : this.#e[r] = E, E;
        }
        #t(e) {
            if (!this.#T) return !1;
            let r = e;
            return !!r && r instanceof Promise && r.hasOwnProperty("__staleWhileFetching") && r.__abortController instanceof Pn;
        }
        async fetch(e, r = {}) {
            let { allowStale: i = this.allowStale, updateAgeOnGet: n = this.updateAgeOnGet, noDeleteOnStaleGet: o = this.noDeleteOnStaleGet, ttl: s = this.ttl, noDisposeOnSet: a = this.noDisposeOnSet, size: u = 0, sizeCalculation: f = this.sizeCalculation, noUpdateTTL: d = this.noUpdateTTL, noDeleteOnFetchRejection: h = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: g = this.allowStaleOnFetchRejection, ignoreFetchAbort: b = this.ignoreFetchAbort, allowStaleOnFetchAbort: E = this.allowStaleOnFetchAbort, context: w, forceRefresh: S = !1, status: I, signal: P } = r;
            if (!this.#T) return I && (I.fetch = "get"), this.get(e, {
                allowStale: i,
                updateAgeOnGet: n,
                noDeleteOnStaleGet: o,
                status: I
            });
            let C = {
                allowStale: i,
                updateAgeOnGet: n,
                noDeleteOnStaleGet: o,
                ttl: s,
                noDisposeOnSet: a,
                size: u,
                sizeCalculation: f,
                noUpdateTTL: d,
                noDeleteOnFetchRejection: h,
                allowStaleOnFetchRejection: g,
                allowStaleOnFetchAbort: E,
                ignoreFetchAbort: b,
                status: I,
                signal: P
            }, M = this.#i.get(e);
            if (M === void 0) {
                I && (I.fetch = "miss");
                let q = this.#M(e, M, C, w);
                return q.__returned = q;
            } else {
                let q = this.#e[M];
                if (this.#t(q)) {
                    let te = i && q.__staleWhileFetching !== void 0;
                    return I && (I.fetch = "inflight", te && (I.returnedStale = !0)), te ? q.__staleWhileFetching : q.__returned = q;
                }
                let z = this.#p(M);
                if (!S && !z) return I && (I.fetch = "hit"), this.#P(M), n && this.#R(M), I && this.#I(I, M), q;
                let j = this.#M(e, M, C, w), $ = j.__staleWhileFetching !== void 0 && i;
                return I && (I.fetch = z ? "stale" : "refresh", $ && z && (I.returnedStale = !0)), $ ? j.__staleWhileFetching : j.__returned = j;
            }
        }
        async forceFetch(e, r = {}) {
            let i = await this.fetch(e, r);
            if (i === void 0) throw new Error("fetch() returned undefined");
            return i;
        }
        memo(e, r = {}) {
            let i = this.#B;
            if (!i) throw new Error("no memoMethod provided to constructor");
            let { context: n, forceRefresh: o, ...s } = r, a = this.get(e, s);
            if (!o && a !== void 0) return a;
            let u = i(e, a, {
                options: s,
                context: n
            });
            return this.set(e, u, s), u;
        }
        get(e, r = {}) {
            let { allowStale: i = this.allowStale, updateAgeOnGet: n = this.updateAgeOnGet, noDeleteOnStaleGet: o = this.noDeleteOnStaleGet, status: s } = r, a = this.#i.get(e);
            if (a !== void 0) {
                let u = this.#e[a], f = this.#t(u);
                return s && this.#I(s, a), this.#p(a) ? (s && (s.get = "stale"), f ? (s && i && u.__staleWhileFetching !== void 0 && (s.returnedStale = !0), i ? u.__staleWhileFetching : void 0) : (o || this.#A(e, "expire"), s && i && (s.returnedStale = !0), i ? u : void 0)) : (s && (s.get = "hit"), f ? u.__staleWhileFetching : (this.#P(a), n && this.#R(a), u));
            } else s && (s.get = "miss");
        }
        #D(e, r) {
            this.#h[r] = e, this.#u[e] = r;
        }
        #P(e) {
            e !== this.#s && (e === this.#a ? this.#a = this.#u[e] : this.#D(this.#h[e], this.#u[e]), this.#D(this.#s, e), this.#s = e);
        }
        delete(e) {
            return this.#A(e, "delete");
        }
        #A(e, r) {
            let i = !1;
            if (this.#n !== 0) {
                let n = this.#i.get(e);
                if (n !== void 0) {
                    if (i = !0, this.#n === 1) this.#j(r);
                    else {
                        this.#C(n);
                        let o = this.#e[n];
                        if (this.#t(o) ? o.__abortController.abort(new Error("deleted")) : (this.#v || this.#c) && (this.#v && this.#g?.(o, e, r), this.#c && this.#o?.push([
                            o,
                            e,
                            r
                        ])), this.#i.delete(e), this.#r[n] = void 0, this.#e[n] = void 0, n === this.#s) this.#s = this.#h[n];
                        else if (n === this.#a) this.#a = this.#u[n];
                        else {
                            let s = this.#h[n];
                            this.#u[s] = this.#u[n];
                            let a = this.#u[n];
                            this.#h[a] = this.#h[n];
                        }
                        this.#n--, this.#w.push(n);
                    }
                }
            }
            if (this.#c && this.#o?.length) {
                let n = this.#o, o;
                for(; o = n?.shift();)this.#b?.(...o);
            }
            return i;
        }
        clear() {
            return this.#j("delete");
        }
        #j(e) {
            for (let r of this.#S({
                allowStale: !0
            })){
                let i = this.#e[r];
                if (this.#t(i)) i.__abortController.abort(new Error("deleted"));
                else {
                    let n = this.#r[r];
                    this.#v && this.#g?.(i, n, e), this.#c && this.#o?.push([
                        i,
                        n,
                        e
                    ]);
                }
            }
            if (this.#i.clear(), this.#e.fill(void 0), this.#r.fill(void 0), this.#d && this.#m && (this.#d.fill(0), this.#m.fill(0)), this.#_ && this.#_.fill(0), this.#a = 0, this.#s = 0, this.#w.length = 0, this.#y = 0, this.#n = 0, this.#c && this.#o) {
                let r = this.#o, i;
                for(; i = r?.shift();)this.#b?.(...i);
            }
        }
    };
    kn.LRUCache = ra;
});
var st = O(($t)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty($t, "t", {
        value: !0
    });
    $t.ContainerIterator = $t.Container = $t.Base = void 0;
    var ia = class {
        constructor(e = 0){
            this.iteratorType = e;
        }
        equals(e) {
            return this.o === e.o;
        }
    };
    $t.ContainerIterator = ia;
    var Bn = class {
        constructor(){
            this.i = 0;
        }
        get length() {
            return this.i;
        }
        size() {
            return this.i;
        }
        empty() {
            return this.i === 0;
        }
    };
    $t.Base = Bn;
    var na = class extends Bn {
    };
    $t.Container = na;
});
var Yd = O((xn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(xn, "t", {
        value: !0
    });
    xn.default = void 0;
    var kv = st(), sa = class extends kv.Base {
        constructor(e = []){
            super(), this.S = [];
            let r = this;
            e.forEach(function(i) {
                r.push(i);
            });
        }
        clear() {
            this.i = 0, this.S = [];
        }
        push(e) {
            return this.S.push(e), this.i += 1, this.i;
        }
        pop() {
            if (this.i !== 0) return this.i -= 1, this.S.pop();
        }
        top() {
            return this.S[this.i - 1];
        }
    }, Bv = sa;
    xn.default = Bv;
});
var Jd = O((On)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(On, "t", {
        value: !0
    });
    On.default = void 0;
    var xv = st(), oa = class extends xv.Base {
        constructor(e = []){
            super(), this.j = 0, this.q = [];
            let r = this;
            e.forEach(function(i) {
                r.push(i);
            });
        }
        clear() {
            this.q = [], this.i = this.j = 0;
        }
        push(e) {
            let r = this.q.length;
            if (this.j / r > .5 && this.j + this.i >= r && r > 4096) {
                let i = this.i;
                for(let n = 0; n < i; ++n)this.q[n] = this.q[this.j + n];
                this.j = 0, this.q[this.i] = e;
            } else this.q[this.j + this.i] = e;
            return ++this.i;
        }
        pop() {
            if (this.i === 0) return;
            let e = this.q[this.j++];
            return this.i -= 1, e;
        }
        front() {
            if (this.i !== 0) return this.q[this.j];
        }
    }, Ov = oa;
    On.default = Ov;
});
var Xd = O((Mn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Mn, "t", {
        value: !0
    });
    Mn.default = void 0;
    var Mv = st(), aa = class extends Mv.Base {
        constructor(e = [], r = function(n, o) {
            return n > o ? -1 : n < o ? 1 : 0;
        }, i = !0){
            if (super(), this.v = r, Array.isArray(e)) this.C = i ? [
                ...e
            ] : e;
            else {
                this.C = [];
                let o = this;
                e.forEach(function(s) {
                    o.C.push(s);
                });
            }
            this.i = this.C.length;
            let n = this.i >> 1;
            for(let o = this.i - 1 >> 1; o >= 0; --o)this.k(o, n);
        }
        m(e) {
            let r = this.C[e];
            for(; e > 0;){
                let i = e - 1 >> 1, n = this.C[i];
                if (this.v(n, r) <= 0) break;
                this.C[e] = n, e = i;
            }
            this.C[e] = r;
        }
        k(e, r) {
            let i = this.C[e];
            for(; e < r;){
                let n = e << 1 | 1, o = n + 1, s = this.C[n];
                if (o < this.i && this.v(s, this.C[o]) > 0 && (n = o, s = this.C[o]), this.v(s, i) >= 0) break;
                this.C[e] = s, e = n;
            }
            this.C[e] = i;
        }
        clear() {
            this.i = 0, this.C.length = 0;
        }
        push(e) {
            this.C.push(e), this.m(this.i), this.i += 1;
        }
        pop() {
            if (this.i === 0) return;
            let e = this.C[0], r = this.C.pop();
            return this.i -= 1, this.i && (this.C[0] = r, this.k(0, this.i >> 1)), e;
        }
        top() {
            return this.C[0];
        }
        find(e) {
            return this.C.indexOf(e) >= 0;
        }
        remove(e) {
            let r = this.C.indexOf(e);
            return r < 0 ? !1 : (r === 0 ? this.pop() : r === this.i - 1 ? (this.C.pop(), this.i -= 1) : (this.C.splice(r, 1, this.C.pop()), this.i -= 1, this.m(r), this.k(r, this.i >> 1)), !0);
        }
        updateItem(e) {
            let r = this.C.indexOf(e);
            return r < 0 ? !1 : (this.m(r), this.k(r, this.i >> 1), !0);
        }
        toArray() {
            return [
                ...this.C
            ];
        }
    }, Lv = aa;
    Mn.default = Lv;
});
var qn = O((Ln)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Ln, "t", {
        value: !0
    });
    Ln.default = void 0;
    var qv = st(), la = class extends qv.Container {
    }, Uv = la;
    Ln.default = Uv;
});
var ot = O((ua)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(ua, "t", {
        value: !0
    });
    ua.throwIteratorAccessError = Nv;
    function Nv() {
        throw new RangeError("Iterator access denied!");
    }
});
var fa = O((Nn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Nn, "t", {
        value: !0
    });
    Nn.RandomIterator = void 0;
    var Dv = st(), Un = ot(), ca = class extends Dv.ContainerIterator {
        constructor(e, r){
            super(r), this.o = e, this.iteratorType === 0 ? (this.pre = function() {
                return this.o === 0 && (0, Un.throwIteratorAccessError)(), this.o -= 1, this;
            }, this.next = function() {
                return this.o === this.container.size() && (0, Un.throwIteratorAccessError)(), this.o += 1, this;
            }) : (this.pre = function() {
                return this.o === this.container.size() - 1 && (0, Un.throwIteratorAccessError)(), this.o += 1, this;
            }, this.next = function() {
                return this.o === -1 && (0, Un.throwIteratorAccessError)(), this.o -= 1, this;
            });
        }
        get pointer() {
            return this.container.getElementByPos(this.o);
        }
        set pointer(e) {
            this.container.setElementByPos(this.o, e);
        }
    };
    Nn.RandomIterator = ca;
});
var Zd = O((Dn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Dn, "t", {
        value: !0
    });
    Dn.default = void 0;
    var jv = Wv(qn()), Fv = fa();
    function Wv(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var fr = class t extends Fv.RandomIterator {
        constructor(e, r, i){
            super(e, i), this.container = r;
        }
        copy() {
            return new t(this.o, this.container, this.iteratorType);
        }
    }, ha = class extends jv.default {
        constructor(e = [], r = !0){
            if (super(), Array.isArray(e)) this.J = r ? [
                ...e
            ] : e, this.i = e.length;
            else {
                this.J = [];
                let i = this;
                e.forEach(function(n) {
                    i.pushBack(n);
                });
            }
        }
        clear() {
            this.i = 0, this.J.length = 0;
        }
        begin() {
            return new fr(0, this);
        }
        end() {
            return new fr(this.i, this);
        }
        rBegin() {
            return new fr(this.i - 1, this, 1);
        }
        rEnd() {
            return new fr(-1, this, 1);
        }
        front() {
            return this.J[0];
        }
        back() {
            return this.J[this.i - 1];
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            return this.J[e];
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            return this.J.splice(e, 1), this.i -= 1, this.i;
        }
        eraseElementByValue(e) {
            let r = 0;
            for(let i = 0; i < this.i; ++i)this.J[i] !== e && (this.J[r++] = this.J[i]);
            return this.i = this.J.length = r, this.i;
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return e = e.next(), this.eraseElementByPos(r), e;
        }
        pushBack(e) {
            return this.J.push(e), this.i += 1, this.i;
        }
        popBack() {
            if (this.i !== 0) return this.i -= 1, this.J.pop();
        }
        setElementByPos(e, r) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            this.J[e] = r;
        }
        insert(e, r, i = 1) {
            if (e < 0 || e > this.i) throw new RangeError;
            return this.J.splice(e, 0, ...new Array(i).fill(r)), this.i += i, this.i;
        }
        find(e) {
            for(let r = 0; r < this.i; ++r)if (this.J[r] === e) return new fr(r, this);
            return this.end();
        }
        reverse() {
            this.J.reverse();
        }
        unique() {
            let e = 1;
            for(let r = 1; r < this.i; ++r)this.J[r] !== this.J[r - 1] && (this.J[e++] = this.J[r]);
            return this.i = this.J.length = e, this.i;
        }
        sort(e) {
            this.J.sort(e);
        }
        forEach(e) {
            for(let r = 0; r < this.i; ++r)e(this.J[r], r, this);
        }
        [Symbol.iterator]() {
            return (function*() {
                yield* this.J;
            }).bind(this)();
        }
    }, $v = ha;
    Dn.default = $v;
});
var ep = O((jn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(jn, "t", {
        value: !0
    });
    jn.default = void 0;
    var Hv = zv(qn()), Vv = st(), hr = ot();
    function zv(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var dr = class t extends Vv.ContainerIterator {
        constructor(e, r, i, n){
            super(n), this.o = e, this.h = r, this.container = i, this.iteratorType === 0 ? (this.pre = function() {
                return this.o.L === this.h && (0, hr.throwIteratorAccessError)(), this.o = this.o.L, this;
            }, this.next = function() {
                return this.o === this.h && (0, hr.throwIteratorAccessError)(), this.o = this.o.B, this;
            }) : (this.pre = function() {
                return this.o.B === this.h && (0, hr.throwIteratorAccessError)(), this.o = this.o.B, this;
            }, this.next = function() {
                return this.o === this.h && (0, hr.throwIteratorAccessError)(), this.o = this.o.L, this;
            });
        }
        get pointer() {
            return this.o === this.h && (0, hr.throwIteratorAccessError)(), this.o.l;
        }
        set pointer(e) {
            this.o === this.h && (0, hr.throwIteratorAccessError)(), this.o.l = e;
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, da = class extends Hv.default {
        constructor(e = []){
            super(), this.h = {}, this.p = this._ = this.h.L = this.h.B = this.h;
            let r = this;
            e.forEach(function(i) {
                r.pushBack(i);
            });
        }
        V(e) {
            let { L: r, B: i } = e;
            r.B = i, i.L = r, e === this.p && (this.p = i), e === this._ && (this._ = r), this.i -= 1;
        }
        G(e, r) {
            let i = r.B, n = {
                l: e,
                L: r,
                B: i
            };
            r.B = n, i.L = n, r === this.h && (this.p = n), i === this.h && (this._ = n), this.i += 1;
        }
        clear() {
            this.i = 0, this.p = this._ = this.h.L = this.h.B = this.h;
        }
        begin() {
            return new dr(this.p, this.h, this);
        }
        end() {
            return new dr(this.h, this.h, this);
        }
        rBegin() {
            return new dr(this._, this.h, this, 1);
        }
        rEnd() {
            return new dr(this.h, this.h, this, 1);
        }
        front() {
            return this.p.l;
        }
        back() {
            return this._.l;
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return r.l;
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return this.V(r), this.i;
        }
        eraseElementByValue(e) {
            let r = this.p;
            for(; r !== this.h;)r.l === e && this.V(r), r = r.B;
            return this.i;
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return r === this.h && (0, hr.throwIteratorAccessError)(), e = e.next(), this.V(r), e;
        }
        pushBack(e) {
            return this.G(e, this._), this.i;
        }
        popBack() {
            if (this.i === 0) return;
            let e = this._.l;
            return this.V(this._), e;
        }
        pushFront(e) {
            return this.G(e, this.h), this.i;
        }
        popFront() {
            if (this.i === 0) return;
            let e = this.p.l;
            return this.V(this.p), e;
        }
        setElementByPos(e, r) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let i = this.p;
            for(; e--;)i = i.B;
            i.l = r;
        }
        insert(e, r, i = 1) {
            if (e < 0 || e > this.i) throw new RangeError;
            if (i <= 0) return this.i;
            if (e === 0) for(; i--;)this.pushFront(r);
            else if (e === this.i) for(; i--;)this.pushBack(r);
            else {
                let n = this.p;
                for(let s = 1; s < e; ++s)n = n.B;
                let o = n.B;
                for(this.i += i; i--;)n.B = {
                    l: r,
                    L: n
                }, n.B.L = n, n = n.B;
                n.B = o, o.L = n;
            }
            return this.i;
        }
        find(e) {
            let r = this.p;
            for(; r !== this.h;){
                if (r.l === e) return new dr(r, this.h, this);
                r = r.B;
            }
            return this.end();
        }
        reverse() {
            if (this.i <= 1) return;
            let e = this.p, r = this._, i = 0;
            for(; i << 1 < this.i;){
                let n = e.l;
                e.l = r.l, r.l = n, e = e.B, r = r.L, i += 1;
            }
        }
        unique() {
            if (this.i <= 1) return this.i;
            let e = this.p;
            for(; e !== this.h;){
                let r = e;
                for(; r.B !== this.h && r.l === r.B.l;)r = r.B, this.i -= 1;
                e.B = r.B, e.B.L = e, e = e.B;
            }
            return this.i;
        }
        sort(e) {
            if (this.i <= 1) return;
            let r = [];
            this.forEach(function(n) {
                r.push(n);
            }), r.sort(e);
            let i = this.p;
            r.forEach(function(n) {
                i.l = n, i = i.B;
            });
        }
        merge(e) {
            let r = this;
            if (this.i === 0) e.forEach(function(i) {
                r.pushBack(i);
            });
            else {
                let i = this.p;
                e.forEach(function(n) {
                    for(; i !== r.h && i.l <= n;)i = i.B;
                    r.G(n, i.L);
                });
            }
            return this.i;
        }
        forEach(e) {
            let r = this.p, i = 0;
            for(; r !== this.h;)e(r.l, i++, this), r = r.B;
        }
        [Symbol.iterator]() {
            return (function*() {
                if (this.i === 0) return;
                let e = this.p;
                for(; e !== this.h;)yield e.l, e = e.B;
            }).bind(this)();
        }
    }, Kv = da;
    jn.default = Kv;
});
var tp = O((Fn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Fn, "t", {
        value: !0
    });
    Fn.default = void 0;
    var Gv = Yv(qn()), Qv = fa();
    function Yv(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var pr = class t extends Qv.RandomIterator {
        constructor(e, r, i){
            super(e, i), this.container = r;
        }
        copy() {
            return new t(this.o, this.container, this.iteratorType);
        }
    }, pa = class extends Gv.default {
        constructor(e = [], r = 4096){
            super(), this.j = 0, this.D = 0, this.R = 0, this.N = 0, this.P = 0, this.A = [];
            let i = (()=>{
                if (typeof e.length == "number") return e.length;
                if (typeof e.size == "number") return e.size;
                if (typeof e.size == "function") return e.size();
                throw new TypeError("Cannot get the length or size of the container");
            })();
            this.F = r, this.P = Math.max(Math.ceil(i / this.F), 1);
            for(let s = 0; s < this.P; ++s)this.A.push(new Array(this.F));
            let n = Math.ceil(i / this.F);
            this.j = this.R = (this.P >> 1) - (n >> 1), this.D = this.N = this.F - i % this.F >> 1;
            let o = this;
            e.forEach(function(s) {
                o.pushBack(s);
            });
        }
        T() {
            let e = [], r = Math.max(this.P >> 1, 1);
            for(let i = 0; i < r; ++i)e[i] = new Array(this.F);
            for(let i = this.j; i < this.P; ++i)e[e.length] = this.A[i];
            for(let i = 0; i < this.R; ++i)e[e.length] = this.A[i];
            e[e.length] = [
                ...this.A[this.R]
            ], this.j = r, this.R = e.length - 1;
            for(let i = 0; i < r; ++i)e[e.length] = new Array(this.F);
            this.A = e, this.P = e.length;
        }
        O(e) {
            let r = this.D + e + 1, i = r % this.F, n = i - 1, o = this.j + (r - i) / this.F;
            return i === 0 && (o -= 1), o %= this.P, n < 0 && (n += this.F), {
                curNodeBucketIndex: o,
                curNodePointerIndex: n
            };
        }
        clear() {
            this.A = [
                new Array(this.F)
            ], this.P = 1, this.j = this.R = this.i = 0, this.D = this.N = this.F >> 1;
        }
        begin() {
            return new pr(0, this);
        }
        end() {
            return new pr(this.i, this);
        }
        rBegin() {
            return new pr(this.i - 1, this, 1);
        }
        rEnd() {
            return new pr(-1, this, 1);
        }
        front() {
            if (this.i !== 0) return this.A[this.j][this.D];
        }
        back() {
            if (this.i !== 0) return this.A[this.R][this.N];
        }
        pushBack(e) {
            return this.i && (this.N < this.F - 1 ? this.N += 1 : this.R < this.P - 1 ? (this.R += 1, this.N = 0) : (this.R = 0, this.N = 0), this.R === this.j && this.N === this.D && this.T()), this.i += 1, this.A[this.R][this.N] = e, this.i;
        }
        popBack() {
            if (this.i === 0) return;
            let e = this.A[this.R][this.N];
            return this.i !== 1 && (this.N > 0 ? this.N -= 1 : this.R > 0 ? (this.R -= 1, this.N = this.F - 1) : (this.R = this.P - 1, this.N = this.F - 1)), this.i -= 1, e;
        }
        pushFront(e) {
            return this.i && (this.D > 0 ? this.D -= 1 : this.j > 0 ? (this.j -= 1, this.D = this.F - 1) : (this.j = this.P - 1, this.D = this.F - 1), this.j === this.R && this.D === this.N && this.T()), this.i += 1, this.A[this.j][this.D] = e, this.i;
        }
        popFront() {
            if (this.i === 0) return;
            let e = this.A[this.j][this.D];
            return this.i !== 1 && (this.D < this.F - 1 ? this.D += 1 : this.j < this.P - 1 ? (this.j += 1, this.D = 0) : (this.j = 0, this.D = 0)), this.i -= 1, e;
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let { curNodeBucketIndex: r, curNodePointerIndex: i } = this.O(e);
            return this.A[r][i];
        }
        setElementByPos(e, r) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let { curNodeBucketIndex: i, curNodePointerIndex: n } = this.O(e);
            this.A[i][n] = r;
        }
        insert(e, r, i = 1) {
            if (e < 0 || e > this.i) throw new RangeError;
            if (e === 0) for(; i--;)this.pushFront(r);
            else if (e === this.i) for(; i--;)this.pushBack(r);
            else {
                let n = [];
                for(let o = e; o < this.i; ++o)n.push(this.getElementByPos(o));
                this.cut(e - 1);
                for(let o = 0; o < i; ++o)this.pushBack(r);
                for(let o = 0; o < n.length; ++o)this.pushBack(n[o]);
            }
            return this.i;
        }
        cut(e) {
            if (e < 0) return this.clear(), 0;
            let { curNodeBucketIndex: r, curNodePointerIndex: i } = this.O(e);
            return this.R = r, this.N = i, this.i = e + 1, this.i;
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            if (e === 0) this.popFront();
            else if (e === this.i - 1) this.popBack();
            else {
                let r = [];
                for(let n = e + 1; n < this.i; ++n)r.push(this.getElementByPos(n));
                this.cut(e), this.popBack();
                let i = this;
                r.forEach(function(n) {
                    i.pushBack(n);
                });
            }
            return this.i;
        }
        eraseElementByValue(e) {
            if (this.i === 0) return 0;
            let r = [];
            for(let n = 0; n < this.i; ++n){
                let o = this.getElementByPos(n);
                o !== e && r.push(o);
            }
            let i = r.length;
            for(let n = 0; n < i; ++n)this.setElementByPos(n, r[n]);
            return this.cut(i - 1);
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return this.eraseElementByPos(r), e = e.next(), e;
        }
        find(e) {
            for(let r = 0; r < this.i; ++r)if (this.getElementByPos(r) === e) return new pr(r, this);
            return this.end();
        }
        reverse() {
            let e = 0, r = this.i - 1;
            for(; e < r;){
                let i = this.getElementByPos(e);
                this.setElementByPos(e, this.getElementByPos(r)), this.setElementByPos(r, i), e += 1, r -= 1;
            }
        }
        unique() {
            if (this.i <= 1) return this.i;
            let e = 1, r = this.getElementByPos(0);
            for(let i = 1; i < this.i; ++i){
                let n = this.getElementByPos(i);
                n !== r && (r = n, this.setElementByPos(e++, n));
            }
            for(; this.i > e;)this.popBack();
            return this.i;
        }
        sort(e) {
            let r = [];
            for(let i = 0; i < this.i; ++i)r.push(this.getElementByPos(i));
            r.sort(e);
            for(let i = 0; i < this.i; ++i)this.setElementByPos(i, r[i]);
        }
        shrinkToFit() {
            if (this.i === 0) return;
            let e = [];
            this.forEach(function(r) {
                e.push(r);
            }), this.P = Math.max(Math.ceil(this.i / this.F), 1), this.i = this.j = this.R = this.D = this.N = 0, this.A = [];
            for(let r = 0; r < this.P; ++r)this.A.push(new Array(this.F));
            for(let r = 0; r < e.length; ++r)this.pushBack(e[r]);
        }
        forEach(e) {
            for(let r = 0; r < this.i; ++r)e(this.getElementByPos(r), r, this);
        }
        [Symbol.iterator]() {
            return (function*() {
                for(let e = 0; e < this.i; ++e)yield this.getElementByPos(e);
            }).bind(this)();
        }
    }, Jv = pa;
    Fn.default = Jv;
});
var rp = O((Qr)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Qr, "t", {
        value: !0
    });
    Qr.TreeNodeEnableIndex = Qr.TreeNode = void 0;
    var Wn = class {
        constructor(e, r){
            this.ee = 1, this.u = void 0, this.l = void 0, this.U = void 0, this.W = void 0, this.tt = void 0, this.u = e, this.l = r;
        }
        L() {
            let e = this;
            if (e.ee === 1 && e.tt.tt === e) e = e.W;
            else if (e.U) for(e = e.U; e.W;)e = e.W;
            else {
                let r = e.tt;
                for(; r.U === e;)e = r, r = e.tt;
                e = r;
            }
            return e;
        }
        B() {
            let e = this;
            if (e.W) {
                for(e = e.W; e.U;)e = e.U;
                return e;
            } else {
                let r = e.tt;
                for(; r.W === e;)e = r, r = e.tt;
                return e.W !== r ? r : e;
            }
        }
        te() {
            let e = this.tt, r = this.W, i = r.U;
            return e.tt === this ? e.tt = r : e.U === this ? e.U = r : e.W = r, r.tt = e, r.U = this, this.tt = r, this.W = i, i && (i.tt = this), r;
        }
        se() {
            let e = this.tt, r = this.U, i = r.W;
            return e.tt === this ? e.tt = r : e.U === this ? e.U = r : e.W = r, r.tt = e, r.W = this, this.tt = r, this.U = i, i && (i.tt = this), r;
        }
    };
    Qr.TreeNode = Wn;
    var ga = class extends Wn {
        constructor(){
            super(...arguments), this.rt = 1;
        }
        te() {
            let e = super.te();
            return this.ie(), e.ie(), e;
        }
        se() {
            let e = super.se();
            return this.ie(), e.ie(), e;
        }
        ie() {
            this.rt = 1, this.U && (this.rt += this.U.rt), this.W && (this.rt += this.W.rt);
        }
    };
    Qr.TreeNodeEnableIndex = ga;
});
var ya = O(($n)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty($n, "t", {
        value: !0
    });
    $n.default = void 0;
    var ip = rp(), Xv = st(), np = ot(), ba = class extends Xv.Container {
        constructor(e = function(i, n) {
            return i < n ? -1 : i > n ? 1 : 0;
        }, r = !1){
            super(), this.Y = void 0, this.v = e, r ? (this.re = ip.TreeNodeEnableIndex, this.M = function(i, n, o) {
                let s = this.ne(i, n, o);
                if (s) {
                    let a = s.tt;
                    for(; a !== this.h;)a.rt += 1, a = a.tt;
                    let u = this.he(s);
                    if (u) {
                        let { parentNode: f, grandParent: d, curNode: h } = u;
                        f.ie(), d.ie(), h.ie();
                    }
                }
                return this.i;
            }, this.V = function(i) {
                let n = this.fe(i);
                for(; n !== this.h;)n.rt -= 1, n = n.tt;
            }) : (this.re = ip.TreeNode, this.M = function(i, n, o) {
                let s = this.ne(i, n, o);
                return s && this.he(s), this.i;
            }, this.V = this.fe), this.h = new this.re;
        }
        X(e, r) {
            let i = this.h;
            for(; e;){
                let n = this.v(e.u, r);
                if (n < 0) e = e.W;
                else if (n > 0) i = e, e = e.U;
                else return e;
            }
            return i;
        }
        Z(e, r) {
            let i = this.h;
            for(; e;)this.v(e.u, r) <= 0 ? e = e.W : (i = e, e = e.U);
            return i;
        }
        $(e, r) {
            let i = this.h;
            for(; e;){
                let n = this.v(e.u, r);
                if (n < 0) i = e, e = e.W;
                else if (n > 0) e = e.U;
                else return e;
            }
            return i;
        }
        rr(e, r) {
            let i = this.h;
            for(; e;)this.v(e.u, r) < 0 ? (i = e, e = e.W) : e = e.U;
            return i;
        }
        ue(e) {
            for(;;){
                let r = e.tt;
                if (r === this.h) return;
                if (e.ee === 1) {
                    e.ee = 0;
                    return;
                }
                if (e === r.U) {
                    let i = r.W;
                    if (i.ee === 1) i.ee = 0, r.ee = 1, r === this.Y ? this.Y = r.te() : r.te();
                    else if (i.W && i.W.ee === 1) {
                        i.ee = r.ee, r.ee = 0, i.W.ee = 0, r === this.Y ? this.Y = r.te() : r.te();
                        return;
                    } else i.U && i.U.ee === 1 ? (i.ee = 1, i.U.ee = 0, i.se()) : (i.ee = 1, e = r);
                } else {
                    let i = r.U;
                    if (i.ee === 1) i.ee = 0, r.ee = 1, r === this.Y ? this.Y = r.se() : r.se();
                    else if (i.U && i.U.ee === 1) {
                        i.ee = r.ee, r.ee = 0, i.U.ee = 0, r === this.Y ? this.Y = r.se() : r.se();
                        return;
                    } else i.W && i.W.ee === 1 ? (i.ee = 1, i.W.ee = 0, i.te()) : (i.ee = 1, e = r);
                }
            }
        }
        fe(e) {
            if (this.i === 1) return this.clear(), this.h;
            let r = e;
            for(; r.U || r.W;){
                if (r.W) for(r = r.W; r.U;)r = r.U;
                else r = r.U;
                [e.u, r.u] = [
                    r.u,
                    e.u
                ], [e.l, r.l] = [
                    r.l,
                    e.l
                ], e = r;
            }
            this.h.U === r ? this.h.U = r.tt : this.h.W === r && (this.h.W = r.tt), this.ue(r);
            let i = r.tt;
            return r === i.U ? i.U = void 0 : i.W = void 0, this.i -= 1, this.Y.ee = 0, i;
        }
        oe(e, r) {
            return e === void 0 ? !1 : this.oe(e.U, r) || r(e) ? !0 : this.oe(e.W, r);
        }
        he(e) {
            for(;;){
                let r = e.tt;
                if (r.ee === 0) return;
                let i = r.tt;
                if (r === i.U) {
                    let n = i.W;
                    if (n && n.ee === 1) {
                        if (n.ee = r.ee = 0, i === this.Y) return;
                        i.ee = 1, e = i;
                        continue;
                    } else if (e === r.W) {
                        if (e.ee = 0, e.U && (e.U.tt = r), e.W && (e.W.tt = i), r.W = e.U, i.U = e.W, e.U = r, e.W = i, i === this.Y) this.Y = e, this.h.tt = e;
                        else {
                            let o = i.tt;
                            o.U === i ? o.U = e : o.W = e;
                        }
                        return e.tt = i.tt, r.tt = e, i.tt = e, i.ee = 1, {
                            parentNode: r,
                            grandParent: i,
                            curNode: e
                        };
                    } else r.ee = 0, i === this.Y ? this.Y = i.se() : i.se(), i.ee = 1;
                } else {
                    let n = i.U;
                    if (n && n.ee === 1) {
                        if (n.ee = r.ee = 0, i === this.Y) return;
                        i.ee = 1, e = i;
                        continue;
                    } else if (e === r.U) {
                        if (e.ee = 0, e.U && (e.U.tt = i), e.W && (e.W.tt = r), i.W = e.U, r.U = e.W, e.U = i, e.W = r, i === this.Y) this.Y = e, this.h.tt = e;
                        else {
                            let o = i.tt;
                            o.U === i ? o.U = e : o.W = e;
                        }
                        return e.tt = i.tt, r.tt = e, i.tt = e, i.ee = 1, {
                            parentNode: r,
                            grandParent: i,
                            curNode: e
                        };
                    } else r.ee = 0, i === this.Y ? this.Y = i.te() : i.te(), i.ee = 1;
                }
                return;
            }
        }
        ne(e, r, i) {
            if (this.Y === void 0) {
                this.i += 1, this.Y = new this.re(e, r), this.Y.ee = 0, this.Y.tt = this.h, this.h.tt = this.Y, this.h.U = this.Y, this.h.W = this.Y;
                return;
            }
            let n, o = this.h.U, s = this.v(o.u, e);
            if (s === 0) {
                o.l = r;
                return;
            } else if (s > 0) o.U = new this.re(e, r), o.U.tt = o, n = o.U, this.h.U = n;
            else {
                let a = this.h.W, u = this.v(a.u, e);
                if (u === 0) {
                    a.l = r;
                    return;
                } else if (u < 0) a.W = new this.re(e, r), a.W.tt = a, n = a.W, this.h.W = n;
                else {
                    if (i !== void 0) {
                        let f = i.o;
                        if (f !== this.h) {
                            let d = this.v(f.u, e);
                            if (d === 0) {
                                f.l = r;
                                return;
                            } else if (d > 0) {
                                let h = f.L(), g = this.v(h.u, e);
                                if (g === 0) {
                                    h.l = r;
                                    return;
                                } else g < 0 && (n = new this.re(e, r), h.W === void 0 ? (h.W = n, n.tt = h) : (f.U = n, n.tt = f));
                            }
                        }
                    }
                    if (n === void 0) for(n = this.Y;;){
                        let f = this.v(n.u, e);
                        if (f > 0) {
                            if (n.U === void 0) {
                                n.U = new this.re(e, r), n.U.tt = n, n = n.U;
                                break;
                            }
                            n = n.U;
                        } else if (f < 0) {
                            if (n.W === void 0) {
                                n.W = new this.re(e, r), n.W.tt = n, n = n.W;
                                break;
                            }
                            n = n.W;
                        } else {
                            n.l = r;
                            return;
                        }
                    }
                }
            }
            return this.i += 1, n;
        }
        I(e, r) {
            for(; e;){
                let i = this.v(e.u, r);
                if (i < 0) e = e.W;
                else if (i > 0) e = e.U;
                else return e;
            }
            return e || this.h;
        }
        clear() {
            this.i = 0, this.Y = void 0, this.h.tt = void 0, this.h.U = this.h.W = void 0;
        }
        updateKeyByIterator(e, r) {
            let i = e.o;
            if (i === this.h && (0, np.throwIteratorAccessError)(), this.i === 1) return i.u = r, !0;
            if (i === this.h.U) return this.v(i.B().u, r) > 0 ? (i.u = r, !0) : !1;
            if (i === this.h.W) return this.v(i.L().u, r) < 0 ? (i.u = r, !0) : !1;
            let n = i.L().u;
            if (this.v(n, r) >= 0) return !1;
            let o = i.B().u;
            return this.v(o, r) <= 0 ? !1 : (i.u = r, !0);
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = 0, i = this;
            return this.oe(this.Y, function(n) {
                return e === r ? (i.V(n), !0) : (r += 1, !1);
            }), this.i;
        }
        eraseElementByKey(e) {
            if (this.i === 0) return !1;
            let r = this.I(this.Y, e);
            return r === this.h ? !1 : (this.V(r), !0);
        }
        eraseElementByIterator(e) {
            let r = e.o;
            r === this.h && (0, np.throwIteratorAccessError)();
            let i = r.W === void 0;
            return e.iteratorType === 0 ? i && e.next() : (!i || r.U === void 0) && e.next(), this.V(r), e;
        }
        forEach(e) {
            let r = 0;
            for (let i of this)e(i, r++, this);
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r, i = 0;
            for (let n of this){
                if (i === e) {
                    r = n;
                    break;
                }
                i += 1;
            }
            return r;
        }
        getHeight() {
            if (this.i === 0) return 0;
            let e = function(r) {
                return r ? Math.max(e(r.U), e(r.W)) + 1 : 0;
            };
            return e(this.Y);
        }
    }, Zv = ba;
    $n.default = Zv;
});
var _a = O((Vn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Vn, "t", {
        value: !0
    });
    Vn.default = void 0;
    var eE = st(), Hn = ot(), wa = class extends eE.ContainerIterator {
        constructor(e, r, i){
            super(i), this.o = e, this.h = r, this.iteratorType === 0 ? (this.pre = function() {
                return this.o === this.h.U && (0, Hn.throwIteratorAccessError)(), this.o = this.o.L(), this;
            }, this.next = function() {
                return this.o === this.h && (0, Hn.throwIteratorAccessError)(), this.o = this.o.B(), this;
            }) : (this.pre = function() {
                return this.o === this.h.W && (0, Hn.throwIteratorAccessError)(), this.o = this.o.B(), this;
            }, this.next = function() {
                return this.o === this.h && (0, Hn.throwIteratorAccessError)(), this.o = this.o.L(), this;
            });
        }
        get index() {
            let e = this.o, r = this.h.tt;
            if (e === this.h) return r ? r.rt - 1 : 0;
            let i = 0;
            for(e.U && (i += e.U.rt); e !== r;){
                let n = e.tt;
                e === n.W && (i += 1, n.U && (i += n.U.rt)), e = n;
            }
            return i;
        }
    }, tE = wa;
    Vn.default = tE;
});
var op = O((zn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(zn, "t", {
        value: !0
    });
    zn.default = void 0;
    var rE = sp(ya()), iE = sp(_a()), nE = ot();
    function sp(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var ze = class t extends iE.default {
        constructor(e, r, i, n){
            super(e, r, n), this.container = i;
        }
        get pointer() {
            return this.o === this.h && (0, nE.throwIteratorAccessError)(), this.o.u;
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, ma = class extends rE.default {
        constructor(e = [], r, i){
            super(r, i);
            let n = this;
            e.forEach(function(o) {
                n.insert(o);
            });
        }
        *K(e) {
            e !== void 0 && (yield* this.K(e.U), yield e.u, yield* this.K(e.W));
        }
        begin() {
            return new ze(this.h.U || this.h, this.h, this);
        }
        end() {
            return new ze(this.h, this.h, this);
        }
        rBegin() {
            return new ze(this.h.W || this.h, this.h, this, 1);
        }
        rEnd() {
            return new ze(this.h, this.h, this, 1);
        }
        front() {
            return this.h.U ? this.h.U.u : void 0;
        }
        back() {
            return this.h.W ? this.h.W.u : void 0;
        }
        insert(e, r) {
            return this.M(e, void 0, r);
        }
        find(e) {
            let r = this.I(this.Y, e);
            return new ze(r, this.h, this);
        }
        lowerBound(e) {
            let r = this.X(this.Y, e);
            return new ze(r, this.h, this);
        }
        upperBound(e) {
            let r = this.Z(this.Y, e);
            return new ze(r, this.h, this);
        }
        reverseLowerBound(e) {
            let r = this.$(this.Y, e);
            return new ze(r, this.h, this);
        }
        reverseUpperBound(e) {
            let r = this.rr(this.Y, e);
            return new ze(r, this.h, this);
        }
        union(e) {
            let r = this;
            return e.forEach(function(i) {
                r.insert(i);
            }), this.i;
        }
        [Symbol.iterator]() {
            return this.K(this.Y);
        }
    }, sE = ma;
    zn.default = sE;
});
var lp = O((Kn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Kn, "t", {
        value: !0
    });
    Kn.default = void 0;
    var oE = ap(ya()), aE = ap(_a()), lE = ot();
    function ap(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var Ke = class t extends aE.default {
        constructor(e, r, i, n){
            super(e, r, n), this.container = i;
        }
        get pointer() {
            this.o === this.h && (0, lE.throwIteratorAccessError)();
            let e = this;
            return new Proxy([], {
                get (r, i) {
                    if (i === "0") return e.o.u;
                    if (i === "1") return e.o.l;
                },
                set (r, i, n) {
                    if (i !== "1") throw new TypeError("props must be 1");
                    return e.o.l = n, !0;
                }
            });
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, va = class extends oE.default {
        constructor(e = [], r, i){
            super(r, i);
            let n = this;
            e.forEach(function(o) {
                n.setElement(o[0], o[1]);
            });
        }
        *K(e) {
            e !== void 0 && (yield* this.K(e.U), yield [
                e.u,
                e.l
            ], yield* this.K(e.W));
        }
        begin() {
            return new Ke(this.h.U || this.h, this.h, this);
        }
        end() {
            return new Ke(this.h, this.h, this);
        }
        rBegin() {
            return new Ke(this.h.W || this.h, this.h, this, 1);
        }
        rEnd() {
            return new Ke(this.h, this.h, this, 1);
        }
        front() {
            if (this.i === 0) return;
            let e = this.h.U;
            return [
                e.u,
                e.l
            ];
        }
        back() {
            if (this.i === 0) return;
            let e = this.h.W;
            return [
                e.u,
                e.l
            ];
        }
        lowerBound(e) {
            let r = this.X(this.Y, e);
            return new Ke(r, this.h, this);
        }
        upperBound(e) {
            let r = this.Z(this.Y, e);
            return new Ke(r, this.h, this);
        }
        reverseLowerBound(e) {
            let r = this.$(this.Y, e);
            return new Ke(r, this.h, this);
        }
        reverseUpperBound(e) {
            let r = this.rr(this.Y, e);
            return new Ke(r, this.h, this);
        }
        setElement(e, r, i) {
            return this.M(e, r, i);
        }
        find(e) {
            let r = this.I(this.Y, e);
            return new Ke(r, this.h, this);
        }
        getElementByKey(e) {
            return this.I(this.Y, e).l;
        }
        union(e) {
            let r = this;
            return e.forEach(function(i) {
                r.setElement(i[0], i[1]);
            }), this.i;
        }
        [Symbol.iterator]() {
            return this.K(this.Y);
        }
    }, uE = va;
    Kn.default = uE;
});
var Sa = O((Ea)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Ea, "t", {
        value: !0
    });
    Ea.default = cE;
    function cE(t) {
        let e = typeof t;
        return e === "object" && t !== null || e === "function";
    }
});
var Ra = O((Yr)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Yr, "t", {
        value: !0
    });
    Yr.HashContainerIterator = Yr.HashContainer = void 0;
    var up = st(), Aa = fE(Sa()), Ai = ot();
    function fE(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var Ia = class extends up.ContainerIterator {
        constructor(e, r, i){
            super(i), this.o = e, this.h = r, this.iteratorType === 0 ? (this.pre = function() {
                return this.o.L === this.h && (0, Ai.throwIteratorAccessError)(), this.o = this.o.L, this;
            }, this.next = function() {
                return this.o === this.h && (0, Ai.throwIteratorAccessError)(), this.o = this.o.B, this;
            }) : (this.pre = function() {
                return this.o.B === this.h && (0, Ai.throwIteratorAccessError)(), this.o = this.o.B, this;
            }, this.next = function() {
                return this.o === this.h && (0, Ai.throwIteratorAccessError)(), this.o = this.o.L, this;
            });
        }
    };
    Yr.HashContainerIterator = Ia;
    var Ta = class extends up.Container {
        constructor(){
            super(), this.H = [], this.g = {}, this.HASH_TAG = Symbol("@@HASH_TAG"), Object.setPrototypeOf(this.g, null), this.h = {}, this.h.L = this.h.B = this.p = this._ = this.h;
        }
        V(e) {
            let { L: r, B: i } = e;
            r.B = i, i.L = r, e === this.p && (this.p = i), e === this._ && (this._ = r), this.i -= 1;
        }
        M(e, r, i) {
            i === void 0 && (i = (0, Aa.default)(e));
            let n;
            if (i) {
                let o = e[this.HASH_TAG];
                if (o !== void 0) return this.H[o].l = r, this.i;
                Object.defineProperty(e, this.HASH_TAG, {
                    value: this.H.length,
                    configurable: !0
                }), n = {
                    u: e,
                    l: r,
                    L: this._,
                    B: this.h
                }, this.H.push(n);
            } else {
                let o = this.g[e];
                if (o) return o.l = r, this.i;
                n = {
                    u: e,
                    l: r,
                    L: this._,
                    B: this.h
                }, this.g[e] = n;
            }
            return this.i === 0 ? (this.p = n, this.h.B = n) : this._.B = n, this._ = n, this.h.L = n, ++this.i;
        }
        I(e, r) {
            if (r === void 0 && (r = (0, Aa.default)(e)), r) {
                let i = e[this.HASH_TAG];
                return i === void 0 ? this.h : this.H[i];
            } else return this.g[e] || this.h;
        }
        clear() {
            let e = this.HASH_TAG;
            this.H.forEach(function(r) {
                delete r.u[e];
            }), this.H = [], this.g = {}, Object.setPrototypeOf(this.g, null), this.i = 0, this.p = this._ = this.h.L = this.h.B = this.h;
        }
        eraseElementByKey(e, r) {
            let i;
            if (r === void 0 && (r = (0, Aa.default)(e)), r) {
                let n = e[this.HASH_TAG];
                if (n === void 0) return !1;
                delete e[this.HASH_TAG], i = this.H[n], delete this.H[n];
            } else {
                if (i = this.g[e], i === void 0) return !1;
                delete this.g[e];
            }
            return this.V(i), !0;
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return r === this.h && (0, Ai.throwIteratorAccessError)(), this.V(r), e.next();
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return this.V(r), this.i;
        }
    };
    Yr.HashContainer = Ta;
});
var fp = O((Gn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Gn, "t", {
        value: !0
    });
    Gn.default = void 0;
    var cp = Ra(), hE = ot(), gr = class t extends cp.HashContainerIterator {
        constructor(e, r, i, n){
            super(e, r, n), this.container = i;
        }
        get pointer() {
            return this.o === this.h && (0, hE.throwIteratorAccessError)(), this.o.u;
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, Ca = class extends cp.HashContainer {
        constructor(e = []){
            super();
            let r = this;
            e.forEach(function(i) {
                r.insert(i);
            });
        }
        begin() {
            return new gr(this.p, this.h, this);
        }
        end() {
            return new gr(this.h, this.h, this);
        }
        rBegin() {
            return new gr(this._, this.h, this, 1);
        }
        rEnd() {
            return new gr(this.h, this.h, this, 1);
        }
        front() {
            return this.p.u;
        }
        back() {
            return this._.u;
        }
        insert(e, r) {
            return this.M(e, void 0, r);
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return r.u;
        }
        find(e, r) {
            let i = this.I(e, r);
            return new gr(i, this.h, this);
        }
        forEach(e) {
            let r = 0, i = this.p;
            for(; i !== this.h;)e(i.u, r++, this), i = i.B;
        }
        [Symbol.iterator]() {
            return (function*() {
                let e = this.p;
                for(; e !== this.h;)yield e.u, e = e.B;
            }).bind(this)();
        }
    }, dE = Ca;
    Gn.default = dE;
});
var dp = O((Qn)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Qn, "t", {
        value: !0
    });
    Qn.default = void 0;
    var hp = Ra(), pE = bE(Sa()), gE = ot();
    function bE(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var br = class t extends hp.HashContainerIterator {
        constructor(e, r, i, n){
            super(e, r, n), this.container = i;
        }
        get pointer() {
            this.o === this.h && (0, gE.throwIteratorAccessError)();
            let e = this;
            return new Proxy([], {
                get (r, i) {
                    if (i === "0") return e.o.u;
                    if (i === "1") return e.o.l;
                },
                set (r, i, n) {
                    if (i !== "1") throw new TypeError("props must be 1");
                    return e.o.l = n, !0;
                }
            });
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, Pa = class extends hp.HashContainer {
        constructor(e = []){
            super();
            let r = this;
            e.forEach(function(i) {
                r.setElement(i[0], i[1]);
            });
        }
        begin() {
            return new br(this.p, this.h, this);
        }
        end() {
            return new br(this.h, this.h, this);
        }
        rBegin() {
            return new br(this._, this.h, this, 1);
        }
        rEnd() {
            return new br(this.h, this.h, this, 1);
        }
        front() {
            if (this.i !== 0) return [
                this.p.u,
                this.p.l
            ];
        }
        back() {
            if (this.i !== 0) return [
                this._.u,
                this._.l
            ];
        }
        setElement(e, r, i) {
            return this.M(e, r, i);
        }
        getElementByKey(e, r) {
            if (r === void 0 && (r = (0, pE.default)(e)), r) {
                let n = e[this.HASH_TAG];
                return n !== void 0 ? this.H[n].l : void 0;
            }
            let i = this.g[e];
            return i ? i.l : void 0;
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return [
                r.u,
                r.l
            ];
        }
        find(e, r) {
            let i = this.I(e, r);
            return new br(i, this.h, this);
        }
        forEach(e) {
            let r = 0, i = this.p;
            for(; i !== this.h;)e([
                i.u,
                i.l
            ], r++, this), i = i.B;
        }
        [Symbol.iterator]() {
            return (function*() {
                let e = this.p;
                for(; e !== this.h;)yield [
                    e.u,
                    e.l
                ], e = e.B;
            }).bind(this)();
        }
    }, yE = Pa;
    Qn.default = yE;
});
var pp = O((Ne)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Ne, "t", {
        value: !0
    });
    Object.defineProperty(Ne, "Deque", {
        enumerable: !0,
        get: function() {
            return SE.default;
        }
    });
    Object.defineProperty(Ne, "HashMap", {
        enumerable: !0,
        get: function() {
            return RE.default;
        }
    });
    Object.defineProperty(Ne, "HashSet", {
        enumerable: !0,
        get: function() {
            return TE.default;
        }
    });
    Object.defineProperty(Ne, "LinkList", {
        enumerable: !0,
        get: function() {
            return EE.default;
        }
    });
    Object.defineProperty(Ne, "OrderedMap", {
        enumerable: !0,
        get: function() {
            return IE.default;
        }
    });
    Object.defineProperty(Ne, "OrderedSet", {
        enumerable: !0,
        get: function() {
            return AE.default;
        }
    });
    Object.defineProperty(Ne, "PriorityQueue", {
        enumerable: !0,
        get: function() {
            return mE.default;
        }
    });
    Object.defineProperty(Ne, "Queue", {
        enumerable: !0,
        get: function() {
            return _E.default;
        }
    });
    Object.defineProperty(Ne, "Stack", {
        enumerable: !0,
        get: function() {
            return wE.default;
        }
    });
    Object.defineProperty(Ne, "Vector", {
        enumerable: !0,
        get: function() {
            return vE.default;
        }
    });
    var wE = at(Yd()), _E = at(Jd()), mE = at(Xd()), vE = at(Zd()), EE = at(ep()), SE = at(tp()), AE = at(op()), IE = at(lp()), TE = at(fp()), RE = at(dp());
    function at(t) {
        return t && t.t ? t : {
            default: t
        };
    }
});
var bp = O((VU, gp)=>{
    "use strict";
    _();
    v();
    m();
    var CE = pp().OrderedSet, lt = nt()("number-allocator:trace"), PE = nt()("number-allocator:error");
    function Re(t, e) {
        this.low = t, this.high = e;
    }
    Re.prototype.equals = function(t) {
        return this.low === t.low && this.high === t.high;
    };
    Re.prototype.compare = function(t) {
        return this.low < t.low && this.high < t.low ? -1 : t.low < this.low && t.high < this.low ? 1 : 0;
    };
    function ut(t, e) {
        if (!(this instanceof ut)) return new ut(t, e);
        this.min = t, this.max = e, this.ss = new CE([], (r, i)=>r.compare(i)), lt("Create"), this.clear();
    }
    ut.prototype.firstVacant = function() {
        return this.ss.size() === 0 ? null : this.ss.front().low;
    };
    ut.prototype.alloc = function() {
        if (this.ss.size() === 0) return lt("alloc():empty"), null;
        let t = this.ss.begin(), e = t.pointer.low, r = t.pointer.high, i = e;
        return i + 1 <= r ? this.ss.updateKeyByIterator(t, new Re(e + 1, r)) : this.ss.eraseElementByPos(0), lt("alloc():" + i), i;
    };
    ut.prototype.use = function(t) {
        let e = new Re(t, t), r = this.ss.lowerBound(e);
        if (!r.equals(this.ss.end())) {
            let i = r.pointer.low, n = r.pointer.high;
            return r.pointer.equals(e) ? (this.ss.eraseElementByIterator(r), lt("use():" + t), !0) : i > t ? !1 : i === t ? (this.ss.updateKeyByIterator(r, new Re(i + 1, n)), lt("use():" + t), !0) : n === t ? (this.ss.updateKeyByIterator(r, new Re(i, n - 1)), lt("use():" + t), !0) : (this.ss.updateKeyByIterator(r, new Re(t + 1, n)), this.ss.insert(new Re(i, t - 1)), lt("use():" + t), !0);
        }
        return lt("use():failed"), !1;
    };
    ut.prototype.free = function(t) {
        if (t < this.min || t > this.max) {
            PE("free():" + t + " is out of range");
            return;
        }
        let e = new Re(t, t), r = this.ss.upperBound(e);
        if (r.equals(this.ss.end())) {
            if (r.equals(this.ss.begin())) {
                this.ss.insert(e);
                return;
            }
            r.pre();
            let i = r.pointer.high;
            r.pointer.high + 1 === t ? this.ss.updateKeyByIterator(r, new Re(i, t)) : this.ss.insert(e);
        } else if (r.equals(this.ss.begin())) {
            if (t + 1 === r.pointer.low) {
                let i = r.pointer.high;
                this.ss.updateKeyByIterator(r, new Re(t, i));
            } else this.ss.insert(e);
        } else {
            let i = r.pointer.low, n = r.pointer.high;
            r.pre();
            let o = r.pointer.low;
            r.pointer.high + 1 === t ? t + 1 === i ? (this.ss.eraseElementByIterator(r), this.ss.updateKeyByIterator(r, new Re(o, n))) : this.ss.updateKeyByIterator(r, new Re(o, t)) : t + 1 === i ? (this.ss.eraseElementByIterator(r.next()), this.ss.insert(new Re(t, n))) : this.ss.insert(e);
        }
        lt("free():" + t);
    };
    ut.prototype.clear = function() {
        lt("clear()"), this.ss.clear(), this.ss.insert(new Re(this.min, this.max));
    };
    ut.prototype.intervalCount = function() {
        return this.ss.size();
    };
    ut.prototype.dump = function() {
        console.log("length:" + this.ss.size());
        for (let t of this.ss)console.log(t);
    };
    gp.exports = ut;
});
var ka = O((tN, yp)=>{
    _();
    v();
    m();
    var kE = bp();
    yp.exports.NumberAllocator = kE;
});
var wp = O((xa)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(xa, "__esModule", {
        value: !0
    });
    var BE = Qd(), xE = ka(), Ba = class {
        constructor(e){
            e > 0 && (this.aliasToTopic = new BE.LRUCache({
                max: e
            }), this.topicToAlias = {}, this.numberAllocator = new xE.NumberAllocator(1, e), this.max = e, this.length = 0);
        }
        put(e, r) {
            if (r === 0 || r > this.max) return !1;
            let i = this.aliasToTopic.get(r);
            return i && delete this.topicToAlias[i], this.aliasToTopic.set(r, e), this.topicToAlias[e] = r, this.numberAllocator.use(r), this.length = this.aliasToTopic.size, !0;
        }
        getTopicByAlias(e) {
            return this.aliasToTopic.get(e);
        }
        getAliasByTopic(e) {
            let r = this.topicToAlias[e];
            return typeof r < "u" && this.aliasToTopic.get(r), r;
        }
        clear() {
            this.aliasToTopic.clear(), this.topicToAlias = {}, this.numberAllocator.clear(), this.length = 0;
        }
        getLruAlias() {
            let e = this.numberAllocator.firstVacant();
            return e || [
                ...this.aliasToTopic.keys()
            ][this.aliasToTopic.size - 1];
        }
    };
    xa.default = Ba;
});
var _p = O((Ii)=>{
    "use strict";
    _();
    v();
    m();
    var OE = Ii && Ii.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Ii, "__esModule", {
        value: !0
    });
    var ME = Si(), LE = OE(wp()), qE = cr(), UE = (t, e)=>{
        t.log("_handleConnack");
        let { options: r } = t, n = r.protocolVersion === 5 ? e.reasonCode : e.returnCode;
        if (clearTimeout(t.connackTimer), delete t.topicAliasSend, e.properties) {
            if (e.properties.topicAliasMaximum) {
                if (e.properties.topicAliasMaximum > 65535) {
                    t.emit("error", new Error("topicAliasMaximum from broker is out of range"));
                    return;
                }
                e.properties.topicAliasMaximum > 0 && (t.topicAliasSend = new LE.default(e.properties.topicAliasMaximum));
            }
            e.properties.serverKeepAlive && r.keepalive && (r.keepalive = e.properties.serverKeepAlive), e.properties.maximumPacketSize && (r.properties || (r.properties = {}), r.properties.maximumPacketSize = e.properties.maximumPacketSize);
        }
        if (n === 0) t.reconnecting = !1, t._onConnect(e);
        else if (n > 0) {
            let o = new qE.ErrorWithReasonCode(`Connection refused: ${ME.ReasonCodes[n]}`, n);
            t.emit("error", o), t.options.reconnectOnConnackError && t._cleanUp(!0);
        }
    };
    Ii.default = UE;
});
var mp = O((Oa)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Oa, "__esModule", {
        value: !0
    });
    var NE = (t, e, r)=>{
        t.log("handling pubrel packet");
        let i = typeof r < "u" ? r : t.noop, { messageId: n } = e, o = {
            cmd: "pubcomp",
            messageId: n
        };
        t.incomingStore.get(e, (s, a)=>{
            s ? t._sendPacket(o, i) : (t.emit("message", a.topic, a.payload, a), t.handleMessage(a, (u)=>{
                if (u) return i(u);
                t.incomingStore.del(a, t.noop), t._sendPacket(o, i);
            }));
        });
    };
    Oa.default = NE;
});
var vp = O((Ti)=>{
    "use strict";
    _();
    v();
    m();
    var Ri = Ti && Ti.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Ti, "__esModule", {
        value: !0
    });
    var DE = Ri(jd()), jE = Ri(Hd()), FE = Ri(_p()), WE = Ri(Si()), $E = Ri(mp()), HE = (t, e, r)=>{
        let { options: i } = t;
        if (i.protocolVersion === 5 && i.properties && i.properties.maximumPacketSize && i.properties.maximumPacketSize < e.length) return t.emit("error", new Error(`exceeding packets size ${e.cmd}`)), t.end({
            reasonCode: 149,
            properties: {
                reasonString: "Maximum packet size was exceeded"
            }
        }), t;
        switch(t.log("_handlePacket :: emitting packetreceive"), t.emit("packetreceive", e), e.cmd){
            case "publish":
                (0, DE.default)(t, e, r);
                break;
            case "puback":
            case "pubrec":
            case "pubcomp":
            case "suback":
            case "unsuback":
                t.reschedulePing(), (0, WE.default)(t, e), r();
                break;
            case "pubrel":
                t.reschedulePing(), (0, $E.default)(t, e, r);
                break;
            case "connack":
                (0, FE.default)(t, e), r();
                break;
            case "auth":
                t.reschedulePing(), (0, jE.default)(t, e), r();
                break;
            case "pingresp":
                t.log("_handlePacket :: received pingresp"), t.reschedulePing(!0), r();
                break;
            case "disconnect":
                t.emit("disconnect", e), r();
                break;
            default:
                t.log("_handlePacket :: unknown command"), r();
                break;
        }
    };
    Ti.default = HE;
});
var Ep = O((Jr)=>{
    "use strict";
    _();
    v();
    m();
    var VE = Jr && Jr.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Jr, "__esModule", {
        value: !0
    });
    Jr.TypedEventEmitter = void 0;
    var zE = VE((Ot(), Q(xt))), KE = cr(), Yn = class {
    };
    Jr.TypedEventEmitter = Yn;
    (0, KE.applyMixin)(Yn, zE.default);
});
var Ci = O((yr)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(yr, "__esModule", {
        value: !0
    });
    yr.isReactNativeBrowser = yr.isWebWorker = void 0;
    var GE = ()=>{
        var t;
        return typeof window < "u" ? typeof navigator < "u" && ((t = navigator.userAgent) === null || t === void 0 ? void 0 : t.toLowerCase().indexOf(" electron/")) > -1 && !(R === null || R === void 0) && R.versions ? !Object.prototype.hasOwnProperty.call(R.versions, "electron") : typeof window.document < "u" : !1;
    }, Sp = ()=>{
        var t, e;
        return !!(typeof self == "object" && !((e = (t = self?.constructor) === null || t === void 0 ? void 0 : t.name) === null || e === void 0) && e.includes("WorkerGlobalScope"));
    }, Ap = ()=>typeof navigator < "u" && navigator.product === "ReactNative", QE = GE() || Sp() || Ap();
    yr.isWebWorker = Sp();
    yr.isReactNativeBrowser = Ap();
    yr.default = QE;
});
var Tp = O((Jn, Ip)=>{
    _();
    v();
    m();
    (function(t, e) {
        typeof Jn == "object" && typeof Ip < "u" ? e(Jn) : typeof define == "function" && define.amd ? define([
            "exports"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
    })(Jn, function(t) {
        "use strict";
        var e = function(g) {
            return function(b) {
                var E = g(b);
                return b.add(E), E;
            };
        }, r = function(g) {
            return function(b, E) {
                return g.set(b, E), E;
            };
        }, i = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, n = 536870912, o = n * 2, s = function(g, b) {
            return function(E) {
                var w = b.get(E), S = w === void 0 ? E.size : w < o ? w + 1 : 0;
                if (!E.has(S)) return g(E, S);
                if (E.size < n) {
                    for(; E.has(S);)S = Math.floor(Math.random() * o);
                    return g(E, S);
                }
                if (E.size > i) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; E.has(S);)S = Math.floor(Math.random() * i);
                return g(E, S);
            };
        }, a = new WeakMap, u = r(a), f = s(u, a), d = e(f);
        t.addUniqueNumber = d, t.generateUniqueNumber = f;
    });
});
var Cp = O((Xn, Rp)=>{
    _();
    v();
    m();
    (function(t, e) {
        typeof Xn == "object" && typeof Rp < "u" ? e(Xn, Tp()) : typeof define == "function" && define.amd ? define([
            "exports",
            "fast-unique-numbers"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.workerTimersBroker = {}, t.fastUniqueNumbers));
    })(Xn, function(t, e) {
        "use strict";
        var r = function(s) {
            return s.method !== void 0 && s.method === "call";
        }, i = function(s) {
            return s.error === null && typeof s.id == "number";
        }, n = function(s) {
            var a = new Map([
                [
                    0,
                    function() {}
                ]
            ]), u = new Map([
                [
                    0,
                    function() {}
                ]
            ]), f = new Map, d = new Worker(s);
            d.addEventListener("message", function(w) {
                var S = w.data;
                if (r(S)) {
                    var I = S.params, P = I.timerId, C = I.timerType;
                    if (C === "interval") {
                        var M = a.get(P);
                        if (typeof M == "number") {
                            var q = f.get(M);
                            if (q === void 0 || q.timerId !== P || q.timerType !== C) throw new Error("The timer is in an undefined state.");
                        } else if (typeof M < "u") M();
                        else throw new Error("The timer is in an undefined state.");
                    } else if (C === "timeout") {
                        var z = u.get(P);
                        if (typeof z == "number") {
                            var j = f.get(z);
                            if (j === void 0 || j.timerId !== P || j.timerType !== C) throw new Error("The timer is in an undefined state.");
                        } else if (typeof z < "u") z(), u.delete(P);
                        else throw new Error("The timer is in an undefined state.");
                    }
                } else if (i(S)) {
                    var G = S.id, $ = f.get(G);
                    if ($ === void 0) throw new Error("The timer is in an undefined state.");
                    var te = $.timerId, pt = $.timerType;
                    f.delete(G), pt === "interval" ? a.delete(te) : u.delete(te);
                } else {
                    var Fe = S.error.message;
                    throw new Error(Fe);
                }
            });
            var h = function(S) {
                var I = e.generateUniqueNumber(f);
                f.set(I, {
                    timerId: S,
                    timerType: "interval"
                }), a.set(S, I), d.postMessage({
                    id: I,
                    method: "clear",
                    params: {
                        timerId: S,
                        timerType: "interval"
                    }
                });
            }, g = function(S) {
                var I = e.generateUniqueNumber(f);
                f.set(I, {
                    timerId: S,
                    timerType: "timeout"
                }), u.set(S, I), d.postMessage({
                    id: I,
                    method: "clear",
                    params: {
                        timerId: S,
                        timerType: "timeout"
                    }
                });
            }, b = function(S) {
                var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, P = e.generateUniqueNumber(a);
                return a.set(P, function() {
                    S(), typeof a.get(P) == "function" && d.postMessage({
                        id: null,
                        method: "set",
                        params: {
                            delay: I,
                            now: performance.now(),
                            timerId: P,
                            timerType: "interval"
                        }
                    });
                }), d.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: I,
                        now: performance.now(),
                        timerId: P,
                        timerType: "interval"
                    }
                }), P;
            }, E = function(S) {
                var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, P = e.generateUniqueNumber(u);
                return u.set(P, S), d.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: I,
                        now: performance.now(),
                        timerId: P,
                        timerType: "timeout"
                    }
                }), P;
            };
            return {
                clearInterval: h,
                clearTimeout: g,
                setInterval: b,
                setTimeout: E
            };
        };
        t.load = n;
    });
});
var kp = O((Zn, Pp)=>{
    _();
    v();
    m();
    (function(t, e) {
        typeof Zn == "object" && typeof Pp < "u" ? e(Zn, Cp()) : typeof define == "function" && define.amd ? define([
            "exports",
            "worker-timers-broker"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.workerTimers = {}, t.workerTimersBroker));
    })(Zn, function(t, e) {
        "use strict";
        var r = function(d, h) {
            var g = null;
            return function() {
                if (g !== null) return g;
                var b = new Blob([
                    h
                ], {
                    type: "application/javascript; charset=utf-8"
                }), E = URL.createObjectURL(b);
                return g = d(E), setTimeout(function() {
                    return URL.revokeObjectURL(E);
                }), g;
            };
        }, i = `(()=>{var e={472:(e,t,r)=>{var o,i;void 0===(i="function"==typeof(o=function(){"use strict";var e=new Map,t=new Map,r=function(t){var r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)},o=function(e){var r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)},i=function(e,t){var r,o=performance.now();return{expected:o+(r=e-Math.max(0,o-t)),remainingDelay:r}},n=function e(t,r,o,i){var n=performance.now();n>o?postMessage({id:null,method:"call",params:{timerId:r,timerType:i}}):t.set(r,setTimeout(e,o-n,t,r,o,i))},a=function(t,r,o){var a=i(t,o),s=a.expected,d=a.remainingDelay;e.set(r,setTimeout(n,d,e,r,s,"interval"))},s=function(e,r,o){var a=i(e,o),s=a.expected,d=a.remainingDelay;t.set(r,setTimeout(n,d,t,r,s,"timeout"))};addEventListener("message",(function(e){var t=e.data;try{if("clear"===t.method){var i=t.id,n=t.params,d=n.timerId,c=n.timerType;if("interval"===c)r(d),postMessage({error:null,id:i});else{if("timeout"!==c)throw new Error('The given type "'.concat(c,'" is not supported'));o(d),postMessage({error:null,id:i})}}else{if("set"!==t.method)throw new Error('The given method "'.concat(t.method,'" is not supported'));var u=t.params,l=u.delay,p=u.now,m=u.timerId,v=u.timerType;if("interval"===v)a(l,m,p);else{if("timeout"!==v)throw new Error('The given type "'.concat(v,'" is not supported'));s(l,m,p)}}}catch(e){postMessage({error:{message:e.message},id:t.id,result:null})}}))})?o.call(t,r,t,e):o)||(e.exports=i)}},t={};function r(o){var i=t[o];if(void 0!==i)return i.exports;var n=t[o]={exports:{}};return e[o](n,n.exports,r),n.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),(()=>{"use strict";r(472)})()})();`, n = r(e.load, i), o = function(d) {
            return n().clearInterval(d);
        }, s = function(d) {
            return n().clearTimeout(d);
        }, a = function() {
            var d;
            return (d = n()).setInterval.apply(d, arguments);
        }, u = function() {
            var d;
            return (d = n()).setTimeout.apply(d, arguments);
        };
        t.clearInterval = o, t.clearTimeout = s, t.setInterval = a, t.setTimeout = u;
    });
});
var Mp = O((St)=>{
    "use strict";
    _();
    v();
    m();
    var YE = St && St.__createBinding || (Object.create ? function(t, e, r, i) {
        i === void 0 && (i = r);
        var n = Object.getOwnPropertyDescriptor(e, r);
        (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, i, n);
    } : function(t, e, r, i) {
        i === void 0 && (i = r), t[i] = e[r];
    }), JE = St && St.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), XE = St && St.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var i = [];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (i[i.length] = n);
                return i;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var i = t(e), n = 0; n < i.length; n++)i[n] !== "default" && YE(r, e, i[n]);
            return JE(r, e), r;
        };
    }();
    Object.defineProperty(St, "__esModule", {
        value: !0
    });
    var Ma = XE(Ci()), Bp = kp(), xp = {
        set: Bp.setInterval,
        clear: Bp.clearInterval
    }, Op = {
        set: (t, e)=>setInterval(t, e),
        clear: (t)=>clearInterval(t)
    }, ZE = (t)=>{
        switch(t){
            case "native":
                return Op;
            case "worker":
                return xp;
            case "auto":
            default:
                return Ma.default && !Ma.isWebWorker && !Ma.isReactNativeBrowser ? xp : Op;
        }
    };
    St.default = ZE;
});
var qa = O((Pi)=>{
    "use strict";
    _();
    v();
    m();
    var e1 = Pi && Pi.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Pi, "__esModule", {
        value: !0
    });
    var t1 = e1(Mp()), La = class {
        get keepaliveTimeoutTimestamp() {
            return this._keepaliveTimeoutTimestamp;
        }
        get intervalEvery() {
            return this._intervalEvery;
        }
        get keepalive() {
            return this._keepalive;
        }
        constructor(e, r){
            this.destroyed = !1, this.client = e, this.timer = typeof r == "object" && "set" in r && "clear" in r ? r : (0, t1.default)(r), this.setKeepalive(e.options.keepalive);
        }
        clear() {
            this.timerId && (this.timer.clear(this.timerId), this.timerId = null);
        }
        setKeepalive(e) {
            if (e *= 1e3, isNaN(e) || e <= 0 || e > 2147483647) throw new Error(`Keepalive value must be an integer between 0 and 2147483647. Provided value is ${e}`);
            this._keepalive = e, this.reschedule(), this.client.log(`KeepaliveManager: set keepalive to ${e}ms`);
        }
        destroy() {
            this.clear(), this.destroyed = !0;
        }
        reschedule() {
            if (this.destroyed) return;
            this.clear(), this.counter = 0;
            let e = Math.ceil(this._keepalive * 1.5);
            this._keepaliveTimeoutTimestamp = Date.now() + e, this._intervalEvery = Math.ceil(this._keepalive / 2), this.timerId = this.timer.set(()=>{
                this.destroyed || (this.counter += 1, this.counter === 2 ? this.client.sendPing() : this.counter > 2 && this.client.onKeepaliveTimeout());
            }, this._intervalEvery);
        }
    };
    Pi.default = La;
});
var ts = O((Ge)=>{
    "use strict";
    _();
    v();
    m();
    var r1 = Ge && Ge.__createBinding || (Object.create ? function(t, e, r, i) {
        i === void 0 && (i = r);
        var n = Object.getOwnPropertyDescriptor(e, r);
        (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, i, n);
    } : function(t, e, r, i) {
        i === void 0 && (i = r), t[i] = e[r];
    }), i1 = Ge && Ge.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), Dp = Ge && Ge.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var i = [];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (i[i.length] = n);
                return i;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var i = t(e), n = 0; n < i.length; n++)i[n] !== "default" && r1(r, e, i[n]);
            return i1(r, e), r;
        };
    }(), Ht = Ge && Ge.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Ge, "__esModule", {
        value: !0
    });
    var n1 = Ht($u()), Ua = Ht(xd()), s1 = Ht(zo()), o1 = Nt(), Lp = Ht(qd()), qp = Dp(Nd()), a1 = Ht(nt()), Xr = Ht(Qo()), l1 = Ht(vp()), ki = cr(), u1 = Ep(), c1 = Ht(qa()), Up = Dp(Ci()), Na = globalThis.setImmediate || ((...t)=>{
        let e = t.shift();
        (0, ki.nextTick)(()=>{
            e(...t);
        });
    }), Np = {
        keepalive: 60,
        reschedulePings: !0,
        protocolId: "MQTT",
        protocolVersion: 4,
        reconnectPeriod: 1e3,
        connectTimeout: 30000,
        clean: !0,
        resubscribe: !0,
        subscribeBatchSize: null,
        writeCache: !0,
        timerVariant: "auto"
    }, es = class t extends u1.TypedEventEmitter {
        static defaultId() {
            return `mqttjs_${Math.random().toString(16).substr(2, 8)}`;
        }
        constructor(e, r){
            super(), this.options = r || {};
            for(let i in Np)typeof this.options[i] > "u" ? this.options[i] = Np[i] : this.options[i] = r[i];
            this.log = this.options.log || (0, a1.default)("mqttjs:client"), this.noop = this._noop.bind(this), this.log("MqttClient :: version:", t.VERSION), Up.isWebWorker ? this.log("MqttClient :: environment", "webworker") : this.log("MqttClient :: environment", Up.default ? "browser" : "node"), this.log("MqttClient :: options.protocol", r.protocol), this.log("MqttClient :: options.protocolVersion", r.protocolVersion), this.log("MqttClient :: options.username", r.username), this.log("MqttClient :: options.keepalive", r.keepalive), this.log("MqttClient :: options.reconnectPeriod", r.reconnectPeriod), this.log("MqttClient :: options.rejectUnauthorized", r.rejectUnauthorized), this.log("MqttClient :: options.properties.topicAliasMaximum", r.properties ? r.properties.topicAliasMaximum : void 0), this.options.clientId = typeof r.clientId == "string" ? r.clientId : t.defaultId(), this.log("MqttClient :: clientId", this.options.clientId), this.options.customHandleAcks = r.protocolVersion === 5 && r.customHandleAcks ? r.customHandleAcks : (...i)=>{
                i[3](null, 0);
            }, this.options.writeCache || (Ua.default.writeToStream.cacheNumbers = !1), this.streamBuilder = e, this.messageIdProvider = typeof this.options.messageIdProvider > "u" ? new s1.default : this.options.messageIdProvider, this.outgoingStore = r.outgoingStore || new Xr.default, this.incomingStore = r.incomingStore || new Xr.default, this.queueQoSZero = r.queueQoSZero === void 0 ? !0 : r.queueQoSZero, this._resubscribeTopics = {}, this.messageIdToTopic = {}, this.keepaliveManager = null, this.connected = !1, this.disconnecting = !1, this.reconnecting = !1, this.queue = [], this.connackTimer = null, this.reconnectTimer = null, this._storeProcessing = !1, this._packetIdsDuringStoreProcessing = {}, this._storeProcessingQueue = [], this.outgoing = {}, this._firstConnection = !0, r.properties && r.properties.topicAliasMaximum > 0 && (r.properties.topicAliasMaximum > 65535 ? this.log("MqttClient :: options.properties.topicAliasMaximum is out of range") : this.topicAliasRecv = new n1.default(r.properties.topicAliasMaximum)), this.on("connect", ()=>{
                let { queue: i } = this, n = ()=>{
                    let o = i.shift();
                    this.log("deliver :: entry %o", o);
                    let s = null;
                    if (!o) {
                        this._resubscribe();
                        return;
                    }
                    s = o.packet, this.log("deliver :: call _sendPacket for %o", s);
                    let a = !0;
                    s.messageId && s.messageId !== 0 && (this.messageIdProvider.register(s.messageId) || (a = !1)), a ? this._sendPacket(s, (u)=>{
                        o.cb && o.cb(u), n();
                    }) : (this.log("messageId: %d has already used. The message is skipped and removed.", s.messageId), n());
                };
                this.log("connect :: sending queued packets"), n();
            }), this.on("close", ()=>{
                this.log("close :: connected set to `false`"), this.connected = !1, this.log("close :: clearing connackTimer"), clearTimeout(this.connackTimer), this._destroyKeepaliveManager(), this.topicAliasRecv && this.topicAliasRecv.clear(), this.log("close :: calling _setupReconnect"), this._setupReconnect();
            }), this.options.manualConnect || (this.log("MqttClient :: setting up stream"), this.connect());
        }
        handleAuth(e, r) {
            r();
        }
        handleMessage(e, r) {
            r();
        }
        _nextId() {
            return this.messageIdProvider.allocate();
        }
        getLastMessageId() {
            return this.messageIdProvider.getLastAllocated();
        }
        connect() {
            var e;
            let r = new o1.Writable, i = Ua.default.parser(this.options), n = null, o = [];
            this.log("connect :: calling method to clear reconnect"), this._clearReconnect(), this.disconnected && !this.reconnecting && (this.incomingStore = this.options.incomingStore || new Xr.default, this.outgoingStore = this.options.outgoingStore || new Xr.default, this.disconnecting = !1, this.disconnected = !1), this.log("connect :: using streamBuilder provided to client to create stream"), this.stream = this.streamBuilder(this), i.on("packet", (d)=>{
                this.log("parser :: on packet push to packets array."), o.push(d);
            });
            let s = ()=>{
                this.log("work :: getting next packet in queue");
                let d = o.shift();
                if (d) this.log("work :: packet pulled from queue"), (0, l1.default)(this, d, a);
                else {
                    this.log("work :: no packets in queue");
                    let h = n;
                    n = null, this.log("work :: done flag is %s", !!h), h && h();
                }
            }, a = ()=>{
                if (o.length) (0, ki.nextTick)(s);
                else {
                    let d = n;
                    n = null, d();
                }
            };
            r._write = (d, h, g)=>{
                n = g, this.log("writable stream :: parsing buffer"), i.parse(d), s();
            };
            let u = (d)=>{
                this.log("streamErrorHandler :: error", d.message), d.code ? (this.log("streamErrorHandler :: emitting error"), this.emit("error", d)) : this.noop(d);
            };
            this.log("connect :: pipe stream to writable stream"), this.stream.pipe(r), this.stream.on("error", u), this.stream.on("close", ()=>{
                this.log("(%s)stream :: on close", this.options.clientId), this._flushVolatile(), this.log("stream: emit close to MqttClient"), this.emit("close");
            }), this.log("connect: sending packet `connect`");
            let f = {
                cmd: "connect",
                protocolId: this.options.protocolId,
                protocolVersion: this.options.protocolVersion,
                clean: this.options.clean,
                clientId: this.options.clientId,
                keepalive: this.options.keepalive,
                username: this.options.username,
                password: this.options.password,
                properties: this.options.properties
            };
            if (this.options.will && (f.will = Object.assign(Object.assign({}, this.options.will), {
                payload: (e = this.options.will) === null || e === void 0 ? void 0 : e.payload
            })), this.topicAliasRecv && (f.properties || (f.properties = {}), this.topicAliasRecv && (f.properties.topicAliasMaximum = this.topicAliasRecv.max)), this._writePacket(f), i.on("error", this.emit.bind(this, "error")), this.options.properties) {
                if (!this.options.properties.authenticationMethod && this.options.properties.authenticationData) return this.end(()=>this.emit("error", new Error("Packet has no Authentication Method"))), this;
                if (this.options.properties.authenticationMethod && this.options.authPacket && typeof this.options.authPacket == "object") {
                    let d = Object.assign({
                        cmd: "auth",
                        reasonCode: 0
                    }, this.options.authPacket);
                    this._writePacket(d);
                }
            }
            return this.stream.setMaxListeners(1e3), clearTimeout(this.connackTimer), this.connackTimer = setTimeout(()=>{
                this.log("!!connectTimeout hit!! Calling _cleanUp with force `true`"), this.emit("error", new Error("connack timeout")), this._cleanUp(!0);
            }, this.options.connectTimeout), this;
        }
        publish(e, r, i, n) {
            this.log("publish :: message `%s` to topic `%s`", r, e);
            let { options: o } = this;
            typeof i == "function" && (n = i, i = null), i = i || {}, i = Object.assign(Object.assign({}, {
                qos: 0,
                retain: !1,
                dup: !1
            }), i);
            let { qos: a, retain: u, dup: f, properties: d, cbStorePut: h } = i;
            if (this._checkDisconnecting(n)) return this;
            let g = ()=>{
                let b = 0;
                if ((a === 1 || a === 2) && (b = this._nextId(), b === null)) return this.log("No messageId left"), !1;
                let E = {
                    cmd: "publish",
                    topic: e,
                    payload: r,
                    qos: a,
                    retain: u,
                    messageId: b,
                    dup: f
                };
                switch(o.protocolVersion === 5 && (E.properties = d), this.log("publish :: qos", a), a){
                    case 1:
                    case 2:
                        this.outgoing[E.messageId] = {
                            volatile: !1,
                            cb: n || this.noop
                        }, this.log("MqttClient:publish: packet cmd: %s", E.cmd), this._sendPacket(E, void 0, h);
                        break;
                    default:
                        this.log("MqttClient:publish: packet cmd: %s", E.cmd), this._sendPacket(E, n, h);
                        break;
                }
                return !0;
            };
            return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !g()) && this._storeProcessingQueue.push({
                invoke: g,
                cbStorePut: i.cbStorePut,
                callback: n
            }), this;
        }
        publishAsync(e, r, i) {
            return new Promise((n, o)=>{
                this.publish(e, r, i, (s, a)=>{
                    s ? o(s) : n(a);
                });
            });
        }
        subscribe(e, r, i) {
            let n = this.options.protocolVersion;
            typeof r == "function" && (i = r), i = i || this.noop;
            let o = !1, s = [];
            typeof e == "string" ? (e = [
                e
            ], s = e) : Array.isArray(e) ? s = e : typeof e == "object" && (o = e.resubscribe, delete e.resubscribe, s = Object.keys(e));
            let a = qp.validateTopics(s);
            if (a !== null) return Na(i, new Error(`Invalid topic ${a}`)), this;
            if (this._checkDisconnecting(i)) return this.log("subscribe: discconecting true"), this;
            let u = {
                qos: 0
            };
            n === 5 && (u.nl = !1, u.rap = !1, u.rh = 0), r = Object.assign(Object.assign({}, u), r);
            let f = r.properties, d = [], h = (E, w)=>{
                if (w = w || r, !Object.prototype.hasOwnProperty.call(this._resubscribeTopics, E) || this._resubscribeTopics[E].qos < w.qos || o) {
                    let S = {
                        topic: E,
                        qos: w.qos
                    };
                    n === 5 && (S.nl = w.nl, S.rap = w.rap, S.rh = w.rh, S.properties = f), this.log("subscribe: pushing topic `%s` and qos `%s` to subs list", S.topic, S.qos), d.push(S);
                }
            };
            if (Array.isArray(e) ? e.forEach((E)=>{
                this.log("subscribe: array topic %s", E), h(E);
            }) : Object.keys(e).forEach((E)=>{
                this.log("subscribe: object topic %s, %o", E, e[E]), h(E, e[E]);
            }), !d.length) return i(null, []), this;
            let g = (E, w)=>{
                let S = {
                    cmd: "subscribe",
                    subscriptions: E,
                    messageId: w
                };
                if (f && (S.properties = f), this.options.resubscribe) {
                    this.log("subscribe :: resubscribe true");
                    let P = [];
                    E.forEach((C)=>{
                        if (this.options.reconnectPeriod > 0) {
                            let M = {
                                qos: C.qos
                            };
                            n === 5 && (M.nl = C.nl || !1, M.rap = C.rap || !1, M.rh = C.rh || 0, M.properties = C.properties), this._resubscribeTopics[C.topic] = M, P.push(C.topic);
                        }
                    }), this.messageIdToTopic[S.messageId] = P;
                }
                let I = new Promise((P, C)=>{
                    this.outgoing[S.messageId] = {
                        volatile: !0,
                        cb (M, q) {
                            if (!M) {
                                let { granted: z } = q;
                                for(let j = 0; j < z.length; j += 1)E[j].qos = z[j];
                            }
                            M ? C(new ki.ErrorWithSubackPacket(M.message, q)) : P(q);
                        }
                    };
                });
                return this.log("subscribe :: call _sendPacket"), this._sendPacket(S), I;
            }, b = ()=>{
                var E;
                let w = (E = this.options.subscribeBatchSize) !== null && E !== void 0 ? E : d.length, S = [];
                for(let I = 0; I < d.length; I += w){
                    let P = d.slice(I, I + w), C = this._nextId();
                    if (C === null) return this.log("No messageId left"), !1;
                    S.push(g(P, C));
                }
                return Promise.all(S).then((I)=>{
                    i(null, d, I.at(-1));
                }).catch((I)=>{
                    i(I, d, I.packet);
                }), !0;
            };
            return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !b()) && this._storeProcessingQueue.push({
                invoke: b,
                callback: i
            }), this;
        }
        subscribeAsync(e, r) {
            return new Promise((i, n)=>{
                this.subscribe(e, r, (o, s)=>{
                    o ? n(o) : i(s);
                });
            });
        }
        unsubscribe(e, r, i) {
            typeof e == "string" && (e = [
                e
            ]), typeof r == "function" && (i = r), i = i || this.noop;
            let n = qp.validateTopics(e);
            if (n !== null) return Na(i, new Error(`Invalid topic ${n}`)), this;
            if (this._checkDisconnecting(i)) return this;
            let o = ()=>{
                let s = this._nextId();
                if (s === null) return this.log("No messageId left"), !1;
                let a = {
                    cmd: "unsubscribe",
                    messageId: s,
                    unsubscriptions: []
                };
                return typeof e == "string" ? a.unsubscriptions = [
                    e
                ] : Array.isArray(e) && (a.unsubscriptions = e), this.options.resubscribe && a.unsubscriptions.forEach((u)=>{
                    delete this._resubscribeTopics[u];
                }), typeof r == "object" && r.properties && (a.properties = r.properties), this.outgoing[a.messageId] = {
                    volatile: !0,
                    cb: i
                }, this.log("unsubscribe: call _sendPacket"), this._sendPacket(a), !0;
            };
            return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !o()) && this._storeProcessingQueue.push({
                invoke: o,
                callback: i
            }), this;
        }
        unsubscribeAsync(e, r) {
            return new Promise((i, n)=>{
                this.unsubscribe(e, r, (o, s)=>{
                    o ? n(o) : i(s);
                });
            });
        }
        end(e, r, i) {
            this.log("end :: (%s)", this.options.clientId), (e == null || typeof e != "boolean") && (i = i || r, r = e, e = !1), typeof r != "object" && (i = i || r, r = null), this.log("end :: cb? %s", !!i), (!i || typeof i != "function") && (i = this.noop);
            let n = ()=>{
                this.log("end :: closeStores: closing incoming and outgoing stores"), this.disconnected = !0, this.incomingStore.close((s)=>{
                    this.outgoingStore.close((a)=>{
                        if (this.log("end :: closeStores: emitting end"), this.emit("end"), i) {
                            let u = s || a;
                            this.log("end :: closeStores: invoking callback with args"), i(u);
                        }
                    });
                }), this._deferredReconnect ? this._deferredReconnect() : (this.options.reconnectPeriod === 0 || this.options.manualConnect) && (this.disconnecting = !1);
            }, o = ()=>{
                this.log("end :: (%s) :: finish :: calling _cleanUp with force %s", this.options.clientId, e), this._cleanUp(e, ()=>{
                    this.log("end :: finish :: calling process.nextTick on closeStores"), (0, ki.nextTick)(n);
                }, r);
            };
            return this.disconnecting ? (i(), this) : (this._clearReconnect(), this.disconnecting = !0, !e && Object.keys(this.outgoing).length > 0 ? (this.log("end :: (%s) :: calling finish in 10ms once outgoing is empty", this.options.clientId), this.once("outgoingEmpty", setTimeout.bind(null, o, 10))) : (this.log("end :: (%s) :: immediately calling finish", this.options.clientId), o()), this);
        }
        endAsync(e, r) {
            return new Promise((i, n)=>{
                this.end(e, r, (o)=>{
                    o ? n(o) : i();
                });
            });
        }
        removeOutgoingMessage(e) {
            if (this.outgoing[e]) {
                let { cb: r } = this.outgoing[e];
                this._removeOutgoingAndStoreMessage(e, ()=>{
                    r(new Error("Message removed"));
                });
            }
            return this;
        }
        reconnect(e) {
            this.log("client reconnect");
            let r = ()=>{
                e ? (this.options.incomingStore = e.incomingStore, this.options.outgoingStore = e.outgoingStore) : (this.options.incomingStore = null, this.options.outgoingStore = null), this.incomingStore = this.options.incomingStore || new Xr.default, this.outgoingStore = this.options.outgoingStore || new Xr.default, this.disconnecting = !1, this.disconnected = !1, this._deferredReconnect = null, this._reconnect();
            };
            return this.disconnecting && !this.disconnected ? this._deferredReconnect = r : r(), this;
        }
        _flushVolatile() {
            this.outgoing && (this.log("_flushVolatile :: deleting volatile messages from the queue and setting their callbacks as error function"), Object.keys(this.outgoing).forEach((e)=>{
                this.outgoing[e].volatile && typeof this.outgoing[e].cb == "function" && (this.outgoing[e].cb(new Error("Connection closed")), delete this.outgoing[e]);
            }));
        }
        _flush() {
            this.outgoing && (this.log("_flush: queue exists? %b", !!this.outgoing), Object.keys(this.outgoing).forEach((e)=>{
                typeof this.outgoing[e].cb == "function" && (this.outgoing[e].cb(new Error("Connection closed")), delete this.outgoing[e]);
            }));
        }
        _removeTopicAliasAndRecoverTopicName(e) {
            let r;
            e.properties && (r = e.properties.topicAlias);
            let i = e.topic.toString();
            if (this.log("_removeTopicAliasAndRecoverTopicName :: alias %d, topic %o", r, i), i.length === 0) {
                if (typeof r > "u") return new Error("Unregistered Topic Alias");
                if (i = this.topicAliasSend.getTopicByAlias(r), typeof i > "u") return new Error("Unregistered Topic Alias");
                e.topic = i;
            }
            r && delete e.properties.topicAlias;
        }
        _checkDisconnecting(e) {
            return this.disconnecting && (e && e !== this.noop ? e(new Error("client disconnecting")) : this.emit("error", new Error("client disconnecting"))), this.disconnecting;
        }
        _reconnect() {
            this.log("_reconnect: emitting reconnect to client"), this.emit("reconnect"), this.connected ? (this.end(()=>{
                this.connect();
            }), this.log("client already connected. disconnecting first.")) : (this.log("_reconnect: calling connect"), this.connect());
        }
        _setupReconnect() {
            !this.disconnecting && !this.reconnectTimer && this.options.reconnectPeriod > 0 ? (this.reconnecting || (this.log("_setupReconnect :: emit `offline` state"), this.emit("offline"), this.log("_setupReconnect :: set `reconnecting` to `true`"), this.reconnecting = !0), this.log("_setupReconnect :: setting reconnectTimer for %d ms", this.options.reconnectPeriod), this.reconnectTimer = setInterval(()=>{
                this.log("reconnectTimer :: reconnect triggered!"), this._reconnect();
            }, this.options.reconnectPeriod)) : this.log("_setupReconnect :: doing nothing...");
        }
        _clearReconnect() {
            this.log("_clearReconnect : clearing reconnect timer"), this.reconnectTimer && (clearInterval(this.reconnectTimer), this.reconnectTimer = null);
        }
        _cleanUp(e, r, i = {}) {
            if (r && (this.log("_cleanUp :: done callback provided for on stream close"), this.stream.on("close", r)), this.log("_cleanUp :: forced? %s", e), e) this.options.reconnectPeriod === 0 && this.options.clean && this._flush(), this.log("_cleanUp :: (%s) :: destroying stream", this.options.clientId), this.stream.destroy();
            else {
                let n = Object.assign({
                    cmd: "disconnect"
                }, i);
                this.log("_cleanUp :: (%s) :: call _sendPacket with disconnect packet", this.options.clientId), this._sendPacket(n, ()=>{
                    this.log("_cleanUp :: (%s) :: destroying stream", this.options.clientId), Na(()=>{
                        this.stream.end(()=>{
                            this.log("_cleanUp :: (%s) :: stream destroyed", this.options.clientId);
                        });
                    });
                });
            }
            !this.disconnecting && !this.reconnecting && (this.log("_cleanUp :: client not disconnecting/reconnecting. Clearing and resetting reconnect."), this._clearReconnect(), this._setupReconnect()), this._destroyKeepaliveManager(), r && !this.connected && (this.log("_cleanUp :: (%s) :: removing stream `done` callback `close` listener", this.options.clientId), this.stream.removeListener("close", r), r());
        }
        _storeAndSend(e, r, i) {
            this.log("storeAndSend :: store packet with cmd %s to outgoingStore", e.cmd);
            let n = e, o;
            if (n.cmd === "publish" && (n = (0, Lp.default)(e), o = this._removeTopicAliasAndRecoverTopicName(n), o)) return r && r(o);
            this.outgoingStore.put(n, (s)=>{
                if (s) return r && r(s);
                i(), this._writePacket(e, r);
            });
        }
        _applyTopicAlias(e) {
            if (this.options.protocolVersion === 5 && e.cmd === "publish") {
                let r;
                e.properties && (r = e.properties.topicAlias);
                let i = e.topic.toString();
                if (this.topicAliasSend) {
                    if (r) {
                        if (i.length !== 0 && (this.log("applyTopicAlias :: register topic: %s - alias: %d", i, r), !this.topicAliasSend.put(i, r))) return this.log("applyTopicAlias :: error out of range. topic: %s - alias: %d", i, r), new Error("Sending Topic Alias out of range");
                    } else i.length !== 0 && (this.options.autoAssignTopicAlias ? (r = this.topicAliasSend.getAliasByTopic(i), r ? (e.topic = "", e.properties = Object.assign(Object.assign({}, e.properties), {
                        topicAlias: r
                    }), this.log("applyTopicAlias :: auto assign(use) topic: %s - alias: %d", i, r)) : (r = this.topicAliasSend.getLruAlias(), this.topicAliasSend.put(i, r), e.properties = Object.assign(Object.assign({}, e.properties), {
                        topicAlias: r
                    }), this.log("applyTopicAlias :: auto assign topic: %s - alias: %d", i, r))) : this.options.autoUseTopicAlias && (r = this.topicAliasSend.getAliasByTopic(i), r && (e.topic = "", e.properties = Object.assign(Object.assign({}, e.properties), {
                        topicAlias: r
                    }), this.log("applyTopicAlias :: auto use topic: %s - alias: %d", i, r))));
                } else if (r) return this.log("applyTopicAlias :: error out of range. topic: %s - alias: %d", i, r), new Error("Sending Topic Alias out of range");
            }
        }
        _noop(e) {
            this.log("noop ::", e);
        }
        _writePacket(e, r) {
            this.log("_writePacket :: packet: %O", e), this.log("_writePacket :: emitting `packetsend`"), this.emit("packetsend", e), this.log("_writePacket :: writing to stream");
            let i = Ua.default.writeToStream(e, this.stream, this.options);
            this.log("_writePacket :: writeToStream result %s", i), !i && r && r !== this.noop ? (this.log("_writePacket :: handle events on `drain` once through callback."), this.stream.once("drain", r)) : r && (this.log("_writePacket :: invoking cb"), r());
        }
        _sendPacket(e, r, i, n) {
            this.log("_sendPacket :: (%s) ::  start", this.options.clientId), i = i || this.noop, r = r || this.noop;
            let o = this._applyTopicAlias(e);
            if (o) {
                r(o);
                return;
            }
            if (!this.connected) {
                if (e.cmd === "auth") {
                    this._writePacket(e, r);
                    return;
                }
                this.log("_sendPacket :: client not connected. Storing packet offline."), this._storePacket(e, r, i);
                return;
            }
            if (n) {
                this._writePacket(e, r);
                return;
            }
            switch(e.cmd){
                case "publish":
                    break;
                case "pubrel":
                    this._storeAndSend(e, r, i);
                    return;
                default:
                    this._writePacket(e, r);
                    return;
            }
            switch(e.qos){
                case 2:
                case 1:
                    this._storeAndSend(e, r, i);
                    break;
                case 0:
                default:
                    this._writePacket(e, r);
                    break;
            }
            this.log("_sendPacket :: (%s) ::  end", this.options.clientId);
        }
        _storePacket(e, r, i) {
            this.log("_storePacket :: packet: %o", e), this.log("_storePacket :: cb? %s", !!r), i = i || this.noop;
            let n = e;
            if (n.cmd === "publish") {
                n = (0, Lp.default)(e);
                let s = this._removeTopicAliasAndRecoverTopicName(n);
                if (s) return r && r(s);
            }
            let o = n.qos || 0;
            o === 0 && this.queueQoSZero || n.cmd !== "publish" ? this.queue.push({
                packet: n,
                cb: r
            }) : o > 0 ? (r = this.outgoing[n.messageId] ? this.outgoing[n.messageId].cb : null, this.outgoingStore.put(n, (s)=>{
                if (s) return r && r(s);
                i();
            })) : r && r(new Error("No connection to broker"));
        }
        _setupKeepaliveManager() {
            this.log("_setupKeepaliveManager :: keepalive %d (seconds)", this.options.keepalive), !this.keepaliveManager && this.options.keepalive && (this.keepaliveManager = new c1.default(this, this.options.timerVariant));
        }
        _destroyKeepaliveManager() {
            this.keepaliveManager && (this.log("_destroyKeepaliveManager :: destroying keepalive manager"), this.keepaliveManager.destroy(), this.keepaliveManager = null);
        }
        reschedulePing(e = !1) {
            this.keepaliveManager && this.options.keepalive && (e || this.options.reschedulePings) && this._reschedulePing();
        }
        _reschedulePing() {
            this.log("_reschedulePing :: rescheduling ping"), this.keepaliveManager.reschedule();
        }
        sendPing() {
            this.log("_sendPing :: sending pingreq"), this._sendPacket({
                cmd: "pingreq"
            });
        }
        onKeepaliveTimeout() {
            this.emit("error", new Error("Keepalive timeout")), this.log("onKeepaliveTimeout :: calling _cleanUp with force true"), this._cleanUp(!0);
        }
        _resubscribe() {
            this.log("_resubscribe");
            let e = Object.keys(this._resubscribeTopics);
            if (!this._firstConnection && (this.options.clean || this.options.protocolVersion >= 4 && !this.connackPacket.sessionPresent) && e.length > 0) {
                if (this.options.resubscribe) {
                    if (this.options.protocolVersion === 5) {
                        this.log("_resubscribe: protocolVersion 5");
                        for(let r = 0; r < e.length; r++){
                            let i = {};
                            i[e[r]] = this._resubscribeTopics[e[r]], i.resubscribe = !0, this.subscribe(i, {
                                properties: i[e[r]].properties
                            });
                        }
                    } else this._resubscribeTopics.resubscribe = !0, this.subscribe(this._resubscribeTopics);
                } else this._resubscribeTopics = {};
            }
            this._firstConnection = !1;
        }
        _onConnect(e) {
            if (this.disconnected) {
                this.emit("connect", e);
                return;
            }
            this.connackPacket = e, this.messageIdProvider.clear(), this._setupKeepaliveManager(), this.connected = !0;
            let r = ()=>{
                let i = this.outgoingStore.createStream(), n = ()=>{
                    i.destroy(), i = null, this._flushStoreProcessingQueue(), o();
                }, o = ()=>{
                    this._storeProcessing = !1, this._packetIdsDuringStoreProcessing = {};
                };
                this.once("close", n), i.on("error", (a)=>{
                    o(), this._flushStoreProcessingQueue(), this.removeListener("close", n), this.emit("error", a);
                });
                let s = ()=>{
                    if (!i) return;
                    let a = i.read(1), u;
                    if (!a) {
                        i.once("readable", s);
                        return;
                    }
                    if (this._storeProcessing = !0, this._packetIdsDuringStoreProcessing[a.messageId]) {
                        s();
                        return;
                    }
                    !this.disconnecting && !this.reconnectTimer ? (u = this.outgoing[a.messageId] ? this.outgoing[a.messageId].cb : null, this.outgoing[a.messageId] = {
                        volatile: !1,
                        cb (f, d) {
                            u && u(f, d), s();
                        }
                    }, this._packetIdsDuringStoreProcessing[a.messageId] = !0, this.messageIdProvider.register(a.messageId) ? this._sendPacket(a, void 0, void 0, !0) : this.log("messageId: %d has already used.", a.messageId)) : i.destroy && i.destroy();
                };
                i.on("end", ()=>{
                    let a = !0;
                    for(let u in this._packetIdsDuringStoreProcessing)if (!this._packetIdsDuringStoreProcessing[u]) {
                        a = !1;
                        break;
                    }
                    this.removeListener("close", n), a ? (o(), this._invokeAllStoreProcessingQueue(), this.emit("connect", e)) : r();
                }), s();
            };
            r();
        }
        _invokeStoreProcessingQueue() {
            if (!this._storeProcessing && this._storeProcessingQueue.length > 0) {
                let e = this._storeProcessingQueue[0];
                if (e && e.invoke()) return this._storeProcessingQueue.shift(), !0;
            }
            return !1;
        }
        _invokeAllStoreProcessingQueue() {
            for(; this._invokeStoreProcessingQueue(););
        }
        _flushStoreProcessingQueue() {
            for (let e of this._storeProcessingQueue)e.cbStorePut && e.cbStorePut(new Error("Connection closed")), e.callback && e.callback(new Error("Connection closed"));
            this._storeProcessingQueue.splice(0);
        }
        _removeOutgoingAndStoreMessage(e, r) {
            delete this.outgoing[e], this.outgoingStore.del({
                messageId: e
            }, (i, n)=>{
                r(i, n), this.messageIdProvider.deallocate(e), this._invokeStoreProcessingQueue();
            });
        }
    };
    es.VERSION = ki.MQTTJS_VERSION;
    Ge.default = es;
});
var jp = O((ja)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(ja, "__esModule", {
        value: !0
    });
    var f1 = ka(), Da = class {
        constructor(){
            this.numberAllocator = new f1.NumberAllocator(1, 65535);
        }
        allocate() {
            return this.lastId = this.numberAllocator.alloc(), this.lastId;
        }
        getLastAllocated() {
            return this.lastId;
        }
        register(e) {
            return this.numberAllocator.use(e);
        }
        deallocate(e) {
            this.numberAllocator.free(e);
        }
        clear() {
            this.numberAllocator.clear();
        }
    };
    ja.default = Da;
});
function wr(t) {
    throw new RangeError(g1[t]);
}
function Fp(t, e) {
    let r = t.split("@"), i = "";
    r.length > 1 && (i = r[0] + "@", t = r[1]);
    let n = (function(o, s) {
        let a = [], u = o.length;
        for(; u--;)a[u] = s(o[u]);
        return a;
    })((t = t.replace(p1, ".")).split("."), e).join(".");
    return i + n;
}
function Vp(t) {
    let e = [], r = 0, i = t.length;
    for(; r < i;){
        let n = t.charCodeAt(r++);
        if (n >= 55296 && n <= 56319 && r < i) {
            let o = t.charCodeAt(r++);
            (64512 & o) == 56320 ? e.push(((1023 & n) << 10) + (1023 & o) + 65536) : (e.push(n), r--);
        } else e.push(n);
    }
    return e;
}
var h1, d1, p1, g1, ct, Fa, Wp, zp, $p, Hp, Vt, Kp = Ae(()=>{
    _();
    v();
    m();
    h1 = /^xn--/, d1 = /[^\0-\x7E]/, p1 = /[\x2E\u3002\uFF0E\uFF61]/g, g1 = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, ct = Math.floor, Fa = String.fromCharCode;
    Wp = function(t, e) {
        return t + 22 + 75 * (t < 26) - ((e != 0) << 5);
    }, zp = function(t, e, r) {
        let i = 0;
        for(t = r ? ct(t / 700) : t >> 1, t += ct(t / e); t > 455; i += 36)t = ct(t / 35);
        return ct(i + 36 * t / (t + 38));
    }, $p = function(t) {
        let e = [], r = t.length, i = 0, n = 128, o = 72, s = t.lastIndexOf("-");
        s < 0 && (s = 0);
        for(let u = 0; u < s; ++u)t.charCodeAt(u) >= 128 && wr("not-basic"), e.push(t.charCodeAt(u));
        for(let u = s > 0 ? s + 1 : 0; u < r;){
            let f = i;
            for(let h = 1, g = 36;; g += 36){
                u >= r && wr("invalid-input");
                let b = (a = t.charCodeAt(u++)) - 48 < 10 ? a - 22 : a - 65 < 26 ? a - 65 : a - 97 < 26 ? a - 97 : 36;
                (b >= 36 || b > ct((2147483647 - i) / h)) && wr("overflow"), i += b * h;
                let E = g <= o ? 1 : g >= o + 26 ? 26 : g - o;
                if (b < E) break;
                let w = 36 - E;
                h > ct(2147483647 / w) && wr("overflow"), h *= w;
            }
            let d = e.length + 1;
            o = zp(i - f, d, f == 0), ct(i / d) > 2147483647 - n && wr("overflow"), n += ct(i / d), i %= d, e.splice(i++, 0, n);
        }
        var a;
        return String.fromCodePoint(...e);
    }, Hp = function(t) {
        let e = [], r = (t = Vp(t)).length, i = 128, n = 0, o = 72;
        for (let u of t)u < 128 && e.push(Fa(u));
        let s = e.length, a = s;
        for(s && e.push("-"); a < r;){
            let u = 2147483647;
            for (let d of t)d >= i && d < u && (u = d);
            let f = a + 1;
            u - i > ct((2147483647 - n) / f) && wr("overflow"), n += (u - i) * f, i = u;
            for (let d of t)if (d < i && ++n > 2147483647 && wr("overflow"), d == i) {
                let h = n;
                for(let g = 36;; g += 36){
                    let b = g <= o ? 1 : g >= o + 26 ? 26 : g - o;
                    if (h < b) break;
                    let E = h - b, w = 36 - b;
                    e.push(Fa(Wp(b + E % w, 0))), h = ct(E / w);
                }
                e.push(Fa(Wp(h, 0))), o = zp(n, f, a == s), n = 0, ++a;
            }
            ++n, ++i;
        }
        return e.join("");
    }, Vt = {
        version: "2.1.0",
        ucs2: {
            decode: Vp,
            encode: (t)=>String.fromCodePoint(...t)
        },
        decode: $p,
        encode: Hp,
        toASCII: function(t) {
            return Fp(t, function(e) {
                return d1.test(e) ? "xn--" + Hp(e) : e;
            });
        },
        toUnicode: function(t) {
            return Fp(t, function(e) {
                return h1.test(e) ? $p(e.slice(4).toLowerCase()) : e;
            });
        }
    };
    Vt.decode;
    Vt.encode;
    Vt.toASCII;
    Vt.toUnicode;
    Vt.ucs2;
    Vt.version;
});
function b1(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
}
var y1, Bi, w1, ft, Gp = Ae(()=>{
    _();
    v();
    m();
    y1 = function(t, e, r, i) {
        e = e || "&", r = r || "=";
        var n = {};
        if (typeof t != "string" || t.length === 0) return n;
        var o = /\+/g;
        t = t.split(e);
        var s = 1e3;
        i && typeof i.maxKeys == "number" && (s = i.maxKeys);
        var a = t.length;
        s > 0 && a > s && (a = s);
        for(var u = 0; u < a; ++u){
            var f, d, h, g, b = t[u].replace(o, "%20"), E = b.indexOf(r);
            E >= 0 ? (f = b.substr(0, E), d = b.substr(E + 1)) : (f = b, d = ""), h = decodeURIComponent(f), g = decodeURIComponent(d), b1(n, h) ? Array.isArray(n[h]) ? n[h].push(g) : n[h] = [
                n[h],
                g
            ] : n[h] = g;
        }
        return n;
    }, Bi = function(t) {
        switch(typeof t){
            case "string":
                return t;
            case "boolean":
                return t ? "true" : "false";
            case "number":
                return isFinite(t) ? t : "";
            default:
                return "";
        }
    }, w1 = function(t, e, r, i) {
        return e = e || "&", r = r || "=", t === null && (t = void 0), typeof t == "object" ? Object.keys(t).map(function(n) {
            var o = encodeURIComponent(Bi(n)) + r;
            return Array.isArray(t[n]) ? t[n].map(function(s) {
                return o + encodeURIComponent(Bi(s));
            }).join(e) : o + encodeURIComponent(Bi(t[n]));
        }).join(e) : i ? encodeURIComponent(Bi(i)) + r + encodeURIComponent(Bi(t)) : "";
    }, ft = {};
    ft.decode = ft.parse = y1, ft.encode = ft.stringify = w1;
    ft.decode;
    ft.encode;
    ft.parse;
    ft.stringify;
});
function Wa() {
    throw new Error("setTimeout has not been defined");
}
function $a() {
    throw new Error("clearTimeout has not been defined");
}
function Jp(t) {
    if (It === setTimeout) return setTimeout(t, 0);
    if ((It === Wa || !It) && setTimeout) return It = setTimeout, setTimeout(t, 0);
    try {
        return It(t, 0);
    } catch  {
        try {
            return It.call(null, t, 0);
        } catch  {
            return It.call(this || ei, t, 0);
        }
    }
}
function _1() {
    Zr && _r && (Zr = !1, _r.length ? Rt = _r.concat(Rt) : rs = -1, Rt.length && Xp());
}
function Xp() {
    if (!Zr) {
        var t = Jp(_1);
        Zr = !0;
        for(var e = Rt.length; e;){
            for(_r = Rt, Rt = []; ++rs < e;)_r && _r[rs].run();
            rs = -1, e = Rt.length;
        }
        _r = null, Zr = !1, function(r) {
            if (Tt === clearTimeout) return clearTimeout(r);
            if ((Tt === $a || !Tt) && clearTimeout) return Tt = clearTimeout, clearTimeout(r);
            try {
                Tt(r);
            } catch  {
                try {
                    return Tt.call(null, r);
                } catch  {
                    return Tt.call(this || ei, r);
                }
            }
        }(t);
    }
}
function Qp(t, e) {
    (this || ei).fun = t, (this || ei).array = e;
}
function At() {}
var Yp, It, Tt, ei, fe, _r, Rt, Zr, rs, oe, Zp = Ae(()=>{
    _();
    v();
    m();
    ei = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : global, fe = Yp = {};
    (function() {
        try {
            It = typeof setTimeout == "function" ? setTimeout : Wa;
        } catch  {
            It = Wa;
        }
        try {
            Tt = typeof clearTimeout == "function" ? clearTimeout : $a;
        } catch  {
            Tt = $a;
        }
    })();
    Rt = [], Zr = !1, rs = -1;
    fe.nextTick = function(t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        Rt.push(new Qp(t, e)), Rt.length !== 1 || Zr || Jp(Xp);
    }, Qp.prototype.run = function() {
        (this || ei).fun.apply(null, (this || ei).array);
    }, fe.title = "browser", fe.browser = !0, fe.env = {}, fe.argv = [], fe.version = "", fe.versions = {}, fe.on = At, fe.addListener = At, fe.once = At, fe.off = At, fe.removeListener = At, fe.removeAllListeners = At, fe.emit = At, fe.prependListener = At, fe.prependOnceListener = At, fe.listeners = function(t) {
        return [];
    }, fe.binding = function(t) {
        throw new Error("process.binding is not supported");
    }, fe.cwd = function() {
        return "/";
    }, fe.chdir = function(t) {
        throw new Error("process.chdir is not supported");
    }, fe.umask = function() {
        return 0;
    };
    oe = Yp;
    oe.addListener;
    oe.argv;
    oe.binding;
    oe.browser;
    oe.chdir;
    oe.cwd;
    oe.emit;
    oe.env;
    oe.listeners;
    oe.nextTick;
    oe.off;
    oe.on;
    oe.once;
    oe.prependListener;
    oe.prependOnceListener;
    oe.removeAllListeners;
    oe.removeListener;
    oe.title;
    oe.umask;
    oe.version;
    oe.versions;
});
function m1() {
    if (eg) return Ha;
    eg = !0;
    var t = Ha = {}, e, r;
    function i() {
        throw new Error("setTimeout has not been defined");
    }
    function n() {
        throw new Error("clearTimeout has not been defined");
    }
    (function() {
        try {
            typeof setTimeout == "function" ? e = setTimeout : e = i;
        } catch  {
            e = i;
        }
        try {
            typeof clearTimeout == "function" ? r = clearTimeout : r = n;
        } catch  {
            r = n;
        }
    })();
    function o(w) {
        if (e === setTimeout) return setTimeout(w, 0);
        if ((e === i || !e) && setTimeout) return e = setTimeout, setTimeout(w, 0);
        try {
            return e(w, 0);
        } catch  {
            try {
                return e.call(null, w, 0);
            } catch  {
                return e.call(this || ti, w, 0);
            }
        }
    }
    function s(w) {
        if (r === clearTimeout) return clearTimeout(w);
        if ((r === n || !r) && clearTimeout) return r = clearTimeout, clearTimeout(w);
        try {
            return r(w);
        } catch  {
            try {
                return r.call(null, w);
            } catch  {
                return r.call(this || ti, w);
            }
        }
    }
    var a = [], u = !1, f, d = -1;
    function h() {
        !u || !f || (u = !1, f.length ? a = f.concat(a) : d = -1, a.length && g());
    }
    function g() {
        if (!u) {
            var w = o(h);
            u = !0;
            for(var S = a.length; S;){
                for(f = a, a = []; ++d < S;)f && f[d].run();
                d = -1, S = a.length;
            }
            f = null, u = !1, s(w);
        }
    }
    t.nextTick = function(w) {
        var S = new Array(arguments.length - 1);
        if (arguments.length > 1) for(var I = 1; I < arguments.length; I++)S[I - 1] = arguments[I];
        a.push(new b(w, S)), a.length === 1 && !u && o(g);
    };
    function b(w, S) {
        (this || ti).fun = w, (this || ti).array = S;
    }
    b.prototype.run = function() {
        (this || ti).fun.apply(null, (this || ti).array);
    }, t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.version = "", t.versions = {};
    function E() {}
    return t.on = E, t.addListener = E, t.once = E, t.off = E, t.removeListener = E, t.removeAllListeners = E, t.emit = E, t.prependListener = E, t.prependOnceListener = E, t.listeners = function(w) {
        return [];
    }, t.binding = function(w) {
        throw new Error("process.binding is not supported");
    }, t.cwd = function() {
        return "/";
    }, t.chdir = function(w) {
        throw new Error("process.chdir is not supported");
    }, t.umask = function() {
        return 0;
    }, Ha;
}
var Ha, eg, ti, ne, Va = Ae(()=>{
    _();
    v();
    m();
    Ha = {}, eg = !1, ti = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : global;
    ne = m1();
    ne.platform = "browser";
    ne.addListener;
    ne.argv;
    ne.binding;
    ne.browser;
    ne.chdir;
    ne.cwd;
    ne.emit;
    ne.env;
    ne.listeners;
    ne.nextTick;
    ne.off;
    ne.on;
    ne.once;
    ne.prependListener;
    ne.prependOnceListener;
    ne.removeAllListeners;
    ne.removeListener;
    ne.title;
    ne.umask;
    ne.version;
    ne.versions;
});
function v1() {
    if (tg) return za;
    tg = !0;
    var t = ne;
    function e(o) {
        if (typeof o != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(o));
    }
    function r(o, s) {
        for(var a = "", u = 0, f = -1, d = 0, h, g = 0; g <= o.length; ++g){
            if (g < o.length) h = o.charCodeAt(g);
            else {
                if (h === 47) break;
                h = 47;
            }
            if (h === 47) {
                if (!(f === g - 1 || d === 1)) {
                    if (f !== g - 1 && d === 2) {
                        if (a.length < 2 || u !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
                            if (a.length > 2) {
                                var b = a.lastIndexOf("/");
                                if (b !== a.length - 1) {
                                    b === -1 ? (a = "", u = 0) : (a = a.slice(0, b), u = a.length - 1 - a.lastIndexOf("/")), f = g, d = 0;
                                    continue;
                                }
                            } else if (a.length === 2 || a.length === 1) {
                                a = "", u = 0, f = g, d = 0;
                                continue;
                            }
                        }
                        s && (a.length > 0 ? a += "/.." : a = "..", u = 2);
                    } else a.length > 0 ? a += "/" + o.slice(f + 1, g) : a = o.slice(f + 1, g), u = g - f - 1;
                }
                f = g, d = 0;
            } else h === 46 && d !== -1 ? ++d : d = -1;
        }
        return a;
    }
    function i(o, s) {
        var a = s.dir || s.root, u = s.base || (s.name || "") + (s.ext || "");
        return a ? a === s.root ? a + u : a + o + u : u;
    }
    var n = {
        resolve: function() {
            for(var s = "", a = !1, u, f = arguments.length - 1; f >= -1 && !a; f--){
                var d;
                f >= 0 ? d = arguments[f] : (u === void 0 && (u = t.cwd()), d = u), e(d), d.length !== 0 && (s = d + "/" + s, a = d.charCodeAt(0) === 47);
            }
            return s = r(s, !a), a ? s.length > 0 ? "/" + s : "/" : s.length > 0 ? s : ".";
        },
        normalize: function(s) {
            if (e(s), s.length === 0) return ".";
            var a = s.charCodeAt(0) === 47, u = s.charCodeAt(s.length - 1) === 47;
            return s = r(s, !a), s.length === 0 && !a && (s = "."), s.length > 0 && u && (s += "/"), a ? "/" + s : s;
        },
        isAbsolute: function(s) {
            return e(s), s.length > 0 && s.charCodeAt(0) === 47;
        },
        join: function() {
            if (arguments.length === 0) return ".";
            for(var s, a = 0; a < arguments.length; ++a){
                var u = arguments[a];
                e(u), u.length > 0 && (s === void 0 ? s = u : s += "/" + u);
            }
            return s === void 0 ? "." : n.normalize(s);
        },
        relative: function(s, a) {
            if (e(s), e(a), s === a || (s = n.resolve(s), a = n.resolve(a), s === a)) return "";
            for(var u = 1; u < s.length && s.charCodeAt(u) === 47; ++u);
            for(var f = s.length, d = f - u, h = 1; h < a.length && a.charCodeAt(h) === 47; ++h);
            for(var g = a.length, b = g - h, E = d < b ? d : b, w = -1, S = 0; S <= E; ++S){
                if (S === E) {
                    if (b > E) {
                        if (a.charCodeAt(h + S) === 47) return a.slice(h + S + 1);
                        if (S === 0) return a.slice(h + S);
                    } else d > E && (s.charCodeAt(u + S) === 47 ? w = S : S === 0 && (w = 0));
                    break;
                }
                var I = s.charCodeAt(u + S), P = a.charCodeAt(h + S);
                if (I !== P) break;
                I === 47 && (w = S);
            }
            var C = "";
            for(S = u + w + 1; S <= f; ++S)(S === f || s.charCodeAt(S) === 47) && (C.length === 0 ? C += ".." : C += "/..");
            return C.length > 0 ? C + a.slice(h + w) : (h += w, a.charCodeAt(h) === 47 && ++h, a.slice(h));
        },
        _makeLong: function(s) {
            return s;
        },
        dirname: function(s) {
            if (e(s), s.length === 0) return ".";
            for(var a = s.charCodeAt(0), u = a === 47, f = -1, d = !0, h = s.length - 1; h >= 1; --h)if (a = s.charCodeAt(h), a === 47) {
                if (!d) {
                    f = h;
                    break;
                }
            } else d = !1;
            return f === -1 ? u ? "/" : "." : u && f === 1 ? "//" : s.slice(0, f);
        },
        basename: function(s, a) {
            if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
            e(s);
            var u = 0, f = -1, d = !0, h;
            if (a !== void 0 && a.length > 0 && a.length <= s.length) {
                if (a.length === s.length && a === s) return "";
                var g = a.length - 1, b = -1;
                for(h = s.length - 1; h >= 0; --h){
                    var E = s.charCodeAt(h);
                    if (E === 47) {
                        if (!d) {
                            u = h + 1;
                            break;
                        }
                    } else b === -1 && (d = !1, b = h + 1), g >= 0 && (E === a.charCodeAt(g) ? --g === -1 && (f = h) : (g = -1, f = b));
                }
                return u === f ? f = b : f === -1 && (f = s.length), s.slice(u, f);
            } else {
                for(h = s.length - 1; h >= 0; --h)if (s.charCodeAt(h) === 47) {
                    if (!d) {
                        u = h + 1;
                        break;
                    }
                } else f === -1 && (d = !1, f = h + 1);
                return f === -1 ? "" : s.slice(u, f);
            }
        },
        extname: function(s) {
            e(s);
            for(var a = -1, u = 0, f = -1, d = !0, h = 0, g = s.length - 1; g >= 0; --g){
                var b = s.charCodeAt(g);
                if (b === 47) {
                    if (!d) {
                        u = g + 1;
                        break;
                    }
                    continue;
                }
                f === -1 && (d = !1, f = g + 1), b === 46 ? a === -1 ? a = g : h !== 1 && (h = 1) : a !== -1 && (h = -1);
            }
            return a === -1 || f === -1 || h === 0 || h === 1 && a === f - 1 && a === u + 1 ? "" : s.slice(a, f);
        },
        format: function(s) {
            if (s === null || typeof s != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof s);
            return i("/", s);
        },
        parse: function(s) {
            e(s);
            var a = {
                root: "",
                dir: "",
                base: "",
                ext: "",
                name: ""
            };
            if (s.length === 0) return a;
            var u = s.charCodeAt(0), f = u === 47, d;
            f ? (a.root = "/", d = 1) : d = 0;
            for(var h = -1, g = 0, b = -1, E = !0, w = s.length - 1, S = 0; w >= d; --w){
                if (u = s.charCodeAt(w), u === 47) {
                    if (!E) {
                        g = w + 1;
                        break;
                    }
                    continue;
                }
                b === -1 && (E = !1, b = w + 1), u === 46 ? h === -1 ? h = w : S !== 1 && (S = 1) : h !== -1 && (S = -1);
            }
            return h === -1 || b === -1 || S === 0 || S === 1 && h === b - 1 && h === g + 1 ? b !== -1 && (g === 0 && f ? a.base = a.name = s.slice(1, b) : a.base = a.name = s.slice(g, b)) : (g === 0 && f ? (a.name = s.slice(1, h), a.base = s.slice(1, b)) : (a.name = s.slice(g, h), a.base = s.slice(g, b)), a.ext = s.slice(h, b)), g > 0 ? a.dir = s.slice(0, g - 1) : f && (a.dir = "/"), a;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
    };
    return n.posix = n, za = n, za;
}
var za, tg, Ka, rg = Ae(()=>{
    _();
    v();
    m();
    Va();
    za = {}, tg = !1;
    Ka = v1();
});
var cg = {};
Ir(cg, {
    URL: ()=>J1,
    Url: ()=>z1,
    default: ()=>X,
    fileURLToPath: ()=>lg,
    format: ()=>K1,
    parse: ()=>Y1,
    pathToFileURL: ()=>ug,
    resolve: ()=>G1,
    resolveObject: ()=>Q1
});
function De() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
function xi(t, e, r) {
    if (t && ht.isObject(t) && t instanceof De) return t;
    var i = new De;
    return i.parse(t, e, r), i;
}
function P1() {
    if (og) return Ya;
    og = !0;
    var t = oe;
    function e(o) {
        if (typeof o != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(o));
    }
    function r(o, s) {
        for(var a = "", u = 0, f = -1, d = 0, h, g = 0; g <= o.length; ++g){
            if (g < o.length) h = o.charCodeAt(g);
            else {
                if (h === 47) break;
                h = 47;
            }
            if (h === 47) {
                if (!(f === g - 1 || d === 1)) {
                    if (f !== g - 1 && d === 2) {
                        if (a.length < 2 || u !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
                            if (a.length > 2) {
                                var b = a.lastIndexOf("/");
                                if (b !== a.length - 1) {
                                    b === -1 ? (a = "", u = 0) : (a = a.slice(0, b), u = a.length - 1 - a.lastIndexOf("/")), f = g, d = 0;
                                    continue;
                                }
                            } else if (a.length === 2 || a.length === 1) {
                                a = "", u = 0, f = g, d = 0;
                                continue;
                            }
                        }
                        s && (a.length > 0 ? a += "/.." : a = "..", u = 2);
                    } else a.length > 0 ? a += "/" + o.slice(f + 1, g) : a = o.slice(f + 1, g), u = g - f - 1;
                }
                f = g, d = 0;
            } else h === 46 && d !== -1 ? ++d : d = -1;
        }
        return a;
    }
    function i(o, s) {
        var a = s.dir || s.root, u = s.base || (s.name || "") + (s.ext || "");
        return a ? a === s.root ? a + u : a + o + u : u;
    }
    var n = {
        resolve: function() {
            for(var s = "", a = !1, u, f = arguments.length - 1; f >= -1 && !a; f--){
                var d;
                f >= 0 ? d = arguments[f] : (u === void 0 && (u = t.cwd()), d = u), e(d), d.length !== 0 && (s = d + "/" + s, a = d.charCodeAt(0) === 47);
            }
            return s = r(s, !a), a ? s.length > 0 ? "/" + s : "/" : s.length > 0 ? s : ".";
        },
        normalize: function(s) {
            if (e(s), s.length === 0) return ".";
            var a = s.charCodeAt(0) === 47, u = s.charCodeAt(s.length - 1) === 47;
            return s = r(s, !a), s.length === 0 && !a && (s = "."), s.length > 0 && u && (s += "/"), a ? "/" + s : s;
        },
        isAbsolute: function(s) {
            return e(s), s.length > 0 && s.charCodeAt(0) === 47;
        },
        join: function() {
            if (arguments.length === 0) return ".";
            for(var s, a = 0; a < arguments.length; ++a){
                var u = arguments[a];
                e(u), u.length > 0 && (s === void 0 ? s = u : s += "/" + u);
            }
            return s === void 0 ? "." : n.normalize(s);
        },
        relative: function(s, a) {
            if (e(s), e(a), s === a || (s = n.resolve(s), a = n.resolve(a), s === a)) return "";
            for(var u = 1; u < s.length && s.charCodeAt(u) === 47; ++u);
            for(var f = s.length, d = f - u, h = 1; h < a.length && a.charCodeAt(h) === 47; ++h);
            for(var g = a.length, b = g - h, E = d < b ? d : b, w = -1, S = 0; S <= E; ++S){
                if (S === E) {
                    if (b > E) {
                        if (a.charCodeAt(h + S) === 47) return a.slice(h + S + 1);
                        if (S === 0) return a.slice(h + S);
                    } else d > E && (s.charCodeAt(u + S) === 47 ? w = S : S === 0 && (w = 0));
                    break;
                }
                var I = s.charCodeAt(u + S), P = a.charCodeAt(h + S);
                if (I !== P) break;
                I === 47 && (w = S);
            }
            var C = "";
            for(S = u + w + 1; S <= f; ++S)(S === f || s.charCodeAt(S) === 47) && (C.length === 0 ? C += ".." : C += "/..");
            return C.length > 0 ? C + a.slice(h + w) : (h += w, a.charCodeAt(h) === 47 && ++h, a.slice(h));
        },
        _makeLong: function(s) {
            return s;
        },
        dirname: function(s) {
            if (e(s), s.length === 0) return ".";
            for(var a = s.charCodeAt(0), u = a === 47, f = -1, d = !0, h = s.length - 1; h >= 1; --h)if (a = s.charCodeAt(h), a === 47) {
                if (!d) {
                    f = h;
                    break;
                }
            } else d = !1;
            return f === -1 ? u ? "/" : "." : u && f === 1 ? "//" : s.slice(0, f);
        },
        basename: function(s, a) {
            if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
            e(s);
            var u = 0, f = -1, d = !0, h;
            if (a !== void 0 && a.length > 0 && a.length <= s.length) {
                if (a.length === s.length && a === s) return "";
                var g = a.length - 1, b = -1;
                for(h = s.length - 1; h >= 0; --h){
                    var E = s.charCodeAt(h);
                    if (E === 47) {
                        if (!d) {
                            u = h + 1;
                            break;
                        }
                    } else b === -1 && (d = !1, b = h + 1), g >= 0 && (E === a.charCodeAt(g) ? --g === -1 && (f = h) : (g = -1, f = b));
                }
                return u === f ? f = b : f === -1 && (f = s.length), s.slice(u, f);
            } else {
                for(h = s.length - 1; h >= 0; --h)if (s.charCodeAt(h) === 47) {
                    if (!d) {
                        u = h + 1;
                        break;
                    }
                } else f === -1 && (d = !1, f = h + 1);
                return f === -1 ? "" : s.slice(u, f);
            }
        },
        extname: function(s) {
            e(s);
            for(var a = -1, u = 0, f = -1, d = !0, h = 0, g = s.length - 1; g >= 0; --g){
                var b = s.charCodeAt(g);
                if (b === 47) {
                    if (!d) {
                        u = g + 1;
                        break;
                    }
                    continue;
                }
                f === -1 && (d = !1, f = g + 1), b === 46 ? a === -1 ? a = g : h !== 1 && (h = 1) : a !== -1 && (h = -1);
            }
            return a === -1 || f === -1 || h === 0 || h === 1 && a === f - 1 && a === u + 1 ? "" : s.slice(a, f);
        },
        format: function(s) {
            if (s === null || typeof s != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof s);
            return i("/", s);
        },
        parse: function(s) {
            e(s);
            var a = {
                root: "",
                dir: "",
                base: "",
                ext: "",
                name: ""
            };
            if (s.length === 0) return a;
            var u = s.charCodeAt(0), f = u === 47, d;
            f ? (a.root = "/", d = 1) : d = 0;
            for(var h = -1, g = 0, b = -1, E = !0, w = s.length - 1, S = 0; w >= d; --w){
                if (u = s.charCodeAt(w), u === 47) {
                    if (!E) {
                        g = w + 1;
                        break;
                    }
                    continue;
                }
                b === -1 && (E = !1, b = w + 1), u === 46 ? h === -1 ? h = w : S !== 1 && (S = 1) : h !== -1 && (S = -1);
            }
            return h === -1 || b === -1 || S === 0 || S === 1 && h === b - 1 && h === g + 1 ? b !== -1 && (g === 0 && f ? a.base = a.name = s.slice(1, b) : a.base = a.name = s.slice(g, b)) : (g === 0 && f ? (a.name = s.slice(1, h), a.base = s.slice(1, b)) : (a.name = s.slice(g, h), a.base = s.slice(g, b)), a.ext = s.slice(h, b)), g > 0 ? a.dir = s.slice(0, g - 1) : f && (a.dir = "/"), a;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
    };
    return n.posix = n, Ya = n, Ya;
}
function F1(t) {
    if (typeof t == "string") t = new URL(t);
    else if (!(t instanceof URL)) throw new Deno.errors.InvalidData("invalid argument path , must be a string or URL");
    if (t.protocol !== "file:") throw new Deno.errors.InvalidData("invalid url scheme");
    return Xa ? W1(t) : $1(t);
}
function W1(t) {
    let e = t.hostname, r = t.pathname;
    for(let i = 0; i < r.length; i++)if (r[i] === "%") {
        let n = r.codePointAt(i + 2) || 32;
        if (r[i + 1] === "2" && n === 102 || r[i + 1] === "5" && n === 99) throw new Deno.errors.InvalidData("must not include encoded \\ or / characters");
    }
    if (r = r.replace(L1, "\\"), r = decodeURIComponent(r), e !== "") return `\\\\${e}${r}`;
    {
        let i = r.codePointAt(1) | 32, n = r[2];
        if (i < O1 || i > M1 || n !== ":") throw new Deno.errors.InvalidData("file url path must be absolute");
        return r.slice(1);
    }
}
function $1(t) {
    if (t.hostname !== "") throw new Deno.errors.InvalidData("invalid file url hostname");
    let e = t.pathname;
    for(let r = 0; r < e.length; r++)if (e[r] === "%") {
        let i = e.codePointAt(r + 2) || 32;
        if (e[r + 1] === "2" && i === 102) throw new Deno.errors.InvalidData("must not include encoded / characters");
    }
    return decodeURIComponent(e);
}
function H1(t) {
    let e = ag.resolve(t), r = t.charCodeAt(t.length - 1);
    (r === x1 || Xa && r === B1) && e[e.length - 1] !== ag.sep && (e += "/");
    let i = new URL("file://");
    return e.includes("%") && (e = e.replace(q1, "%25")), !Xa && e.includes("\\") && (e = e.replace(U1, "%5C")), e.includes(`
`) && (e = e.replace(N1, "%0A")), e.includes("\r") && (e = e.replace(D1, "%0D")), e.includes("	") && (e = e.replace(j1, "%09")), i.pathname = e, i;
}
function lg(t) {
    if (typeof t == "string") t = new URL(t);
    else if (!(t instanceof URL)) throw new Deno.errors.InvalidData("invalid argument path , must be a string or URL");
    if (t.protocol !== "file:") throw new Deno.errors.InvalidData("invalid url scheme");
    return Za ? lS(t) : uS(t);
}
function lS(t) {
    let e = t.hostname, r = t.pathname;
    for(let i = 0; i < r.length; i++)if (r[i] === "%") {
        let n = r.codePointAt(i + 2) || 32;
        if (r[i + 1] === "2" && n === 102 || r[i + 1] === "5" && n === 99) throw new Deno.errors.InvalidData("must not include encoded \\ or / characters");
    }
    if (r = r.replace(rS, "\\"), r = decodeURIComponent(r), e !== "") return `\\\\${e}${r}`;
    {
        let i = r.codePointAt(1) | 32, n = r[2];
        if (i < eS || i > tS || n !== ":") throw new Deno.errors.InvalidData("file url path must be absolute");
        return r.slice(1);
    }
}
function uS(t) {
    if (t.hostname !== "") throw new Deno.errors.InvalidData("invalid file url hostname");
    let e = t.pathname;
    for(let r = 0; r < e.length; r++)if (e[r] === "%") {
        let i = e.codePointAt(r + 2) || 32;
        if (e[r + 1] === "2" && i === 102) throw new Deno.errors.InvalidData("must not include encoded / characters");
    }
    return decodeURIComponent(e);
}
function ug(t) {
    let e = Ka.resolve(t), r = t.charCodeAt(t.length - 1);
    (r === Z1 || Za && r === X1) && e[e.length - 1] !== Ka.sep && (e += "/");
    let i = new URL("file://");
    return e.includes("%") && (e = e.replace(iS, "%25")), !Za && e.includes("\\") && (e = e.replace(nS, "%5C")), e.includes(`
`) && (e = e.replace(sS, "%0A")), e.includes("\r") && (e = e.replace(oS, "%0D")), e.includes("	") && (e = e.replace(aS, "%09")), i.pathname = e, i;
}
var X, E1, ht, S1, A1, I1, T1, Ja, ig, ng, sg, R1, C1, Ga, ri, Qa, Ya, og, ag, k1, B1, x1, O1, M1, Xa, L1, q1, U1, N1, D1, j1, V1, z1, K1, G1, Q1, Y1, J1, X1, Z1, eS, tS, Za, rS, iS, nS, sS, oS, aS, fg = Ae(()=>{
    _();
    v();
    m();
    Kp();
    Gp();
    Zp();
    rg();
    Va();
    X = {}, E1 = Vt, ht = {
        isString: function(t) {
            return typeof t == "string";
        },
        isObject: function(t) {
            return typeof t == "object" && t !== null;
        },
        isNull: function(t) {
            return t === null;
        },
        isNullOrUndefined: function(t) {
            return t == null;
        }
    };
    X.parse = xi, X.resolve = function(t, e) {
        return xi(t, !1, !0).resolve(e);
    }, X.resolveObject = function(t, e) {
        return t ? xi(t, !1, !0).resolveObject(e) : e;
    }, X.format = function(t) {
        return ht.isString(t) && (t = xi(t)), t instanceof De ? t.format() : De.prototype.format.call(t);
    }, X.Url = De;
    S1 = /^([a-z0-9.+-]+:)/i, A1 = /:[0-9]*$/, I1 = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, T1 = [
        "{",
        "}",
        "|",
        "\\",
        "^",
        "`"
    ].concat([
        "<",
        ">",
        '"',
        "`",
        " ",
        "\r",
        `
`,
        "	"
    ]), Ja = [
        "'"
    ].concat(T1), ig = [
        "%",
        "/",
        "?",
        ";",
        "#"
    ].concat(Ja), ng = [
        "/",
        "?",
        "#"
    ], sg = /^[+a-z0-9A-Z_-]{0,63}$/, R1 = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, C1 = {
        javascript: !0,
        "javascript:": !0
    }, Ga = {
        javascript: !0,
        "javascript:": !0
    }, ri = {
        http: !0,
        https: !0,
        ftp: !0,
        gopher: !0,
        file: !0,
        "http:": !0,
        "https:": !0,
        "ftp:": !0,
        "gopher:": !0,
        "file:": !0
    }, Qa = ft;
    De.prototype.parse = function(t, e, r) {
        if (!ht.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
        var i = t.indexOf("?"), n = i !== -1 && i < t.indexOf("#") ? "?" : "#", o = t.split(n);
        o[0] = o[0].replace(/\\/g, "/");
        var s = t = o.join(n);
        if (s = s.trim(), !r && t.split("#").length === 1) {
            var a = I1.exec(s);
            if (a) return this.path = s, this.href = s, this.pathname = a[1], a[2] ? (this.search = a[2], this.query = e ? Qa.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
        }
        var u = S1.exec(s);
        if (u) {
            var f = (u = u[0]).toLowerCase();
            this.protocol = f, s = s.substr(u.length);
        }
        if (r || u || s.match(/^\/\/[^@\/]+@[^@\/]+/)) {
            var d = s.substr(0, 2) === "//";
            !d || u && Ga[u] || (s = s.substr(2), this.slashes = !0);
        }
        if (!Ga[u] && (d || u && !ri[u])) {
            for(var h, g, b = -1, E = 0; E < ng.length; E++)(w = s.indexOf(ng[E])) !== -1 && (b === -1 || w < b) && (b = w);
            for((g = b === -1 ? s.lastIndexOf("@") : s.lastIndexOf("@", b)) !== -1 && (h = s.slice(0, g), s = s.slice(g + 1), this.auth = decodeURIComponent(h)), b = -1, E = 0; E < ig.length; E++){
                var w;
                (w = s.indexOf(ig[E])) !== -1 && (b === -1 || w < b) && (b = w);
            }
            b === -1 && (b = s.length), this.host = s.slice(0, b), s = s.slice(b), this.parseHost(), this.hostname = this.hostname || "";
            var S = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
            if (!S) for(var I = this.hostname.split(/\./), P = (E = 0, I.length); E < P; E++){
                var C = I[E];
                if (C && !C.match(sg)) {
                    for(var M = "", q = 0, z = C.length; q < z; q++)C.charCodeAt(q) > 127 ? M += "x" : M += C[q];
                    if (!M.match(sg)) {
                        var j = I.slice(0, E), G = I.slice(E + 1), $ = C.match(R1);
                        $ && (j.push($[1]), G.unshift($[2])), G.length && (s = "/" + G.join(".") + s), this.hostname = j.join(".");
                        break;
                    }
                }
            }
            this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), S || (this.hostname = E1.toASCII(this.hostname));
            var te = this.port ? ":" + this.port : "", pt = this.hostname || "";
            this.host = pt + te, this.href += this.host, S && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), s[0] !== "/" && (s = "/" + s));
        }
        if (!C1[f]) for(E = 0, P = Ja.length; E < P; E++){
            var Fe = Ja[E];
            if (s.indexOf(Fe) !== -1) {
                var Se = encodeURIComponent(Fe);
                Se === Fe && (Se = escape(Fe)), s = s.split(Fe).join(Se);
            }
        }
        var vr = s.indexOf("#");
        vr !== -1 && (this.hash = s.substr(vr), s = s.slice(0, vr));
        var Er = s.indexOf("?");
        if (Er !== -1 ? (this.search = s.substr(Er), this.query = s.substr(Er + 1), e && (this.query = Qa.parse(this.query)), s = s.slice(0, Er)) : e && (this.search = "", this.query = {}), s && (this.pathname = s), ri[f] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
            te = this.pathname || "";
            var ls = this.search || "";
            this.path = te + ls;
        }
        return this.href = this.format(), this;
    }, De.prototype.format = function() {
        var t = this.auth || "";
        t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
        var e = this.protocol || "", r = this.pathname || "", i = this.hash || "", n = !1, o = "";
        this.host ? n = t + this.host : this.hostname && (n = t + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (n += ":" + this.port)), this.query && ht.isObject(this.query) && Object.keys(this.query).length && (o = Qa.stringify(this.query));
        var s = this.search || o && "?" + o || "";
        return e && e.substr(-1) !== ":" && (e += ":"), this.slashes || (!e || ri[e]) && n !== !1 ? (n = "//" + (n || ""), r && r.charAt(0) !== "/" && (r = "/" + r)) : n || (n = ""), i && i.charAt(0) !== "#" && (i = "#" + i), s && s.charAt(0) !== "?" && (s = "?" + s), e + n + (r = r.replace(/[?#]/g, function(a) {
            return encodeURIComponent(a);
        })) + (s = s.replace("#", "%23")) + i;
    }, De.prototype.resolve = function(t) {
        return this.resolveObject(xi(t, !1, !0)).format();
    }, De.prototype.resolveObject = function(t) {
        if (ht.isString(t)) {
            var e = new De;
            e.parse(t, !1, !0), t = e;
        }
        for(var r = new De, i = Object.keys(this), n = 0; n < i.length; n++){
            var o = i[n];
            r[o] = this[o];
        }
        if (r.hash = t.hash, t.href === "") return r.href = r.format(), r;
        if (t.slashes && !t.protocol) {
            for(var s = Object.keys(t), a = 0; a < s.length; a++){
                var u = s[a];
                u !== "protocol" && (r[u] = t[u]);
            }
            return ri[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
        }
        if (t.protocol && t.protocol !== r.protocol) {
            if (!ri[t.protocol]) {
                for(var f = Object.keys(t), d = 0; d < f.length; d++){
                    var h = f[d];
                    r[h] = t[h];
                }
                return r.href = r.format(), r;
            }
            if (r.protocol = t.protocol, t.host || Ga[t.protocol]) r.pathname = t.pathname;
            else {
                for(var g = (t.pathname || "").split("/"); g.length && !(t.host = g.shift()););
                t.host || (t.host = ""), t.hostname || (t.hostname = ""), g[0] !== "" && g.unshift(""), g.length < 2 && g.unshift(""), r.pathname = g.join("/");
            }
            if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
                var b = r.pathname || "", E = r.search || "";
                r.path = b + E;
            }
            return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
        }
        var w = r.pathname && r.pathname.charAt(0) === "/", S = t.host || t.pathname && t.pathname.charAt(0) === "/", I = S || w || r.host && t.pathname, P = I, C = r.pathname && r.pathname.split("/") || [], M = (g = t.pathname && t.pathname.split("/") || [], r.protocol && !ri[r.protocol]);
        if (M && (r.hostname = "", r.port = null, r.host && (C[0] === "" ? C[0] = r.host : C.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && (g[0] === "" ? g[0] = t.host : g.unshift(t.host)), t.host = null), I = I && (g[0] === "" || C[0] === "")), S) r.host = t.host || t.host === "" ? t.host : r.host, r.hostname = t.hostname || t.hostname === "" ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, C = g;
        else if (g.length) C || (C = []), C.pop(), C = C.concat(g), r.search = t.search, r.query = t.query;
        else if (!ht.isNullOrUndefined(t.search)) return M && (r.hostname = r.host = C.shift(), ($ = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = $.shift(), r.host = r.hostname = $.shift())), r.search = t.search, r.query = t.query, ht.isNull(r.pathname) && ht.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
        if (!C.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
        for(var q = C.slice(-1)[0], z = (r.host || t.host || C.length > 1) && (q === "." || q === "..") || q === "", j = 0, G = C.length; G >= 0; G--)(q = C[G]) === "." ? C.splice(G, 1) : q === ".." ? (C.splice(G, 1), j++) : j && (C.splice(G, 1), j--);
        if (!I && !P) for(; j--; j)C.unshift("..");
        !I || C[0] === "" || C[0] && C[0].charAt(0) === "/" || C.unshift(""), z && C.join("/").substr(-1) !== "/" && C.push("");
        var $, te = C[0] === "" || C[0] && C[0].charAt(0) === "/";
        return M && (r.hostname = r.host = te ? "" : C.length ? C.shift() : "", ($ = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = $.shift(), r.host = r.hostname = $.shift())), (I = I || r.host && C.length) && !te && C.unshift(""), C.length ? r.pathname = C.join("/") : (r.pathname = null, r.path = null), ht.isNull(r.pathname) && ht.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
    }, De.prototype.parseHost = function() {
        var t = this.host, e = A1.exec(t);
        e && ((e = e[0]) !== ":" && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
    };
    X.Url;
    X.format;
    X.resolve;
    X.resolveObject;
    Ya = {}, og = !1;
    ag = P1(), k1 = typeof Deno < "u" ? Deno.build.os === "windows" ? "win32" : Deno.build.os : void 0;
    X.URL = typeof URL < "u" ? URL : null;
    X.pathToFileURL = H1;
    X.fileURLToPath = F1;
    X.Url;
    X.format;
    X.resolve;
    X.resolveObject;
    X.URL;
    B1 = 92, x1 = 47, O1 = 97, M1 = 122, Xa = k1 === "win32", L1 = /\//g, q1 = /%/g, U1 = /\\/g, N1 = /\n/g, D1 = /\r/g, j1 = /\t/g;
    V1 = typeof Deno < "u" ? Deno.build.os === "windows" ? "win32" : Deno.build.os : void 0;
    X.URL = typeof URL < "u" ? URL : null;
    X.pathToFileURL = ug;
    X.fileURLToPath = lg;
    z1 = X.Url, K1 = X.format, G1 = X.resolve, Q1 = X.resolveObject, Y1 = X.parse, J1 = X.URL, X1 = 92, Z1 = 47, eS = 97, tS = 122, Za = V1 === "win32", rS = /\//g, iS = /%/g, nS = /\\/g, sS = /\n/g, oS = /\r/g, aS = /\t/g;
});
var dg = O((F3, hg)=>{
    "use strict";
    _();
    v();
    m();
    hg.exports = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
});
var is = O((Oi)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(Oi, "__esModule", {
        value: !0
    });
    Oi.BufferedDuplex = void 0;
    Oi.writev = gg;
    var cS = Nt(), pg = (he(), Q(ye));
    function gg(t, e) {
        let r = new Array(t.length);
        for(let i = 0; i < t.length; i++)typeof t[i].chunk == "string" ? r[i] = pg.Buffer.from(t[i].chunk, "utf8") : r[i] = t[i].chunk;
        this._write(pg.Buffer.concat(r), "binary", e);
    }
    var el = class extends cS.Duplex {
        constructor(e, r, i){
            super({
                objectMode: !0
            }), this.proxy = r, this.socket = i, this.writeQueue = [], e.objectMode || (this._writev = gg.bind(this)), this.isSocketOpen = !1, this.proxy.on("data", (n)=>{
                !this.destroyed && this.readable && this.push(n);
            });
        }
        _read(e) {
            this.proxy.read(e);
        }
        _write(e, r, i) {
            this.isSocketOpen ? this.writeToProxy(e, r, i) : this.writeQueue.push({
                chunk: e,
                encoding: r,
                cb: i
            });
        }
        _final(e) {
            this.writeQueue = [], this.proxy.end(e);
        }
        _destroy(e, r) {
            this.writeQueue = [], this.proxy.destroy(), r(e);
        }
        socketReady() {
            this.emit("connect"), this.isSocketOpen = !0, this.processWriteQueue();
        }
        writeToProxy(e, r, i) {
            this.proxy.write(e, r) === !1 ? this.proxy.once("drain", i) : i();
        }
        processWriteQueue() {
            for(; this.writeQueue.length > 0;){
                let { chunk: e, encoding: r, cb: i } = this.writeQueue.shift();
                this.writeToProxy(e, r, i);
            }
        }
    };
    Oi.BufferedDuplex = el;
});
var Mi = O((Kt)=>{
    "use strict";
    _();
    v();
    m();
    var rl = Kt && Kt.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Kt, "__esModule", {
        value: !0
    });
    Kt.streamBuilder = Kt.browserStreamBuilder = void 0;
    var ns = (he(), Q(ye)), bg = rl(dg()), fS = rl(nt()), hS = Nt(), dS = rl(Ci()), tl = is(), zt = (0, fS.default)("mqttjs:ws"), pS = [
        "rejectUnauthorized",
        "ca",
        "cert",
        "key",
        "pfx",
        "passphrase"
    ];
    function yg(t, e) {
        let r = `${t.protocol}://${t.hostname}:${t.port}${t.path}`;
        return typeof t.transformWsUrl == "function" && (r = t.transformWsUrl(r, t, e)), r;
    }
    function wg(t) {
        let e = t;
        return t.port || (t.protocol === "wss" ? e.port = 443 : e.port = 80), t.path || (e.path = "/"), t.wsOptions || (e.wsOptions = {}), !dS.default && !t.forceNativeWebSocket && t.protocol === "wss" && pS.forEach((r)=>{
            Object.prototype.hasOwnProperty.call(t, r) && !Object.prototype.hasOwnProperty.call(t.wsOptions, r) && (e.wsOptions[r] = t[r]);
        }), e;
    }
    function gS(t) {
        let e = wg(t);
        if (e.hostname || (e.hostname = e.host), !e.hostname) {
            if (typeof document > "u") throw new Error("Could not determine host. Specify host manually.");
            let r = new URL(document.URL);
            e.hostname = r.hostname, e.port || (e.port = Number(r.port));
        }
        return e.objectMode === void 0 && (e.objectMode = !(e.binary === !0 || e.binary === void 0)), e;
    }
    function bS(t, e, r) {
        zt("createWebSocket"), zt(`protocol: ${r.protocolId} ${r.protocolVersion}`);
        let i = r.protocolId === "MQIsdp" && r.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
        zt(`creating new Websocket for url: ${e} and protocol: ${i}`);
        let n;
        return r.createWebsocket ? n = r.createWebsocket(e, [
            i
        ], r) : n = new bg.default(e, [
            i
        ], r.wsOptions), n;
    }
    function yS(t, e) {
        let r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt", i = yg(e, t), n;
        return e.createWebsocket ? n = e.createWebsocket(i, [
            r
        ], e) : n = new WebSocket(i, [
            r
        ]), n.binaryType = "arraybuffer", n;
    }
    var wS = (t, e)=>{
        zt("streamBuilder");
        let r = wg(e);
        r.hostname = r.hostname || r.host || "localhost";
        let i = yg(r, t), n = bS(t, i, r), o = bg.default.createWebSocketStream(n, r.wsOptions);
        return o.url = i, n.on("close", ()=>{
            o.destroy();
        }), o;
    };
    Kt.streamBuilder = wS;
    var _S = (t, e)=>{
        zt("browserStreamBuilder");
        let r, n = gS(e).browserBufferSize || 524288, o = e.browserBufferTimeout || 1e3, s = !e.objectMode, a = yS(t, e), u = d(e, w, S);
        e.objectMode || (u._writev = tl.writev.bind(u)), u.on("close", ()=>{
            a.close();
        });
        let f = typeof a.addEventListener < "u";
        a.readyState === a.OPEN ? (r = u, r.socket = a) : (r = new tl.BufferedDuplex(e, u, a), f ? a.addEventListener("open", h) : a.onopen = h), f ? (a.addEventListener("close", g), a.addEventListener("error", b), a.addEventListener("message", E)) : (a.onclose = g, a.onerror = b, a.onmessage = E);
        function d(I, P, C) {
            let M = new hS.Transform({
                objectMode: I.objectMode
            });
            return M._write = P, M._flush = C, M;
        }
        function h() {
            zt("WebSocket onOpen"), r instanceof tl.BufferedDuplex && r.socketReady();
        }
        function g(I) {
            zt("WebSocket onClose", I), r.end(), r.destroy();
        }
        function b(I) {
            zt("WebSocket onError", I);
            let P = new Error("WebSocket error");
            P.event = I, r.destroy(P);
        }
        async function E(I) {
            if (!u || u.destroyed || !u.readable) return;
            let { data: P } = I;
            P instanceof ArrayBuffer ? P = ns.Buffer.from(P) : P instanceof Blob ? P = ns.Buffer.from(await new Response(P).arrayBuffer()) : P = ns.Buffer.from(P, "utf8"), u.push(P);
        }
        function w(I, P, C) {
            if (a.bufferedAmount > n) {
                setTimeout(w, o, I, P, C);
                return;
            }
            s && typeof I == "string" && (I = ns.Buffer.from(I, "utf8"));
            try {
                a.send(I);
            } catch (M) {
                return C(M);
            }
            C();
        }
        function S(I) {
            a.close(), I();
        }
        return r;
    };
    Kt.browserStreamBuilder = _S;
});
var il = {};
Ir(il, {
    Server: ()=>xe,
    Socket: ()=>xe,
    Stream: ()=>xe,
    _createServerHandle: ()=>xe,
    _normalizeArgs: ()=>xe,
    _setSimultaneousAccepts: ()=>xe,
    connect: ()=>xe,
    createConnection: ()=>xe,
    createServer: ()=>xe,
    default: ()=>mS,
    isIP: ()=>xe,
    isIPv4: ()=>xe,
    isIPv6: ()=>xe
});
function xe() {
    throw new Error("Node.js net module is not supported by JSPM core outside of Node.js");
}
var mS, nl = Ae(()=>{
    _();
    v();
    m();
    mS = {
        _createServerHandle: xe,
        _normalizeArgs: xe,
        _setSimultaneousAccepts: xe,
        connect: xe,
        createConnection: xe,
        createServer: xe,
        isIP: xe,
        isIPv4: xe,
        isIPv6: xe,
        Server: xe,
        Socket: xe,
        Stream: xe
    };
});
var sl = O((TF, _g)=>{
    _();
    v();
    m();
    _g.exports = {};
});
var al = O((Li)=>{
    "use strict";
    _();
    v();
    m();
    var ol = Li && Li.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Li, "__esModule", {
        value: !0
    });
    var vS = ol((nl(), Q(il))), ES = ol(nt()), SS = ol(sl()), AS = (0, ES.default)("mqttjs:tcp"), IS = (t, e)=>{
        if (e.port = e.port || 1883, e.hostname = e.hostname || e.host || "localhost", e.socksProxy) return (0, SS.default)(e.hostname, e.port, e.socksProxy, {
            timeout: e.socksTimeout
        });
        let { port: r, path: i } = e, n = e.hostname;
        return AS("port %d and host %s", r, n), vS.default.createConnection({
            port: r,
            host: n,
            path: i
        });
    };
    Li.default = IS;
});
var mg = {};
Ir(mg, {
    default: ()=>TS
});
var TS, vg = Ae(()=>{
    _();
    v();
    m();
    TS = {};
});
var ll = O((mr)=>{
    "use strict";
    _();
    v();
    m();
    var RS = mr && mr.__rest || function(t, e) {
        var r = {};
        for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
        if (t != null && typeof Object.getOwnPropertySymbols == "function") for(var n = 0, i = Object.getOwnPropertySymbols(t); n < i.length; n++)e.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[n]) && (r[i[n]] = t[i[n]]);
        return r;
    }, ss = mr && mr.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(mr, "__esModule", {
        value: !0
    });
    var CS = ss((vg(), Q(mg))), PS = ss((nl(), Q(il))), kS = ss(nt()), BS = ss(sl()), xS = (0, kS.default)("mqttjs:tls");
    function OS(t) {
        let { host: e, port: r, socksProxy: i } = t, n = RS(t, [
            "host",
            "port",
            "socksProxy"
        ]);
        return CS.default.connect(i ? Object.assign(Object.assign({}, n), {
            socket: (0, BS.default)(e, r, i, {
                timeout: t.socksTimeout
            })
        }) : t);
    }
    var MS = (t, e)=>{
        e.port = e.port || 8883, e.host = e.hostname || e.host || "localhost", PS.default.isIP(e.host) === 0 && (e.servername = e.host), e.rejectUnauthorized = e.rejectUnauthorized !== !1, delete e.path, xS("port %d host %s rejectUnauthorized %b", e.port, e.host, e.rejectUnauthorized);
        let r = OS(e);
        r.on("secureConnect", ()=>{
            e.rejectUnauthorized && !r.authorized ? r.emit("error", new Error("TLS not authorized")) : r.removeListener("error", i);
        });
        function i(n) {
            e.rejectUnauthorized && t.emit("error", n), r.end();
        }
        return r.on("error", i), r;
    };
    mr.default = MS;
});
var fl = O((cl)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(cl, "__esModule", {
        value: !0
    });
    var Eg = (he(), Q(ye)), LS = Nt(), qS = is(), dt, ul, Oe;
    function US() {
        let t = new LS.Transform;
        return t._write = (e, r, i)=>{
            dt.send({
                data: e.buffer,
                success () {
                    i();
                },
                fail (n) {
                    i(new Error(n));
                }
            });
        }, t._flush = (e)=>{
            dt.close({
                success () {
                    e();
                }
            });
        }, t;
    }
    function NS(t) {
        t.hostname || (t.hostname = "localhost"), t.path || (t.path = "/"), t.wsOptions || (t.wsOptions = {});
    }
    function DS(t, e) {
        let r = t.protocol === "wxs" ? "wss" : "ws", i = `${r}://${t.hostname}${t.path}`;
        return t.port && t.port !== 80 && t.port !== 443 && (i = `${r}://${t.hostname}:${t.port}${t.path}`), typeof t.transformWsUrl == "function" && (i = t.transformWsUrl(i, t, e)), i;
    }
    function jS() {
        dt.onOpen(()=>{
            Oe.socketReady();
        }), dt.onMessage((t)=>{
            let { data: e } = t;
            e instanceof ArrayBuffer ? e = Eg.Buffer.from(e) : e = Eg.Buffer.from(e, "utf8"), ul.push(e);
        }), dt.onClose(()=>{
            Oe.emit("close"), Oe.end(), Oe.destroy();
        }), dt.onError((t)=>{
            let e = new Error(t.errMsg);
            Oe.destroy(e);
        });
    }
    var FS = (t, e)=>{
        if (e.hostname = e.hostname || e.host, !e.hostname) throw new Error("Could not determine host. Specify host manually.");
        let r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
        NS(e);
        let i = DS(e, t);
        dt = wx.connectSocket({
            url: i,
            protocols: [
                r
            ]
        }), ul = US(), Oe = new qS.BufferedDuplex(e, ul, dt), Oe._destroy = (o, s)=>{
            dt.close({
                success () {
                    s && s(o);
                }
            });
        };
        let n = Oe.destroy;
        return Oe.destroy = (o, s)=>(Oe.destroy = n, setTimeout(()=>{
                dt.close({
                    fail () {
                        Oe._destroy(o, s);
                    }
                });
            }, 0), Oe), jS(), Oe;
    };
    cl.default = FS;
});
var pl = O((dl)=>{
    "use strict";
    _();
    v();
    m();
    Object.defineProperty(dl, "__esModule", {
        value: !0
    });
    var hl = (he(), Q(ye)), WS = Nt(), $S = is(), Ct, os, ii, Sg = !1;
    function HS() {
        let t = new WS.Transform;
        return t._write = (e, r, i)=>{
            Ct.sendSocketMessage({
                data: e.buffer,
                success () {
                    i();
                },
                fail () {
                    i(new Error);
                }
            });
        }, t._flush = (e)=>{
            Ct.closeSocket({
                success () {
                    e();
                }
            });
        }, t;
    }
    function VS(t) {
        t.hostname || (t.hostname = "localhost"), t.path || (t.path = "/"), t.wsOptions || (t.wsOptions = {});
    }
    function zS(t, e) {
        let r = t.protocol === "alis" ? "wss" : "ws", i = `${r}://${t.hostname}${t.path}`;
        return t.port && t.port !== 80 && t.port !== 443 && (i = `${r}://${t.hostname}:${t.port}${t.path}`), typeof t.transformWsUrl == "function" && (i = t.transformWsUrl(i, t, e)), i;
    }
    function KS() {
        Sg || (Sg = !0, Ct.onSocketOpen(()=>{
            ii.socketReady();
        }), Ct.onSocketMessage((t)=>{
            if (typeof t.data == "string") {
                let e = hl.Buffer.from(t.data, "base64");
                os.push(e);
            } else {
                let e = new FileReader;
                e.addEventListener("load", ()=>{
                    let r = e.result;
                    r instanceof ArrayBuffer ? r = hl.Buffer.from(r) : r = hl.Buffer.from(r, "utf8"), os.push(r);
                }), e.readAsArrayBuffer(t.data);
            }
        }), Ct.onSocketClose(()=>{
            ii.end(), ii.destroy();
        }), Ct.onSocketError((t)=>{
            ii.destroy(t);
        }));
    }
    var GS = (t, e)=>{
        if (e.hostname = e.hostname || e.host, !e.hostname) throw new Error("Could not determine host. Specify host manually.");
        let r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
        VS(e);
        let i = zS(e, t);
        return Ct = e.my, Ct.connectSocket({
            url: i,
            protocols: r
        }), os = HS(), ii = new $S.BufferedDuplex(e, os, Ct), KS(), ii;
    };
    dl.default = GS;
});
var Rg = O((ni)=>{
    "use strict";
    _();
    v();
    m();
    var as = ni && ni.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(ni, "__esModule", {
        value: !0
    });
    ni.connectAsync = ZS;
    var QS = as(nt()), YS = as((fg(), Q(cg))), JS = as(ts()), Ag = as(Ci());
    typeof (R === null || R === void 0 ? void 0 : R.nextTick) != "function" && (R.nextTick = setImmediate);
    var Ig = (0, QS.default)("mqttjs"), ge = null;
    function XS(t) {
        let e;
        t.auth && (e = t.auth.match(/^(.+):(.+)$/), e ? (t.username = e[1], t.password = e[2]) : t.username = t.auth);
    }
    function Tg(t, e) {
        var r, i, n;
        if (Ig("connecting to an MQTT broker..."), typeof t == "object" && !e && (e = t, t = ""), e = e || {}, t && typeof t == "string") {
            let a = YS.default.parse(t, !0), u = {};
            if (a.port != null && (u.port = Number(a.port)), u.host = a.hostname, u.query = a.query, u.auth = a.auth, u.protocol = a.protocol, u.path = a.path, e = Object.assign(Object.assign({}, u), e), !e.protocol) throw new Error("Missing protocol");
            e.protocol = e.protocol.replace(/:$/, "");
        }
        if (e.unixSocket = e.unixSocket || ((r = e.protocol) === null || r === void 0 ? void 0 : r.includes("+unix")), e.unixSocket ? e.protocol = e.protocol.replace("+unix", "") : !(!((i = e.protocol) === null || i === void 0) && i.startsWith("ws")) && !(!((n = e.protocol) === null || n === void 0) && n.startsWith("wx")) && delete e.path, XS(e), e.query && typeof e.query.clientId == "string" && (e.clientId = e.query.clientId), Ag.default || e.unixSocket ? e.socksProxy = void 0 : e.socksProxy === void 0 && typeof R < "u" && (e.socksProxy = R.env.MQTTJS_SOCKS_PROXY), e.cert && e.key) {
            if (e.protocol) {
                if ([
                    "mqtts",
                    "wss",
                    "wxs",
                    "alis"
                ].indexOf(e.protocol) === -1) switch(e.protocol){
                    case "mqtt":
                        e.protocol = "mqtts";
                        break;
                    case "ws":
                        e.protocol = "wss";
                        break;
                    case "wx":
                        e.protocol = "wxs";
                        break;
                    case "ali":
                        e.protocol = "alis";
                        break;
                    default:
                        throw new Error(`Unknown protocol for secure connection: "${e.protocol}"!`);
                }
            } else throw new Error("Missing secure protocol key");
        }
        if (ge || (ge = {}, !Ag.default && !e.forceNativeWebSocket ? (ge.ws = Mi().streamBuilder, ge.wss = Mi().streamBuilder, ge.mqtt = al().default, ge.tcp = al().default, ge.ssl = ll().default, ge.tls = ge.ssl, ge.mqtts = ll().default) : (ge.ws = Mi().browserStreamBuilder, ge.wss = Mi().browserStreamBuilder, ge.wx = fl().default, ge.wxs = fl().default, ge.ali = pl().default, ge.alis = pl().default)), !ge[e.protocol]) {
            let a = [
                "mqtts",
                "wss"
            ].indexOf(e.protocol) !== -1;
            e.protocol = [
                "mqtt",
                "mqtts",
                "ws",
                "wss",
                "wx",
                "wxs",
                "ali",
                "alis"
            ].filter((u, f)=>a && f % 2 === 0 ? !1 : typeof ge[u] == "function")[0];
        }
        if (e.clean === !1 && !e.clientId) throw new Error("Missing clientId for unclean clients");
        e.protocol && (e.defaultProtocol = e.protocol);
        function o(a) {
            return e.servers && ((!a._reconnectCount || a._reconnectCount === e.servers.length) && (a._reconnectCount = 0), e.host = e.servers[a._reconnectCount].host, e.port = e.servers[a._reconnectCount].port, e.protocol = e.servers[a._reconnectCount].protocol ? e.servers[a._reconnectCount].protocol : e.defaultProtocol, e.hostname = e.host, a._reconnectCount++), Ig("calling streambuilder for", e.protocol), ge[e.protocol](a, e);
        }
        let s = new JS.default(o, e);
        return s.on("error", ()=>{}), s;
    }
    function ZS(t, e, r = !0) {
        return new Promise((i, n)=>{
            let o = Tg(t, e), s = {
                connect: (u)=>{
                    a(), i(o);
                },
                end: ()=>{
                    a(), i(o);
                },
                error: (u)=>{
                    a(), o.end(), n(u);
                }
            };
            r === !1 && (s.close = ()=>{
                s.error(new Error("Couldn't connect to server"));
            });
            function a() {
                Object.keys(s).forEach((u)=>{
                    o.off(u, s[u]);
                });
            }
            Object.keys(s).forEach((u)=>{
                o.on(u, s[u]);
            });
        });
    }
    ni.default = Tg;
});
var gl = O((K)=>{
    "use strict";
    _();
    v();
    m();
    var Cg = K && K.__createBinding || (Object.create ? function(t, e, r, i) {
        i === void 0 && (i = r);
        var n = Object.getOwnPropertyDescriptor(e, r);
        (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, i, n);
    } : function(t, e, r, i) {
        i === void 0 && (i = r), t[i] = e[r];
    }), eA = K && K.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), tA = K && K.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var i = [];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (i[i.length] = n);
                return i;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var i = t(e), n = 0; n < i.length; n++)i[n] !== "default" && Cg(r, e, i[n]);
            return eA(r, e), r;
        };
    }(), Pg = K && K.__exportStar || function(t, e) {
        for(var r in t)r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && Cg(e, t, r);
    }, qi = K && K.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(K, "__esModule", {
        value: !0
    });
    K.ReasonCodes = K.KeepaliveManager = K.UniqueMessageIdProvider = K.DefaultMessageIdProvider = K.Store = K.MqttClient = K.connectAsync = K.connect = K.Client = void 0;
    var kg = qi(ts());
    K.MqttClient = kg.default;
    var rA = qi(zo());
    K.DefaultMessageIdProvider = rA.default;
    var iA = qi(jp());
    K.UniqueMessageIdProvider = iA.default;
    var nA = qi(Qo());
    K.Store = nA.default;
    var Bg = tA(Rg());
    K.connect = Bg.default;
    Object.defineProperty(K, "connectAsync", {
        enumerable: !0,
        get: function() {
            return Bg.connectAsync;
        }
    });
    var sA = qi(qa());
    K.KeepaliveManager = sA.default;
    K.Client = kg.default;
    Pg(ts(), K);
    Pg(cr(), K);
    var oA = Si();
    Object.defineProperty(K, "ReasonCodes", {
        enumerable: !0,
        get: function() {
            return oA.ReasonCodes;
        }
    });
});
var fA = O((je)=>{
    _();
    v();
    m();
    var xg = je && je.__createBinding || (Object.create ? function(t, e, r, i) {
        i === void 0 && (i = r);
        var n = Object.getOwnPropertyDescriptor(e, r);
        (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, i, n);
    } : function(t, e, r, i) {
        i === void 0 && (i = r), t[i] = e[r];
    }), aA = je && je.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), lA = je && je.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var i = [];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (i[i.length] = n);
                return i;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var i = t(e), n = 0; n < i.length; n++)i[n] !== "default" && xg(r, e, i[n]);
            return aA(r, e), r;
        };
    }(), uA = je && je.__exportStar || function(t, e) {
        for(var r in t)r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && xg(e, t, r);
    };
    Object.defineProperty(je, "__esModule", {
        value: !0
    });
    var cA = lA(gl());
    je.default = cA;
    uA(gl(), je);
});
exports.default = fA(); /*! Bundled license information:

@jspm/core/nodelibs/browser/buffer.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

safe-buffer/index.js:
  (*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)
*/ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"kWmyL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimerControlAction", ()=>TimerControlAction);
var TimerControlAction = /*#__PURE__*/ function(TimerControlAction) {
    TimerControlAction["PLAY"] = "play";
    TimerControlAction["STOP"] = "stop";
    TimerControlAction["RESUME"] = "resume";
    TimerControlAction["RESET"] = "reset";
    TimerControlAction["SET_TOTAL_TIME"] = "setTotalTime";
    return TimerControlAction;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"a31Zc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataFetchService", ()=>DataFetchService);
var _tvsType = require("../types/tvs.type");
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
class DataFetchService {
    logger;
    apiService;
    config;
    classData;
    bookingData;
    movementData;
    constructor(apiService, config){
        this.logger = (0, _loggerUtilsDefault.default).getLogger('DataFetchService');
        this.apiService = apiService;
        this.config = config;
    }
    async startFetching() {
        const tv = this.config.currentTv;
        if (!tv) throw new Error('TV configuration not found');
        this.logger.info(`Starting data fetching for TV type ${tv.type}.`);
        switch(tv.type){
            case (0, _tvsType.TvTypeEnum).Timer:
            case (0, _tvsType.TvTypeEnum).Exercise:
                await this.refreshClassData();
                setInterval(()=>this.refreshClassData(), this.config.tvDataUpdateInterval);
                break;
            case (0, _tvsType.TvTypeEnum).Schedule:
                await this.refreshBookingData();
                setInterval(()=>this.refreshBookingData(), this.config.tvDataUpdateInterval);
                break;
            default:
                this.logger.error('Invalid TV type:', tv.type);
                throw new Error('Invalid TV type');
        }
    }
    async refreshClassData() {
        try {
            const date = this.config.classDate;
            const newClassData = await this.apiService.fetchClassData({
                date: date,
                classInstanceId: this.config.classInstanceId
            });
            this.classData = newClassData;
            this.logger.trace('Class data has been updated:', this.classData);
            return this.classData;
        } catch (error) {
            this.logger.error('Error fetching class data:', error);
            throw error;
        }
    }
    async refreshBookingData() {
        try {
            const date = this.config.classDate;
            const newBookingData = await this.apiService.fetchBookingData(date);
            this.bookingData = newBookingData;
            this.logger.debug('Booking data has been updated:', this.bookingData);
            return this.bookingData;
        } catch (error) {
            this.logger.error('Error fetching booking data:', error);
            throw error;
        }
    }
    async refreshMovementData() {
        try {
            const date = this.config.classDate;
            const newMovementData = await this.apiService.fetchMovementData(date);
            this.movementData = newMovementData;
            this.logger.debug('Movement data has been updated:', this.movementData);
            return this.movementData;
        } catch (error) {
            this.logger.error('Error fetching movement data:', error);
            throw error;
        }
    }
    getClassData() {
        return this.classData;
    }
    getBookingData() {
        return this.bookingData;
    }
    getMovementData() {
        return this.movementData;
    }
}

},{"../types/tvs.type":"jhV4I","../utils/logger.utils":"jsBaU","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4N2dl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenderService", ()=>RenderService);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var _loggerUtils = require("../utils/logger.utils");
var _loggerUtilsDefault = parcelHelpers.interopDefault(_loggerUtils);
var _eventsService = require("./events.service");
var _eventsServiceDefault = parcelHelpers.interopDefault(_eventsService);
var _configService = require("./config.service");
var _eventsType = require("../types/events.type");
var _renderTypes = require("../types/render.types");
class RenderService extends (0, _eventemitter3Default.default) {
    logger;
    screenData;
    bookingScreenData;
    configService;
    // A map that holds arrays of handlers for different event types
    eventHandlers = new Map();
    static instance;
    constructor(){
        super();
        this.configService = (0, _configService.ConfigService).getInstance();
        this.logger = (0, _loggerUtilsDefault.default).getLogger('RenderService');
        this.registerEventListeners();
        this.logger.info('Initialized');
    }
    static getInstance() {
        if (!RenderService.instance) RenderService.instance = new RenderService();
        return RenderService.instance;
    }
    // Method to add a handler for a specific event type
    addHandler(eventType, handler) {
        if (!this.eventHandlers.has(eventType)) this.eventHandlers.set(eventType, []);
        this.eventHandlers.get(eventType)?.push(handler);
    }
    // Method to remove a handler for a specific event type
    removeHandler(eventType, handler) {
        const handlers = this.eventHandlers.get(eventType);
        if (handlers) this.eventHandlers.set(eventType, handlers.filter((h)=>h !== handler));
    }
    // Notify all handlers for a specific event type
    notifyHandlers(eventType, data) {
        const handlers = this.eventHandlers.get(eventType);
        if (handlers) handlers.forEach((handler, index)=>{
            this.logger.trace(`Handler ${index + 1} for event type "${eventType}" is being called with data:`, data);
            handler(data);
        });
        else this.logger.debug(`No handlers found for event type "${eventType}".`);
    }
    // Example: registering event listeners for multiple types of events
    registerEventListeners() {
        const handleEvent = (event, renderItem)=>{
            this.logger.debug(`Received ${event} event with data:`, renderItem);
            if (event === (0, _eventsType.RenderEvents).bookingClassesWrapper) {
                if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).BOOKING) {
                    this.bookingScreenData = this.renderItemBooking(renderItem);
                    this.notifyHandlers("BookingScreenData", this.bookingScreenData);
                    return;
                }
                return;
            } else if (event === (0, _eventsType.RenderEvents).classWorkoutStart) {
                this.screenData = this.renderItem(renderItem);
                this.notifyHandlers("WorkoutScreenData", this.screenData);
                return;
            } else if (event === (0, _eventsType.RenderEvents).classNextWorkout) {
                this.screenData = this.renderItem(renderItem);
                this.notifyHandlers("WorkoutScreenData", this.screenData);
                return;
            } else if (event === (0, _eventsType.RenderEvents).movementDataUpdated) {
                if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).MOVEMENT) {
                    let movementScreenData = this.renderItemMovement(renderItem);
                    this.notifyHandlers("MovementScreenData", movementScreenData);
                    return;
                }
                return;
            } else if (event === (0, _eventsType.RenderEvents).timerPreWorkout) {
                if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).TIMER_PRE_WORKOUT) {
                    let timerScreenData = this.renderTimerPreWorkout(renderItem);
                    this.notifyHandlers("TimerScreenData", timerScreenData);
                    return;
                }
                return;
            } else if (event === (0, _eventsType.RenderEvents).timerStartWorkout) {
                if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).TIMER) {
                    let timerScreenData = renderItem.renderItemInfo?.exerciseTask?.type == 'introduction' ? this.renderTimerPreWorkout(renderItem) : this.renderTimerWorkout(renderItem);
                    this.notifyHandlers("TimerScreenData", timerScreenData);
                    return;
                }
                return;
            }
        };
        const eventsToRegister = [
            (0, _eventsType.RenderEvents).classNextWorkout,
            (0, _eventsType.RenderEvents).classWorkoutAboutToStart,
            (0, _eventsType.RenderEvents).classWorkoutStart,
            (0, _eventsType.RenderEvents).bookingClassesWrapper,
            (0, _eventsType.RenderEvents).movementDataUpdated,
            (0, _eventsType.RenderEvents).timerPreWorkout,
            (0, _eventsType.RenderEvents).timerStartWorkout
        ];
        eventsToRegister.forEach((event)=>{
            (0, _eventsServiceDefault.default).on(event, (renderItem)=>handleEvent(event, renderItem));
        });
    }
    // #region Methods
    renderItemBooking(renderItem) {
        if (!renderItem) return {};
        let bookingScreenData = {
            bookingClasses: renderItem.renderItemInfo?.bookingClassesWrapper?.bookingClasses,
            imgPath: this.configService.getFilesStorageUrl()
        };
        return bookingScreenData ? bookingScreenData : {};
    }
    renderItem(renderItem) {
        if (!renderItem) return {};
        switch(renderItem.renderItemType){
            case (0, _renderTypes.RenderItemType).EXERCISE_NEXT_WORKOUT:
                return this.renderNextWorkout(renderItem);
            case (0, _renderTypes.RenderItemType).EXERCISE_ABOUT_TO_START:
                return this.renderAboutToStartWorkout(renderItem);
            case (0, _renderTypes.RenderItemType).EXERCISE:
                return this.renderWorkout(renderItem);
            default:
                this.logger.debug('No renderItemType data', renderItem, renderItem.renderItemType);
                return {};
        }
    }
    renderItemMovement(renderItem) {
        if (!renderItem || !renderItem.classSchedule) return {};
        let fs = this.configService.getFilesStorageUrl();
        let cs = renderItem.classSchedule;
        let workoutImage = cs.workout.image ? fs + cs.workout.image : '/img/default_workout_120x120.jpg';
        let movementImage = cs.workout.movement.image ? fs + cs.workout.movement.image : '/img/default_movement.jpeg';
        const task = renderItem.renderItemInfo?.exerciseTask;
        let movementScreenData = {
            workoutImage: workoutImage,
            totalSets: task?.is_group_routine ? 1 : task?.exercises_total,
            hydrations: task?.hydrate_total,
            hydrationTime: cs.workout.hydration_break,
            stations: cs.workout.movement.stations,
            pods: cs.workout.movement.pods,
            movementImage: movementImage,
            name: cs.workout.movement.name,
            description: cs.workout.description
        };
        return movementScreenData ? movementScreenData : {};
    }
    renderNextWorkout(workoutRenderItem) {
        if (!workoutRenderItem) return {};
        const layoutType = workoutRenderItem.classSchedule?.workout.movement?.movement_tv_layouts?.find((l)=>l.tv_id == this.configService.getTvId())?.layout_type;
        this.screenData = {
            header: this.composeWorkoutModulesHeader(workoutRenderItem),
            progressCircle: this.composeProgressCircle(workoutRenderItem),
            videos: this.composeWorkoutModulesVideos(workoutRenderItem),
            personalTrainer: this.composeWorkoutModulesPersonalTrainer(workoutRenderItem),
            layoutType: layoutType
        };
        this.logger.debug('Rendered next workout with data', this.screenData);
        return this.screenData ? this.screenData : {};
    }
    renderTimerPreWorkout(renderItem) {
        if (!renderItem || !renderItem.classSchedule) return {};
        let fs = this.configService.getFilesStorageUrl();
        let cs = renderItem.classSchedule;
        let workoutImage = cs.workout.image ? fs + cs.workout.image : '/img/basezero_logo.png';
        let movementImage = cs.workout.movement?.image ? fs + cs.workout.movement.image : '/img/basezero_logo.jpeg';
        const info = renderItem.renderItemInfo;
        let screenData = {
            workoutImage: workoutImage,
            totalSets: info?.exerciseTask?.is_group_routine ? 1 : info?.exerciseTask?.exercises_total,
            podSets: info?.exerciseTask?.is_group_routine ? 1 : cs.workout.pod_config?.[0]?.laps[0]?.sets,
            laps: cs.workout.pod_config?.[0]?.laps?.length,
            hydrations: info?.exerciseTask?.hydrate_total,
            hydrationTime: cs.workout.hydration_break,
            exerciseTime: renderItem.work_time,
            restTime: renderItem?.rest_time,
            stations: cs.workout.workout_single_station ? cs.workout.workout_single_station.exercises_count : cs.workout.movement.stations,
            pods: cs.workout.movement?.pods || 1,
            movementImage: movementImage,
            name: cs.workout.name,
            description: cs.workout.description
        };
        this.logger.debug('Rendered Timer next workout with data', screenData);
        return screenData ? screenData : {};
    }
    renderAboutToStartWorkout(workoutRenderItem) {
        if (!workoutRenderItem) return {};
        this.screenData = {
            header: this.composeWorkoutModulesHeader(workoutRenderItem),
            progressCircle: this.composeProgressCircle(workoutRenderItem),
            videos: this.composeWorkoutModulesVideos(workoutRenderItem)
        };
        return this.screenData ? this.screenData : {};
    }
    renderWorkout(item) {
        // Check if the renderItemType is EXERCISE and there is exerciseTask info
        if (item.renderItemType !== (0, _renderTypes.RenderItemType).EXERCISE || !item.renderItemInfo || !item.renderItemInfo.exerciseTask) return {};
        const { exerciseTask } = item.renderItemInfo;
        const isWarmup = exerciseTask.type === 'warmup';
        const isGroupExercise = exerciseTask.type === 'group_exercise';
        const isWork = exerciseTask.type === 'work';
        const isGroupRoutine = exerciseTask.is_group_routine;
        const isRest = exerciseTask.type === 'rest';
        const isHydrate = exerciseTask.type === 'hydrate';
        const isStarting = exerciseTask.type === 'starting';
        const isIntroduction = exerciseTask.type === 'introduction';
        const isEnding = exerciseTask.type === 'ending';
        const changeStation = exerciseTask.station_change;
        const remainingSets = exerciseTask.remaining_sets;
        const totalSets = exerciseTask.current_set + exerciseTask.remaining_sets;
        const title = item.classSchedule?.workout.exercise_types.join(' + ') || '';
        const layoutType = item.classSchedule?.workout.movement?.movement_tv_layouts?.find((l)=>l.tv_id == this.configService.getTvId())?.layout_type;
        let workoutScreenData = {};
        if (isWarmup) workoutScreenData = {
            type: 'warmup',
            // A.1: Show header without date and time
            header: {
                show: false,
                icon: '/img/warm-up.svg',
                title: 'Warmup'
            },
            // A.2: Show progress circle with time and green color
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                bypassCacheGuid: new Date().getTime().toString()
            },
            // A.3 & A.4: Show progress bar with stations unless station change is true
            progressBar: undefined,
            // A.4: Show notification when station change is true
            notification: undefined,
            // A.5: Show videos with stations
            videos: this.composeWorkoutModulesVideos(item)
        };
        if (isGroupExercise) workoutScreenData = {
            type: 'group_exercise',
            // A.1: Show header without date and time
            header: {
                show: false,
                icon: '/img/dumbbell.svg',
                title: 'Group'
            },
            // A.2: Show progress circle with time and green color
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                bypassCacheGuid: new Date().getTime().toString()
            },
            // A.3 & A.4: Show progress bar with stations unless station change is true
            progressBar: undefined,
            // A.4: Show notification when station change is true
            notification: undefined,
            // A.5: Show videos with stations
            videos: this.composeWorkoutModulesVideos(item)
        };
        if (isWork) workoutScreenData = {
            type: 'work',
            // A.1: Show header without date and time
            header: {
                show: false,
                icon: '/img/dumbbell.svg',
                title: title
            },
            // A.2: Show progress circle with time and green color
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                bypassCacheGuid: new Date().getTime().toString()
            },
            // A.3 & A.4: Show progress bar with stations unless station change is true
            //progressBar: this.getProgressBar(item),
            // A.4: Show notification when station change is true
            notification: isGroupRoutine ? undefined : this.getNotificationMessage(item),
            // A.5: Show videos with stations
            videos: this.composeWorkoutModulesVideos(item)
        };
        if (isRest) workoutScreenData = {
            type: 'rest',
            // B.1: Show header without date and time
            header: {
                show: false,
                icon: '/img/dumbbell.svg',
                title: title
            },
            // B.2: Show progress circle with time and red color
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                color: 'red'
            },
            // B.3: Always hide the progress bar
            progressBar: undefined,
            //sets
            sets: changeStation ? undefined : {
                show: true,
                total: totalSets,
                active: exerciseTask.current_set
            },
            // B.4: Show stay module if station change is true
            stay: !changeStation ? {
                show: !isGroupRoutine ? true : false,
                message: 'station'
            } : undefined,
            changeStation: changeStation ? {
                show: !isGroupRoutine ? true : false,
                message: 'station_move'
            } : undefined,
            // B.6: Show notification with remaining sets
            notification: changeStation ? undefined : {
                show: !isGroupRoutine ? true : false,
                message: `${remainingSets}`
            },
            // B.7: Do not show videos
            videos: this.composeWorkoutModulesVideos(item)
        };
        if (isHydrate) workoutScreenData = {
            type: 'hydrate',
            // B.1: Show header without date and time
            header: {
                show: true,
                icon: '/img/dumbbell.svg',
                title: title
            },
            // B.2: Show progress circle with time and red color
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                color: 'red'
            },
            batteryMedium: {
                show: true,
                message: 'recover'
            },
            progressBar: undefined,
            sets: undefined,
            stay: undefined,
            changeStation: undefined,
            notification: undefined,
            videos: this.composeWorkoutModulesVideos(item)
        };
        if (isStarting || isIntroduction) workoutScreenData = {
            type: 'starting',
            header: {
                show: false,
                icon: '/img/dumbbell.svg',
                title: title
            },
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                color: 'red'
            },
            progressBar: undefined,
            sets: undefined,
            stay: undefined,
            changeStation: undefined,
            notification: {
                show: true,
                message: isStarting ? 'get_ready' : 'introduction'
            },
            videos: this.composeWorkoutModulesVideos(item)
        };
        if (isEnding) workoutScreenData = {
            type: 'ending',
            header: {
                show: true,
                icon: '/img/dumbbell.svg',
                title: title
            },
            progressCircle: {
                show: true,
                initialTotalTime: 0,
                color: 'red'
            },
            progressBar: undefined,
            sets: undefined,
            stay: undefined,
            changeStation: undefined,
            notification: undefined,
            finish: {
                show: true,
                message: 'finish',
                icon: item.classSchedule?.workout.image && item.classSchedule?.workout.image ? this.configService.getFilesStorageUrl() + item.classSchedule?.workout.image : undefined
            },
            videos: undefined
        };
        if (workoutScreenData.type !== 'warmup') // define layout type for every moment if it's not an warmup
        workoutScreenData.layoutType = layoutType;
        return workoutScreenData;
    }
    renderTimerWorkout(item) {
        // Check if the renderItemType is EXERCISE and there is exerciseTask info
        if (item.renderItemType !== (0, _renderTypes.RenderItemType).TIMER || !item.renderItemInfo || !item.renderItemInfo.exerciseTask) return {};
        const { exerciseTask } = item.renderItemInfo;
        // If the task used is the starting but is a transiction between group routines and the workout
        if (exerciseTask.type == 'starting' && exerciseTask.is_transaction) exerciseTask.type = 'rest';
        const isWarmUp = exerciseTask.type === 'warmup';
        const isGroupExercises = exerciseTask.type === 'group_exercise';
        const isWork = exerciseTask.type === 'work';
        const isRest = exerciseTask.type === 'rest';
        const isHydrate = exerciseTask.type === 'hydrate';
        const isStarting = exerciseTask.type === 'starting';
        const isIntroduction = exerciseTask.type === 'introduction';
        const isEnding = exerciseTask.type === 'ending';
        const title = item.classSchedule?.workout.exercise_types.join(' + ') || '';
        let workoutScreenData = {};
        const isGroupRoutine = isGroupExercises || isWarmUp;
        if (isWork || isRest || isHydrate || isGroupRoutine) workoutScreenData = {
            isWorkout: true,
            isWorkoutStarting: false,
            workoutName: title,
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                color: isRest ? 'red' : 'green',
                bypassCacheGuid: new Date().getTime().toString()
            },
            totalTime: exerciseTask.total_time || exerciseTask.time,
            currentExercise: exerciseTask.exercises_accumulated || 1,
            totalExercises: exerciseTask.exercises_total || 1,
            totalSets: exerciseTask.is_group_routine ? 1 : exerciseTask.exercises_total,
            totalPods: item.classSchedule?.workout?.movement?.pods || 1,
            currentSetTime: exerciseTask.time,
            currentPod: exerciseTask.current_pod,
            hydrate_active: exerciseTask.hydrate_active,
            hydrate_total: exerciseTask.hydrate_total,
            type: exerciseTask.type,
            podDuration: exerciseTask.is_transaction || isGroupRoutine ? 0 : exerciseTask.podDuration
        };
        if (isStarting || isIntroduction) workoutScreenData = {
            isWorkout: true,
            isWorkoutStarting: isStarting,
            isWorkoutIntroduction: isIntroduction,
            progressCircle: {
                show: true,
                initialTotalTime: item.renderItemInfo.duration || exerciseTask.time,
                color: 'red'
            }
        };
        if (isEnding) workoutScreenData = {
            isWorkout: true,
            isWorkoutStarting: false,
            progressCircle: undefined,
            workoutName: title,
            currentExercise: exerciseTask.exercises_total,
            totalExercises: exerciseTask.exercises_total,
            type: exerciseTask.type
        };
        return workoutScreenData;
    }
    composeWorkoutModulesPersonalTrainer(workoutRenderItem) {
        const cs = workoutRenderItem.classSchedule;
        if (!cs) return {
            show: false,
            name: "",
            job_title: "",
            photo: ""
        };
        const show = workoutRenderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_NEXT_WORKOUT ? true : false;
        const trainerPhoto = this.getTrainerPhoto(cs);
        const workoutModulesPersonalTrainer = {
            show: show,
            name: cs.trainer?.name,
            job_title: cs.trainer?.job_title,
            photo: trainerPhoto
        };
        return workoutModulesPersonalTrainer;
    }
    composeWorkoutModulesVideos(renderItem) {
        const vid = {
            show: false,
            showStations: false,
            exercisesStation: [],
            isGroupRoutine: false
        };
        const classSchedule = renderItem.classSchedule;
        if (!classSchedule) return {
            show: false,
            showStations: false,
            exercisesStation: []
        };
        const isRestingTask = renderItem.renderItemInfo?.exerciseTask?.type === 'rest' || renderItem.renderItemInfo?.exerciseTask?.type === 'hydrate';
        if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_NEXT_WORKOUT) {
            vid.show = true;
            vid.isGroupRoutine = renderItem.classSchedule?.workout?.workout_single_station ? true : false;
            vid.showStations = vid.isGroupRoutine ? false : true;
            vid.exercisesStation = this.composeExerciseInfo(classSchedule);
        } else if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_ABOUT_TO_START) {
            vid.show = true;
            vid.showStations = true;
            vid.exercisesStation = this.composeExerciseInfo(classSchedule);
        } else if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE) {
            let show = true;
            if (isRestingTask) show = false;
            const isWarmUp = renderItem.renderItemInfo?.exerciseTask?.type === 'warmup';
            const isGoupExercises = renderItem.renderItemInfo?.exerciseTask?.type === 'group_exercise';
            const isGroupRoutine = isWarmUp || renderItem.renderItemInfo?.exerciseTask?.is_group_routine || isGoupExercises;
            vid.show = show;
            vid.showStations = isGroupRoutine ? false : true;
            vid.exercisesStation = this.composeExerciseInfo(classSchedule, renderItem.renderItemInfo?.exerciseTask);
            vid.isGroupRoutine = isGroupRoutine;
        }
        if (vid.isGroupRoutine) {
            let currSet = renderItem.renderItemInfo?.exerciseTask?.exercises_accumulated || 1;
            // on resting tasks on a group routine we want to move the next exercise to the top
            currSet = isRestingTask ? currSet + 1 : currSet;
            // Performance wise: only send the number of videos that will be present on the screen
            vid.exercisesStation = vid.exercisesStation?.slice(currSet - 1, currSet + 2);
        }
        return vid;
    }
    composeProgressCircle(renderItem) {
        const pg = {
            show: false,
            initialTotalTime: 0
        };
        if (!renderItem) return pg;
        if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_NEXT_WORKOUT) {
            pg.show = true;
            pg.initialTotalTime = renderItem.duration ? renderItem.duration : 0;
        } else if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_ABOUT_TO_START) {
            pg.show = true;
            pg.initialTotalTime = renderItem.duration ? renderItem.duration : 0;
        } else if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE) {
            pg.show = true;
            pg.initialTotalTime = renderItem.renderItemInfo?.exerciseTask?.time || 0;
            pg.color = renderItem.renderItemInfo?.exerciseTask?.type === 'work' ? 'green' : 'red';
        }
        return pg;
    }
    composeWorkoutModulesHeader(renderItem) {
        const cs = renderItem.classSchedule;
        const header = {
            show: false,
            icon: "",
            title: "",
            date: "",
            time: ""
        };
        if (!cs) return header;
        if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_NEXT_WORKOUT) {
            header.show = true;
            header.icon = "/img/goal.svg";
            header.title = cs.workout.exercise_types.join(' + ');
            header.date = renderItem.date;
            header.time = renderItem.time;
        } else if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE_ABOUT_TO_START) {
            header.show = false;
            header.icon = "/img/goal.svg";
            header.title = cs.workout.exercise_types.join(' + ');
            header.date = renderItem.date;
            header.time = renderItem.time;
        } else if (renderItem.renderItemType === (0, _renderTypes.RenderItemType).EXERCISE) {
            header.show = false;
            header.icon = "/img/dumbbell.svg";
            header.title = cs.workout.exercise_types.join(' + ');
            header.date = "";
            header.time = "";
        }
        return header;
    }
    composeExerciseInfo(classSchedule, task) {
        const exerciseInfoList = [];
        const workout = classSchedule?.workout;
        if (workout) {
            const isWarmup = task?.type == 'warmup';
            const isGroupRoutine = task?.type == 'group_exercise';
            let exercises = [];
            if (isWarmup) exercises = workout.warmup?.exercises;
            else if (isGroupRoutine) exercises = workout.workout_group_routines.find((wgr)=>wgr.phase == task.phase && wgr.group_routine.id == task.routine_id)?.group_routine?.exercises;
            else exercises = workout.exercises?.map((exerciseItem)=>({
                    ...exerciseItem.exercise,
                    station_number: exerciseItem.station_number,
                    target: exerciseItem.target
                })) || [];
            for (const exercise of exercises)exerciseInfoList.push({
                id: exercise.id,
                name: exercise.name,
                video: this.configService.getFilesStorageUrl() + exercise.video,
                station_number: exercise.station_number?.toString(),
                type: exercise.type,
                target: exercise.target
            });
        }
        return exerciseInfoList;
    }
    // #endregion
    // #region Aux Methods
    getTrainerPhoto(cs) {
        return this.configService.getFilesStorageUrl() && cs.trainer?.profile_image ? this.configService.getFilesStorageUrl() + cs.trainer.profile_image : undefined;
    }
    getNotificationMessage(item) {
        let notification = {
            show: false,
            message: '',
            time: 0,
            showOnTimeLeft: 0
        };
        if (!item.renderItemInfo || !item.renderItemInfo.exerciseTask) return notification;
        notification.show = true;
        notification.showOnTimeLeft = 15;
        notification.time = item.renderItemInfo.exerciseTask.time;
        if (item.renderItemInfo.exerciseTask.pod_change) notification.message = 'set_pod_move';
        else if (!item.renderItemInfo.exerciseTask.station_change && item.renderItemInfo.exerciseTask.remaining_sets !== 0) notification.message = 'set_station';
        else if (item.renderItemInfo.exerciseTask.station_change && item.renderItemInfo.exerciseTask.remaining_sets === 0) notification.message = 'set_station_move';
        return notification;
    }
}

},{"eventemitter3":"g0kuJ","../utils/logger.utils":"jsBaU","./events.service":"hklsm","./config.service":"gpIRk","../types/events.type":"5nuR4","../types/render.types":"4ztcW","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"pIs5H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeLanguage", ()=>changeLanguage);
parcelHelpers.export(exports, "getStoredLanguage", ()=>getStoredLanguage);
parcelHelpers.export(exports, "initializeLanguage", ()=>initializeLanguage);
var _i18N = require("../locales/i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
const changeLanguage = (language)=>{
    // Change the current language using the i18n internationalization framework
    (0, _i18NDefault.default).changeLanguage(language);
    // Persist the language preference in local storage to retain it across sessions
    localStorage.setItem('language', language);
};
const getStoredLanguage = ()=>{
    return localStorage.getItem('language');
};
const initializeLanguage = (defaultLanguage)=>{
    const storedLanguage = getStoredLanguage();
    // Use stored language if available; otherwise, use the default
    if (storedLanguage) changeLanguage(storedLanguage);
    else changeLanguage(defaultLanguage);
};

},{"../locales/i18n":"7WMTA","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"7WMTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _i18Next = require("i18next");
var _i18NextDefault = parcelHelpers.interopDefault(_i18Next);
var _reactI18Next = require("react-i18next");
var _translationJson = require("./en/translation.json");
var _translationJsonDefault = parcelHelpers.interopDefault(_translationJson);
var _translationJson1 = require("./pt/translation.json");
var _translationJsonDefault1 = parcelHelpers.interopDefault(_translationJson1);
// Function to get the initial language setting
const getInitialLanguage = ()=>{
    // Check for a saved language in local storage or use the browser's default language
    const savedLanguage = localStorage.getItem('language');
    const browserLanguage = navigator.language.split('-')[0]; // e.g., 'en' from 'en-US'
    // Default to saved language, then browser language, then fallback to English
    return savedLanguage || browserLanguage || 'en';
};
(0, _i18NextDefault.default).use((0, _reactI18Next.initReactI18next)).init({
    resources: {
        en: {
            translation: (0, _translationJsonDefault.default)
        },
        pt: {
            translation: (0, _translationJsonDefault1.default)
        }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});
exports.default = (0, _i18NextDefault.default);

},{"i18next":"bkZYT","react-i18next":"k5Ajr","./en/translation.json":"iUowU","./pt/translation.json":"2jp9m","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"bkZYT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeLanguage", ()=>changeLanguage);
parcelHelpers.export(exports, "createInstance", ()=>createInstance);
parcelHelpers.export(exports, "default", ()=>instance);
parcelHelpers.export(exports, "dir", ()=>dir);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "getFixedT", ()=>getFixedT);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadResources", ()=>loadResources);
parcelHelpers.export(exports, "reloadResources", ()=>reloadResources);
parcelHelpers.export(exports, "setDefaultNamespace", ()=>setDefaultNamespace);
parcelHelpers.export(exports, "t", ()=>t);
parcelHelpers.export(exports, "use", ()=>use);
const isString = (obj)=>typeof obj === 'string';
const defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const lastOfPathSeparatorRegExp = /###/g;
const cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
const canNotTraverseDeeper = (object)=>!object || isString(object);
const getLastOfPath = (object, path, Empty)=>{
    const stack = !isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper(object)) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
};
const setPath = (object, path, newValue)=>{
    const { obj, k } = getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const pushPath = (object, path, newValue, concat)=>{
    const { obj, k } = getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const getPath = (object, path)=>{
    const { obj, k } = getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const getPathWithDefaults = (data, defaultData, key)=>{
    const value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
};
const deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const escape = (data)=>{
    if (isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>_entityMap[s]);
    return data;
};
class RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
const looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const getCleanedCode = (code)=>code && code.replace('_', '-');
const consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new Logger(this.logger, options);
    }
}
var baseLogger = new Logger();
class EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class ResourceStore extends EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !isString(key)) return result;
        return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const checkedLoadedFor = {};
class Translator extends EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key,
                namespaces: isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key,
            namespaces: isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key, namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !isString(options.count);
            const hasDefaultValue = Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey,
            exactUsedKey,
            usedLng,
            usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (isString(code) && code.indexOf('-') > -1) {
            if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if (isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if (isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let _rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const intlVersions = [
    'v4'
];
const suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const createRules = ()=>{
    const rules = {};
    sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const cleanedCode = getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode,
                type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            let rule;
            try {
                rule = new Intl.PluralRules(cleanedCode, {
                    type
                });
            } catch (err) {
                if (!code.match(/-|_/)) return;
                const lngPart = this.languageUtils.getLanguagePartFromCode(code);
                rule = this.getRule(lngPart, options);
            }
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && isString(key)) {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue, useRawValueToEscape, prefix, prefixEscaped, suffix, suffixEscaped, formatSeparator, unescapeSuffix, unescapePrefix, nestingPrefix, nestingPrefixEscaped, nestingSuffix, nestingSuffixEscaped, nestingOptionsSeparator, maxReplaces, alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!isString(value) && !this.useRawValueToEscape) value = makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !isString(value)) return value;
            if (!isString(value)) value = makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName,
        formatOptions
    };
};
const createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn(getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName, formatOptions } = parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class Connector extends EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            pushPath(q.loaded, [
                lng
            ], ns);
            removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng,
                ns,
                fcName,
                tried,
                wait,
                callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if (isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if (isString(args[1])) ret.defaultValue = args[1];
            if (isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const transformOptions = (options)=>{
    if (isString(options.ns)) options.ns = [
        options.ns
    ];
    if (isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if (isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const noop = ()=>{};
const bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class I18n extends EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = transformOptions(options);
        this.services = {};
        this.logger = baseLogger;
        this.modules = {
            external: []
        };
        bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = Formatter;
            const lu = new LanguageUtil(this.options);
            this.store = new ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
        let usedCallback = callback;
        const usedLng = isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = defer();
        if (isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
const createInstance = instance.createInstance;
const dir = instance.dir;
const init = instance.init;
const loadResources = instance.loadResources;
const reloadResources = instance.reloadResources;
const use = instance.use;
const changeLanguage = instance.changeLanguage;
const getFixedT = instance.getFixedT;
const t = instance.t;
const exists = instance.exists;
const setDefaultNamespace = instance.setDefaultNamespace;
const hasLoadedNamespace = instance.hasLoadedNamespace;
const loadNamespaces = instance.loadNamespaces;
const loadLanguages = instance.loadLanguages;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"k5Ajr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trans", ()=>(0, _transJs.Trans));
parcelHelpers.export(exports, "TransWithoutContext", ()=>(0, _transWithoutContextJs.Trans));
parcelHelpers.export(exports, "useTranslation", ()=>(0, _useTranslationJs.useTranslation));
parcelHelpers.export(exports, "withTranslation", ()=>(0, _withTranslationJs.withTranslation));
parcelHelpers.export(exports, "Translation", ()=>(0, _translationJs.Translation));
parcelHelpers.export(exports, "I18nextProvider", ()=>(0, _i18NextProviderJs.I18nextProvider));
parcelHelpers.export(exports, "withSSR", ()=>(0, _withSSRJs.withSSR));
parcelHelpers.export(exports, "useSSR", ()=>(0, _useSSRJs.useSSR));
parcelHelpers.export(exports, "initReactI18next", ()=>(0, _initReactI18NextJs.initReactI18next));
parcelHelpers.export(exports, "setDefaults", ()=>(0, _defaultsJs.setDefaults));
parcelHelpers.export(exports, "getDefaults", ()=>(0, _defaultsJs.getDefaults));
parcelHelpers.export(exports, "setI18n", ()=>(0, _i18NInstanceJs.setI18n));
parcelHelpers.export(exports, "getI18n", ()=>(0, _i18NInstanceJs.getI18n));
parcelHelpers.export(exports, "I18nContext", ()=>(0, _contextJs.I18nContext));
parcelHelpers.export(exports, "composeInitialProps", ()=>(0, _contextJs.composeInitialProps));
parcelHelpers.export(exports, "getInitialProps", ()=>(0, _contextJs.getInitialProps));
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "time", ()=>time);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "select", ()=>select);
parcelHelpers.export(exports, "plural", ()=>plural);
parcelHelpers.export(exports, "selectOrdinal", ()=>selectOrdinal);
var _transJs = require("./Trans.js");
var _transWithoutContextJs = require("./TransWithoutContext.js");
var _useTranslationJs = require("./useTranslation.js");
var _withTranslationJs = require("./withTranslation.js");
var _translationJs = require("./Translation.js");
var _i18NextProviderJs = require("./I18nextProvider.js");
var _withSSRJs = require("./withSSR.js");
var _useSSRJs = require("./useSSR.js");
var _initReactI18NextJs = require("./initReactI18next.js");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
var _contextJs = require("./context.js");
const date = ()=>'';
const time = ()=>'';
const number = ()=>'';
const select = ()=>'';
const plural = ()=>'';
const selectOrdinal = ()=>'';

},{"./Trans.js":"d33qr","./TransWithoutContext.js":"4ytJY","./useTranslation.js":"feMFC","./withTranslation.js":"blWOT","./Translation.js":"4ryq7","./I18nextProvider.js":"gEgWK","./withSSR.js":"ht0n9","./useSSR.js":"3w1Rs","./initReactI18next.js":"klhTI","./defaults.js":"eyab5","./i18nInstance.js":"1sCMN","./context.js":"pI7w4","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"d33qr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>(0, _transWithoutContextJs.nodesToString));
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _react = require("react");
var _transWithoutContextJs = require("./TransWithoutContext.js");
var _contextJs = require("./context.js");
function Trans({ children, count, parent, i18nKey, context, tOptions = {}, values, defaults, components, ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, _transWithoutContextJs.Trans)({
        children,
        count,
        parent,
        i18nKey,
        context,
        tOptions,
        values,
        defaults,
        components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n,
        t: tFromProps,
        shouldUnescape,
        ...additionalProps
    });
}

},{"react":"bmhQu","./TransWithoutContext.js":"4ytJY","./context.js":"pI7w4","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4ytJY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>nodesToString);
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _react = require("react");
var _htmlParseStringify = require("html-parse-stringify");
var _htmlParseStringifyDefault = parcelHelpers.interopDefault(_htmlParseStringify);
var _utilsJs = require("./utils.js");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
const hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? getAsArray(children) : children;
};
const hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, _react.isValidElement));
const getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const nodesToString = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, _utilsJs.isString)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, _react.isValidElement)(child)) {
            const { props, type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, _utilsJs.isString)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = nodesToString(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, _utilsJs.warn)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey
            });
            return;
        }
        if ((0, _utilsJs.isObject)(child)) {
            const { format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, _utilsJs.warn)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey,
                child
            });
            return;
        }
        (0, _utilsJs.warn)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey,
            child
        });
    });
    return stringNode;
};
const renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, _utilsJs.isString)(child)) return;
            if (hasChildren(child)) getData(getChildren(child));
            else if ((0, _utilsJs.isObject)(child) && !(0, _react.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, _htmlParseStringifyDefault.default).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, _react.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, _react.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, _react.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.props.ref ?? c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = getAsArray(reactNode);
        const astNodes = getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, _react.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, _utilsJs.isObject)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, _utilsJs.isObject)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, _utilsJs.isString)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if (hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, _react.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, _react.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, _utilsJs.isObject)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, _react.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, getAsArray(children || []));
    return getChildren(result[0]);
};
const fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, _react.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, _react.createElement)((0, _react.Fragment), null, comp);
    }
    return (0, _react.createElement)(Componentized, {
        key: componentKey
    });
};
const generateArrayComponents = (components, translation)=>components.map((c, index)=>fixComponentProps(c, index, translation));
const generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return generateArrayComponents(components, translation);
    if ((0, _utilsJs.isObject)(components)) return generateObjectComponents(components, translation);
    (0, _utilsJs.warnOnce)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey
    });
    return null;
};
const isComponentsMap = (object)=>{
    if (!(0, _utilsJs.isObject)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function Trans({ children, count, parent, i18nKey, context, tOptions = {}, values, defaults, components, ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, _i18NInstanceJs.getI18n)();
    if (!i18n) {
        (0, _utilsJs.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, _defaultsJs.getDefaults)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, _utilsJs.isString)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = nodesToString(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count,
        ...values,
        ...interpolationOverride,
        defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if (isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, _react.createElement)(useAsParent, additionalProps, content) : content;
}

},{"react":"bmhQu","html-parse-stringify":"jryGq","./utils.js":"xEEW3","./defaults.js":"eyab5","./i18nInstance.js":"1sCMN","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"jryGq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _voidElements = require("void-elements");
var _voidElementsDefault = parcelHelpers.interopDefault(_voidElements);
var e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, _voidElementsDefault.default)[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp(e), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var l = c[1].trim(), o = [
                l,
                ""
            ];
            l.indexOf("=") > -1 && (o = l.split("=")), r.attrs[o[0]] = o[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i = /^\s*$/, s = Object.create(null);
function a(t, e) {
    switch(e.type){
        case "text":
            return t + e.content;
        case "tag":
            return t += "<" + e.name + (e.attrs ? function(t) {
                var e = [];
                for(var n in t)e.push(n + '="' + t[n] + '"');
                return e.length ? " " + e.join(" ") : "";
            }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce(a, "") + "</" + e.name + ">";
        case "comment":
            return t + "\x3c!--" + e.comment + "--\x3e";
    }
}
var c = {
    parse: function(t, e) {
        e || (e = {}), e.components || (e.components = s);
        var a, c = [], l = [], o = -1, u = !1;
        if (0 !== t.indexOf("<")) {
            var h = t.indexOf("<");
            c.push({
                type: "text",
                content: -1 === h ? t : t.substring(0, h)
            });
        }
        for(var v, f = []; v = r.exec(t);)f.push(v);
        return f.forEach(function(t, e) {
            var n = t[0];
            if (n && !n.startsWith("\x3c!--")) {
                for(var r = 0, i = 0, s = -1, a = null, c = 0; c < n.length; c++){
                    var l = n.charAt(c);
                    a ? l === a && (a = null) : '"' === l || "'" === l ? a = l : "<" === l ? 2 == ++r && (s = c) : ">" === l && i++;
                }
                var o = s > -1 && /[a-zA-Z0-9\-!/]/.test(n.charAt(s + 1));
                if (r > i && o) {
                    var u = n.substring(0, s), h = n.substring(u.length);
                    f[e][0] = h, f[e].index += u.length;
                }
            }
        }), f.forEach(function(r, s) {
            var h = r[0];
            if (h) {
                var v = r.index;
                if (u) {
                    if (h !== "</" + a.name + ">") return;
                    u = !1;
                }
                var m, d, p = "/" !== h.charAt(1), x = h.startsWith("\x3c!--"), g = v + h.length, y = t.charAt(g), E = f[s + 1];
                if ("<" === y && E) {
                    var A = t.substring(g, E.index);
                    m = A.split("<").length > A.split(">").length;
                }
                if (x) {
                    var b = n(h);
                    if (o < 0) return c.push(b), c;
                    (d = l[o]).children.push(b);
                    var O = t.slice(g, E ? E.index : void 0);
                    return O.length > 0 && d.children.push({
                        type: "text",
                        content: O
                    }), c;
                }
                if (p && (o++, "tag" === (a = n(h)).type && e.components[a.name] && (a.type = "component", u = !0), a.voidElement || u || !y || "<" === y || a.children.push({
                    type: "text",
                    content: t.slice(g, E ? E.index : void 0)
                }), 0 === o && c.push(a), (d = l[o - 1]) && d.children.push(a), l[o] = a), (!p || a.voidElement) && (o > -1 && (a.voidElement || a.name === h.slice(2, -1)) && (o--, a = -1 === o ? c : l[o]), !u && ("<" !== y || m) && y)) {
                    d = -1 === o ? c : l[o].children;
                    var W = E ? E.index : -1, j = t.slice(g, -1 === W ? void 0 : W);
                    i.test(j) && (j = " "), (W > -1 && o + d.length >= 0 || " " !== j) && d.push({
                        type: "text",
                        content: j
                    });
                }
            }
        }), c;
    },
    stringify: function(t) {
        return t.reduce(function(t, e) {
            return t + a("", e);
        }, "");
    }
};
exports.default = c;

},{"void-elements":"b4L74","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"b4L74":[function(require,module,exports,__globalThis) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

},{}],"xEEW3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isObject", ()=>isObject);
const warn = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if (isString(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const alreadyWarned = {};
const warnOnce = (i18n, code, msg, rest)=>{
    if (isString(msg) && alreadyWarned[msg]) return;
    if (isString(msg)) alreadyWarned[msg] = new Date();
    warn(i18n, code, msg, rest);
};
const loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const loadNamespaces = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, loadedClb(i18n, cb));
};
const loadLanguages = (i18n, lng, ns, cb)=>{
    if (isString(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return loadNamespaces(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, loadedClb(i18n, cb));
};
const hasLoadedNamespace = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        warnOnce(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n?.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const getDisplayName = (Component)=>Component.displayName || Component.name || (isString(Component) && Component.length > 0 ? Component : 'Unknown');
const isString = (obj)=>typeof obj === 'string';
const isObject = (obj)=>typeof obj === 'object' && obj !== null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"eyab5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDefaults", ()=>setDefaults);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
var _unescapeJs = require("./unescape.js");
let defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, _unescapeJs.unescape)
};
const setDefaults = (options = {})=>{
    defaultOptions = {
        ...defaultOptions,
        ...options
    };
};
const getDefaults = ()=>defaultOptions;

},{"./unescape.js":"6vZI4","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"6vZI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unescape", ()=>unescape);
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const unescapeHtmlEntity = (m)=>htmlEntities[m];
const unescape = (text)=>text.replace(matchHtmlEntity, unescapeHtmlEntity);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"1sCMN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setI18n", ()=>setI18n);
parcelHelpers.export(exports, "getI18n", ()=>getI18n);
let i18nInstance;
const setI18n = (instance)=>{
    i18nInstance = instance;
};
const getI18n = ()=>i18nInstance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"pI7w4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaults", ()=>(0, _defaultsJs.getDefaults));
parcelHelpers.export(exports, "setDefaults", ()=>(0, _defaultsJs.setDefaults));
parcelHelpers.export(exports, "getI18n", ()=>(0, _i18NInstanceJs.getI18n));
parcelHelpers.export(exports, "setI18n", ()=>(0, _i18NInstanceJs.setI18n));
parcelHelpers.export(exports, "initReactI18next", ()=>(0, _initReactI18NextJs.initReactI18next));
parcelHelpers.export(exports, "I18nContext", ()=>I18nContext);
parcelHelpers.export(exports, "ReportNamespaces", ()=>ReportNamespaces);
parcelHelpers.export(exports, "composeInitialProps", ()=>composeInitialProps);
parcelHelpers.export(exports, "getInitialProps", ()=>getInitialProps);
var _react = require("react");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
var _initReactI18NextJs = require("./initReactI18next.js");
const I18nContext = (0, _react.createContext)();
class ReportNamespaces {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const composeInitialProps = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = getInitialProps();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const getInitialProps = ()=>{
    const i18n = (0, _i18NInstanceJs.getI18n)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};

},{"react":"bmhQu","./defaults.js":"eyab5","./i18nInstance.js":"1sCMN","./initReactI18next.js":"klhTI","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"klhTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initReactI18next", ()=>initReactI18next);
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
const initReactI18next = {
    type: '3rdParty',
    init (instance) {
        (0, _defaultsJs.setDefaults)(instance.options.react);
        (0, _i18NInstanceJs.setI18n)(instance);
    }
};

},{"./defaults.js":"eyab5","./i18nInstance.js":"1sCMN","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"feMFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTranslation", ()=>useTranslation);
var _react = require("react");
var _contextJs = require("./context.js");
var _utilsJs = require("./utils.js");
const usePrevious = (value, ignore)=>{
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, _react.useCallback)(alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const useTranslation = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, _contextJs.ReportNamespaces)();
    if (!i18n) {
        (0, _utilsJs.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, _utilsJs.isString)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, _utilsJs.isObject)(optsOrDefaultValue) && (0, _utilsJs.isString)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, _utilsJs.warnOnce)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, _contextJs.getDefaults)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense, keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, _utilsJs.isString)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, _utilsJs.hasLoadedNamespace)(n, i18n, i18nOptions));
    const memoGetT = useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, _react.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = usePrevious(joinedNS);
    const isMounted = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        const { bindI18n, bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, _utilsJs.loadLanguages)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, _utilsJs.loadNamespaces)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n) bindI18n?.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, _react.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, _utilsJs.loadLanguages)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, _utilsJs.loadNamespaces)(i18n, namespaces, ()=>resolve());
    });
};

},{"react":"bmhQu","./context.js":"pI7w4","./utils.js":"xEEW3","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"blWOT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withTranslation", ()=>withTranslation);
var _react = require("react");
var _useTranslationJs = require("./useTranslation.js");
var _utilsJs = require("./utils.js");
const withTranslation = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, _useTranslationJs.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t,
                i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, _react.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, _utilsJs.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, _react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, _react.forwardRef)(forwardRef) : I18nextWithTranslation;
    };

},{"react":"bmhQu","./useTranslation.js":"feMFC","./utils.js":"xEEW3","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4ryq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Translation", ()=>Translation);
var _useTranslationJs = require("./useTranslation.js");
const Translation = ({ ns, children, ...options })=>{
    const [t, i18n, ready] = (0, _useTranslationJs.useTranslation)(ns, options);
    return children(t, {
        i18n,
        lng: i18n.language
    }, ready);
};

},{"./useTranslation.js":"feMFC","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"gEgWK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nextProvider", ()=>I18nextProvider);
var _react = require("react");
var _contextJs = require("./context.js");
function I18nextProvider({ i18n, defaultNS, children }) {
    const value = (0, _react.useMemo)(()=>({
            i18n,
            defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, _react.createElement)((0, _contextJs.I18nContext).Provider, {
        value
    }, children);
}

},{"react":"bmhQu","./context.js":"pI7w4","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"ht0n9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSSR", ()=>withSSR);
var _react = require("react");
var _useSSRJs = require("./useSSR.js");
var _contextJs = require("./context.js");
var _utilsJs = require("./utils.js");
const withSSR = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore, initialLanguage, ...rest }) {
            (0, _useSSRJs.useSSR)(initialI18nStore, initialLanguage);
            return (0, _react.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, _contextJs.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, _utilsJs.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };

},{"react":"bmhQu","./useSSR.js":"3w1Rs","./context.js":"pI7w4","./utils.js":"xEEW3","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"3w1Rs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSSR", ()=>useSSR);
var _react = require("react");
var _contextJs = require("./context.js");
const useSSR = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};

},{"react":"bmhQu","./context.js":"pI7w4","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"iUowU":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"exercise_type\":{\"Strength\":\"Strength\",\"Cardio\":\"Cardio\",\"Mobility\":\"Mobility\",\"default\":\"Exercise\"},\"period\":{\"morning\":\"Morning\",\"afternoon\":\"Afternoon\",\"night\":\"Night\",\"default\":\"Morning\"},\"week_day_short\":{\"Monday\":\"Monday\",\"Tuesday\":\"Tuesday\",\"Wednesday\":\"Wednesday\",\"Thursday\":\"Thursday\",\"Friday\":\"Friday\",\"Saturday\":\"Saturday\",\"Sunday\":\"Sunday\",\"default\":\"Monday\"},\"today\":\"Today\",\"stay\":{\"station\":\"Stay in this Station\",\"pod\":\"Stay in this Base\",\"station_move\":\"Move to next Station\",\"pod_move\":\"Move to next Base\",\"set_station\":\"After this Set, stay in this Station\",\"set_station_move\":\"After this Set, move to next Station\",\"set_pod_move\":\"After this Set, move to next Base\",\"get_ready\":\"Get Ready\",\"introduction\":\"Introduction\"},\"sets_number_one\":\"{{count}} set left\",\"sets_number_other\":\"{{count}} sets left\",\"group_exercise\":\"Group\",\"stations\":\"Stations\",\"pods\":\"Bases\",\"sets\":\"Sets\",\"laps\":\"Laps\",\"finish\":{\"finish\":\"Workout completed.\"},\"hydrate\":{\"recover\":\"Recover\"},\"next_class\":\"Next Class\"}");

},{}],"2jp9m":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"exercise_type":{"Strength":"For\xe7a","Cardio":"Cardio","Mobility":"Mobilidade","default":"Exerc\xedcio"},"period":{"morning":"Manh\xe3","afternoon":"Tarde","night":"Noite","default":"Morning"},"week_day_short":{"Monday":"Segunda","Tuesday":"Ter\xe7a","Wednesday":"Quarta","Thursday":"Quinta","Friday":"Sexta","Saturday":"S\xe1bado","Sunday":"Domingo","default":"Segunda"},"today":"Hoje","stay":{"station":"FICA NA ESTA\xc7\xc3O","pod":"CONTINUA NESTA BASE","station_move":"TROCA DE ESTA\xc7\xc3O","pod_move":"TROCA DE BASE","set_station":"Ap\xf3s este Set, fica na Esta\xe7\xe3o","set_station_move":"Ap\xf3s este Set, troca de Esta\xe7\xe3o","set_pod_move":"Ap\xf3s este Set, troca de Base","get_ready":"Prepara-te","introduction":"Introdu\xe7\xe3o"},"sets_number_one":"Ainda falta {{count}} set","sets_number_other":"Ainda faltam {{count}} sets","stations":"Esta\xe7\xf5es","sets":"Sets","exercise":"Exerc\xedcio","work":"Exerc\xedcio","warmup":"Aquecimento","group_exercise":"Grupo","hydration":"Intervalo","rest":"Descanso","pods":"Bases","total_time":"Tempo Total","laps":"Voltas","finish":{"finish":"BOM TRABALHO"},"hydrate":{"recover":"DESCANSAR"},"next_class":"Pr\xf3xima aula"}');

},{}],"lCZDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Exercise", ()=>Exercise);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _soundPlayer = require("../../components/vertical/SoundPlayer/SoundPlayer");
var _soundPlayerDefault = parcelHelpers.interopDefault(_soundPlayer);
var _progressBar = require("../../components/vertical/ProgressBar");
var _video = require("../../components/vertical/Video");
var _header = require("../../components/vertical/Header");
var _hydrate = require("../../components/vertical/Hydrate");
var _changeStation = require("../../components/vertical/ChangeStation");
var _components = require("../../components");
var _notification = require("../../components/vertical/Notification");
var _finish = require("../../components/vertical/Finish");
var _reactI18Next = require("react-i18next");
var _exerciseCss = require("./Exercise.css");
const Exercise = ({ screenData, timerControlRef, onLoad })=>{
    const [timeLeft, setTimeLeft] = (0, _react.useState)(null);
    const { t } = (0, _reactI18Next.useTranslation)();
    (0, _react.useEffect)(()=>{
        if (screenData && screenData.type !== "work" && screenData.progressCircle && screenData.progressCircle.initialTotalTime !== undefined) setTimeLeft(screenData.progressCircle.initialTotalTime); // Initialize with the total time
    }, [
        screenData,
        screenData?.progressCircle?.initialTotalTime
    ]);
    (0, _react.useEffect)(()=>{
        if (timeLeft !== null && timeLeft > 0) {
            const timer = setInterval(()=>{
                setTimeLeft((prevTime)=>prevTime !== null ? prevTime - 1 : null);
            }, 1000); // Decrease the time every second
            return ()=>clearInterval(timer); // Cleanup timer on component unmount
        }
    }, [
        timeLeft
    ]);
    (0, _react.useEffect)(()=>{
        if (onLoad) onLoad(); // Notify that this component has finished loading
    }, [
        onLoad
    ]);
    if (!screenData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "workout",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "container-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Loading), {
                    message: "Loading..."
                })
            })
        })
    });
    else {
        const halfTaskTime = screenData.progressCircle?.initialTotalTime ? screenData.progressCircle?.initialTotalTime / 2 : 1;
        const showVideos = screenData.type !== "rest" && screenData.type !== "hydrate" ? true : timeLeft && timeLeft <= halfTaskTime;
        const showStayOrChangeStation = screenData.type === "rest" && timeLeft && timeLeft > halfTaskTime;
        const showHydrate = screenData.type === "hydrate" && timeLeft && timeLeft > halfTaskTime;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "workout",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "container-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "container",
                    children: [
                        screenData.header?.show && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                            icon: screenData.header.icon,
                            label: t('next_class'),
                            time: screenData.header.time
                        }),
                        screenData.progressCircle?.show && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ProgressCircle), {
                            ref: timerControlRef,
                            initialTotalTime: screenData.progressCircle.initialTotalTime,
                            color: screenData.progressCircle.color,
                            bypassCacheGuid: screenData.progressCircle.bypassCacheGuid
                        }),
                        screenData.progressBar?.show && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBar.ProgressBar), {
                            total: screenData.progressBar.numberOfElements,
                            progress: screenData.progressBar.progress,
                            label: screenData.progressBar.label,
                            time: screenData.progressBar.time,
                            hideOnTimeLeft: screenData.progressBar.hideOnTimeLeft,
                            bypassCacheGuid: Date.now().toString()
                        }),
                        showStayOrChangeStation && screenData.stay && screenData.sets && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stay), {
                            message: screenData.stay?.message,
                            total: screenData.sets.total,
                            active: screenData.sets.active
                        }),
                        showStayOrChangeStation && screenData.changeStation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeStation.ChangeStation), {
                            message: screenData.changeStation?.message
                        }),
                        showHydrate && screenData.batteryMedium && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hydrate.Hydrate), {
                            message: screenData.batteryMedium?.message
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _video.Videos), {
                            hidden: !showVideos,
                            taskType: screenData.type,
                            exerciseStationVideos: screenData.videos?.exercisesStation,
                            showStations: screenData.videos?.showStations,
                            isPersonalTrainerLayout: screenData.personalTrainer ? true : false,
                            isGroupRoutine: screenData.videos?.isGroupRoutine,
                            layoutType: screenData.layoutType
                        }, screenData.type == 'warmup' ? 'warmup' : 'work'),
                        screenData.notification?.show && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notification.Notification2), {
                            message: screenData.notification.message,
                            time: screenData.notification.time,
                            showOnTimeLeft: screenData.notification.showOnTimeLeft,
                            bypassCacheGuid: Date.now().toString()
                        }),
                        screenData.finish?.show && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finish.Finish), {
                            message: screenData.finish.message,
                            img: screenData.finish?.icon
                        }),
                        screenData.personalTrainer?.show && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PersonalTrainer), {
                            name: screenData.personalTrainer.name,
                            jobTitle: screenData.personalTrainer.job_title,
                            photo: screenData.personalTrainer.photo
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _soundPlayerDefault.default), {
                            soundFile: "/sound/notification_alert_ping_bright.mp3",
                            play: false
                        })
                    ]
                })
            })
        });
    }
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../components/vertical/SoundPlayer/SoundPlayer":"gUcWX","../../components/vertical/ProgressBar":"lJDyJ","../../components/vertical/Video":"14bja","../../components/vertical/Header":"1E7ZA","../../components/vertical/Hydrate":"jbytk","../../components/vertical/ChangeStation":"dZRgt","../../components":"4B6OY","../../components/vertical/Notification":"dUUAH","../../components/vertical/Finish":"cZfFy","react-i18next":"k5Ajr","./Exercise.css":"kUMvn","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"gUcWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const SoundPlayer = ({ soundFile, play })=>{
    const audioRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (audioRef.current) {
            if (play) audioRef.current.play().catch((error)=>{
                console.warn("Error playing audio:", error);
            });
            else {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reset playback to the start
            }
        }
    }, [
        play
    ]); // Run effect when `play` changes
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("audio", {
            ref: audioRef,
            src: soundFile,
            preload: "auto"
        })
    });
};
exports.default = SoundPlayer;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"lJDyJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBarDefault.default));
var _progressBar = require("./ProgressBar");
var _progressBarDefault = parcelHelpers.interopDefault(_progressBar);

},{"./ProgressBar":"22Ai5","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"22Ai5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _progressBarCss = require("./ProgressBar.css");
var _reactI18Next = require("react-i18next");
const ProgressBar = ({ total = 10, progress = 0, label = "Stations", time = 0, hideOnTimeLeft, bypassCacheGuid })=>{
    const [currentTime, setCurrentTime] = (0, _react.useState)(time); // state for the current time
    const [show, setShow] = (0, _react.useState)(true); // state for showing the notification
    const [_, setCacheGuid] = (0, _react.useState)(bypassCacheGuid);
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    (0, _react.useEffect)(()=>{
        setCacheGuid(bypassCacheGuid);
        setCurrentTime(time);
    }, [
        bypassCacheGuid
    ]);
    (0, _react.useEffect)(()=>{
        if (time > 0) {
            const interval = setInterval(()=>{
                setCurrentTime((prevTime)=>{
                    if (prevTime > 0) return prevTime - 1;
                    return 0;
                });
            }, 1000);
            return ()=>{
                clearInterval(interval);
            };
        }
    }, [
        time,
        bypassCacheGuid
    ]);
    (0, _react.useEffect)(()=>{
        if (hideOnTimeLeft) {
            if (currentTime <= hideOnTimeLeft) setShow(false);
            else setShow(true);
        }
    }, [
        currentTime,
        hideOnTimeLeft,
        bypassCacheGuid
    ]);
    // Ensure progress doesn't exceed total
    const safeProgress = Math.min(progress, total);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: show && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "workout-progress-bar",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "progress-bar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "percentage",
                        children: t(`${label}`)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "exercises",
                        children: [
                            ...Array(total)
                        ].map((_, index)=>{
                            const isLastProgress = index === safeProgress - 1;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: index < safeProgress ? isLastProgress ? "rectangle blinking" // Apply blinking class to the last progress element
                                 : "rectangle" : "div"
                            }, index);
                        })
                    })
                ]
            })
        })
    }, bypassCacheGuid);
};
exports.default = ProgressBar;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProgressBar.css":"ismR2","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"ismR2":[function() {},{}],"14bja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Videos", ()=>(0, _videosDefault.default));
parcelHelpers.export(exports, "Video", ()=>(0, _videoDefault.default));
var _videos = require("./Videos");
var _videosDefault = parcelHelpers.interopDefault(_videos);
var _video = require("./Video");
var _videoDefault = parcelHelpers.interopDefault(_video);

},{"./Videos":"6QpD6","./Video":"aFLpl","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"6QpD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _videosCss = require("./Videos.css");
var _ = require(".");
const Videos = ({ hidden = false, exerciseStationVideos = [], showStations = false, isPersonalTrainerLayout = false, isGroupRoutine = false, taskType, layoutType = 'vertical' })=>{
    const [applyOverlay, setApplyOverlay] = (0, _react.useState)(false);
    const isSmallLayout = exerciseStationVideos.length <= 4 && layoutType == 'vertical' || isGroupRoutine;
    let overlayClass = `routine-${taskType}-overlay`;
    (0, _react.useEffect)(()=>{
        if (exerciseStationVideos.length > 6) setApplyOverlay(true);
        else setApplyOverlay(false);
    }, [
        exerciseStationVideos
    ]);
    // Remove useMemo and directly render the mapped elements
    const renderedVideos = exerciseStationVideos.map((exercise)=>{
        const containerClass = isSmallLayout ? "small-container" : "large-container";
        const contentClass = isPersonalTrainerLayout ? "pt-content" : isSmallLayout ? "small-content" : "content-2";
        const textClass = isPersonalTrainerLayout ? "pt-text" : isSmallLayout ? "small-text" : "text-5";
        const exerciseTypeIcon = exercise.type == 1 ? '/img/strength.svg' : exercise.type == 2 ? '/img/cardio.svg' : undefined;
        // Optional target of the station (e.g. "100m"). Nothing is rendered when it is not set.
        const target = exercise.target?.trim();
        // The side bars of the small layouts are narrow: the fewer characters, the bigger the text (see Videos.css)
        const targetSize = target && target.length <= 2 ? ' target-xl' : target && target.length === 3 ? ' target-l' : '';
        const targetElement = target ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `station-target${targetSize}`,
            children: target
        }) : null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `video-container ${containerClass} ${isGroupRoutine ? "is-group-routine" : ""} ${overlayClass}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: contentClass,
                children: [
                    showStations && isSmallLayout && isPersonalTrainerLayout && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "workout-movement pt-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text",
                                children: exercise.station_number
                            }),
                            exerciseTypeIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "exercise_type",
                                alt: "Exercise Type Icon",
                                src: exerciseTypeIcon
                            }),
                            targetElement
                        ]
                    }),
                    showStations && isSmallLayout && !isPersonalTrainerLayout && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "workout-movement small-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text",
                                children: exercise.station_number
                            }),
                            exerciseTypeIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "exercise_type",
                                alt: "Exercise Type Icon",
                                src: exerciseTypeIcon
                            }),
                            targetElement
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "workout",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `video video-${exerciseStationVideos.length}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Video), {
                                url: exercise.video
                            }, exercise.id)
                        })
                    }),
                    showStations && !isSmallLayout && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `workout-movement ${applyOverlay ? 'apply-overlay' : ''}${applyOverlay && target ? ' has-target' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: textClass,
                                children: exercise.station_number
                            }),
                            exerciseTypeIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "exercise_type",
                                alt: "Exercise Type Icon",
                                src: exerciseTypeIcon
                            }),
                            targetElement
                        ]
                    })
                ]
            })
        }, `${exercise.station_number}-ex${exercise.id}`);
    });
    if (hidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `videos ${isPersonalTrainerLayout && isSmallLayout ? "pt-layout" : isSmallLayout ? "small-layout" : "large-layout"}	${isGroupRoutine ? "is-group-routine" : ""}`,
        children: renderedVideos
    });
};
exports.default = Videos;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Videos.css":"1plsS",".":"14bja","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"1plsS":[function() {},{}],"aFLpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _videosCss = require("./Videos.css");
// The transformUrl function to modify the video URL correctly
function transformUrl(url) {
    const regex = /(https:\/\/[^/]+\/)exercises\/(\d+)(\.mp4|\.mov)/;
    return url.replace(regex, "$1exercises_converted/540_540_$2$3");
}
// Function to check if a URL exists by sending a HEAD request
async function urlExists(url) {
    try {
        const response = await fetch(url, {
            method: "HEAD"
        });
        if (response.status !== 200) return false;
        return response.ok;
    } catch (error) {
        // Handle CORS error or network issues without logging it to console
        error instanceof TypeError && error.message.includes("Failed to fetch");
        return false; // Assume the URL does not exist
    }
}
const Video = ({ url, onLoad, maxRetries = 3 })=>{
    const videoRef = (0, _react.useRef)(null);
    const [retryCount, setRetryCount] = (0, _react.useState)(0);
    const [finalUrl, setFinalUrl] = (0, _react.useState)(undefined);
    // Proper cleanup only on unmount
    (0, _react.useEffect)(()=>{
        const video = videoRef.current;
        return ()=>{
            // Only run when component is truly unmounted
            if (video && !video.isConnected) {
                video.pause();
                video.src = '';
                video.load();
                video.remove();
            }
        };
    }, []);
    // Handle when the URL changes, transform it, and check if it exists
    (0, _react.useEffect)(()=>{
        if (url) {
            const transformedUrl = transformUrl(url);
            // Check if the transformed URL exists
            urlExists(transformedUrl).then((exists)=>{
                setFinalUrl(exists ? transformedUrl + `?cb=${Date.now()}` : url);
            });
        }
    }, [
        url
    ]);
    // Effect to handle retries on video error
    (0, _react.useEffect)(()=>{
        if (retryCount > maxRetries) {
            console.warn("Max retries exceeded for video loading.");
            return;
        }
    }, [
        retryCount,
        maxRetries
    ]);
    // Event handler for when the video loads successfully
    const handleLoadedData = ()=>{
        if (onLoad) onLoad(); // Notify the parent component
    };
    const handleError = ()=>{
        const video = videoRef.current;
        if (video?.error) {
            const error = video.error;
            // Log the error details
            switch(error.code){
                case error.MEDIA_ERR_ABORTED:
                    console.error("The user aborted the video playback.");
                    break;
                case error.MEDIA_ERR_NETWORK:
                    console.error("A network error caused the video download to fail.");
                    break;
                case error.MEDIA_ERR_DECODE:
                    console.error("The video playback was aborted due to a corruption problem or because the video used features your browser did not support.");
                    break;
                case error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                    console.error("The video could not be loaded because the format is not supported.");
                    break;
                default:
                    console.error("An unknown error occurred.");
                    break;
            }
            // Log the full error object for further debugging
            console.error("Error code:", error.code);
            console.error("Error message:", error.message || "No error message provided");
        }
        // Retry logic
        if (retryCount < maxRetries) setTimeout(()=>{
            setRetryCount((prev)=>prev + 1); // Increment retry count
            video?.load(); // Reload video
            video?.play().catch(()=>{});
        }, 500); // Retry after 500ms
        else console.warn("Max retries exceeded for video loading.");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
        ref: videoRef,
        width: "100%",
        autoPlay: true,
        loop: true,
        muted: true,
        controls: false,
        onLoadedData: handleLoadedData,
        onError: handleError,
        disablePictureInPicture: true,
        disableRemotePlayback: true,
        children: finalUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
            src: finalUrl,
            type: "video/mp4"
        }) : null
    });
};
exports.default = Video;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Videos.css":"1plsS","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"1plsS":[function() {},{}],"1E7ZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>(0, _headerDefault.default));
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);

},{"./Header":"dtKvX","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"dtKvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerCss = require("./Header.css");
var _days = require("../../Days");
var _reactI18Next = require("react-i18next");
const Header = ({ icon, title = '', label, time })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // useTranslation hook
    // Split title into words, translate each word, and then join them back
    const translatedTitle = title.split(" + ") // Split the title into individual words
    .map((word)=>t(`exercise_type.` + word.trim())) // Translate each word separately
    .join(" + "); // Join them back with a space
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "header",
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "dumbbell1",
                        alt: "Workout Icon",
                        src: icon
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text",
                        children: translatedTitle
                    })
                ]
            }),
            label && time && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "dumbbell1",
                        alt: "Date range Icon",
                        src: '/img/date_range.svg'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _days.Day), {
                        label: label,
                        time: time
                    })
                ]
            })
        ]
    });
};
exports.default = Header;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Header.css":"7ZgK5","../../Days":"MYTBq","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"7ZgK5":[function() {},{}],"MYTBq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Day", ()=>(0, _dayDefault.default));
parcelHelpers.export(exports, "DaysWrapper", ()=>(0, _daysWrapperDefault.default));
parcelHelpers.export(exports, "WeekDays", ()=>(0, _weekDaysDefault.default));
var _day = require("./Day");
var _dayDefault = parcelHelpers.interopDefault(_day);
var _daysWrapper = require("./DaysWrapper");
var _daysWrapperDefault = parcelHelpers.interopDefault(_daysWrapper);
var _weekDays = require("./WeekDays");
var _weekDaysDefault = parcelHelpers.interopDefault(_weekDays);

},{"./Day":"4i29B","./DaysWrapper":"2WczR","./WeekDays":"594hG","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4i29B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dayCss = require("./Day.css");
var _datetimeUtils = require("../../utils/datetime.utils");
// Use the props in the component
const Day = ({ label, time, onLoad })=>{
    (0, _react.useEffect)(()=>{
        if (onLoad) onLoad(); // Notify that this component has finished loading
    }, [
        onLoad
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "workout-day",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-wrapper",
                children: "|"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-wrapper",
                children: (0, _datetimeUtils.DateTimeUtils).formatTimeToHHMM(time)
            })
        ]
    });
};
exports.default = Day;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Day.css":"5daF1","../../utils/datetime.utils":"cyuXt","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"5daF1":[function() {},{}],"2WczR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _daysWrapperCss = require("./DaysWrapper.css");
const DaysWrapper = ({ hours = [] })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "horCompDaysWrapper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "horCompDays3",
            children: hours.map((hour, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: index === 0 ? "horCompDay3" : "horCompDay4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "textWrapper3",
                        children: hour.slice(0, 5)
                    })
                }, index))
        })
    });
};
exports.default = DaysWrapper;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./DaysWrapper.css":"4zOcX","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4zOcX":[function() {},{}],"594hG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _weekDaysCss = require("./WeekDays.css");
var _datetimeUtils = require("../../utils/datetime.utils");
var _reactI18Next = require("react-i18next");
const WeekDays = ({ booking, imgpath })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    let getImage = function(image) {
        if (imgpath && image) return imgpath + image;
        return "/img/default_workout_icon.png";
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "horCompWeekDays",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "horCompDays2",
            children: booking && booking.map((data, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: index === 0 ? "horCompDay" : "horCompDay2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "logoCalendar",
                            alt: "Logo calendar",
                            src: getImage(data.image)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "textWrapper",
                            children: index === 0 ? t("today") // Use "today" as the translation key for index 0
                             : t(`week_day_short.${(0, _datetimeUtils.DateTimeUtils).getDayOfWeek(data.date) ?? 'default'}`)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "textWrapper2",
                            children: (0, _datetimeUtils.DateTimeUtils).formatDate(data.date)
                        })
                    ]
                }, index))
        })
    });
};
exports.default = WeekDays;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./WeekDays.css":"71ChS","../../utils/datetime.utils":"cyuXt","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"71ChS":[function() {},{}],"jbytk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrateDefault.default));
var _hydrate = require("./Hydrate");
var _hydrateDefault = parcelHelpers.interopDefault(_hydrate);

},{"./Hydrate":"c6H4R","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"c6H4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hydrateCss = require("./Hydrate.css");
var _reactI18Next = require("react-i18next");
const Hydrate = ({ message })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "gif",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: "/img/water-bottle.gif",
                alt: "Hydrate GIF",
                width: 596,
                height: 596
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-2",
                children: t(`hydrate.${message}`)
            })
        ]
    });
};
exports.default = Hydrate;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Hydrate.css":"bJtOf","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"bJtOf":[function() {},{}],"dZRgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeStation", ()=>(0, _changeStationDefault.default));
var _changeStation = require("./ChangeStation");
var _changeStationDefault = parcelHelpers.interopDefault(_changeStation);

},{"./ChangeStation":"aGloQ","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"aGloQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _changeStationModuleCss = require("./ChangeStation.module.css");
var _reactI18Next = require("react-i18next");
const ChangeStation = ({ message = "text" })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "gif",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: "/img/fast-forward.gif",
                alt: "Movement GIF",
                width: 400,
                height: 400
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text",
                children: t(`stay.${message}`)
            })
        ]
    });
};
exports.default = ChangeStation;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ChangeStation.module.css":"a2K9h","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"a2K9h":[function(require,module,exports,__globalThis) {
module.exports["gif"] = `f6nFnG_gif`;
module.exports["text"] = `f6nFnG_text`;

},{}],"4B6OY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeStation", ()=>(0, _changeStationDefault.default));
parcelHelpers.export(exports, "Day", ()=>(0, _dayDefault.default));
parcelHelpers.export(exports, "DaysWrapper", ()=>(0, _daysWrapperDefault.default));
parcelHelpers.export(exports, "WeekDays", ()=>(0, _weekDaysDefault.default));
parcelHelpers.export(exports, "Videos", ()=>(0, _videosDefault.default));
parcelHelpers.export(exports, "Stay", ()=>(0, _stayDefault.default));
parcelHelpers.export(exports, "PersonalTrainer", ()=>(0, _personalTrainerDefault.default));
parcelHelpers.export(exports, "Loading", ()=>(0, _loadingDefault.default));
parcelHelpers.export(exports, "ProgressCircle", ()=>(0, _progressCircleDefault.default));
var _changeStation = require("./vertical/ChangeStation/ChangeStation");
var _changeStationDefault = parcelHelpers.interopDefault(_changeStation);
var _day = require("./Days/Day");
var _dayDefault = parcelHelpers.interopDefault(_day);
var _daysWrapper = require("./Days/DaysWrapper");
var _daysWrapperDefault = parcelHelpers.interopDefault(_daysWrapper);
var _weekDays = require("./Days/WeekDays");
var _weekDaysDefault = parcelHelpers.interopDefault(_weekDays);
var _videos = require("./vertical/Video/Videos");
var _videosDefault = parcelHelpers.interopDefault(_videos);
var _stay = require("./vertical/Stay/Stay");
var _stayDefault = parcelHelpers.interopDefault(_stay);
var _personalTrainer = require("./vertical/PersonalTrainer/PersonalTrainer");
var _personalTrainerDefault = parcelHelpers.interopDefault(_personalTrainer);
var _loading = require("./Loading/Loading");
var _loadingDefault = parcelHelpers.interopDefault(_loading);
var _progressCircle = require("./ProgressCircle/ProgressCircle");
var _progressCircleDefault = parcelHelpers.interopDefault(_progressCircle);

},{"./vertical/ChangeStation/ChangeStation":"aGloQ","./Days/Day":"4i29B","./Days/DaysWrapper":"2WczR","./Days/WeekDays":"594hG","./vertical/Video/Videos":"6QpD6","./vertical/Stay/Stay":"fDhs9","./vertical/PersonalTrainer/PersonalTrainer":"2CeJp","./Loading/Loading":"aFj92","./ProgressCircle/ProgressCircle":"9oi28","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"fDhs9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stayCss = require("./Stay.css");
var _reactI18Next = require("react-i18next");
const Stay = ({ message = "text", total = 3, active = 1 })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    const timerResets = Array.from({
        length: total
    }, (_, index)=>{
        const isRed = index < active;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            className: "set_svg",
            alt: "Timer reset",
            src: `/img/set.svg`,
            // Adjust color for non-red images
            style: {
                filter: isRed ? 'none' : 'brightness(0) invert(1)'
            }
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "gif",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "sets",
                children: timerResets
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text",
                children: t(`stay.${message}`)
            })
        ]
    });
};
exports.default = Stay;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Stay.css":"2ZGHg","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"2ZGHg":[function() {},{}],"2CeJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _personalTrainerCss = require("./PersonalTrainer.css");
const PersonalTrainer = ({ photo, name, jobTitle })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "PT-container",
        children: [
            photo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "icon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "rectangle",
                    alt: "Profile",
                    src: photo
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-wrapper",
                        children: name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-wrapper",
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-wrapper",
                        children: jobTitle
                    })
                ]
            })
        ]
    });
};
exports.default = PersonalTrainer;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./PersonalTrainer.css":"k49vR","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"k49vR":[function() {},{}],"aFj92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loadingCss = require("./Loading.css");
const Loading = ({ message = "text", onLoad })=>{
    (0, _react.useEffect)(()=>{
        if (onLoad) onLoad(); // Notify that this component has finished loading
    }, [
        onLoad
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "logo",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "text",
            children: message
        })
    });
};
exports.default = Loading;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Loading.css":"7mkFm","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"7mkFm":[function() {},{}],"9oi28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _progressCircleCss = require("./ProgressCircle.css");
var _datetimeUtils = require("../../utils/datetime.utils"); // Importing the function
var _circleProgressBar = require("./CircleProgressBar");
var _circleProgressBarDefault = parcelHelpers.interopDefault(_circleProgressBar);
var _theme = require("../../constants/theme");
const ProgressCircle = /*#__PURE__*/ (0, _react.forwardRef)(({ initialTotalTime, color, sound = true, bypassCacheGuid, label, icon, customValue, type = "segmented" }, ref)=>{
    const intervalIdRef = (0, _react.useRef)(null);
    const [totalTime, setTotalTime] = (0, _react.useState)(initialTotalTime);
    const [timeLeft, setTimeLeft] = (0, _react.useState)(initialTotalTime);
    const [paused, setPaused] = (0, _react.useState)(false);
    const [bgColor, setBgColor] = (0, _react.useState)("#E0E0E0");
    const [progressColor, setProgressColor] = (0, _react.useState)("#FF5733");
    const [fontSize, setFontSize] = (0, _react.useState)("var(--title-hero-font-size)");
    const audioRef = (0, _react.useRef)(null); // Reference to audio element
    const [_, setCacheGuid] = (0, _react.useState)(bypassCacheGuid);
    const updateColorsAndFontSize = (0, _react.useCallback)(()=>{
        setFontSize(timeLeft > 3600 ? "var(--font-fontSize-3xl, 40px)" : "var(--font-fontSize-3xl, 72px)");
    }, [
        timeLeft
    ]);
    (0, _react.useEffect)(()=>{
        if (intervalIdRef.current) clearInterval(intervalIdRef.current); // Clear any existing interval when initialTotalTime changes
        const delayStart = setTimeout(()=>{
            intervalIdRef.current = setInterval(()=>{
                if (!paused) setTimeLeft((prevTime)=>Math.max(prevTime - 1, 0));
            }, 1000);
        }, 150);
        return ()=>{
            clearTimeout(delayStart); // Clear the timeout if the component unmounts
            if (intervalIdRef.current) clearInterval(intervalIdRef.current); // Clear the interval if the component unmounts
        };
    }, [
        initialTotalTime,
        paused
    ]);
    (0, _react.useEffect)(()=>{
        updateColorsAndFontSize();
        if (sound && timeLeft == 3 && audioRef.current) audioRef?.current?.play();
    }, [
        timeLeft,
        updateColorsAndFontSize
    ]);
    (0, _react.useEffect)(()=>{
        setCacheGuid(bypassCacheGuid);
        setTotalTime(initialTotalTime);
        setTimeLeft(initialTotalTime);
    }, [
        initialTotalTime,
        bypassCacheGuid
    ]);
    // useImperativeHandle exposes functions to parent components via ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            stop: ()=>setPaused(true),
            play: ()=>setPaused(false),
            resume: ()=>setPaused(false),
            reset: ()=>{
                setPaused(false);
                setTimeLeft(initialTotalTime);
                setTotalTime(initialTotalTime);
            },
            setTime: (newTime)=>{
                setPaused(true);
                setTimeLeft(newTime);
                setTotalTime(newTime);
                setPaused(false);
            }
        }));
    (0, _react.useEffect)(()=>{
        if (color === "default" || !color) {
            // Apply default colors here
            setBgColor("#E0E0E0");
            setProgressColor((0, _theme.AppTheme).active_color);
        } else if (color === "red") {
            setBgColor("#E0E0E0");
            setProgressColor("#ED6769");
        } else if (color === "green") {
            setBgColor("#E0E0E0");
            setProgressColor("#2B5A38");
        } else if (color === "yellow") {
            setBgColor("#E0E0E0");
            setProgressColor("#836C18");
        } else {
            // Default color case
            setBgColor("#0B0B0B");
            setProgressColor((0, _theme.AppTheme).active_color);
        }
    }, [
        color,
        timeLeft,
        initialTotalTime
    ]);
    const progress = totalTime ? (totalTime - timeLeft) / totalTime * 100 : 0;
    const circleColorClass = color === "yellow" || color === "red" && timeLeft < 10 ? "content yellow" : color === "green" ? "content green" : color === "red" ? "content red" : "content";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-circle",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: circleColorClass,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "element",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circleProgressBarDefault.default), {
                                progress: progress,
                                bgColor: bgColor,
                                progressColor: progressColor,
                                type: type
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "overlap-group",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-wrapper-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            alt: "Workout Icon",
                                            src: icon ? icon : '/img/flame.svg',
                                            width: "56",
                                            height: "56"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div",
                                            style: {
                                                fontSize
                                            },
                                            children: customValue ? customValue : (0, _datetimeUtils.DateTimeUtils).formatTime(timeLeft)
                                        }),
                                        label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div timer-label",
                                            children: label
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("audio", {
                    ref: audioRef,
                    src: "/sound/ding_3s.wav",
                    preload: "auto"
                })
            ]
        })
    }, bypassCacheGuid);
});
exports.default = ProgressCircle;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProgressCircle.css":"loyFe","../../utils/datetime.utils":"cyuXt","./CircleProgressBar":"8qdw3","../../constants/theme":"iq9pr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"loyFe":[function() {},{}],"8qdw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const CircleProgressBar = ({ progress, bgColor, progressColor, type = "segmented", segmentCount = 8, segmentGap = 2 })=>{
    const radius = 115;
    const circumference = 2 * Math.PI * radius;
    const circleRef = (0, _react.useRef)(null);
    // Calculate stroke dash offset (unchanged)
    const strokeDashoffset = Math.max(0, circumference - Math.min(Math.max(progress, 0), 100) / 100 * circumference);
    // Animation logic (unchanged)
    (0, _react.useEffect)(()=>{
        if (circleRef.current) {
            circleRef.current.style.transition = progress === 0 ? "none" : "stroke-dashoffset 1s linear";
            circleRef.current.style.strokeDashoffset = `${strokeDashoffset}px`;
        }
    }, [
        strokeDashoffset,
        progress
    ]);
    // Calculate segments (unchanged)
    const { segmentLength, gapLength } = (()=>{
        const gapAngle = segmentGap;
        const segmentAngle = (360 - segmentCount * gapAngle) / segmentCount;
        return {
            segmentLength: segmentAngle / 360 * circumference,
            gapLength: gapAngle / 360 * circumference
        };
    })();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: "230",
        height: "230",
        viewBox: "0 0 230 230",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "115",
                cy: "115",
                r: radius,
                fill: "none",
                stroke: bgColor,
                strokeWidth: "17",
                strokeDasharray: type === "segmented" ? `${segmentLength} ${gapLength}` : undefined
            }),
            type === "segmented" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                            id: "segment-mask",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    x: "0",
                                    y: "0",
                                    width: "230",
                                    height: "230",
                                    fill: "black"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "115",
                                    cy: "115",
                                    r: radius,
                                    fill: "none",
                                    stroke: "white",
                                    strokeWidth: "17",
                                    strokeDasharray: `${segmentLength} ${gapLength}`,
                                    transform: "rotate(-90 115 115)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: "115",
                        cy: "115",
                        r: "92.5" /* 185px diameter / 2 */ ,
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                ref: circleRef,
                cx: "115",
                cy: "115",
                r: radius,
                fill: "none",
                stroke: progressColor,
                strokeWidth: "17",
                strokeDasharray: circumference,
                strokeDashoffset: strokeDashoffset,
                transform: "rotate(-90 115 115)",
                mask: type === "segmented" ? "url(#segment-mask)" : undefined
            })
        ]
    });
};
exports.default = CircleProgressBar;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"iq9pr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppTheme", ()=>AppTheme);
const AppTheme = {
    active_color: "#307FE2"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"dUUAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notification2", ()=>(0, _notificationDefault.default));
var _notification = require("./Notification");
var _notificationDefault = parcelHelpers.interopDefault(_notification);

},{"./Notification":"aKo0Y","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"aKo0Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notificationCss = require("./Notification.css");
var _reactI18Next = require("react-i18next");
const Notification2 = ({ message = "text", time = 0, showOnTimeLeft = 0, isNumber = false, bypassCacheGuid })=>{
    const [currentTime, setCurrentTime] = (0, _react.useState)(time); // state for the current time
    const [show, setShow] = (0, _react.useState)(false); // state for showing the notification
    const [_, setCacheGuid] = (0, _react.useState)(bypassCacheGuid);
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    (0, _react.useEffect)(()=>{
        setCacheGuid(bypassCacheGuid);
        setCurrentTime(time);
    }, [
        bypassCacheGuid
    ]);
    (0, _react.useEffect)(()=>{
        // only set an interval if the time is greater than 0
        if (time > 0) {
            const interval = setInterval(()=>{
                setCurrentTime((prevTime)=>{
                    if (prevTime > 0) return prevTime - 1;
                    return 0;
                });
            }, 1000);
            return ()=>{
                clearInterval(interval); // cleanup interval on component unmount
            };
        }
    }, [
        time,
        bypassCacheGuid
    ]);
    (0, _react.useEffect)(()=>{
        // show the notification when currentTime is less than or equal to showOnTimeLeft
        if (currentTime <= showOnTimeLeft) setShow(true);
        else setShow(false);
    }, [
        currentTime,
        showOnTimeLeft,
        bypassCacheGuid
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: message && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                " ",
                show && !isNumber && isNaN(Number(message)) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "notification",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text",
                        children: t(`stay.${message}`)
                    })
                }),
                show && (isNumber || !isNaN(Number(message))) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "notification",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text",
                        children: t('sets_number', {
                            count: Number(message)
                        })
                    })
                })
            ]
        }, bypassCacheGuid)
    });
};
exports.default = Notification2;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Notification.css":"ainnX","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"ainnX":[function() {},{}],"cZfFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Finish", ()=>(0, _finishDefault.default));
var _finish = require("./Finish");
var _finishDefault = parcelHelpers.interopDefault(_finish);

},{"./Finish":"bGtmq","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"bGtmq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _finishCss = require("./Finish.css");
var _reactI18Next = require("react-i18next");
const Finish = ({ message = "text", img = "/img/basezero_logo.png" })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "finish",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "image-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "finish-gif",
                    alt: "Finish",
                    src: img,
                    height: 551,
                    width: 538
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text",
                children: t(`finish.${message}`)
            })
        ]
    });
};
exports.default = Finish;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Finish.css":"e6Xfb","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"e6Xfb":[function() {},{}],"kUMvn":[function() {},{}],"c8Bsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Booking", ()=>Booking);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next"); // Import useTranslation
var _horBookingStyles = require("./HorBookingStyles"); // Import styles
var _bookingService = require("../../services/booking.service");
var _components = require("../../components");
const Booking = ({ screenData })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use useTranslation hook
    const bookingClasses = screenData?.bookingClasses;
    const bookingData = bookingClasses ? (0, _bookingService.BookingService).toBookingData(bookingClasses) : [];
    const filteredClassTimesByPeriod = bookingClasses ? (0, _bookingService.BookingService).filterClassTimesByPeriod(bookingData) : [];
    const booking = (0, _bookingService.BookingService).transformScheduleData(filteredClassTimesByPeriod);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _horBookingStyles.StyledHorBooking), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "hor-comp-container-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "hor-comp-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "hor-comp-inner-stack",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.WeekDays), {
                            booking: bookingData,
                            imgpath: screenData?.imgPath
                        }),
                        Object.keys(booking).map((period)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "hor-comp-time",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: t(`period.${period ?? 'default'}`)
                                        })
                                    }),
                                    booking[period].map((times, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DaysWrapper), {
                                            hours: Array.from(times).map((hour)=>hour || "").slice(0, 7).concat(Array(7 - times.length).fill(""))
                                        }, `${period}-${index}`))
                                ]
                            }, period))
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-i18next":"k5Ajr","./HorBookingStyles":"8AIBk","../../services/booking.service":"5C0Vz","../../components":"4B6OY","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"8AIBk":[function(require,module,exports,__globalThis) {
// basezero-tvs/src/screens/HorBooking/HorBookingStyles.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledHorBooking", ()=>StyledHorBooking);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const StyledHorBooking = (0, _styledComponentsDefault.default).div`
  background-color: #0c0c0c;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  & .hor-comp-container-wrapper {
    background-color: var(--color-styles-foundation-dark-dark-500);
    height: 1080px;
    width: 1920px;
  }

  & .hor-comp-container {
    align-items: center;
    display: flex;
    gap: 8px;
    height: 1080px;
    padding: 32px;
    position: relative;
    width: 1920px;
  }

  & .hor-comp-inner-stack {
    align-items: flex-start;
    align-self: stretch;
    background-color: var(--color-styles-bg-dark-components);
    display: flex;
    flex: 1;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
  }

  & .hor-comp-time {
    align-items: flex-start;
    align-self: stretch;
    background-color: var(--color-styles-foundation-dark-dark-400);
    display: flex;
    flex: 1;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    padding: 8px 8px 8px 24px;
    position: relative;
    width: 100%;
  }

  & .text-wrapper-9 {
    align-self: stretch;
    color: var(--color-styles-foundation-light-light-500);
    font-family: var(--heading-font-family);
    font-size: var(--heading-font-size);
    font-style: var(--heading-font-style);
    font-weight: var(--heading-font-weight);
    letter-spacing: var(--heading-letter-spacing);
    line-height: var(--heading-line-height);
    position: relative;
  }
`;

},{"styled-components":"cwIkX","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"cwIkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerStyleSheet", ()=>vt);
parcelHelpers.export(exports, "StyleSheetConsumer", ()=>Be);
parcelHelpers.export(exports, "StyleSheetContext", ()=>$e);
parcelHelpers.export(exports, "StyleSheetManager", ()=>Ye);
parcelHelpers.export(exports, "ThemeConsumer", ()=>tt);
parcelHelpers.export(exports, "ThemeContext", ()=>et);
parcelHelpers.export(exports, "ThemeProvider", ()=>ot);
parcelHelpers.export(exports, "__PRIVATE__", ()=>gt);
parcelHelpers.export(exports, "createGlobalStyle", ()=>ft);
parcelHelpers.export(exports, "css", ()=>lt);
parcelHelpers.export(exports, "default", ()=>dt);
parcelHelpers.export(exports, "isStyledComponent", ()=>se);
parcelHelpers.export(exports, "keyframes", ()=>mt);
parcelHelpers.export(exports, "styled", ()=>dt);
parcelHelpers.export(exports, "useTheme", ()=>nt);
parcelHelpers.export(exports, "version", ()=>v);
parcelHelpers.export(exports, "withTheme", ()=>yt);
var _tslib = require("tslib");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _stylis = require("stylis");
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var f = "data-styled", m = "active", y = "data-styled-version", v = "6.1.19", g = "/*!sc*/\n", S = "undefined" != typeof window && "undefined" != typeof document, w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), b = {}, E = /invalid hook call/i, N = new Set, P = function(t, n) {
    var o, s, i, a, e;
}, _ = Object.freeze([]), C = Object.freeze({});
function I(e, t, n) {
    return void 0 === n && (n = C), e.theme !== n.theme && e.theme || t || n.theme;
}
var A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, D = /(^-|-$)/g;
function R(e) {
    return e.replace(O, "-").replace(D, "");
}
var T = /(a)(d)/gi, k = 52, j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > k; t = t / k | 0)n = j(t % k) + n;
    return (j(t % k) + n).replace(T, "$1-$2");
}
var V, F = 5381, M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, z = function(e) {
    return M(F, e);
};
function $(e) {
    return x(z(e) >>> 0);
}
function B(e) {
    return e.displayName || e.name || "Component";
}
function L(e) {
    return "string" == typeof e && true;
}
var G = "function" == typeof Symbol && Symbol.for, Y = G ? Symbol.for("react.memo") : 60115, W = G ? Symbol.for("react.forward_ref") : 60112, q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, J = ((V = {})[W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, V[Y] = U, V);
function X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === Y ? U : "$$typeof" in e ? J[e.$$typeof] : q;
}
var Z = Object.defineProperty, K = Object.getOwnPropertyNames, Q = Object.getOwnPropertySymbols, ee = Object.getOwnPropertyDescriptor, te = Object.getPrototypeOf, ne = Object.prototype;
function oe(e, t, n) {
    if ("string" != typeof t) {
        if (ne) {
            var o = te(t);
            o && o !== ne && oe(e, o, n);
        }
        var r = K(t);
        Q && (r = r.concat(Q(t)));
        for(var s = X(e), i = X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in H || n && n[c] || i && c in i || s && c in s)) {
                var l = ee(t, c);
                try {
                    Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function re(e) {
    return "function" == typeof e;
}
function se(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = le(e[o], t[o]);
    else if (ce(t)) for(var o in t)e[o] = le(e[o], t[o]);
    return e;
}
function ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var pe = {};
function de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat(g);
        return t;
    }, e;
}(), me = 1073741824, ye = new Map, ve = new Map, ge = 1, Se = function(e) {
    if (ye.has(e)) return ye.get(e);
    for(; ve.has(ge);)ge++;
    var t = ge++;
    return ye.set(e, t), ve.set(t, e), t;
}, we = function(e, t) {
    ge = t + 1, ye.set(e, t), ve.set(t, e);
}, be = "style[".concat(f, "][").concat(y, '="').concat(v, '"]'), Ee = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split(g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match(Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && (we(u, l), Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, _e = function(e) {
    for(var t = document.querySelectorAll(be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute(f) !== m && (Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat(f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute(f, m), o.setAttribute(y, v);
    var i = Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, Ae = function() {
    function e(e) {
        this.element = Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), Oe = function() {
    function e(e) {
        this.element = Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), Re = S, Te = {
    isServer: !S,
    useCSSOMInjection: !w
}, ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && S && Re && (Re = !1, _e(this)), ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat(f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat(g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && S && _e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new De(n) : t ? new Ae(n) : new Oe(n);
        }(this.options), new fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if (Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup(Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), je = /&/g, xe = /^\s*\/\/.*$/gm;
function Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = Ve(e.children, t)), e;
    });
}
function Fe(e) {
    var t, n, o, r = void 0 === e ? C : e, s = r.options, i = void 0 === s ? C : s, a = r.plugins, c = void 0 === a ? _ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === _stylis.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace(je, n).replace(o, l));
    }), i.prefix && u.push(_stylis.prefixer), u.push(_stylis.stringify);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace(xe, ""), l = _stylis.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = Ve(l, i.namespace));
        var p = [];
        return _stylis.serialize(l, _stylis.middleware(u.concat(_stylis.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || he(15), M(e, t.name);
    }, F).toString() : "", p;
}
var Me = new ke, ze = Fe(), $e = (0, _reactDefault.default).createContext({
    shouldForwardProp: void 0,
    styleSheet: Me,
    stylis: ze
}), Be = $e.Consumer, Le = (0, _reactDefault.default).createContext(void 0);
function Ge() {
    return (0, _react.useContext)($e);
}
function Ye(e) {
    var t = (0, _react.useState)(e.stylisPlugins), n = t[0], r = t[1], c = Ge().styleSheet, l = (0, _react.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, _react.useMemo)(function() {
        return Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, _react.useEffect)(function() {
        (0, _shallowequalDefault.default)(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, _react.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, _reactDefault.default).createElement($e.Provider, {
        value: d
    }, (0, _reactDefault.default).createElement(Le.Provider, {
        value: u
    }, e.children));
}
var We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, ue(this, function() {
            throw he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = ze), this.name + e.hash;
    }, e;
}(), qe = function(e) {
    return e >= "A" && e <= "Z";
};
function He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !Ue(i) && (Array.isArray(i) && i.isCss || re(i) ? r.push("".concat(He(s), ":"), i, ";") : ce(i) ? r.push.apply(r, (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([
            "".concat(s, " {")
        ], Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat(He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, _unitlessDefault.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function Xe(e, t, n, o) {
    if (Ue(e)) return [];
    if (se(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if (re(e)) {
        if (!re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return Xe(r, t, n, o);
    }
    var s;
    return e instanceof We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : ce(e) ? Je(e) : Array.isArray(e) ? Array.prototype.concat.apply(_, e.map(function(e) {
        return Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if (re(n) && !se(n)) return !1;
    }
    return !0;
}
var Ke = z(v), Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && Ze(e), this.componentId = t, this.baseHash = M(Ke, t), this.baseStyle = n, ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = ie(o, this.staticRulesId);
            else {
                var r = ae(Xe(this.rules, e, t, n)), s = x(M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = ae(Xe(u, e, t, n));
                    a = M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = ie(o, d);
            }
        }
        return o;
    }, e;
}(), et = (0, _reactDefault.default).createContext(void 0), tt = et.Consumer;
function nt() {
    var e = (0, _react.useContext)(et);
    if (!e) throw he(18);
    return e;
}
function ot(e) {
    var n = (0, _reactDefault.default).useContext(et), r = (0, _react.useMemo)(function() {
        return function(e, n) {
            if (!e) throw he(14);
            if (re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw he(8);
            return n ? (0, _tslib.__assign)((0, _tslib.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, _reactDefault.default).createElement(et.Provider, {
        value: r
    }, e.children) : null;
}
var rt = {}, st = new Set;
function it(e, r, s) {
    var i = se(e), a = e, c = !L(e), p = r.attrs, d = void 0 === p ? _ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : R(e);
        rt[n] = (rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($(v + n + rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return L(e) ? "styled.".concat(e) : "Styled(".concat(B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat(R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, _reactDefault.default).useContext(et), m = Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = I(r, f, c) || C, g = function(e, n, o) {
                for(var r, s = (0, _tslib.__assign)((0, _tslib.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? ie(s[c], a[c]) : "style" === c ? (0, _tslib.__assign)((0, _tslib.__assign)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[L(S) && !A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, _react.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, _reactDefault.default).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function lt(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if (re(t) || ce(t)) return ct(Xe(at(_, (0, _tslib.__spreadArray)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? Xe(r) : ct(Xe(at(r, n)));
}
function ut(n, o, r) {
    if (void 0 === r && (r = C), !o) throw he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, lt.apply(void 0, (0, _tslib.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return ut(n, o, (0, _tslib.__assign)((0, _tslib.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return ut(n, o, (0, _tslib.__assign)((0, _tslib.__assign)({}, r), e));
    }, s;
}
var pt = function(e) {
    return ut(it, e);
}, dt = pt;
A.forEach(function(e) {
    dt[e] = pt(e);
});
var ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = Ze(e), ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o(ae(Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function ft(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = lt.apply(void 0, (0, _tslib.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat($(JSON.stringify(i))), c = new ht(i, a);
    var l = function(e) {
        var t = Ge(), n = (0, _reactDefault.default).useContext(et), r = (0, _reactDefault.default).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, _reactDefault.default).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, b, o, s);
        else {
            var i = (0, _tslib.__assign)((0, _tslib.__assign)({}, n), {
                theme: I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, _reactDefault.default).memo(l);
}
function mt(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = ae(lt.apply(void 0, (0, _tslib.__spreadArray)([
        t
    ], n, !1))), s = $(r);
    return new We(s, r);
}
function yt(e) {
    var n = (0, _reactDefault.default).forwardRef(function(n, r) {
        var s = I(n, (0, _reactDefault.default).useContext(et), e.defaultProps);
        return (0, _reactDefault.default).createElement(e, (0, _tslib.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat(B(e), ")"), oe(n, e);
}
var vt = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = Ce(), o = ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat(f, '="true"'),
                "".concat(y, '="').concat(v, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[f] = "", n[y] = v, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = Ce();
            return i && (s.nonce = i), [
                (0, _reactDefault.default).createElement("style", (0, _tslib.__assign)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw he(2);
        return (0, _reactDefault.default).createElement(Ye, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw he(3);
    }, e;
}(), gt = {
    StyleSheet: ke,
    mainSheet: Me
};
var St = "__sc-".concat(f, "__");

},{"tslib":"kBIjG","@emotion/is-prop-valid":"aHWqs","react":"bmhQu","shallowequal":"8MVyy","stylis":"f4S0f","@emotion/unitless":"fosl3","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"kBIjG":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"aHWqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"kMK0P","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"kMK0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"8MVyy":[function(require,module,exports,__globalThis) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"f4S0f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>g);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SCOPE", ()=>k);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>$);
parcelHelpers.export(exports, "alloc", ()=>Y);
parcelHelpers.export(exports, "append", ()=>B);
parcelHelpers.export(exports, "assign", ()=>x);
parcelHelpers.export(exports, "caret", ()=>V);
parcelHelpers.export(exports, "char", ()=>Q);
parcelHelpers.export(exports, "character", ()=>J);
parcelHelpers.export(exports, "characters", ()=>K);
parcelHelpers.export(exports, "charat", ()=>A);
parcelHelpers.export(exports, "column", ()=>G);
parcelHelpers.export(exports, "combine", ()=>D);
parcelHelpers.export(exports, "comment", ()=>oe);
parcelHelpers.export(exports, "commenter", ()=>se);
parcelHelpers.export(exports, "compile", ()=>ue);
parcelHelpers.export(exports, "copy", ()=>N);
parcelHelpers.export(exports, "dealloc", ()=>Z);
parcelHelpers.export(exports, "declaration", ()=>le);
parcelHelpers.export(exports, "delimit", ()=>_);
parcelHelpers.export(exports, "delimiter", ()=>ce);
parcelHelpers.export(exports, "escaping", ()=>ne);
parcelHelpers.export(exports, "filter", ()=>E);
parcelHelpers.export(exports, "from", ()=>m);
parcelHelpers.export(exports, "hash", ()=>y);
parcelHelpers.export(exports, "identifier", ()=>te);
parcelHelpers.export(exports, "indexof", ()=>O);
parcelHelpers.export(exports, "length", ()=>H);
parcelHelpers.export(exports, "lift", ()=>P);
parcelHelpers.export(exports, "line", ()=>F);
parcelHelpers.export(exports, "match", ()=>z);
parcelHelpers.export(exports, "middleware", ()=>be);
parcelHelpers.export(exports, "namespace", ()=>ge);
parcelHelpers.export(exports, "next", ()=>T);
parcelHelpers.export(exports, "node", ()=>L);
parcelHelpers.export(exports, "parse", ()=>ie);
parcelHelpers.export(exports, "peek", ()=>U);
parcelHelpers.export(exports, "position", ()=>I);
parcelHelpers.export(exports, "prefix", ()=>ve);
parcelHelpers.export(exports, "prefixer", ()=>de);
parcelHelpers.export(exports, "prev", ()=>R);
parcelHelpers.export(exports, "replace", ()=>C);
parcelHelpers.export(exports, "ruleset", ()=>fe);
parcelHelpers.export(exports, "rulesheet", ()=>we);
parcelHelpers.export(exports, "serialize", ()=>pe);
parcelHelpers.export(exports, "sizeof", ()=>q);
parcelHelpers.export(exports, "slice", ()=>W);
parcelHelpers.export(exports, "stringify", ()=>he);
parcelHelpers.export(exports, "strlen", ()=>S);
parcelHelpers.export(exports, "substr", ()=>M);
parcelHelpers.export(exports, "token", ()=>X);
parcelHelpers.export(exports, "tokenize", ()=>ee);
parcelHelpers.export(exports, "tokenizer", ()=>ae);
parcelHelpers.export(exports, "trim", ()=>j);
parcelHelpers.export(exports, "whitespace", ()=>re);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var g = "@layer";
var k = "@scope";
var $ = Math.abs;
var m = String.fromCharCode;
var x = Object.assign;
function y(e, r) {
    return A(e, 0) ^ 45 ? (((r << 2 ^ A(e, 0)) << 2 ^ A(e, 1)) << 2 ^ A(e, 2)) << 2 ^ A(e, 3) : 0;
}
function j(e) {
    return e.trim();
}
function z(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, a) {
    return e.replace(r, a);
}
function O(e, r, a) {
    return e.indexOf(r, a);
}
function A(e, r) {
    return e.charCodeAt(r) | 0;
}
function M(e, r, a) {
    return e.slice(r, a);
}
function S(e) {
    return e.length;
}
function q(e) {
    return e.length;
}
function B(e, r) {
    return r.push(e), e;
}
function D(e, r) {
    return e.map(r).join("");
}
function E(e, r) {
    return e.filter(function(e) {
        return !z(e, r);
    });
}
var F = 1;
var G = 1;
var H = 0;
var I = 0;
var J = 0;
var K = "";
function L(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: F,
        column: G,
        length: t,
        return: "",
        siblings: u
    };
}
function N(e, r) {
    return x(L("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function P(e) {
    while(e.root)e = N(e.root, {
        children: [
            e
        ]
    });
    B(e, e.siblings);
}
function Q() {
    return J;
}
function R() {
    J = I > 0 ? A(K, --I) : 0;
    if (G--, J === 10) G = 1, F--;
    return J;
}
function T() {
    J = I < H ? A(K, I++) : 0;
    if (G++, J === 10) G = 1, F++;
    return J;
}
function U() {
    return A(K, I);
}
function V() {
    return I;
}
function W(e, r) {
    return M(K, e, r);
}
function X(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function Y(e) {
    return F = G = 1, H = S(K = e), I = 0, [];
}
function Z(e) {
    return K = "", e;
}
function _(e) {
    return j(W(I - 1, ce(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ee(e) {
    return Z(ae(Y(e)));
}
function re(e) {
    while(J = U())if (J < 33) T();
    else break;
    return X(e) > 2 || X(J) > 3 ? "" : " ";
}
function ae(e) {
    while(T())switch(X(J)){
        case 0:
            B(te(I - 1), e);
            break;
        case 2:
            B(_(J), e);
            break;
        default:
            B(m(J), e);
    }
    return e;
}
function ne(e, r) {
    while(--r && T())if (J < 48 || J > 102 || J > 57 && J < 65 || J > 70 && J < 97) break;
    return W(e, V() + (r < 6 && U() == 32 && T() == 32));
}
function ce(e) {
    while(T())switch(J){
        case e:
            return I;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) ce(J);
            break;
        case 40:
            if (e === 41) ce(e);
            break;
        case 92:
            T();
            break;
    }
    return I;
}
function se(e, r) {
    while(T())if (e + J === 57) break;
    else if (e + J === 84 && U() === 47) break;
    return "/*" + W(r, I - 1) + "*" + m(e === 47 ? e : T());
}
function te(e) {
    while(!X(U()))T();
    return W(e, I);
}
function ue(e) {
    return Z(ie("", null, null, null, [
        ""
    ], e = Y(e), 0, [
        0
    ], e));
}
function ie(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = T()){
        case 40:
            if (h != 108 && A(z, l - 1) == 58) {
                if (O(z += C(_(g), "&", "&\f"), "&\f", $(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += _(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += re(h);
            break;
        case 92:
            z += ne(V() - 1, 7);
            continue;
        case 47:
            switch(U()){
                case 42:
                case 47:
                    B(oe(se(T(), V()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = S(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = C(z, /\f/g, "");
                    if (p > 0 && S(z) - l) B(p > 32 ? le(z + ";", n, a, l - 1, i) : le(C(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    B(j = fe(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) ie(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && A(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                ie(e, j, j, n && B(fe(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                ie(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + S(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && R() == 125) continue;
            }
            switch(z += m(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = (S(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if (U() === 45) z += _(T());
                    v = U(), o = l = S(k = z += te(V())), g++;
                    break;
                case 45:
                    if (h === 45 && S(z) == 2) b = 0;
            }
    }
    return s;
}
function fe(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = q(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = M(e, p + 1, p = $(d = u[w])), x = e; k < b; ++k)if (x = j(d > 0 ? h[k] + " " + m : C(m, /&\f/g, h[k]))) f[g++] = x;
    return L(e, r, a, s === 0 ? c : i, f, o, l, v);
}
function oe(e, r, a, c) {
    return L(e, r, a, n, m(Q()), M(e, 2, -2), 0, c);
}
function le(e, r, a, n, c) {
    return L(e, r, a, s, M(e, 0, n), M(e, n + 1, -1), n, c);
}
function ve(n, c, s) {
    switch(y(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(A(n, c + 11)){
                case 114:
                    return a + n + e + C(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + C(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + C(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + C(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + C(n, /flex-|-self/g, "") + (!z(n, /flex-|baseline/) ? e + "grid-row-" + C(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + C(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + C(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + C(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + C(n, "-grow", "") + a + n + e + C(n, "grow", "positive") + n;
        case 4554:
            return a + C(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return C(C(C(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return C(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return C(C(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!z(n, /flex-|baseline/)) return e + "grid-column-align" + M(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + C(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, z(e.props, /grid-\w+-end/);
            })) return ~O(n + (s = s[c].value), "span", 0) ? n : e + C(n, "-start", "") + n + e + "grid-row-span:" + (~O(s, "span", 0) ? z(s, /\d+/) : +z(s, /\d+/) - +z(n, /\d+/)) + ";";
            return e + C(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return z(e.props, /grid-\w+-start/);
            }) ? n : e + C(C(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return C(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (S(n) - 1 - c > 6) switch(A(n, c + 1)){
                case 109:
                    if (A(n, c + 4) !== 45) break;
                case 102:
                    return C(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (A(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~O(n, "stretch", 0) ? ve(C(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return C(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (A(n, c + 6) === 121) return C(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(A(n, A(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return C(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (A(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return C(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return C(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function pe(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function he(e, r, a, t) {
    switch(e.type){
        case g:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + pe(e.children, t) + "}";
        case c:
            if (!S(e.value = e.props.join(","))) return "";
    }
    return S(a = pe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function be(e) {
    var r = q(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function we(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function de(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = ve(n.value, n.length, u);
                return;
            case h:
                return pe([
                    N(n, {
                        value: C(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return D(u = n.props, function(c) {
                    switch(z(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            P(N(n, {
                                props: [
                                    C(c, /:(read-\w+)/, ":" + r + "$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    c
                                ]
                            }));
                            x(n, {
                                props: E(u, i)
                            });
                            break;
                        case "::placeholder":
                            P(N(n, {
                                props: [
                                    C(c, /:(plac\w+)/, ":" + a + "input-$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    C(c, /:(plac\w+)/, ":" + r + "$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    C(c, /:(plac\w+)/, e + "input-$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    c
                                ]
                            }));
                            x(n, {
                                props: E(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function ge(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return D(ee(r), function(r, a, n) {
                    switch(A(r, 0)){
                        case 12:
                            return M(r, 1, S(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + M(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return q(n) > 1 ? "" : r;
                                case a = q(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"fosl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"5C0Vz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BookingService", ()=>BookingService);
class BookingService {
    static toBookingData(data) {
        if (!data) return [];
        // Sort data by date in ascending order (oldest to newest)
        data.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
        // Get the oldest date in the data
        const oldestDate = new Date(data[0].date); // Oldest date
        // Create a map of existing dates to their data for quick lookup
        const dateMap = new Map();
        data.forEach((entry)=>{
            const firstWorkoutImage = entry.class_schedules[0]?.workout?.image || null;
            const startTimes = entry.class_schedules.map((schedule)=>schedule.start_time);
            dateMap.set(entry.date, {
                date: entry.date,
                class_start_times: startTimes,
                image: firstWorkoutImage
            });
        });
        // Create a list to store the result of complete data
        let completeData = [];
        let currentDate = new Date(oldestDate); // Start from the oldest date
        // Keep filling up to 7 days
        while(completeData.length < 7){
            const dateString = currentDate.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
            // If data exists for this date, use it; otherwise, create an empty entry
            if (dateMap.has(dateString)) completeData.push(dateMap.get(dateString));
            else completeData.push({
                date: dateString,
                class_start_times: [],
                image: null
            });
            // Move to the next day
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return completeData;
    }
    // Method to filter class times into morning, afternoon, and night periods
    static filterClassTimesByPeriod(schedules) {
        return schedules.map((schedule)=>{
            const morning = [];
            const afternoon = [];
            const night = [];
            schedule.class_start_times.forEach((time)=>{
                const [hours, minutes] = time.split(':').map(Number);
                const totalMinutes = hours * 60 + minutes;
                if (totalMinutes >= 360 && totalMinutes < 720) morning.push(time);
                else if (totalMinutes >= 720 && totalMinutes < 1080) afternoon.push(time);
                else night.push(time);
            });
            // Sorting the time arrays
            const sortTimes = (times)=>{
                return times.sort((a, b)=>{
                    const [aHours, aMinutes] = a.split(':').map(Number);
                    const [bHours, bMinutes] = b.split(':').map(Number);
                    return aHours * 60 + aMinutes - (bHours * 60 + bMinutes);
                });
            };
            return {
                date: schedule.date,
                morning: sortTimes(morning),
                afternoon: sortTimes(afternoon),
                night: sortTimes(night),
                image: schedule.image
            };
        });
    }
    // Method to transform filtered schedule data into the final schedule format
    static transformScheduleData(data) {
        const daysCount = 7; // Fixed to always output a 7-day week
        const result = {
            morning: [],
            afternoon: [],
            night: []
        };
        // Sort data by date in descending order
        data.sort((a, b)=>new Date(b.date).getTime() - new Date(a.date).getTime());
        //
        data = data.reverse();
        // Initialize the number of rows needed for each time period
        let maxMorningSlots = 0;
        let maxAfternoonSlots = 0;
        let maxNightSlots = 0;
        // Determine the maximum number of slots needed for each period
        for(let i = 0; i < Math.min(data.length, daysCount); i++){
            const day = data[i];
            maxMorningSlots = Math.max(maxMorningSlots, day.morning.length);
            maxAfternoonSlots = Math.max(maxAfternoonSlots, day.afternoon.length);
            maxNightSlots = Math.max(maxNightSlots, day.night.length);
        }
        // Create the arrays for each time period
        for(let i = 0; i < maxMorningSlots; i++)result.morning.push(Array(daysCount).fill(""));
        for(let i = 0; i < maxAfternoonSlots; i++)result.afternoon.push(Array(daysCount).fill(""));
        for(let i = 0; i < maxNightSlots; i++)result.night.push(Array(daysCount).fill(""));
        // Fill in the data into the result
        for(let i = 0; i < Math.min(data.length, daysCount); i++){
            const day = data[i];
            // Fill morning slots
            for(let j = 0; j < day.morning.length; j++)result.morning[j][i] = day.morning[j] || "";
            // Fill afternoon slots
            for(let j = 0; j < day.afternoon.length; j++)result.afternoon[j][i] = day.afternoon[j] || "";
            // Fill night slots
            for(let j = 0; j < day.night.length; j++)result.night[j][i] = day.night[j] || "";
        }
        // Remove trailing empty arrays if not needed
        result.morning = result.morning.filter((slot)=>slot.some((time)=>time !== ""));
        result.afternoon = result.afternoon.filter((slot)=>slot.some((time)=>time !== ""));
        result.night = result.night.filter((slot)=>slot.some((time)=>time !== ""));
        return result;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"1RTuZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timer", ()=>Timer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _horTvbd = require("../../components/HorTvbd/HorTvbd");
var _startingClassIn30Seconds = require("../../components/StartingClassIn30Seconds/StartingClassIn30Seconds");
var _movement = require("../Movement/Movement");
const Timer = ({ timerScreenData, timerControlRef })=>{
    let showFinish = timerScreenData?.type === "ending" ? true : false;
    if (!timerScreenData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (!timerScreenData.isWorkout) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movement.HorMovement), {
        movementScreenData: timerScreenData
    });
    else {
        if (timerScreenData.isWorkoutStarting || timerScreenData.isWorkoutIntroduction) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _startingClassIn30Seconds.StartingClassIn), {
            message: timerScreenData.isWorkoutStarting ? 'stay.get_ready' : 'stay.introduction',
            initialTotalTime: timerScreenData.progressCircle?.initialTotalTime,
            color: timerScreenData.progressCircle?.color,
            timerControlRef: timerControlRef
        });
        else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _horTvbd.HorTvbd), {
            workoutName: timerScreenData.workoutName ?? "",
            totalTime: timerScreenData.totalTime ?? 0,
            currentExercise: timerScreenData.currentExercise ?? 0,
            totalExercises: timerScreenData.totalExercises ?? 0,
            totalSets: timerScreenData.totalSets ?? 0,
            pod: timerScreenData.currentPod ?? 0,
            totalPods: timerScreenData.totalPods ?? 0,
            podDuration: timerScreenData.podDuration ?? timerScreenData.totalTime ?? 1,
            currentSetTime: timerScreenData.currentSetTime ?? 0,
            hydrate_active: timerScreenData.hydrate_active || 0,
            hydrate_total: timerScreenData.hydrate_total || 0,
            type: timerScreenData.type,
            showFinish: showFinish,
            finishImage: timerScreenData.workoutImage,
            timerControlRef: timerControlRef
        });
    }
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../components/HorTvbd/HorTvbd":"9Tnvr","../../components/StartingClassIn30Seconds/StartingClassIn30Seconds":"4RPCB","../Movement/Movement":"1s4YS","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"9Tnvr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorTvbd", ()=>HorTvbd);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
var _progressCircle = require("../ProgressCircle");
var _reactI18Next = require("react-i18next");
const HorTvbd = ({ totalTime = 2520, currentExercise = 1, totalExercises = 1, showFinish = false, finishMessage = "finish.finish", finishImage = "/img/basezero_logo.png", timerControlRef, totalPods = 0, pod = 0, podDuration = 0, type = "work", currentSetTime = 0 })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const podTimerRef = (0, _reactDefault.default).useRef(null);
    const exerciseTimerRef = (0, _reactDefault.default).useRef(null);
    const totalTimerRef = (0, _reactDefault.default).useRef(null);
    // Create a proxy timer control that forwards actions to all timers
    const timerControlProxy = {
        play: ()=>{
            podTimerRef.current?.play();
            exerciseTimerRef.current?.play();
            totalTimerRef.current?.play();
        },
        stop: ()=>{
            podTimerRef.current?.stop();
            exerciseTimerRef.current?.stop();
            totalTimerRef.current?.stop();
        },
        resume: ()=>{
            podTimerRef.current?.resume();
            exerciseTimerRef.current?.resume();
            totalTimerRef.current?.resume();
        },
        reset: ()=>{
            podTimerRef.current?.reset();
            exerciseTimerRef.current?.reset();
            totalTimerRef.current?.reset();
        },
        setTime: (newTime)=>{
            podTimerRef.current?.setTime(newTime);
            exerciseTimerRef.current?.setTime(newTime);
            totalTimerRef.current?.setTime(newTime);
        }
    };
    // Forward the proxy to the external ref
    (0, _reactDefault.default).useImperativeHandle(timerControlRef, ()=>timerControlProxy);
    const translatedFinishMessage = t(finishMessage);
    const generateSetProgress = ()=>{
        const progressPercentage = currentExercise / totalExercises * 100; // Calculate progress in percentage
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "progress-bar-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "progress-filled",
                    style: {
                        width: `calc(${progressPercentage}% - 125px - 40px)`
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "progress-indicator",
                    children: [
                        currentExercise,
                        "/",
                        totalExercises
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "progress-remaining"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "hor-TVBD",
        children: showFinish ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "finish-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "finish-gif",
                    alt: "Finish",
                    src: finishImage,
                    height: 551,
                    width: 538
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "finish-text",
                    children: translatedFinishMessage
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "progress-container",
                    children: generateSetProgress()
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "timers-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "timer-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                                type: "solid",
                                initialTotalTime: podDuration,
                                ref: podTimerRef,
                                label: t('pods'),
                                icon: "/img/cycle-white.svg",
                                customValue: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        pod,
                                        " / ",
                                        totalPods
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "timer-container timer-exercises",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                                initialTotalTime: currentSetTime,
                                ref: exerciseTimerRef,
                                color: type == 'hydrate' || type == 'rest' ? 'red' : 'default',
                                label: type == 'hydrate' ? t('rest') : t(type)
                            }, `${currentSetTime}-${Date.now()}`)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "timer-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                                type: "solid",
                                initialTotalTime: totalTime,
                                ref: totalTimerRef,
                                label: t('total_time'),
                                icon: "/img/timer-white.svg"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./style.css":"8zcBb","../ProgressCircle":"i549j","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"8zcBb":[function() {},{}],"i549j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleProgressBar", ()=>(0, _circleProgressBarDefault.default));
parcelHelpers.export(exports, "ProgressCircle", ()=>(0, _progressCircleDefault.default));
var _circleProgressBar = require("./CircleProgressBar");
var _circleProgressBarDefault = parcelHelpers.interopDefault(_circleProgressBar);
var _progressCircle = require("./ProgressCircle");
var _progressCircleDefault = parcelHelpers.interopDefault(_progressCircle);

},{"./CircleProgressBar":"8qdw3","./ProgressCircle":"9oi28","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"4RPCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StartingClassIn", ()=>StartingClassIn);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
var _progressCircle = require("../ProgressCircle");
var _reactI18Next = require("react-i18next");
const StartingClassIn = ({ message = "", initialTotalTime = 0, color, timerControlRef })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    message = message ? message : "stay.get_ready";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "starting-class-in",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "header-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                className: "header",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "dumbbell1",
                                        alt: "Workout Icon",
                                        src: "/img/flame.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper",
                                        children: t(message)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                            initialTotalTime: initialTotalTime,
                            color: color,
                            ref: timerControlRef
                        })
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./style.css":"fd4l4","../ProgressCircle":"i549j","react-i18next":"k5Ajr","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"fd4l4":[function() {},{}],"1s4YS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorMovement", ()=>HorMovement);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next"); // Import useTranslation
var _movementCss = require("./Movement.css");
const HorMovement = ({ movementScreenData })=>{
    const { t } = (0, _reactI18Next.useTranslation)(); // Use the hook
    const truncate_description = (description)=>{
        return description ? description.length > 600 ? description.slice(0, 600) + "..." : description : "";
    };
    if (!movementScreenData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mov-movement-horizontal-wrapper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mov-container-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mov-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mov-content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mov-text-wrapper",
                        children: t("Loading")
                    })
                })
            })
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mov-movement-horizontal-wrapper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mov-container-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mov-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mov-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mov-div",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mov-icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "mov-img-2",
                                            alt: "Route",
                                            src: "/img/flag.svg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-2",
                                                children: movementScreenData.stations
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("stations")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mov-div",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mov-icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "mov-img-2",
                                            alt: "Route",
                                            src: "/img/refresh.svg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-2",
                                                children: movementScreenData.podSets
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("sets")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mov-div",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mov-icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "mov-img-2",
                                            alt: "Route",
                                            src: "/img/cycle.svg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-2",
                                                children: movementScreenData.pods
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("pods")
                                            })
                                        ]
                                    }),
                                    movementScreenData.laps && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-2",
                                                children: movementScreenData.laps
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("laps")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mov-div",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mov-icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "mov-img-2",
                                            alt: "Route",
                                            src: "/img/hidration.svg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-2",
                                                children: movementScreenData.hydrations && movementScreenData.hydrations > 0 ? movementScreenData.hydrations : '-'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("hydration")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mov-text-2",
                                                children: [
                                                    movementScreenData.hydrations && movementScreenData.hydrations > 0 ? `${movementScreenData.hydrationTime} s` : '-',
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("rest")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mov-div",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "mov-img-2",
                                        alt: "Timer reset",
                                        src: "/img/timer.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mov-text-2",
                                                children: [
                                                    movementScreenData.exerciseTime,
                                                    " s"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("exercise")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mov-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mov-text-2",
                                                children: [
                                                    movementScreenData.restTime,
                                                    " s"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mov-text-wrapper",
                                                children: t("rest")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mov-movement",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "workout-icon-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "mov-workout-image",
                                    alt: "Container",
                                    src: movementScreenData.workoutImage
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mov-text-description",
                                children: [
                                    " ",
                                    truncate_description(movementScreenData.description)
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-i18next":"k5Ajr","./Movement.css":"7FCIO","@parcel/transformer-js/src/esmodule-helpers.js":"8Bm3l"}],"7FCIO":[function() {},{}]},["5DEId"], "5DEId", "parcelRequireb4e3", {})

//# sourceMappingURL=tmp-deploy.a8ce2486.js.map
